
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2rynm", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6SsN4 = parcelRequire("6SsN4");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");


var $jmjWc = parcelRequire("jmjWc");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $7boqA = parcelRequire("7boqA");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $1xpoY = parcelRequire("1xpoY");


var $8zMP3 = parcelRequire("8zMP3");


var $2wo33 = parcelRequire("2wo33");


var $lfBMY = parcelRequire("lfBMY");

/* SpaceNavigationRelatedContent.tsx generated by @compiled/babel-plugin v3.0.1 */ 



var $kNIYN = parcelRequire("kNIYN");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $iMnC5 = parcelRequire("iMnC5");


var $hBYtq = parcelRequire("hBYtq");


var $4aRua = parcelRequire("4aRua");


var $aRGok = parcelRequire("aRGok");


var $9KSWX = parcelRequire("9KSWX");





var $ep3mz = parcelRequire("ep3mz");


var $1I9Gw = parcelRequire("1I9Gw");


var $bQm3c = parcelRequire("bQm3c");


var $gqqjz = parcelRequire("gqqjz");








var $fR63l = parcelRequire("fR63l");


var $cS7ok = parcelRequire("cS7ok");


var $i9pyX = parcelRequire("i9pyX");





var $5ZqQS = parcelRequire("5ZqQS");





var $k8jyJ = parcelRequire("k8jyJ");

const $dddab7bf95955fb3$var$SPACE_CURATION_3P_AUTH = 'spaceCurationThirdPartyAuth';
const $dddab7bf95955fb3$var$CONNECTION_PRODUCT_KEYS = {
    [(0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).GOOGLE_DRIVE]: [
        (0, $fR63l.ProductKeys3P).GoogleDrive
    ],
    [(0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).MICROSOFT]: [
        (0, $fR63l.ProductKeys3P).OneDrive,
        (0, $fR63l.ProductKeys3P).Sharepoint
    ]
};
const $dddab7bf95955fb3$var$connectionProductKeySet = (product)=>{
    const productKeys = $dddab7bf95955fb3$var$CONNECTION_PRODUCT_KEYS[product];
    return productKeys ? new Set(productKeys) : undefined;
};
const $dddab7bf95955fb3$var$resourceBelongsToConnection = (resourceType, productKeySet, resourceTypeToProductKey)=>{
    const productKey = resourceTypeToProductKey[resourceType];
    return productKey !== undefined && productKeySet.has(productKey);
};
const $dddab7bf95955fb3$export$3d6949c2295aff10 = ({ products: products, cloudId: cloudId })=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [optimisticallyAuthenticatedProducts, setOptimisticallyAuthenticatedProducts] = (0, $cozmU.useState)(new Set());
    const [revalidation, setRevalidation] = (0, $cozmU.useState)({
        done: false,
        confirmed: new Set()
    });
    const hasStartedRevalidationRef = (0, $cozmU.useRef)(false);
    const productsRef = (0, $cozmU.useRef)(products);
    productsRef.current = products;
    const thirdPartyTypesRef = (0, $cozmU.useRef)(null);
    const resolveThirdPartyTypes = (0, $cozmU.useCallback)(()=>{
        if (!thirdPartyTypesRef.current) thirdPartyTypesRef.current = (0, $cS7ok.getThirdPartyTypes)();
        return thirdPartyTypesRef.current;
    }, []);
    const fireAnalyticsEvent = (0, $cozmU.useCallback)((event)=>createAnalyticsEvent(event).fire(), [
        createAnalyticsEvent
    ]);
    const logException = (0, $cozmU.useCallback)((exception)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(exception, {
            attribution: (0, $3IBnw.Attribution).INTEGRATIONS,
            partialFailure: true
        });
    }, []);
    const analytics = (0, $cozmU.useMemo)(()=>({
            searchSessionId: $dddab7bf95955fb3$var$SPACE_CURATION_3P_AUTH,
            source: $dddab7bf95955fb3$var$SPACE_CURATION_3P_AUTH,
            actionSubject: $dddab7bf95955fb3$var$SPACE_CURATION_3P_AUTH,
            taskNamePrefix: $dddab7bf95955fb3$var$SPACE_CURATION_3P_AUTH,
            fireAnalyticsEvent: fireAnalyticsEvent,
            logException: logException
        }), [
        fireAnalyticsEvent,
        logException
    ]);
    const disabled = !cloudId || !userId || products.length === 0;
    const { thirdPartyConfigs: thirdPartyConfigs } = (0, $cS7ok.useThirdPartyConfig)({
        cloudId: cloudId,
        userId: userId ?? undefined,
        disabled: disabled,
        analytics: analytics
    });
    const markOptimisticallyAuthenticated = (0, $cozmU.useCallback)((product)=>{
        setOptimisticallyAuthenticatedProducts((prev)=>{
            const next = new Set(prev);
            next.add(product);
            return next;
        });
        const productKeySet = $dddab7bf95955fb3$var$connectionProductKeySet(product);
        if (userId && cloudId && productKeySet) resolveThirdPartyTypes().then((resourceTypeToProductKey)=>(0, $i9pyX.update3pConfigCacheEntry)(userId, cloudId, (config)=>config.map((resource)=>$dddab7bf95955fb3$var$resourceBelongsToConnection(resource.type, productKeySet, resourceTypeToProductKey) ? {
                        ...resource,
                        isUserOAuthed: true
                    } : resource)));
    }, [
        cloudId,
        userId,
        resolveThirdPartyTypes
    ]);
    const { authenticatedServices: authenticatedServices, unauthenticatedServices: unauthenticatedServices } = (0, $cozmU.useMemo)(()=>{
        const authenticated = {};
        const unauthenticated = {};
        for (const product of products){
            const productKeys = $dddab7bf95955fb3$var$CONNECTION_PRODUCT_KEYS[product];
            if (!productKeys) continue;
            let hasConfig = false;
            let isAuthenticated = false;
            let outboundAuthUrl;
            let icon;
            // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
            for (const productKey of productKeys){
                const config = thirdPartyConfigs?.[productKey];
                if (!config) continue;
                if (!hasConfig) {
                    icon = config.icon;
                    hasConfig = true;
                }
                if (!config.userNeedsOAuth) isAuthenticated = true;
                if (outboundAuthUrl === undefined && config.outboundAuthUrl) outboundAuthUrl = config.outboundAuthUrl;
            }
            if (!hasConfig) continue;
            const connected = isAuthenticated || optimisticallyAuthenticatedProducts.has(product) || revalidation.confirmed.has(product);
            const status = {
                isAuthenticated: connected,
                outboundAuthUrl: outboundAuthUrl,
                icon: icon
            };
            if (connected) authenticated[product] = status;
            else unauthenticated[product] = status;
        }
        return {
            authenticatedServices: authenticated,
            unauthenticatedServices: unauthenticated
        };
    }, [
        products,
        thirdPartyConfigs,
        optimisticallyAuthenticatedProducts,
        revalidation
    ]);
    const runRevalidation = (0, $cozmU.useCallback)(async (options)=>{
        const confirmed = new Set();
        if (!options?.skipFetch && cloudId && userId) try {
            const [resources, resourceTypeToProductKey] = await Promise.all([
                (0, $i9pyX.get3pSearchConfig)({
                    cloudId: cloudId,
                    userId: userId,
                    returnExpired: false,
                    onlyRefreshIfExpired: false
                }),
                resolveThirdPartyTypes()
            ]);
            for (const product of productsRef.current){
                const productKeySet = $dddab7bf95955fb3$var$connectionProductKeySet(product);
                if (!productKeySet) continue;
                // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
                const isConnected = resources?.some((resource)=>$dddab7bf95955fb3$var$resourceBelongsToConnection(resource.type, productKeySet, resourceTypeToProductKey) && resource.isUserOAuthed);
                if (isConnected) confirmed.add(product);
            }
        } catch  {}
        setRevalidation((prev)=>{
            const nextConfirmed = new Set(prev.confirmed);
            confirmed.forEach((product)=>nextConfirmed.add(product));
            return {
                done: true,
                confirmed: nextConfirmed
            };
        });
    }, [
        cloudId,
        userId,
        resolveThirdPartyTypes
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (hasStartedRevalidationRef.current) return;
        if (disabled || thirdPartyConfigs === undefined) return;
        hasStartedRevalidationRef.current = true;
        const skipFetch = Object.keys(unauthenticatedServices).length === 0;
        runRevalidation({
            skipFetch: skipFetch
        });
    }, [
        disabled,
        thirdPartyConfigs,
        unauthenticatedServices,
        runRevalidation
    ]);
    const refetch = (0, $cozmU.useCallback)(async ()=>{
        await runRevalidation();
    }, [
        runRevalidation
    ]);
    const configLoading = !disabled && thirdPartyConfigs === undefined;
    const wouldShowAuthCard = !configLoading && Object.keys(unauthenticatedServices).length > 0;
    const isLoading = configLoading || wouldShowAuthCard && !revalidation.done;
    return {
        authenticatedServices: authenticatedServices,
        unauthenticatedServices: unauthenticatedServices,
        isLoading: isLoading,
        refetch: refetch,
        markOptimisticallyAuthenticated: markOptimisticallyAuthenticated
    };
};


/* ReviewContentSuggestionsModal.tsx generated by @compiled/babel-plugin v3.0.1 */ /* eslint-disable @atlassian/perf-linting/no-quadratic-complexity */ /* eslint-disable @atlassian/perf-linting/no-chain-state-updates */ /* eslint-disable @atlassian/perf-linting/no-expensive-computations-in-render */ 









var $ad7Ou = parcelRequire("ad7Ou");


var $1sCHt = parcelRequire("1sCHt");


var $RfroO = parcelRequire("RfroO");


var $4w5V7 = parcelRequire("4w5V7");


var $l3wuH = parcelRequire("l3wuH");


var $93fnf = parcelRequire("93fnf");


var $kUFQ0 = parcelRequire("kUFQ0");


var $I7hWB = parcelRequire("I7hWB");


var $w6R6I = parcelRequire("w6R6I");


var $7vK9E = parcelRequire("7vK9E");





var $4ez2K = parcelRequire("4ez2K");


var $1l0kj = parcelRequire("1l0kj");


var $dinVW = parcelRequire("dinVW");





var $kh0hi = parcelRequire("kh0hi");





var $7A1BE = parcelRequire("7A1BE");


var $hMaHH = parcelRequire("hMaHH");


var $2uDbg = parcelRequire("2uDbg");


var $lfoFx = parcelRequire("lfoFx");


var $lpNn5 = parcelRequire("lpNn5");


var $431p7 = parcelRequire("431p7");


var $lsxnT = parcelRequire("lsxnT");










/* SuggestionMovePopup.tsx generated by @compiled/babel-plugin v3.0.1 */ 



























var $4n1IT = parcelRequire("4n1IT");


var $bCECL = parcelRequire("bCECL");


var $4M98y = parcelRequire("4M98y");

/**
 * @generated SignedSource<<fae6dc9963c2cb70c50a749af89545fe>>
 * @relayHash 7c0e4d8486e54ba6e102ec5009505b19
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3b4a148a7952924e53af4161b0a5fc2ad94790986d10c32d96e9d7b55976cd6f
const $190e7a369505d2bf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ids"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "ids",
        "variableName": "ids"
    }, v2 = [
        {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ]
        }
    ], v3 = [
        {
            "alias": "pageContent",
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "page"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": v2 /*: any*/ 
        },
        {
            "alias": "folderContent",
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "folder"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": v2 /*: any*/ 
        },
        {
            "alias": "whiteboardContent",
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "whiteboard"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": v2 /*: any*/ 
        },
        {
            "alias": "databaseContent",
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "database"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": v2 /*: any*/ 
        },
        {
            "alias": "embedContent",
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "embed"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": v2 /*: any*/ 
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentTitlesQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentTitlesQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "7c0e4d8486e54ba6e102ec5009505b19",
            "id": "3b4a148a7952924e53af4161b0a5fc2ad94790986d10c32d96e9d7b55976cd6f",
            "metadata": {},
            "name": "useContentTitlesQuery",
            "operationKind": "query",
            "text": "query useContentTitlesQuery($ids:[ID!]!){pageContent:content(ids:$ids,type:\"page\"){nodes{id,title}},folderContent:content(ids:$ids,type:\"folder\"){nodes{id,title}},whiteboardContent:content(ids:$ids,type:\"whiteboard\"){nodes{id,title}},databaseContent:content(ids:$ids,type:\"database\"){nodes{id,title}},embedContent:content(ids:$ids,type:\"embed\"){nodes{id,title}}}"
        }
    };
}();
$190e7a369505d2bf$var$node.hash = "503b371610f42e1634360824bac2cefe";
var $190e7a369505d2bf$export$2e2bcd8739ae039 = $190e7a369505d2bf$var$node;






var $jMyy4 = parcelRequire("jMyy4");

const $877d8332f9570d6f$var$ContentTitlesQuery = (0, $190e7a369505d2bf$export$2e2bcd8739ae039);
const $877d8332f9570d6f$export$7610585fadab893e = (contentIds)=>{
    const ids = (0, $cozmU.useMemo)(()=>{
        const unique = [
            ...new Set(contentIds)
        ].filter(Boolean);
        return unique;
    }, [
        contentIds
    ]);
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($877d8332f9570d6f$var$ContentTitlesQuery, {
        variables: {
            ids: ids
        },
        skip: ids.length === 0,
        __callerPackage__: "space-curation"
    });
    const { titlesByContentId: titlesByContentId, contentMetaById: contentMetaById } = (0, $cozmU.useMemo)(()=>{
        const titlesMap = new Map();
        const metaMap = new Map();
        const typedGroups = [
            {
                nodes: data?.pageContent ?? null,
                type: 'page'
            },
            {
                nodes: data?.folderContent ?? null,
                type: 'folder'
            },
            {
                nodes: data?.whiteboardContent ?? null,
                type: 'whiteboard'
            },
            {
                nodes: data?.databaseContent ?? null,
                type: 'database'
            },
            {
                nodes: data?.embedContent ?? null,
                type: 'embed'
            }
        ];
        for (const { nodes: nodes, type: type } of typedGroups){
            for (const node of nodes?.nodes ?? [])if (node?.id != null) {
                const title = node.title ?? '';
                titlesMap.set(node.id, title);
                metaMap.set(node.id, {
                    title: title,
                    type: type
                });
            }
        }
        return {
            titlesByContentId: titlesMap,
            contentMetaById: metaMap
        };
    }, [
        data
    ]);
    const isLoading = ids.length > 0 && loading;
    return {
        titlesByContentId: titlesByContentId,
        contentMetaById: contentMetaById,
        isLoading: isLoading
    };
};





const $e9fbe7b264ec157f$export$3e0409b11e4da6d2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "16",
        height: "17",
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M8.25 0C8.76904 0 9.26676 0.206236 9.63379 0.573242L12.9268 3.86621C13.2938 4.23324 13.5 4.73096 13.5 5.25V8H12V6H8.25C7.83579 6 7.5 5.66421 7.5 5.25V1.5H3.5C3.22386 1.5 3 1.72386 3 2V14C3 14.2761 3.22386 14.5 3.5 14.5H6V16H3.5C2.39543 16 1.5 15.1046 1.5 14V2C1.5 0.895431 2.39543 0 3.5 0H8.25ZM9 4.5H11.4395L9 2.06055V4.5Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M14.5819 12.3067C14.8222 12.6013 14.8048 13.036 14.5302 13.3106L11.7802 16.0606L10.7196 15.0001L12.1893 13.5303L7.74988 13.5303L7.74988 12.0303L12.1893 12.0303L10.7196 10.5606L11.7802 9.50006L14.5302 12.2501L14.5819 12.3067Z",
        fill: "currentColor"
    }));


const $e4c0d2b6b6e18559$var$styles = {
    movePopupContent: "_4FKVYE8HPE _39xV02ehCh",
    fallbackSectionLabel: "_4FKVYE1Y8M",
    fallbackParentRow: "_2mHwu8gVvo _4FKVYE2ADO _23rrnHo10F _0bjKvD8fU6 _3iDTPbQ4SZ _0hPCNLDIqT _39xV02N91d _0KLXrujOvk _1eOmH6o126 _3sFUREDdj4 _3gzVzLN4oS",
    fallbackParentTitle: "_4bt5LAnQyn _2WAcuGnQyn _2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _39HuIbz8Lp _1ANEUSLRg7 _4ouGXIdnbC _2fwxA57p2s",
    fallbackParentIcon: "_3YEZNOdnbC",
    spinnerContainer: "_4FKVYE8HPE _3iDTPbQ4SZ _37wbyuDIqT"
};
const $e4c0d2b6b6e18559$var$i18n = (0, $kSwu1.defineMessages)({
    moveButton: {
        id: "space-curation.review-content-suggestions-modal.move-button",
        defaultMessage: "Move"
    },
    moveToTitle: {
        id: "space-curation.review-content-suggestions-modal.move-to-title",
        defaultMessage: "Move to"
    },
    suggested: {
        id: "space-curation.review-content-suggestions-modal.move-suggested",
        defaultMessage: "Suggested"
    },
    moveSuggestionTooltip: {
        id: "space-curation.review-content-suggestions-modal.move-suggestion-tooltip",
        defaultMessage: "Move suggestion to another parent"
    }
});
const $e4c0d2b6b6e18559$var$FallbackParentRow = ({ parentId: parentId, meta: meta, title: title, onMoveItemClick: onMoveItemClick })=>{
    const handleClick = (0, $cozmU.useCallback)(()=>{
        onMoveItemClick(parentId);
    }, [
        onMoveItemClick,
        parentId
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $kh0hi.default), {
        key: parentId,
        xcss: $e4c0d2b6b6e18559$var$styles.fallbackParentRow,
        onClick: handleClick,
        testId: `suggestion-move-fallback-parent-${parentId}`
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        xcss: $e4c0d2b6b6e18559$var$styles.fallbackParentIcon,
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $bCECL.ContentIcon), {
        type: meta?.type ?? 'page'
    })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $e4c0d2b6b6e18559$var$styles.fallbackParentTitle
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, meta?.title ?? title)));
};
const $e4c0d2b6b6e18559$export$de484dae570b7c31 = ({ suggestionId: suggestionId, spaceKey: spaceKey, isOpen: isOpen, onOpenChange: onOpenChange, onMoveSuggestion: onMoveSuggestion, fallbackParents: fallbackParents, currentParentId: currentParentId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const filteredFallbackParents = (0, $cozmU.useMemo)(()=>(fallbackParents ?? []).filter((id)=>id !== currentParentId), [
        fallbackParents,
        currentParentId
    ]);
    const fallbackParentIdStrings = (0, $cozmU.useMemo)(()=>filteredFallbackParents.map(String), [
        filteredFallbackParents
    ]);
    const { titlesByContentId: titlesByContentId, contentMetaById: contentMetaById, isLoading: isLoading } = (0, $877d8332f9570d6f$export$7610585fadab893e)(isOpen ? fallbackParentIdStrings : []);
    const handleMoveItemClick = (0, $cozmU.useCallback)((idOrAri)=>{
        const str = String(idOrAri);
        const rawId = str.includes('/') ? str.split('/').pop() ?? str : str;
        const numId = Number(rawId);
        if (!rawId || isNaN(numId)) return;
        onMoveSuggestion(suggestionId, numId);
        onOpenChange(false);
    }, [
        onMoveSuggestion,
        onOpenChange,
        suggestionId
    ]);
    const renderFallbackParentList = ()=>{
        if (isLoading) return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $e4c0d2b6b6e18559$var$styles.spinnerContainer
        }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
            size: "small"
        }));
        const accessibleParents = filteredFallbackParents.filter((parentId)=>contentMetaById.has(String(parentId)));
        if (accessibleParents.length === 0) return null;
        return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $e4c0d2b6b6e18559$var$styles.fallbackSectionLabel
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest",
            weight: "semibold"
        }, formatMessage($e4c0d2b6b6e18559$var$i18n.suggested))), accessibleParents.map((parentId)=>/*#__PURE__*/ $cozmU.createElement($e4c0d2b6b6e18559$var$FallbackParentRow, {
                key: parentId,
                parentId: parentId,
                meta: contentMetaById.get(String(parentId)),
                title: titlesByContentId.get(String(parentId)),
                onMoveItemClick: handleMoveItemClick
            })));
    };
    const fallbackParentRows = isOpen && filteredFallbackParents.length > 0 ? renderFallbackParentList() : null;
    return /*#__PURE__*/ $cozmU.createElement((0, $4n1IT.Popup), {
        isOpen: isOpen,
        onClose: ()=>onOpenChange(false),
        placement: "bottom-start",
        zIndex: 800,
        content: ()=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $e4c0d2b6b6e18559$var$styles.movePopupContent
            }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                weight: "bold"
            }, formatMessage($e4c0d2b6b6e18559$var$i18n.moveToTitle)), /*#__PURE__*/ $cozmU.createElement((0, $4M98y.ContentTreeSearchBase), {
                spaceKey: spaceKey ?? '',
                onItemClick: handleMoveItemClick,
                contentId: "",
                includeFolders: true
            }, fallbackParentRows)),
        trigger: (triggerProps)=>/*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                ...triggerProps,
                appearance: "subtle",
                spacing: "compact",
                isSelected: isOpen,
                icon: ()=>/*#__PURE__*/ $cozmU.createElement((0, $e9fbe7b264ec157f$export$3e0409b11e4da6d2), null),
                label: formatMessage($e4c0d2b6b6e18559$var$i18n.moveButton),
                onClick: ()=>onOpenChange(!isOpen),
                testId: `review-content-suggestion-move-button-${suggestionId}`,
                isTooltipDisabled: false,
                tooltip: {
                    content: formatMessage($e4c0d2b6b6e18559$var$i18n.moveSuggestionTooltip)
                }
            })
    });
};


/* SuggestionsFilterPopup.tsx generated by @compiled/babel-plugin v3.0.1 */ 









var $dPtk6 = parcelRequire("dPtk6");




















var $c0A7H = parcelRequire("c0A7H");







const $d46a749dcc1cd83e$var$messages = (0, $kSwu1.defineMessages)({
    googleDrive: {
        id: "space-curation.review-content-suggestions-modal.filter-source-google-drive",
        defaultMessage: "Google Drive"
    },
    loom: {
        id: "space-curation.review-content-suggestions-modal.filter-source-loom",
        defaultMessage: "Loom"
    },
    microsoft: {
        id: "space-curation.review-content-suggestions-modal.filter-source-microsoft",
        defaultMessage: "Microsoft"
    }
});
const $d46a749dcc1cd83e$export$fc6308b035f32dc = {
    [(0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).GOOGLE_DRIVE]: $d46a749dcc1cd83e$var$messages.googleDrive,
    [(0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).LOOM]: $d46a749dcc1cd83e$var$messages.loom,
    [(0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).MICROSOFT]: $d46a749dcc1cd83e$var$messages.microsoft
};



var $fSlSx = parcelRequire("fSlSx");




const $a01761abc8be8172$var$i18n = (0, $kSwu1.defineMessages)({
    filterButtonLabel: {
        id: "space-curation.review-content-suggestions-modal.filter-button-label",
        defaultMessage: "Filter suggestions by source"
    },
    showOnlyFrom: {
        id: "space-curation.review-content-suggestions-modal.filter-show-only-from",
        defaultMessage: "Show only suggestions from"
    }
});
const $a01761abc8be8172$var$styles = {
    popupContent: "_4FKVYEgVvo _39xV02e7g8",
    sourceRow: "_4c065U2ADO _2Y7lL45zaO",
    heading: "_4c065U2ADO _2Y7lL45zaO",
    sourceName: "_2O5Vij7dHp _4ouGXIdnbC",
    iconWrapper: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02ey7F _0jFU0Vey7F _3YEZNOdnbC"
};
const $a01761abc8be8172$export$21d85d7a6ca378ad = ({ onClose: onClose, availableSources: availableSources })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false); // Available sources are, by definition, ones the user already has suggestions from, so every
    // one is filterable — no auth/connect gating is needed here.
    const visibleSources = (0, $cozmU.useMemo)(()=>availableSources.reduce((acc, ari)=>{
            const connection = (0, $k8jyJ.getConnectionForProviderId)(ari);
            if (connection) acc.push({
                ari: ari,
                connection: connection
            });
            return acc;
        }, []), [
        availableSources
    ]);
    const [enabledSources, setEnabledSources] = (0, $cozmU.useState)({}); // A source counts as enabled unless it has been explicitly toggled off (missing entry ⇒ on).
    const isEnabled = (0, $cozmU.useCallback)((source)=>enabledSources[source.ari] !== false, [
        enabledSources
    ]);
    const closePopup = (0, $cozmU.useCallback)(()=>{
        setIsOpen(false);
        const enabled = visibleSources.filter(isEnabled); // All available sources enabled ⇒ no filter (empty list); otherwise submit the chosen ARIs.
        onClose(enabled.length === visibleSources.length ? [] : enabled.map((source)=>source.ari));
    }, [
        onClose,
        isEnabled,
        visibleSources
    ]);
    const handleToggle = (ari)=>{
        setEnabledSources((prev)=>({
                ...prev,
                [ari]: prev[ari] === false
            }));
    };
    const enabledCount = (0, $cozmU.useMemo)(()=>visibleSources.reduce((count, source)=>isEnabled(source) ? count + 1 : count, 0), [
        isEnabled,
        visibleSources
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        isOpen: isOpen,
        onClose: closePopup,
        placement: "bottom-end",
        zIndex: 800,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $a01761abc8be8172$var$styles.popupContent,
                testId: "suggestions-filter-popup-content"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.0"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $a01761abc8be8172$var$styles.heading
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "small",
                weight: "bold",
                color: "color.text.subtlest"
            }, formatMessage($a01761abc8be8172$var$i18n.showOnlyFrom))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.0"
            }, visibleSources.map((source)=>{
                const name = formatMessage((0, $d46a749dcc1cd83e$export$fc6308b035f32dc)[source.connection]);
                const checked = isEnabled(source);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                    key: source.ari,
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "space.100",
                    xcss: $a01761abc8be8172$var$styles.sourceRow
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                    alignBlock: "center",
                    space: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: $a01761abc8be8172$var$styles.iconWrapper
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fSlSx.ConnectionLogo), {
                    connection: source.connection,
                    size: "xxsmall"
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: $a01761abc8be8172$var$styles.sourceName
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                    size: "medium"
                }, name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c0A7H.default), {
                    label: name,
                    isChecked: checked,
                    isDisabled: checked && enabledCount === 1,
                    onChange: ()=>handleToggle(source.ari),
                    testId: `suggestions-filter-toggle-${source.connection}`
                }));
            })))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...triggerProps,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($dPtk6))),
                label: formatMessage($a01761abc8be8172$var$i18n.filterButtonLabel),
                appearance: "subtle",
                spacing: "compact",
                isSelected: isOpen,
                onClick: ()=>isOpen ? closePopup() : setIsOpen(true),
                testId: "suggestions-filter-button"
            })
    });
};







var $f7B1p = parcelRequire("f7B1p");




/**
 * @generated SignedSource<<2d2408509afa5edbb31555d7592c0d05>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $583f0c72f724db55$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "spaceKey"
        }
    ],
    "kind": "Fragment",
    "name": "useSetSpaceViewsSortTransientWriteFragment",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "kind": "ScalarField",
            "name": "spaceViewsPersistence"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "UserPreferences"
};
$583f0c72f724db55$var$node.hash = "cca4dcc97ad7cd8994207d0b7df73299";
var $583f0c72f724db55$export$2e2bcd8739ae039 = $583f0c72f724db55$var$node;






var $ij4CE = parcelRequire("ij4CE");


const $320110e076811ccd$export$4820105a3dae0c48 = (spaceKey)=>{
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $583f0c72f724db55$export$2e2bcd8739ae039),
        fragmentSpec: (0, $583f0c72f724db55$export$2e2bcd8739ae039),
        __callerPackage__: "space-curation"
    });
    return (0, $cozmU.useCallback)((newSort)=>{
        writeFragmentInterop({
            fragmentId: `$ROOT_QUERY.userPreferences`,
            data: {
                spaceViewsPersistence: newSort,
                __typename: 'UserPreferences'
            },
            variables: {
                spaceKey: spaceKey
            }
        });
    }, [
        spaceKey,
        writeFragmentInterop
    ]);
};


const $55e1c5eec5b4b224$var$SUCCESS_FLAG_ID = 'space-navigation.suggestion-actions.success';
const $55e1c5eec5b4b224$var$i18n = (0, $kSwu1.defineMessages)({
    successFlagTitle: {
        id: "space-curation.suggestion-actions.success.title",
        defaultMessage: "{count, plural, one {{count} item added to space} other {{count} items added to space}}"
    },
    successFlagDescription: {
        id: "space-curation.suggestion-actions.success.description",
        defaultMessage: "Your selected content has been added to this space."
    },
    errorFlagTitle: {
        id: "space-curation.suggestion-actions.error.title",
        defaultMessage: "Failed to add items to space"
    },
    errorFlagDescription: {
        id: "space-curation.suggestion-actions.error.description",
        defaultMessage: "Something went wrong. Please try again."
    },
    viewLastUpdated: {
        id: "space-curation.suggestion-actions.success.view-last-updated",
        defaultMessage: "View last updated"
    }
});
const $55e1c5eec5b4b224$export$c9239e53ef385494 = ({ spaceKey: spaceKey, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const setSpaceViewsSortTransient = (0, $320110e076811ccd$export$4820105a3dae0c48)(spaceKey);
    const submitActions = async (allSuggestions, selectedIds, rejectedIds, { showFlags: showFlags = true } = {})=>{
        if (!spaceKey) return false;
        const actions = allSuggestions.map((s)=>({
                ...s,
                action: selectedIds.has(s.id) ? (0, $k8jyJ.Action).ACCEPT : rejectedIds.has(s.id) ? (0, $k8jyJ.Action).REJECT : (0, $k8jyJ.Action).IGNORE
            }));
        try {
            await (0, $f7B1p.cfetch)(`/wiki/rest/internal/1.0/spaces/${spaceKey}/remote-objects/actions`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    actions: actions
                })
            });
            if (showFlags) flags?.showSuccessFlag({
                id: $55e1c5eec5b4b224$var$SUCCESS_FLAG_ID,
                title: formatMessage($55e1c5eec5b4b224$var$i18n.successFlagTitle, {
                    count: selectedIds.size
                }),
                description: formatMessage($55e1c5eec5b4b224$var$i18n.successFlagDescription),
                isAutoDismiss: false,
                actions: [
                    {
                        content: formatMessage($55e1c5eec5b4b224$var$i18n.viewLastUpdated),
                        onClick: ()=>{
                            setSpaceViewsSortTransient('RECENTLY_MODIFIED');
                            flags?.hideFlag($55e1c5eec5b4b224$var$SUCCESS_FLAG_ID);
                        }
                    }
                ]
            });
            return true;
        } catch  {
            if (showFlags) flags?.showErrorFlag({
                id: 'space-navigation.suggestion-actions.error',
                title: formatMessage($55e1c5eec5b4b224$var$i18n.errorFlagTitle),
                description: formatMessage($55e1c5eec5b4b224$var$i18n.errorFlagDescription),
                isAutoDismiss: true
            });
            return false;
        }
    };
    return {
        submitActions: submitActions
    };
};









var $hBkCm = parcelRequire("hBkCm");



const $b0a504e05d35a946$var$normalizeParentIds = (suggestions)=>suggestions.map((group)=>({
            ...group,
            parentId: group.parentId ?? null,
            // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
            remoteObjects: group.remoteObjects.map((obj)=>({
                    ...obj,
                    parentId: obj.parentId ?? null
                }))
        }));
const $b0a504e05d35a946$export$b1532bcf7c9b2548 = (spaceKey, sources)=>{
    const [groups, setGroups] = (0, $cozmU.useState)([]);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(true);
    const [isSuppressed, setIsSuppressed] = (0, $cozmU.useState)(false);
    const sourcesKey = sources ? [
        ...sources
    ].sort().join(',') : '';
    const refetch = (0, $cozmU.useCallback)(async ()=>{
        if (!spaceKey) {
            setGroups([]);
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        try {
            const selected = sourcesKey ? sourcesKey.split(',') : [];
            const params = new URLSearchParams();
            selected.forEach((source)=>params.append('sources', source));
            const queryString = params.toString();
            const response = await (0, $f7B1p.cfetch)(`/wiki/rest/internal/1.0/spaces/${spaceKey}/remote-objects/suggestions${queryString ? `?${queryString}` : ''}`, {
                method: 'GET'
            });
            const data = await response.json();
            setGroups($b0a504e05d35a946$var$normalizeParentIds(data.suggestions ?? []));
            setIsSuppressed(false);
        } catch (error) {
            if ((0, $hBkCm.BadStatusError).isBadStatusError(error) && error.response.status === 404) setIsSuppressed(true);
        } finally{
            setIsLoading(false);
        }
    }, [
        spaceKey,
        sourcesKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
        refetch();
    }, [
        refetch
    ]);
    return {
        groups: groups,
        isLoading: isLoading,
        refetch: refetch,
        isSuppressed: isSuppressed
    };
};


/**
 * @generated SignedSource<<08247c0e3353f502c6ab48ec21242ef6>>
 * @relayHash 0ca6fbc81dc6db0a2b75e5e31688f8f2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7b02565943ba78281f88347582fa278755748b9ab1ccdcdbaf5300a1ad8b36d1
const $f039663526f9375a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_remoteObjectAvailableSources"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFetchAvailableSourcesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFetchAvailableSourcesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "0ca6fbc81dc6db0a2b75e5e31688f8f2",
            "id": "7b02565943ba78281f88347582fa278755748b9ab1ccdcdbaf5300a1ad8b36d1",
            "metadata": {},
            "name": "useFetchAvailableSourcesQuery",
            "operationKind": "query",
            "text": "query useFetchAvailableSourcesQuery($cloudId:ID!,$spaceKey:String!){confluence_remoteObjectAvailableSources(cloudId:$cloudId,spaceKey:$spaceKey)}"
        }
    };
}();
$f039663526f9375a$var$node.hash = "965970e949d0f5bb2e85206332f80ad9";
var $f039663526f9375a$export$2e2bcd8739ae039 = $f039663526f9375a$var$node;








const $be72420aa1928141$export$4d5f1f6a2bca3255 = (0, $f039663526f9375a$export$2e2bcd8739ae039);
const $be72420aa1928141$export$e83bdb5bee7fb6bb = ({ spaceKey: spaceKey, cloudId: cloudId, skip: skip = false })=>{
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($be72420aa1928141$export$4d5f1f6a2bca3255, {
        variables: {
            cloudId: cloudId,
            spaceKey: spaceKey ?? ''
        },
        skip: skip || !spaceKey,
        interopApolloAggClient: true,
        __callerPackage__: "space-curation"
    });
    const availableSources = (0, $cozmU.useMemo)(()=>{
        const raw = data?.confluence_remoteObjectAvailableSources;
        if (!raw) return [];
        return [
            ...new Set(raw.filter((source)=>Boolean(source)))
        ];
    }, [
        data
    ]);
    return {
        availableSources: availableSources,
        isLoading: loading
    };
};






var $1kHsc = parcelRequire("1kHsc");




const $b3f0a9dc40fecba0$var$NAME = (0, $irVI7.SPACE_CURATION_REVIEW_SUGGESTIONS_EXPERIENCE);
const $b3f0a9dc40fecba0$export$c8d4c1de2c630478 = ()=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $cozmU.useEffect)(()=>{
        experienceTracker.start({
            name: $b3f0a9dc40fecba0$var$NAME
        });
        return ()=>{
            const state = experienceTracker.getExperienceState($b3f0a9dc40fecba0$var$NAME);
            if (state && !state.hasStopped) experienceTracker.abort({
                name: $b3f0a9dc40fecba0$var$NAME,
                reason: 'Modal closed before suggestions rendered'
            });
        };
    }, [
        experienceTracker
    ]);
    return (0, $cozmU.useMemo)(()=>({
            succeed: ()=>experienceTracker.succeed({
                    name: $b3f0a9dc40fecba0$var$NAME
                }),
            fail: ()=>experienceTracker.fail({
                    name: $b3f0a9dc40fecba0$var$NAME,
                    error: new Error('Space curation review modal rendered zero suggestions')
                }),
            abortNotProvisioned: ()=>experienceTracker.abort({
                    name: $b3f0a9dc40fecba0$var$NAME,
                    reason: 'Suggestions endpoint returned 404 (feature not provisioned)'
                })
        }), [
        experienceTracker
    ]);
};


/* eslint-disable @atlassian/perf-linting/no-quadratic-complexity */ 








const $f140ec3197f8db13$var$hashStringToInt = (str)=>{
    let hash = 5381;
    for(let i = 0; i < str.length; i++)// eslint-disable-next-line no-bitwise
    hash = hash * 33 ^ str.charCodeAt(i);
    // eslint-disable-next-line no-bitwise
    return hash >>> 0;
};
const $f140ec3197f8db13$export$b647b214edf4111 = (suggestion, titlesByContentId)=>{
    const { explanation: explanation, relatedPages: relatedPages } = suggestion;
    const hasExplanation = Boolean(explanation);
    const firstRelatedPageId = relatedPages?.[0];
    const relatedPageTitle = firstRelatedPageId ? titlesByContentId.get(String(firstRelatedPageId)) ?? '' : '';
    const hasRelated = relatedPageTitle.length > 0;
    const candidates = [];
    if (hasRelated) candidates.push('related');
    if (hasExplanation) candidates.push('explanation');
    if (candidates.length === 0) return null;
    return candidates[$f140ec3197f8db13$var$hashStringToInt(suggestion.id) % candidates.length];
};


function $1bc25cf918df8e30$export$6ec3dc3eba258cc5({ spaceId: spaceId, spaceKey: spaceKey, orderedSuggestions: orderedSuggestions, titlesByContentId: titlesByContentId, selectedItems: selectedItems, rejectedItems: rejectedItems, isLoading: isLoading, isFetchingSuggestions: isFetchingSuggestions, isSuppressed: isSuppressed, isFilterApplied: isFilterApplied, filterKey: filterKey, modalOpenTimestamp: modalOpenTimestamp, reviewSuggestionsExperience: reviewSuggestionsExperience }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const openTimestampRef = (0, $cozmU.useRef)(modalOpenTimestamp ?? Date.now());
    const dismissMethodRef = (0, $cozmU.useRef)('close_button');
    const latestValuesRef = (0, $cozmU.useRef)({
        spaceId: spaceId,
        spaceKey: spaceKey,
        orderedSuggestions: orderedSuggestions,
        titlesByContentId: titlesByContentId,
        selectedItems: selectedItems,
        rejectedItems: rejectedItems,
        createAnalyticsEvent: createAnalyticsEvent
    });
    latestValuesRef.current = {
        spaceId: spaceId,
        spaceKey: spaceKey,
        orderedSuggestions: orderedSuggestions,
        titlesByContentId: titlesByContentId,
        selectedItems: selectedItems,
        rejectedItems: rejectedItems,
        createAnalyticsEvent: createAnalyticsEvent
    };
    const hasFiredScreenEventRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (hasFiredScreenEventRef.current) return;
        if (isFetchingSuggestions) return;
        hasFiredScreenEventRef.current = true;
        const { spaceId: si, spaceKey: sk, orderedSuggestions: suggestions, createAnalyticsEvent: cae } = latestValuesRef.current;
        cae({
            type: 'sendScreenEvent',
            data: {
                name: 'curationModule',
                source: 'containerNavigation',
                attributes: {
                    spaceId: si,
                    spaceKey: sk,
                    suggestionCount: suggestions.length
                }
            }
        }).fire();
    }, [
        isFetchingSuggestions
    ]);
    const renderedFilterKeyRef = (0, $cozmU.useRef)(null);
    const observedFetchForKeyRef = (0, $cozmU.useRef)(null);
    const hasConcludedExperienceRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (isFetchingSuggestions) {
            observedFetchForKeyRef.current = filterKey;
            return;
        }
        if (isLoading) return;
        if (renderedFilterKeyRef.current === filterKey) return;
        const isInitialRender = renderedFilterKeyRef.current === null;
        if (!isInitialRender && observedFetchForKeyRef.current !== filterKey) return;
        const { spaceId: si, spaceKey: sk, orderedSuggestions: suggestions, titlesByContentId: titles, createAnalyticsEvent: cae } = latestValuesRef.current;
        const renderedSuggestions = suggestions.map((s, rankIndex)=>({
                suggestionId: s.id,
                suggestionUrl: s.url,
                sourceType: (0, $k8jyJ.getSuggestionProductKeyFromContentUrl)(s.url),
                providerId: s.providerId,
                rankIndex: rankIndex,
                suggestedParentId: s.parentId,
                reasoningType: (0, $f140ec3197f8db13$export$b647b214edf4111)(s, titles),
                score: s.score
            }));
        renderedFilterKeyRef.current = filterKey;
        cae({
            type: 'sendTrackEvent',
            data: {
                action: 'rendered',
                actionSubject: 'suggestions',
                source: 'containerNavigation',
                attributes: {
                    spaceId: si,
                    spaceKey: sk,
                    modalLoadLatencyMs: Math.max(0, Date.now() - openTimestampRef.current),
                    suggestions: renderedSuggestions,
                    filterKey: isFilterApplied ? filterKey : undefined
                }
            }
        }).fire();
        if (!hasConcludedExperienceRef.current) {
            if (isSuppressed) {
                hasConcludedExperienceRef.current = true;
                reviewSuggestionsExperience.abortNotProvisioned();
            } else if (renderedSuggestions.length > 0) {
                hasConcludedExperienceRef.current = true;
                reviewSuggestionsExperience.succeed();
            } else if (!isFilterApplied) {
                hasConcludedExperienceRef.current = true;
                reviewSuggestionsExperience.fail();
            }
        }
    }, [
        isFetchingSuggestions,
        isLoading,
        filterKey,
        isSuppressed,
        isFilterApplied,
        reviewSuggestionsExperience
    ]);
    (0, $cozmU.useEffect)(()=>{
        const handleKeyDown = (e)=>{
            if (e.key === 'Escape') dismissMethodRef.current = 'escape';
        };
        document.addEventListener('keydown', handleKeyDown);
        return ()=>document.removeEventListener('keydown', handleKeyDown);
    }, []);
    const fireDismissed = (0, $cozmU.useCallback)(()=>{
        const { spaceId: si, spaceKey: sk, orderedSuggestions: suggestions, rejectedItems: rejected, createAnalyticsEvent: cae } = latestValuesRef.current;
        const rejectedSuggestions = suggestions.filter((s)=>rejected.has(s.id)).map((s)=>({
                suggestionId: s.id,
                suggestionUrl: s.url,
                sourceType: (0, $k8jyJ.getSuggestionProductKeyFromContentUrl)(s.url),
                providerId: s.providerId
            }));
        cae({
            type: 'sendUIEvent',
            data: {
                action: 'dismissed',
                actionSubject: 'curationModule',
                source: 'containerNavigation',
                attributes: {
                    spaceId: si,
                    spaceKey: sk,
                    suggestionCountAtDismiss: suggestions.length,
                    dismissMethod: dismissMethodRef.current,
                    timeInModuleMs: Date.now() - openTimestampRef.current,
                    rejectedItemCount: rejected.size,
                    rejectedSuggestions: rejectedSuggestions
                }
            }
        }).fire();
        dismissMethodRef.current = 'close_button';
    }, []);
    const fireAccepted = (0, $cozmU.useCallback)(()=>{
        const { spaceId: si, spaceKey: sk, orderedSuggestions: suggestions, titlesByContentId: titles, selectedItems: selected, rejectedItems: rejected, createAnalyticsEvent: cae } = latestValuesRef.current;
        const suggestionAcceptancePayload = (s)=>({
                suggestionId: s.id,
                suggestionUrl: s.url,
                sourceType: (0, $k8jyJ.getSuggestionProductKeyFromContentUrl)(s.url),
                providerId: s.providerId,
                targetFolderId: s.parentId,
                folderWasRecommended: true,
                reasoningType: (0, $f140ec3197f8db13$export$b647b214edf4111)(s, titles),
                score: s.score
            });
        const acceptedSuggestions = suggestions.filter((s)=>selected.has(s.id)).map(suggestionAcceptancePayload);
        const dismissedSuggestions = suggestions.filter((s)=>!selected.has(s.id) && !rejected.has(s.id)).map(suggestionAcceptancePayload);
        const rejectedSuggestions = suggestions.filter((s)=>rejected.has(s.id)).map(suggestionAcceptancePayload);
        cae({
            type: 'sendTrackEvent',
            data: {
                action: 'accepted',
                actionSubject: 'suggestions',
                source: 'containerNavigation',
                attributes: {
                    spaceId: si,
                    spaceKey: sk,
                    count: acceptedSuggestions.length,
                    acceptedSuggestions: acceptedSuggestions,
                    dismissedSuggestions: dismissedSuggestions,
                    rejectedSuggestions: rejectedSuggestions
                }
            }
        }).fire();
        acceptedSuggestions.forEach((s)=>{
            cae({
                type: 'sendTrackEvent',
                data: {
                    action: 'createdByFlow',
                    actionSubject: 'content',
                    objectType: 'embed',
                    containerType: 'space',
                    containerId: si,
                    source: 'containerNavigation',
                    attributes: {
                        spaceId: si,
                        spaceKey: sk,
                        contentType: 'embed',
                        flow: 'spaceCuration',
                        suggestionId: s.suggestionId,
                        sourceType: s.sourceType,
                        providerId: s.providerId
                    }
                }
            }).fire();
        });
    }, []);
    const fireSubmitFailed = (0, $cozmU.useCallback)(()=>{
        const { spaceId: si, spaceKey: sk, orderedSuggestions: suggestions, selectedItems: selected, rejectedItems: rejected, createAnalyticsEvent: cae } = latestValuesRef.current;
        const attemptedSuggestionPayload = (s)=>({
                suggestionId: s.id,
                suggestionUrl: s.url,
                sourceType: (0, $k8jyJ.getSuggestionProductKeyFromContentUrl)(s.url),
                providerId: s.providerId
            });
        const acceptedSuggestions = suggestions.filter((s)=>selected.has(s.id)).map(attemptedSuggestionPayload);
        const rejectedSuggestions = suggestions.filter((s)=>rejected.has(s.id)).map(attemptedSuggestionPayload);
        cae({
            type: 'sendOperationalEvent',
            data: {
                action: 'failed',
                actionSubject: 'suggestions',
                source: 'containerNavigation',
                attributes: {
                    spaceId: si,
                    spaceKey: sk,
                    acceptedCount: acceptedSuggestions.length,
                    rejectedCount: rejectedSuggestions.length,
                    acceptedSuggestions: acceptedSuggestions,
                    rejectedSuggestions: rejectedSuggestions
                }
            }
        }).fire();
    }, []);
    return {
        openTimestamp: openTimestampRef.current,
        fireDismissed: fireDismissed,
        fireAccepted: fireAccepted,
        fireSubmitFailed: fireSubmitFailed
    };
}
function $1bc25cf918df8e30$export$180fd386dd30f08f({ spaceId: spaceId, spaceKey: spaceKey, reason: reason, openTimestamp: openTimestamp }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const hasFiredErrorEventRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (hasFiredErrorEventRef.current) return;
        hasFiredErrorEventRef.current = true;
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'curationModuleErrorState',
                source: 'containerNavigation',
                attributes: {
                    spaceId: spaceId,
                    spaceKey: spaceKey,
                    reason: reason,
                    modalLoadLatencyMs: Math.max(0, Date.now() - openTimestamp)
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        spaceId,
        spaceKey,
        reason,
        openTimestamp
    ]);
}
function $1bc25cf918df8e30$export$39012d7f97d73746({ spaceId: spaceId, spaceKey: spaceKey }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const latestValuesRef = (0, $cozmU.useRef)({
        spaceId: spaceId,
        spaceKey: spaceKey,
        createAnalyticsEvent: createAnalyticsEvent
    });
    latestValuesRef.current = {
        spaceId: spaceId,
        spaceKey: spaceKey,
        createAnalyticsEvent: createAnalyticsEvent
    };
    const fireSuggestionClicked = (0, $cozmU.useCallback)((suggestion)=>{
        const { spaceId: si, spaceKey: sk, createAnalyticsEvent: cae } = latestValuesRef.current;
        cae({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'suggestion',
                source: 'containerNavigation',
                attributes: {
                    spaceId: si,
                    spaceKey: sk,
                    suggestionId: suggestion.id,
                    suggestionUrl: suggestion.url,
                    suggestedParentId: suggestion.parentId,
                    sourceType: (0, $k8jyJ.getSuggestionProductKeyFromContentUrl)(suggestion.url),
                    providerId: suggestion.providerId,
                    score: suggestion.score
                }
            }
        }).fire();
    }, []);
    return {
        fireSuggestionClicked: fireSuggestionClicked
    };
}
const $1bc25cf918df8e30$var$SUGGESTION_PREVIEW_MIN_DWELL_MS = 500;
function $1bc25cf918df8e30$export$92bdbf4fb19eb351({ spaceId: spaceId, spaceKey: spaceKey }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const latestValuesRef = (0, $cozmU.useRef)({
        spaceId: spaceId,
        spaceKey: spaceKey,
        createAnalyticsEvent: createAnalyticsEvent
    });
    latestValuesRef.current = {
        spaceId: spaceId,
        spaceKey: spaceKey,
        createAnalyticsEvent: createAnalyticsEvent
    };
    const previewedSuggestionRef = (0, $cozmU.useRef)(null);
    const previewStartRef = (0, $cozmU.useRef)(null);
    const firePreviewed = (0, $cozmU.useCallback)(()=>{
        const suggestion = previewedSuggestionRef.current;
        const startedAt = previewStartRef.current;
        previewedSuggestionRef.current = null;
        previewStartRef.current = null;
        if (!suggestion || startedAt === null) return;
        const previewDwellMs = Date.now() - startedAt;
        if (previewDwellMs < $1bc25cf918df8e30$var$SUGGESTION_PREVIEW_MIN_DWELL_MS) return;
        const { spaceId: si, spaceKey: sk, createAnalyticsEvent: cae } = latestValuesRef.current;
        cae({
            type: 'sendUIEvent',
            data: {
                action: 'previewed',
                actionSubject: 'suggestion',
                source: 'containerNavigation',
                attributes: {
                    spaceId: si,
                    spaceKey: sk,
                    suggestionId: suggestion.id,
                    suggestionUrl: suggestion.url,
                    suggestedParentId: suggestion.parentId,
                    sourceType: (0, $k8jyJ.getSuggestionProductKeyFromContentUrl)(suggestion.url),
                    providerId: suggestion.providerId,
                    previewDwellMs: previewDwellMs
                }
            }
        }).fire();
    }, []);
    const trackPreviewChange = (0, $cozmU.useCallback)((suggestion)=>{
        if (previewedSuggestionRef.current?.id === suggestion?.id) return;
        firePreviewed();
        previewedSuggestionRef.current = suggestion;
        previewStartRef.current = suggestion ? Date.now() : null;
    }, [
        firePreviewed
    ]);
    const flushPreviewAnalytics = (0, $cozmU.useCallback)(()=>{
        firePreviewed();
    }, [
        firePreviewed
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            firePreviewed();
        };
    }, [
        firePreviewed
    ]);
    return {
        trackPreviewChange: trackPreviewChange,
        flushPreviewAnalytics: flushPreviewAnalytics
    };
}




var $e0Gob = parcelRequire("e0Gob");





var $iLX84 = parcelRequire("iLX84");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");

const $444ac254b74f8acb$var$CreatorInfoQuery = (0, $iLX84.default)`query useCreatorInfoQuery($accountIds:[ID!]!){users(accountIds:$accountIds){accountId name picture}}`;
const $444ac254b74f8acb$export$949ad1c6f51713db = (accountIds)=>{
    const [creatorInfoMap, setCreatorInfoMap] = (0, $cozmU.useState)(new Map());
    const uniqueIds = (0, $cozmU.useMemo)(()=>[
            ...new Set(accountIds.filter(Boolean))
        ], [
        accountIds
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (uniqueIds.length === 0) {
            setCreatorInfoMap(new Map());
            return;
        }
        let cancelled = false;
        (async ()=>{
            try {
                const { data: data, error: error } = await (0, $c0rhi.queryInterop)({
                    query: $444ac254b74f8acb$var$CreatorInfoQuery,
                    variables: {
                        accountIds: uniqueIds
                    },
                    forceRelay: false,
                    interopApolloAggClient: true,
                    __callerPackage__: "space-curation"
                });
                if (cancelled) return;
                error?.graphQLErrors?.forEach((e)=>(0, $7Sm4c.markErrorAsHandled)(e));
                const map = new Map();
                if (data?.users) {
                    for (const user of data.users)if (user?.accountId && user.name) map.set(user.accountId, {
                        displayName: user.name,
                        avatarUrl: user.picture || `/wiki/aa-avatar/${user.accountId}`
                    });
                }
                setCreatorInfoMap(map);
            } catch (err) {
                // Non-critical: preview will just not show author info
                if (err instanceof Error) (0, $7Sm4c.markErrorAsHandled)(err);
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        uniqueIds
    ]);
    return creatorInfoMap;
};








const $9e42ae08d7ac1183$var$LOOM_VIDEO_THUMBNAIL_OPERATION = 'LoomVideoThumbnailHydration';
const $9e42ae08d7ac1183$var$LOOM_VIDEO_THUMBNAIL_QUERY = `
	query LoomVideoThumbnailHydration($ids: [ID!]!) {
		loom_videos(ids: $ids) {
			id
			thumbnails {
				default
				static
			}
		}
	}
`;
/**
 * Returns true if the ARI belongs to a video entity (e.g. Loom).
 * Video ARIs from Data Depot follow the pattern: ari:cloud:graph::video/...
 */ function $9e42ae08d7ac1183$var$isVideoAri(ari) {
    return ari.includes('::video/');
}
/**
 * Extracts the Loom video ID from a loom.com share URL.
 * e.g. "https://www.loom.com/share/abc123" → "abc123"
 */ function $9e42ae08d7ac1183$var$extractLoomVideoId(url) {
    try {
        const parsed = new URL(url);
        if (!parsed.hostname.includes('loom.com')) return null;
        const parts = parsed.pathname.split('/');
        const shareIndex = parts.indexOf('share');
        if (shareIndex >= 0 && shareIndex + 1 < parts.length) return parts[shareIndex + 1];
        return null;
    } catch  {
        return null;
    }
}
/**
 * Constructs a proper Loom video ARI from its components.
 * Format: ari:cloud:loom:{cloudId}:video/activation/{activationId}/{videoId}
 */ function $9e42ae08d7ac1183$var$buildLoomAri(cloudId, activationId, videoId) {
    return `ari:cloud:loom:${cloudId}:video/activation/${activationId}/${videoId}`;
}
/**
 * Fetch fresh Loom video thumbnails directly from AGG's loom_videos query.
 * The suggestions API stores Loom thumbnail URLs from Data Depot with signed tokens
 * that are expired by the time we render them. This function queries AGG's loom_videos
 * field directly to get fresh signed URLs, similar to how SmartLinks resolves Loom thumbnails.
 */ async function $9e42ae08d7ac1183$var$fetchLoomVideoThumbnails(entityIdToUrl, cloudId, activationId) {
    const loomAriToEntityId = new Map();
    for (const [entityId, url] of entityIdToUrl){
        const loomVideoId = $9e42ae08d7ac1183$var$extractLoomVideoId(url);
        if (loomVideoId) {
            const loomAri = $9e42ae08d7ac1183$var$buildLoomAri(cloudId, activationId, loomVideoId);
            loomAriToEntityId.set(loomAri, entityId);
        }
    }
    if (loomAriToEntityId.size === 0) return {
        thumbnails: new Map()
    };
    const loomAris = [
        ...loomAriToEntityId.keys()
    ];
    try {
        const response = await (0, $f7B1p.cfetch)(`/gateway/api/graphql?q=${$9e42ae08d7ac1183$var$LOOM_VIDEO_THUMBNAIL_OPERATION}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: $9e42ae08d7ac1183$var$LOOM_VIDEO_THUMBNAIL_QUERY,
                variables: {
                    ids: loomAris
                },
                operationName: $9e42ae08d7ac1183$var$LOOM_VIDEO_THUMBNAIL_OPERATION
            })
        });
        const json = await response.json();
        if (json.errors?.length) return {
            error: new Error(json.errors.map((e)=>e.message ?? 'GraphQL error').join('; '))
        };
        const thumbnails = new Map();
        // Build a reverse lookup from video ID suffix → entity ID for fallback matching.
        // The returned ARI may have a different activationId than what we sent.
        const videoIdToEntityId = new Map();
        const loomAriEntries = Array.from(loomAriToEntityId.entries());
        for(let i = 0; i < loomAriEntries.length; i++){
            const [loomAri, graphEntityId] = loomAriEntries[i];
            const lastSlash = loomAri.lastIndexOf('/');
            if (lastSlash >= 0) videoIdToEntityId.set(loomAri.substring(lastSlash + 1), graphEntityId);
        }
        const videos = json.data?.loom_videos ?? [];
        for(let i = 0; i < videos.length; i++){
            const video = videos[i];
            const thumbnailUrl = video.thumbnails?.static ?? video.thumbnails?.default;
            if (!video.id || !thumbnailUrl) continue;
            let entityId = loomAriToEntityId.get(video.id);
            if (!entityId) {
                const lastSlash = video.id.lastIndexOf('/');
                const returnedVideoId = lastSlash >= 0 ? video.id.substring(lastSlash + 1) : '';
                entityId = videoIdToEntityId.get(returnedVideoId);
            }
            if (entityId) thumbnails.set(entityId, thumbnailUrl);
        }
        return {
            thumbnails: thumbnails
        };
    } catch (e) {
        return {
            error: e instanceof Error ? e : new Error('Failed to fetch Loom video thumbnails')
        };
    }
}
const $9e42ae08d7ac1183$export$faa6742940bdf3c4 = (suggestions, cloudId, activationId)=>{
    const [state, dispatch] = (0, $cozmU.useReducer)((_prev, next)=>next, {
        thumbnailsByEntityId: new Map(),
        isLoading: false,
        error: null
    });
    // Build a stable key from video entity IDs
    const videoEntries = [];
    for (const s of suggestions)if ($9e42ae08d7ac1183$var$isVideoAri(s.id)) videoEntries.push([
        s.id,
        s.url
    ]);
    const stableKey = JSON.stringify(videoEntries);
    const fetchThumbnails = (0, $cozmU.useCallback)(async ()=>{
        const entries = JSON.parse(stableKey);
        if (entries.length === 0) return;
        const entityIdToUrl = new Map(entries);
        const result = await $9e42ae08d7ac1183$var$fetchLoomVideoThumbnails(entityIdToUrl, cloudId, activationId);
        const hasError = 'error' in result;
        const thumbnails = hasError ? new Map() : result.thumbnails;
        // Preload images so they render instantly when the component uses the URL
        const preloadPromises = [];
        for (const [, url] of thumbnails)preloadPromises.push(new Promise((resolve)=>{
            const img = new Image();
            img.onload = ()=>resolve();
            img.onerror = ()=>resolve();
            img.src = url;
        }));
        await Promise.all(preloadPromises);
        dispatch({
            thumbnailsByEntityId: thumbnails,
            isLoading: false,
            error: hasError ? result.error : null
        });
    }, [
        stableKey,
        cloudId,
        activationId
    ]);
    (0, $cozmU.useEffect)(()=>{
        fetchThumbnails();
    }, [
        fetchThumbnails
    ]);
    return state;
};


var $90c94b26b50862e3$exports = {};
$90c94b26b50862e3$exports = new URL("preview-thumbnail-fallback.2f93bc33.svg", import.meta.url).toString();


/* SuggestionFeedbackModal.tsx generated by @compiled/babel-plugin v3.0.1 */ 





















var $fEPJS = parcelRequire("fEPJS");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");

















var $e3Wrf = parcelRequire("e3Wrf");










const $fdaa5fb91b997659$var$i18n = (0, $kSwu1.defineMessages)({
    modalTitle: {
        id: "space-curation.suggestion-feedback-modal.title",
        defaultMessage: "Rate suggestion quality"
    },
    part1Header: {
        id: "space-curation.suggestion-feedback-modal.part1-header",
        defaultMessage: "Part 1: Core Content & Placement"
    },
    part2Header: {
        id: "space-curation.suggestion-feedback-modal.part2-header",
        defaultMessage: "Part 2: Context & Quality"
    },
    skipLabel: {
        id: "space-curation.suggestion-feedback-modal.skip-label",
        defaultMessage: "Skip / I do not know"
    },
    submitButton: {
        id: "space-curation.suggestion-feedback-modal.submit",
        defaultMessage: "Submit"
    },
    cancelButton: {
        id: "space-curation.suggestion-feedback-modal.cancel",
        defaultMessage: "Cancel"
    },
    topicalRelevanceTitle: {
        id: "space-curation.suggestion-feedback-modal.topical-relevance.title",
        defaultMessage: "Topical Relevance"
    },
    topicalRelevanceQuestion: {
        id: "space-curation.suggestion-feedback-modal.topical-relevance.question",
        defaultMessage: "Is the document about the same topic as the space?"
    },
    topicalRelevance3: {
        id: "space-curation.suggestion-feedback-modal.topical-relevance.3",
        defaultMessage: "Highly Relevant \u2013 Core part of this topic."
    },
    topicalRelevance2: {
        id: "space-curation.suggestion-feedback-modal.topical-relevance.2",
        defaultMessage: "Related \u2013 Shares the same theme but is tangential."
    },
    topicalRelevance1: {
        id: "space-curation.suggestion-feedback-modal.topical-relevance.1",
        defaultMessage: "Slightly Related \u2013 Only a small portion fits."
    },
    topicalRelevance0: {
        id: "space-curation.suggestion-feedback-modal.topical-relevance.0",
        defaultMessage: "Irrelevant \u2013 No logical connection."
    },
    placementTitle: {
        id: "space-curation.suggestion-feedback-modal.placement.title",
        defaultMessage: "Placement"
    },
    placementQuestion: {
        id: "space-curation.suggestion-feedback-modal.placement.question",
        defaultMessage: "Is this the right folder suggestion for this content?"
    },
    placement2: {
        id: "space-curation.suggestion-feedback-modal.placement.2",
        defaultMessage: "Perfect Fit \u2013 Exactly where it belongs."
    },
    placement1: {
        id: "space-curation.suggestion-feedback-modal.placement.1",
        defaultMessage: "Acceptable \u2013 Not the best spot, but makes sense."
    },
    placement0: {
        id: "space-curation.suggestion-feedback-modal.placement.0",
        defaultMessage: "Incorrect \u2013 Placement is confusing or wrong."
    },
    usefulnessTitle: {
        id: "space-curation.suggestion-feedback-modal.usefulness.title",
        defaultMessage: "Usefulness"
    },
    usefulnessQuestion: {
        id: "space-curation.suggestion-feedback-modal.usefulness.question",
        defaultMessage: "Would this doc actually help someone working in this space?"
    },
    usefulness4: {
        id: "space-curation.suggestion-feedback-modal.usefulness.4",
        defaultMessage: "Essential \u2013 Crucial; the space is incomplete without it."
    },
    usefulness3: {
        id: "space-curation.suggestion-feedback-modal.usefulness.3",
        defaultMessage: "Helpful \u2013 Adds clear value and saves time."
    },
    usefulness2: {
        id: "space-curation.suggestion-feedback-modal.usefulness.2",
        defaultMessage: "Neutral \u2013 Belongs there, but doesn't change much."
    },
    usefulness1: {
        id: "space-curation.suggestion-feedback-modal.usefulness.1",
        defaultMessage: "Not Very Useful \u2013 Low-value or \"fluff.\""
    },
    usefulness0: {
        id: "space-curation.suggestion-feedback-modal.usefulness.0",
        defaultMessage: "Counter-productive \u2013 Distracting or adds noise."
    },
    redundancyTitle: {
        id: "space-curation.suggestion-feedback-modal.redundancy.title",
        defaultMessage: "Redundancy (Uniqueness)"
    },
    redundancyQuestion: {
        id: "space-curation.suggestion-feedback-modal.redundancy.question",
        defaultMessage: "Does the doc add info not already in the space?"
    },
    redundancy3: {
        id: "space-curation.suggestion-feedback-modal.redundancy.3",
        defaultMessage: "Entirely New \u2013 Information not found elsewhere in the space."
    },
    redundancy2: {
        id: "space-curation.suggestion-feedback-modal.redundancy.2",
        defaultMessage: "Mostly New \u2013 Some overlap, but provides new insights."
    },
    redundancy1: {
        id: "space-curation.suggestion-feedback-modal.redundancy.1",
        defaultMessage: "High Overlap \u2013 Repeats most of what is already there."
    },
    redundancy0: {
        id: "space-curation.suggestion-feedback-modal.redundancy.0",
        defaultMessage: "Redundant \u2013 Information is already present (duplicate/near-duplicate)."
    },
    explainabilityTitle: {
        id: "space-curation.suggestion-feedback-modal.explainability.title",
        defaultMessage: "Explainability"
    },
    explainabilityQuestion: {
        id: "space-curation.suggestion-feedback-modal.explainability.question",
        defaultMessage: "Is it clear why this document was recommended for this space?"
    },
    explainability2: {
        id: "space-curation.suggestion-feedback-modal.explainability.2",
        defaultMessage: "Very Clear \u2013 I immediately see the connection."
    },
    explainability1: {
        id: "space-curation.suggestion-feedback-modal.explainability.1",
        defaultMessage: "Vaguely Clear \u2013 I can see a possible link, but it's weak."
    },
    explainability0: {
        id: "space-curation.suggestion-feedback-modal.explainability.0",
        defaultMessage: "Not Clear \u2013 The suggestion feels random or \"black box.\""
    },
    recencyTitle: {
        id: "space-curation.suggestion-feedback-modal.recency.title",
        defaultMessage: "Recency & Freshness"
    },
    recencyQuestion: {
        id: "space-curation.suggestion-feedback-modal.recency.question",
        defaultMessage: "How would you characterize the timeliness of this document?"
    },
    recency2: {
        id: "space-curation.suggestion-feedback-modal.recency.2",
        defaultMessage: "Current/Evergreen \u2013 Information is up-to-date or foundational (always useful)."
    },
    recency1: {
        id: "space-curation.suggestion-feedback-modal.recency.1",
        defaultMessage: "Historical Reference \u2013 Older but still holds some context or \"lesson learned\" value."
    },
    recency0: {
        id: "space-curation.suggestion-feedback-modal.recency.0",
        defaultMessage: "Obsolete \u2013 The information is expired, superseded, or no longer true."
    },
    permissionsPrivacyTitle: {
        id: "space-curation.suggestion-feedback-modal.permissions-privacy.title",
        defaultMessage: "Permissions & Privacy"
    },
    permissionsPrivacyQuestion: {
        id: "space-curation.suggestion-feedback-modal.permissions-privacy.question",
        defaultMessage: "Does it feel appropriate for this document to be surfaced here?"
    },
    permissionsPrivacy2: {
        id: "space-curation.suggestion-feedback-modal.permissions-privacy.2",
        defaultMessage: "Appropriate \u2013 Safe for general viewing within the space's context."
    },
    permissionsPrivacy1: {
        id: "space-curation.suggestion-feedback-modal.permissions-privacy.1",
        defaultMessage: "Questionable \u2013 Might contain semi-private info that feels \"odd\" to see."
    },
    permissionsPrivacy0: {
        id: "space-curation.suggestion-feedback-modal.permissions-privacy.0",
        defaultMessage: "Inappropriate \u2013 Contains sensitive or private data that should not be surfaced."
    },
    additionalCommentsLabel: {
        id: "space-curation.suggestion-feedback-modal.additional-comments.label",
        defaultMessage: "Additional comments (optional)"
    },
    additionalCommentsPlaceholder: {
        id: "space-curation.suggestion-feedback-modal.additional-comments.placeholder",
        defaultMessage: "Share any other thoughts about this suggestion\u2026"
    },
    searchSource: {
        id: "space-curation.suggestion-feedback-modal.additional-comments.searchSource",
        defaultMessage: "This suggestion was provided by the search pipeline"
    },
    mlSource: {
        id: "space-curation.suggestion-feedback-modal.additional-comments.mlSource",
        defaultMessage: "This suggestion was provided by the ML pipeline"
    }
});
const $fdaa5fb91b997659$var$FEEDBACK_QUESTIONS = [
    {
        key: 'topicalRelevance',
        part: 1,
        title: $fdaa5fb91b997659$var$i18n.topicalRelevanceTitle,
        question: $fdaa5fb91b997659$var$i18n.topicalRelevanceQuestion,
        options: [
            {
                value: 3,
                label: $fdaa5fb91b997659$var$i18n.topicalRelevance3
            },
            {
                value: 2,
                label: $fdaa5fb91b997659$var$i18n.topicalRelevance2
            },
            {
                value: 1,
                label: $fdaa5fb91b997659$var$i18n.topicalRelevance1
            },
            {
                value: 0,
                label: $fdaa5fb91b997659$var$i18n.topicalRelevance0
            }
        ]
    },
    {
        key: 'placement',
        part: 1,
        title: $fdaa5fb91b997659$var$i18n.placementTitle,
        question: $fdaa5fb91b997659$var$i18n.placementQuestion,
        options: [
            {
                value: 2,
                label: $fdaa5fb91b997659$var$i18n.placement2
            },
            {
                value: 1,
                label: $fdaa5fb91b997659$var$i18n.placement1
            },
            {
                value: 0,
                label: $fdaa5fb91b997659$var$i18n.placement0
            }
        ]
    },
    {
        key: 'usefulness',
        part: 1,
        title: $fdaa5fb91b997659$var$i18n.usefulnessTitle,
        question: $fdaa5fb91b997659$var$i18n.usefulnessQuestion,
        options: [
            {
                value: 4,
                label: $fdaa5fb91b997659$var$i18n.usefulness4
            },
            {
                value: 3,
                label: $fdaa5fb91b997659$var$i18n.usefulness3
            },
            {
                value: 2,
                label: $fdaa5fb91b997659$var$i18n.usefulness2
            },
            {
                value: 1,
                label: $fdaa5fb91b997659$var$i18n.usefulness1
            },
            {
                value: 0,
                label: $fdaa5fb91b997659$var$i18n.usefulness0
            }
        ]
    },
    {
        key: 'redundancy',
        part: 1,
        title: $fdaa5fb91b997659$var$i18n.redundancyTitle,
        question: $fdaa5fb91b997659$var$i18n.redundancyQuestion,
        options: [
            {
                value: 3,
                label: $fdaa5fb91b997659$var$i18n.redundancy3
            },
            {
                value: 2,
                label: $fdaa5fb91b997659$var$i18n.redundancy2
            },
            {
                value: 1,
                label: $fdaa5fb91b997659$var$i18n.redundancy1
            },
            {
                value: 0,
                label: $fdaa5fb91b997659$var$i18n.redundancy0
            }
        ]
    },
    {
        key: 'explainability',
        part: 2,
        title: $fdaa5fb91b997659$var$i18n.explainabilityTitle,
        question: $fdaa5fb91b997659$var$i18n.explainabilityQuestion,
        options: [
            {
                value: 2,
                label: $fdaa5fb91b997659$var$i18n.explainability2
            },
            {
                value: 1,
                label: $fdaa5fb91b997659$var$i18n.explainability1
            },
            {
                value: 0,
                label: $fdaa5fb91b997659$var$i18n.explainability0
            }
        ]
    },
    {
        key: 'recency',
        part: 2,
        title: $fdaa5fb91b997659$var$i18n.recencyTitle,
        question: $fdaa5fb91b997659$var$i18n.recencyQuestion,
        options: [
            {
                value: 2,
                label: $fdaa5fb91b997659$var$i18n.recency2
            },
            {
                value: 1,
                label: $fdaa5fb91b997659$var$i18n.recency1
            },
            {
                value: 0,
                label: $fdaa5fb91b997659$var$i18n.recency0
            }
        ]
    },
    {
        key: 'permissionsPrivacy',
        part: 2,
        title: $fdaa5fb91b997659$var$i18n.permissionsPrivacyTitle,
        question: $fdaa5fb91b997659$var$i18n.permissionsPrivacyQuestion,
        options: [
            {
                value: 2,
                label: $fdaa5fb91b997659$var$i18n.permissionsPrivacy2
            },
            {
                value: 1,
                label: $fdaa5fb91b997659$var$i18n.permissionsPrivacy1
            },
            {
                value: 0,
                label: $fdaa5fb91b997659$var$i18n.permissionsPrivacy0
            }
        ]
    }
];
const $fdaa5fb91b997659$var$styles = {
    partHeader: "_46hvQm5zaO _0xmtko2ADO _3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67 _0rIjyk2ADO",
    questionBlock: "_0xmtko5zaO",
    optionRow: "_2mHwu82ADO _0bjKvDKxmn _23rrnHOUfx _4c065UgVvo _2Y7lL42ADO _2V7sgONvrM _3hxITi6wH8 _3vBAKHjOvk _3iDTPbQ4SZ _0hPCNLDIqT _0wOv4Q7zJH _1eOmH6DMqu",
    optionRowSelected: "_3vBAKHrzt2 _0KLXruY9q9 _1eOmH6sumd",
    optionRowDisabled: "_1YKVNsVx3j _0wOv4Qsyl5 _1eOmH6jOvk",
    radioCircle: "_0bjKvDS5Zs _2V7sgONvrM _3hxITi6wH8 _3vBAKHWkXl _39xV02ey7F _0jFU0Vey7F _3YEZNOdnbC _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    radioCircleSelected: "_3vBAKHrzt2 _0KLXrukLmD",
    radioInnerDot: "_0bjKvDS5Zs _39xV02Zimw _0jFU0VZimw _0KLXru6BYM",
    skipRow: "_46hvQm1Y8M",
    additionalCommentsSection: "_46hvQm5zaO _0xmtko2ADO",
    modalBody: "_4c065U5zaO"
};
const $fdaa5fb91b997659$var$OptionRow = ({ label: label, value: value, questionKey: questionKey, isSelected: isSelected, isDisabled: isDisabled, onSelect: onSelect })=>{
    const handleClick = (0, $cozmU.useCallback)(()=>{
        if (!isDisabled) onSelect(questionKey, value);
    }, [
        isDisabled,
        onSelect,
        questionKey,
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        role: "radio",
        "aria-checked": isSelected,
        "aria-disabled": isDisabled,
        xcss: (0, $w6R6I.cx)($fdaa5fb91b997659$var$styles.optionRow, isSelected && $fdaa5fb91b997659$var$styles.optionRowSelected, isDisabled && $fdaa5fb91b997659$var$styles.optionRowDisabled),
        onClick: handleClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($fdaa5fb91b997659$var$styles.radioCircle, isSelected && $fdaa5fb91b997659$var$styles.radioCircleSelected)
    }, isSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fdaa5fb91b997659$var$styles.radioInnerDot
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, label));
};
const $fdaa5fb91b997659$export$2eae41a486732e13 = ({ suggestion: suggestion, spaceId: spaceId, spaceKey: spaceKey, onClose: onClose, onSubmit: onSubmit })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const [answers, setAnswers] = (0, $cozmU.useState)(()=>Object.fromEntries($fdaa5fb91b997659$var$FEEDBACK_QUESTIONS.map((q)=>[
                q.key,
                null
            ])));
    const [skipped, setSkipped] = (0, $cozmU.useState)(()=>Object.fromEntries($fdaa5fb91b997659$var$FEEDBACK_QUESTIONS.map((q)=>[
                q.key,
                false
            ])));
    const [additionalComments, setAdditionalComments] = (0, $cozmU.useState)('');
    const handleSelectOption = (0, $cozmU.useCallback)((questionKey, value)=>{
        setAnswers((prev)=>({
                ...prev,
                [questionKey]: value
            }));
    }, []);
    const handleToggleSkip = (0, $cozmU.useCallback)((questionKey, checked)=>{
        setSkipped((prev)=>({
                ...prev,
                [questionKey]: checked
            }));
        if (checked) setAnswers((prev)=>({
                ...prev,
                [questionKey]: null
            }));
    }, []);
    const handleSubmit = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'submitted',
                actionSubject: 'suggestionFeedback',
                source: 'containerNavigation',
                attributes: {
                    spaceId: spaceId,
                    spaceKey: spaceKey,
                    userId: userId,
                    suggestionAri: suggestion.id,
                    suggestionUrl: suggestion.url,
                    suggestedParentId: suggestion.parentId,
                    sourceType: (0, $k8jyJ.getSuggestionProductKeyFromContentUrl)(suggestion.url),
                    providerId: suggestion.providerId,
                    topicalRelevance: answers.topicalRelevance,
                    placement: answers.placement,
                    usefulness: answers.usefulness,
                    redundancy: answers.redundancy,
                    explainability: answers.explainability,
                    recency: answers.recency,
                    permissionsPrivacy: answers.permissionsPrivacy,
                    additionalComments: additionalComments.trim() || undefined
                }
            }
        }).fire();
        onSubmit?.();
        onClose();
    }, [
        createAnalyticsEvent,
        spaceId,
        spaceKey,
        suggestion,
        answers,
        additionalComments,
        onClose,
        onSubmit,
        userId
    ]);
    const questionsWithPartHeaders = (0, $cozmU.useMemo)(()=>$fdaa5fb91b997659$var$FEEDBACK_QUESTIONS.map((question, index)=>({
                ...question,
                showPartHeader: index === 0 || question.part !== $fdaa5fb91b997659$var$FEEDBACK_QUESTIONS[index - 1].part
            })), []);
    const handleSkipChange = (0, $cozmU.useCallback)((questionKey)=>(e)=>handleToggleSkip(questionKey, e.target.checked), [
        handleToggleSkip
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
        onClose: onClose,
        width: "medium"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, formatMessage($fdaa5fb91b997659$var$i18n.modalTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, suggestion.providerId?.includes('search') ? formatMessage($fdaa5fb91b997659$var$i18n.searchSource) : suggestion.providerId?.includes('ml-feature-store') && formatMessage($fdaa5fb91b997659$var$i18n.mlSource)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fdaa5fb91b997659$var$styles.modalBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.0"
    }, questionsWithPartHeaders.map((question)=>{
        const isSkipped = skipped[question.key];
        const selectedValue = answers[question.key];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            key: question.key
        }, question.showPartHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $fdaa5fb91b997659$var$styles.partHeader
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, question.part === 1 ? formatMessage($fdaa5fb91b997659$var$i18n.part1Header) : formatMessage($fdaa5fb91b997659$var$i18n.part2Header))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $fdaa5fb91b997659$var$styles.questionBlock
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.075"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "semibold"
        }, formatMessage(question.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtle"
        }, formatMessage(question.question)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            role: "radiogroup",
            "aria-label": formatMessage(question.title)
        }, // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
        question.options.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fdaa5fb91b997659$var$OptionRow, {
                key: option.value,
                label: formatMessage(option.label),
                value: option.value,
                questionKey: question.key,
                isSelected: !isSkipped && selectedValue === option.value,
                isDisabled: isSkipped,
                onSelect: handleSelectOption
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $fdaa5fb91b997659$var$styles.skipRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            label: formatMessage($fdaa5fb91b997659$var$i18n.skipLabel),
            isChecked: isSkipped,
            onChange: handleSkipChange(question.key)
        })))));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fdaa5fb91b997659$var$styles.additionalCommentsSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold"
    }, formatMessage($fdaa5fb91b997659$var$i18n.additionalCommentsLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
        value: additionalComments,
        onChange: (e)=>setAdditionalComments(e.target.value),
        placeholder: formatMessage($fdaa5fb91b997659$var$i18n.additionalCommentsPlaceholder),
        maxLength: 500,
        minimumRows: 3
    })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: onClose
    }, formatMessage($fdaa5fb91b997659$var$i18n.cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handleSubmit
    }, formatMessage($fdaa5fb91b997659$var$i18n.submitButton))));
};






var $10315a023767e43f$exports = {};
$10315a023767e43f$exports = new URL("connect-arrow.348feda5.png", import.meta.url).toString();



var $dJySn = parcelRequire("dJySn");


var $3WMx1 = parcelRequire("3WMx1");

const $e0ce0b995765d610$var$i18n = (0, $kSwu1.defineMessages)({
    addItemsToSpace: {
        id: "space-curation.review-content-suggestions-modal.add-items-to-space",
        defaultMessage: "Add {count, plural, one {# item} other {# items}} to space"
    },
    bringTogetherTitle: {
        id: "space-curation.review-content-suggestions-modal.bring-together-title",
        defaultMessage: "Bring together the content that matters"
    },
    bringTogetherDescription: {
        id: "space-curation.review-content-suggestions-modal.bring-together-description",
        defaultMessage: "Add these suggestions and they'll be organized in this space."
    },
    openSuggestion: {
        id: "space-curation.review-content-suggestions-modal.open-suggestion",
        defaultMessage: "Open {title}"
    },
    feedbackButtonLabel: {
        id: "space-curation.review-content-suggestions-modal.feedback-button-label",
        defaultMessage: "Give feedback on {title}"
    },
    evalButtonLabel: {
        id: "space-curation.review-content-suggestions-modal.eval-button-label",
        defaultMessage: "Eval"
    },
    untitled: {
        id: "space-curation.review-content-suggestions-modal.untitled",
        defaultMessage: "Untitled"
    },
    loading: {
        id: "space-curation.review-content-suggestions-modal.loading",
        defaultMessage: "Loading"
    },
    submitting: {
        id: "space-curation.review-content-suggestions-modal.submitting",
        defaultMessage: "Adding..."
    },
    rejectSuggestion: {
        id: "space-curation.review-content-suggestions-modal.reject-suggestion",
        defaultMessage: "Reject {title}"
    },
    resetSuggestion: {
        id: "space-curation.review-content-suggestions-modal.reset-suggestion",
        defaultMessage: "Restore suggestion"
    },
    addToThisSpace: {
        id: "space-curation.review-content-suggestions-modal.add-to-this-space",
        defaultMessage: "Add to this space"
    },
    socialSignalRelatedPage: {
        id: "space-curation.review-content-suggestions-modal.social-signal-related-page",
        defaultMessage: "Related to <b>{pageName}</b>"
    },
    rejectSuggestionTooltip: {
        id: "space-curation.review-content-suggestions-modal.reject-suggestion-tooltip",
        defaultMessage: "Reject suggestion"
    },
    uncategorized: {
        id: "space-curation.review-content-suggestions-modal.uncategorized",
        defaultMessage: "Uncategorized"
    },
    closeModal: {
        id: "space-curation.review-content-suggestions-modal.close-modal",
        defaultMessage: "Close"
    },
    topRelevantSuggestions: {
        id: "space-curation.review-content-suggestions-modal.top-relevant-suggestions",
        defaultMessage: "Top 5 most relevant suggestions"
    },
    filterEmptyTitle: {
        id: "space-curation.review-content-suggestions-modal.filter-empty-title",
        defaultMessage: "No suggestions match your filters"
    },
    filterEmptyDescription: {
        id: "space-curation.review-content-suggestions-modal.filter-empty-description",
        defaultMessage: "Try removing your source filters to see all available suggestions."
    },
    filterEmptyClearButton: {
        id: "space-curation.review-content-suggestions-modal.filter-empty-clear-button",
        defaultMessage: "Remove filters"
    },
    errorStateHeader: {
        id: "space-curation.review-content-suggestions-modal.error-state-header",
        defaultMessage: "Something went wrong"
    },
    errorStateDescription: {
        id: "space-curation.review-content-suggestions-modal.error-state-description",
        defaultMessage: "We couldn't load suggestions for this space. Try again, or check your network connection."
    },
    errorStateRetryButton: {
        id: "space-curation.review-content-suggestions-modal.error-state-retry-button",
        defaultMessage: "Try again"
    }
});
const $e0ce0b995765d610$var$MODAL_WIDTH = 'calc(100vw - 192px)';
const $e0ce0b995765d610$var$MODAL_HEIGHT = 'calc(100vh - 128px)';
const $e0ce0b995765d610$var$MODAL_MAX_WIDTH = '1280px';
const $e0ce0b995765d610$var$MODAL_MAX_HEIGHT = '720px';
const $e0ce0b995765d610$var$styles = {
    layout: "_0bjKvDyzSk _4bt5LAnQyn _2WAcuGnQyn _39xV02lz2S _0jFU0V4uAA _1EqgXlnM2E _0NUa3r5m2b",
    leftPanel: "_2mHwu8NHnM _4bt5LAnQyn _2WAcuGnQyn _3YEZNOdnbC _1bHrqE715P _3iDTPbQ4SZ _0aFT5vbt8w _46hvQmp0Oa _0xmtkop0Oa _0LQT5Ep0Oa _03SyCPp0Oa",
    rightPanel: "_4bt5LAnQyn _2WAcuGnQyn _2O5Vij7dHp _3iDTPbQ4SZ _0aFT5vbt8w _0KLXrulfZc _1mT5xdRAKS _0mcu6jyzSk _3kIZMxyzSk _0LQT5Ep0Oa",
    closeButtonWrapper: "_1mT5xdWVPG _2IhTon5zaO _4ApkO25zaO _42Yu6BHOnL",
    groupListScrollArea: "_2O5Vij7dHp _2WAcuGIZbP _3oUqlsYbGa _4kiQYAdnbC",
    groupCard: "_0bjKvD8fU6 _4bt5LAnQyn _2WAcuGnQyn _3vBAKH9r67 _2V7sgONvrM _3hxITi6wH8",
    groupRow: "_2mHwu82ADO _46hvQm2ADO _0xmtkoPgdg _0LQT5E8HPE _03SyCP8HPE",
    groupIconSlot: "_39xV02oWWg _0jFU0VoWWg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC",
    groupTitleWrapper: "_4bt5LAnQyn _2WAcuGnQyn _2O5Vij7dHp _4ouGXIdnbC",
    itemsList: "_4bt5LAYvD1 _2WAcuGYvD1 _2Y7lL41Y8M _4kiQYAdnbC _0xmtko1Y8M",
    itemRowContainer: "_23rrnHNQBp _0bjKvD8fU6 _4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS _42Yu6BdnbC _39xV02N91d _1eOmH6o126",
    itemRowContainerHovered: "_42Yu6B7dHp",
    suggestionLinkWrapper: "_2mHwu88HPE _2O5Vij7dHp _4ouGXIdnbC _3iDTPbQ4SZ _0hPCNLchRC",
    suggestionLink: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _3TGfC9LRg7 _4ouGXIdnbC _1UtDYzy7kJ _2O5Vij7dHp _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0DCa9Dy7kJ",
    suggestionDescription: "_4bt5LAnQyn _2WAcuGnQyn _2O5Vij7dHp _4ouGXIdnbC",
    suggestionReasonCallout: "_0bjKvD8fU6 _2mHwu82ADO _43nrzT1Y8M _39xV02N91d _0hPCNLchRC",
    suggestionReasonIcon: "_3iDTPbQ4SZ _3YEZNOdnbC _43nrzT1Y8M",
    suggestionIconSlot: "_39xV02UF4f _0jFU0VUF4f _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC",
    suggestionTitleWrapper: "_4bt5LAnQyn _2WAcuGnQyn _2O5Vij7dHp _4ouGXIdnbC",
    leftPanelHeader: "_0Of8r22ADO",
    contentPreviewContainer: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _2O5Vij7dHp _0hPCNLDIqT _37wbyuDIqT _39xV02N91d _1mT5xdRAKS",
    contentPreviewUnit: "_1mT5xdRAKS _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02N91d _0jFU0Vxf28",
    contentPreviewDecorativeBackground: "_4bt5LAnQyn _2WAcuGnQyn _1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _4ApkO2dnbC _0Bm75GdnbC",
    contentPreviewIllustration: "_1mT5xdRAKS _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT",
    contentPreviewIconTopLeft: "_2mHwu82ADO _23rrnH0bPn _1mT5xdWVPG _2IhTonuNcX _3OE6xYRxTa _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _42Yu6BAM5m",
    contentPreviewIconBottomRight: "_23rrnH0bPn _1mT5xdWVPG _0Bm75GUF4f _4ApkO2Wvdz _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _42Yu6BAM5m",
    contentPreviewIconVisible: "_1YKVNs7dHp",
    contentPreviewIconHidden: "_1YKVNsdnbC _1pp6NdYbGa",
    contentPreviewSparkle: "_1mT5xdWVPG _2IhTonRxTa _4ApkO2Wvdz _1VJPcakyhv _42Yu6BAM5m",
    contentPreviewGoogleDriveIcon: "_1VJPcaZwt9 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    contentPreviewLoomIcon: "_1VJPcasvOR _0GTcwR9LX5",
    contentPreviewArrowTopLeft: "_1VJPcaP6fN _2xTnZxTbio",
    contentPreviewDarkBlueBox: "_1mT5xdWVPG _39xV02qMLO _0jFU0VIkEs _0KLXruDM2k _1VJPcaUsxL _0Bm75GLYhK _3OE6xYLYhK",
    contentPreviewCard: "_4bt5LAYvD1 _2WAcuGYvD1 _3iDTPbQ4SZ _0aFT5vbt8w _39xV02PyJ7 _0jFU0Vn5H1 _0KLXrulfZc _1mT5xdRAKS",
    contentPreviewImageContainer: "_4bt5LAnQyn _2WAcuGnQyn _39xV02N91d _0NUa3rlwhp _3YEZNOdnbC",
    contentPreviewImageFallback: "_39xV02N91d _0jFU0VymWf _0KLXrumhAQ _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    contentPreviewProductLabel: "_3YEZNOdnbC _43nrzTIZbP",
    contentPreviewCardPadding: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4FKVYEkG2W _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w _0xmtko5zaO _39xV02N91d",
    itemRow: "_2mHwu81Y8M _4c065U2ADO _2Y7lL42ADO _1eOmH6o126",
    unselectedLink: "_0DCa9D98eZ _3932vvYbGa _02cRtH6wH8",
    loadingOverlay: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02lz2S _0jFU0V4uAA _1EqgXlnM2E _0NUa3r5m2b",
    errorState: "_1mT5xdRAKS _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02lz2S _0jFU0V4uAA _1EqgXlnM2E _0NUa3r5m2b",
    feedbackIconButton: "_0bjKvDKxmn _4FKVYE1Y8M _23rrnHyKLB _3YEZNOdnbC _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0KLXrujOvk _1eOmH6KcZT",
    thumbsDownButton: "_0bjKvDKxmn _4FKVYE1Y8M _23rrnHyKLB _3YEZNOdnbC _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0KLXrujOvk _1eOmH6KcZT",
    itemRowContainerRejected: "_0KLXruVrZW",
    suggestionsListHeader: "_0LQT5EPgdg _46hvQm2ADO _03SyCP2ADO",
    filterEmptyState: "_4c065UVa5s _2Y7lL45zaO _2fwxA5DIqT"
};
const $e0ce0b995765d610$var$SuggestionItemRow = ({ spaceId: spaceId, spaceKey: spaceKey, suggestion: suggestion, isSelected: isSelected, isRejected: isRejected, hasFeedbackBeenSubmitted: hasFeedbackBeenSubmitted, onFeedbackSubmitted: onFeedbackSubmitted, onToggleSelectItem: onToggleSelectItem, onRejectItem: onRejectItem, onMoveSuggestion: onMoveSuggestion, onSuggestionHover: onSuggestionHover, onSuggestionClick: onSuggestionClick, titlesByContentId: titlesByContentId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const logoKey = (0, $k8jyJ.getSuggestionLogoKeyFromContentUrl)(suggestion.url); // Tracks immediate mouse-over state for row UI elements (Move button, row highlight)
    const [isRowHovered, setIsRowHovered] = (0, $cozmU.useState)(false);
    const [isFeedbackModalOpen, setIsFeedbackModalOpen] = (0, $cozmU.useState)(false);
    const [isMovePopupOpen, setIsMovePopupOpen] = (0, $cozmU.useState)(false);
    const { reasonLabel: reasonLabel, hasReason: hasReason } = (0, $cozmU.useMemo)(()=>{
        const { explanation: explanation, relatedPages: relatedPages } = suggestion;
        const firstRelatedPageId = relatedPages?.[0];
        const relatedPageTitle = firstRelatedPageId ? titlesByContentId.get(String(firstRelatedPageId)) ?? '' : ''; // Reuse the shared resolver so the reason shown here matches the reasoningType logged in analytics.
        const choice = (0, $f140ec3197f8db13$export$b647b214edf4111)(suggestion, titlesByContentId);
        if (choice === null) return {
            reasonLabel: null,
            hasReason: false
        };
        if (choice === 'related') return {
            reasonLabel: formatMessage($e0ce0b995765d610$var$i18n.socialSignalRelatedPage, {
                pageName: relatedPageTitle,
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                        weight: "medium",
                        size: "small",
                        color: isRejected ? 'color.text.disabled' : undefined
                    }, chunks)
            }),
            hasReason: true
        };
        return {
            reasonLabel: explanation,
            hasReason: true
        };
    }, [
        suggestion,
        titlesByContentId,
        formatMessage,
        isRejected
    ]); // Clamp the explanation to the number of lines it occupies at rest, so it truncates (rather
    // than wrapping and growing the row) when hover buttons narrow the callout.
    const descRef = (0, $cozmU.useRef)(null);
    const [descLineCount, setDescLineCount] = (0, $cozmU.useState)(undefined);
    (0, $cozmU.useLayoutEffect)(()=>{
        // Skip while narrowed (hovered / move-popup open) so the clamp reflects the at-rest width.
        if (!hasReason || isRowHovered || isMovePopupOpen) return;
        const el = descRef.current;
        if (!el) return;
        const measure = ()=>{
            // Line-height comes from the Text (its small-size metrics), not the wrapper Box.
            const textEl = el.firstElementChild ?? el;
            const computed = getComputedStyle(textEl);
            let lineHeight = parseFloat(computed.lineHeight);
            if (!Number.isFinite(lineHeight) || lineHeight <= 0) lineHeight = (parseFloat(computed.fontSize) || 16) * 1.4;
            setDescLineCount(Math.max(1, Math.round(el.scrollHeight / lineHeight)));
        };
        measure();
        if (typeof ResizeObserver === 'undefined') return;
        const resizeObserver = new ResizeObserver(measure);
        resizeObserver.observe(el);
        return ()=>resizeObserver.disconnect();
    }, [
        hasReason,
        reasonLabel,
        isRowHovered,
        isMovePopupOpen
    ]);
    const handleShow = ()=>{
        if (isRejected) return;
        setIsRowHovered(true);
        onSuggestionHover?.(suggestion);
    };
    const handleHide = ()=>{
        if (isRejected) return;
        setIsRowHovered(false);
    };
    const handleMovePopupOpenChange = (open)=>{
        setIsMovePopupOpen(open);
        if (open) handleHide();
    };
    (0, $cozmU.useEffect)(()=>{
        if (!isSelected) {
            handleHide();
            handleMovePopupOpenChange(false);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isSelected
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($e0ce0b995765d610$var$styles.itemRowContainer, !isRejected && isRowHovered && $e0ce0b995765d610$var$styles.itemRowContainerHovered, isRejected && $e0ce0b995765d610$var$styles.itemRowContainerRejected),
        onMouseEnter: handleShow,
        onMouseLeave: handleHide,
        onFocusCapture: handleShow,
        onBlur: (event)=>{
            if (event.currentTarget.contains(event.relatedTarget)) return;
            handleHide();
        },
        testId: `review-content-suggestion-row-${suggestion.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        xcss: $e0ce0b995765d610$var$styles.itemRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.suggestionLinkWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    ), {
        style: isRejected ? {
            opacity: 0.5
        } : undefined,
        xcss: $e0ce0b995765d610$var$styles.suggestionIconSlot,
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fSlSx.ProductLogo), {
        logoKey: logoKey,
        size: "large"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        href: suggestion.url,
        target: "_blank",
        rel: "noopener noreferrer",
        "aria-label": formatMessage($e0ce0b995765d610$var$i18n.openSuggestion, {
            title: suggestion.title
        }),
        xcss: (0, $w6R6I.cx)($e0ce0b995765d610$var$styles.suggestionLink, !isSelected && $e0ce0b995765d610$var$styles.unselectedLink),
        onClick: ()=>onSuggestionClick?.(suggestion)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.suggestionTitleWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        maxLines: 1,
        color: isRejected ? 'color.text.disabled' : undefined
    }, suggestion.title)), hasReason && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $e0ce0b995765d610$var$styles.suggestionReasonCallout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.suggestionReasonIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4w5V7))), {
        label: "",
        size: "small",
        color: isRejected ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon-subtlest, #6B6E76)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: descRef,
        xcss: $e0ce0b995765d610$var$styles.suggestionDescription
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: isRejected ? 'color.text.disabled' : 'color.text.subtle',
        maxLines: descLineCount
    }, reasonLabel))))), !hasFeedbackBeenSubmitted && (0, $6mKj3.expVal)('cc-space-curation-feedback-survey', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
        xcss: $e0ce0b995765d610$var$styles.feedbackIconButton,
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            handleHide();
            setIsFeedbackModalOpen(true);
        },
        "aria-label": formatMessage($e0ce0b995765d610$var$i18n.feedbackButtonLabel, {
            title: suggestion.title
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage($e0ce0b995765d610$var$i18n.evalButtonLabel))), !isRejected && (isRowHovered || isMovePopupOpen) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e4c0d2b6b6e18559$export$de484dae570b7c31), {
        suggestionId: suggestion.id,
        spaceKey: spaceKey,
        isOpen: isMovePopupOpen,
        onOpenChange: handleMovePopupOpenChange,
        onMoveSuggestion: onMoveSuggestion,
        fallbackParents: suggestion.fallbackParents,
        currentParentId: suggestion.parentId ?? undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage($e0ce0b995765d610$var$i18n.rejectSuggestionTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
        xcss: $e0ce0b995765d610$var$styles.thumbsDownButton,
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            onRejectItem(suggestion.id);
        },
        "aria-label": formatMessage($e0ce0b995765d610$var$i18n.rejectSuggestion, {
            title: suggestion.title
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($93fnf))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    })))), isRejected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        padding: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kUFQ0))),
        label: formatMessage($e0ce0b995765d610$var$i18n.resetSuggestion, {
            title: suggestion.title
        }),
        appearance: "subtle",
        spacing: "compact",
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            onRejectItem(suggestion.id);
        }
    })), !isRejected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        padding: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
        isChecked: isSelected,
        onChange: ()=>onToggleSelectItem(suggestion.id)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, isFeedbackModalOpen && (0, $6mKj3.expVal)('cc-space-curation-feedback-survey', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fdaa5fb91b997659$export$2eae41a486732e13), {
        suggestion: suggestion,
        spaceId: spaceId,
        spaceKey: spaceKey,
        onClose: ()=>{
            setIsFeedbackModalOpen(false);
        },
        onSubmit: ()=>onFeedbackSubmitted?.(suggestion.id)
    })));
};
const $e0ce0b995765d610$var$SuggestionGroupRow = ({ parentTitle: parentTitle, parentType: parentType, suggestions: suggestions, isGroupSelected: isGroupSelected, selectedItems: selectedItems, rejectedItems: rejectedItems, spaceId: spaceId, spaceKey: spaceKey, parentId: parentId, toggleSelectGroup: toggleSelectGroup, onToggleSelectItem: onToggleSelectItem, onRejectItem: onRejectItem, onGroupHoverChange: onGroupHoverChange, submittedFeedbackIds: submittedFeedbackIds, onFeedbackSubmitted: onFeedbackSubmitted, onMoveSuggestion: onMoveSuggestion, onSuggestionHover: onSuggestionHover, onSuggestionClick: onSuggestionClick, titlesByContentId: titlesByContentId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.groupCard,
        onMouseEnter: isGroupSelected ? ()=>onGroupHoverChange(parentId, true) : undefined,
        onMouseLeave: isGroupSelected ? ()=>onGroupHoverChange(parentId, false) : undefined,
        onFocusCapture: isGroupSelected ? ()=>onGroupHoverChange(parentId, true) : undefined,
        onBlur: isGroupSelected ? (event)=>{
            if (!event.currentTarget.contains(event.relatedTarget)) onGroupHoverChange(parentId, false);
        } : undefined,
        testId: `review-content-suggestion-group-card-${parentId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        xcss: $e0ce0b995765d610$var$styles.groupRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        shouldWrap: false,
        grow: "fill",
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.groupIconSlot
    }, parentType === 'page' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7A1BE))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.groupTitleWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium",
        maxLines: 1
    }, parentTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        padding: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
        isChecked: isGroupSelected,
        onChange: ()=>toggleSelectGroup(suggestions)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.itemsList
    }, suggestions.map((suggestion)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e0ce0b995765d610$var$SuggestionItemRow, {
            key: suggestion.id,
            suggestion: suggestion,
            isSelected: selectedItems.has(suggestion.id),
            isRejected: rejectedItems.has(suggestion.id),
            spaceId: spaceId,
            hasFeedbackBeenSubmitted: submittedFeedbackIds.has(suggestion.id),
            onFeedbackSubmitted: onFeedbackSubmitted,
            spaceKey: spaceKey,
            onToggleSelectItem: onToggleSelectItem,
            onRejectItem: onRejectItem,
            onMoveSuggestion: onMoveSuggestion,
            onSuggestionHover: onSuggestionHover,
            onSuggestionClick: onSuggestionClick,
            titlesByContentId: titlesByContentId
        }))));
};
const $e0ce0b995765d610$var$ModalLeftPanel = ({ groupedSuggestionsWithTitles: groupedSuggestionsWithTitles, contentMetaById: contentMetaById, selectedItems: selectedItems, rejectedItems: rejectedItems, toggleSelectGroup: toggleSelectGroup, toggleSelectItem: toggleSelectItem, onRejectItem: onRejectItem, onGroupHoverChange: onGroupHoverChange, onMoveSuggestion: onMoveSuggestion, onSuggestionHover: onSuggestionHover, onSuggestionClick: onSuggestionClick, spaceId: spaceId, spaceKey: spaceKey, titlesByContentId: titlesByContentId, onFilterClose: onFilterClose, filterResetKey: filterResetKey, isFilteredEmpty: isFilteredEmpty, onClearFilters: onClearFilters, availableSources: availableSources })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [submittedFeedbackIds, setSubmittedFeedbackIds] = (0, $cozmU.useState)(new Set());
    const handleFeedbackSubmitted = (0, $cozmU.useCallback)((suggestionId)=>{
        setSubmittedFeedbackIds((prev)=>new Set([
                ...prev,
                suggestionId
            ]));
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, (0, $6mKj3.expVal)('confluence_autonomous_space_curation_filtering', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        justifyContent: "space-between",
        xcss: $e0ce0b995765d610$var$styles.suggestionsListHeader,
        testId: "suggestions-list-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "medium"
    }, formatMessage($e0ce0b995765d610$var$i18n.topRelevantSuggestions)), availableSources.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a01761abc8be8172$export$21d85d7a6ca378ad), {
        key: filterResetKey,
        onClose: onFilterClose,
        availableSources: availableSources
    })), isFilteredEmpty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.filterEmptyState,
        testId: "suggestions-filter-empty-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold"
    }, formatMessage($e0ce0b995765d610$var$i18n.filterEmptyTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, formatMessage($e0ce0b995765d610$var$i18n.filterEmptyDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: onClearFilters,
        testId: "suggestions-filter-empty-clear-button"
    }, formatMessage($e0ce0b995765d610$var$i18n.filterEmptyClearButton)))) : [
        ...groupedSuggestionsWithTitles.entries()
    ].map(([parentId, { parentTitle: parentTitle, suggestions: groupSuggestions }])=>{
        const isGroupSelected = groupSuggestions.some((s)=>selectedItems.has(s.id));
        const parentType = parentId !== null ? contentMetaById.get(String(parentId))?.type : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e0ce0b995765d610$var$SuggestionGroupRow, {
            key: String(parentId),
            parentTitle: parentTitle || formatMessage(parentId === null ? $e0ce0b995765d610$var$i18n.uncategorized : $e0ce0b995765d610$var$i18n.untitled),
            parentType: parentType,
            suggestions: groupSuggestions,
            isGroupSelected: isGroupSelected,
            selectedItems: selectedItems,
            rejectedItems: rejectedItems,
            parentId: parentId,
            toggleSelectGroup: toggleSelectGroup,
            onToggleSelectItem: toggleSelectItem,
            onRejectItem: onRejectItem,
            onGroupHoverChange: onGroupHoverChange,
            onMoveSuggestion: onMoveSuggestion,
            onSuggestionHover: onSuggestionHover,
            onSuggestionClick: onSuggestionClick,
            spaceId: spaceId,
            submittedFeedbackIds: submittedFeedbackIds,
            onFeedbackSubmitted: handleFeedbackSubmitted,
            spaceKey: spaceKey,
            titlesByContentId: titlesByContentId
        });
    }));
};
const $e0ce0b995765d610$var$PreviewContent = ({ imageUrl: imageUrl, imageLoading: imageLoading, title: title, description: description, productLogoKey: productLogoKey, authorName: authorName, authorAvatarUrl: authorAvatarUrl })=>{
    const [imageError, setImageError] = (0, $cozmU.useState)(false);
    const [avatarError, setAvatarError] = (0, $cozmU.useState)(false);
    const [imageLoaded, setImageLoaded] = (0, $cozmU.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewImageContainer
    }, !imageLoading && (!imageUrl || imageError) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewImageFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($90c94b26b50862e3$exports))),
        alt: "",
        "aria-hidden": "true",
        width: "100%"
    })), imageUrl && !imageError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: imageUrl,
        alt: "",
        width: "100%",
        onLoad: ()=>setImageLoaded(true),
        onError: ()=>setImageError(true),
        style: {
            display: imageLoaded ? 'block' : 'none'
        }
    })), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium",
        maxLines: 2
    }, productLogoKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- inline logo alignment can't use xcss
    , {
        style: {
            display: 'inline-flex',
            verticalAlign: '-3px',
            marginRight: '6px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fSlSx.ProductLogo), {
        logoKey: productLogoKey,
        size: "xxsmall"
    })), title), authorName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, authorAvatarUrl && !avatarError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: authorAvatarUrl,
        alt: "",
        width: "16",
        height: "16",
        style: {
            borderRadius: '50%'
        },
        onError: ()=>setAvatarError(true)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, authorName)), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest",
        maxLines: 3
    }, description));
};
const $e0ce0b995765d610$var$ModalRightPanel = ({ previewConnection: previewConnection, previewImageUrl: previewImageUrl, previewImageLoading: previewImageLoading, previewTitle: previewTitle, previewDescription: previewDescription, previewProductLogoKey: previewProductLogoKey, previewAuthorName: previewAuthorName, previewAuthorAvatarUrl: previewAuthorAvatarUrl, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const showGoogleDrive = !previewConnection || previewConnection === (0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).GOOGLE_DRIVE;
    const showLoom = !previewConnection || previewConnection === (0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).LOOM;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.rightPanel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.closeButtonWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: formatMessage($e0ce0b995765d610$var$i18n.closeModal),
        appearance: "subtle",
        onClick: onClose,
        isTooltipDisabled: false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewUnit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewDecorativeBackground
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dJySn))),
        alt: "",
        "aria-hidden": "true"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewIllustration
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewDarkBlueBox
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewCard
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewSparkle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3WMx1))),
        alt: "",
        "aria-hidden": "true",
        width: "75",
        height: "83"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($e0ce0b995765d610$var$styles.contentPreviewIconTopLeft, showGoogleDrive ? $e0ce0b995765d610$var$styles.contentPreviewIconVisible : $e0ce0b995765d610$var$styles.contentPreviewIconHidden)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewGoogleDriveIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fSlSx.ProductLogo), {
        logoKey: "google-drive",
        size: "medium"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewArrowTopLeft
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($10315a023767e43f$exports))),
        alt: "",
        "aria-hidden": "true",
        width: "61",
        height: "36"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($e0ce0b995765d610$var$styles.contentPreviewIconBottomRight, showLoom ? $e0ce0b995765d610$var$styles.contentPreviewIconVisible : $e0ce0b995765d610$var$styles.contentPreviewIconHidden)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewLoomIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fSlSx.ProductLogo), {
        logoKey: "loom",
        size: "medium"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($10315a023767e43f$exports))),
        alt: "",
        "aria-hidden": "true",
        width: "61",
        height: "36"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewCardPadding
    }, previewConnection ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e0ce0b995765d610$var$PreviewContent, {
        key: previewImageUrl || previewTitle,
        imageUrl: previewImageUrl,
        imageLoading: previewImageLoading,
        title: previewTitle,
        description: previewDescription,
        productLogoKey: previewProductLogoKey,
        authorName: previewAuthorName,
        authorAvatarUrl: previewAuthorAvatarUrl
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e0Gob.ContentPreviewPlaceholder), null), previewConnection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewProductLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fSlSx.ConnectionLogo), {
        connection: previewConnection,
        size: "xxsmall"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $d46a749dcc1cd83e$export$fc6308b035f32dc)[previewConnection]))))))))));
};
const $e0ce0b995765d610$var$ModalErrorState = ({ onClose: onClose, onRetry: onRetry, spaceId: spaceId, spaceKey: spaceKey, reason: reason, openTimestamp: openTimestamp })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    (0, $1bc25cf918df8e30$export$180fd386dd30f08f)({
        spaceId: spaceId,
        spaceKey: spaceKey,
        reason: reason,
        openTimestamp: openTimestamp
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.errorState,
        testId: "review-content-suggestions-modal-error-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.closeButtonWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: formatMessage($e0ce0b995765d610$var$i18n.closeModal),
        appearance: "subtle",
        onClick: onClose,
        isTooltipDisabled: false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $RfroO.default), {
        header: formatMessage($e0ce0b995765d610$var$i18n.errorStateHeader),
        description: formatMessage($e0ce0b995765d610$var$i18n.errorStateDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: onRetry
        }, formatMessage($e0ce0b995765d610$var$i18n.errorStateRetryButton)),
        renderImage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $431p7.IllustrationComponent), {
                illustrationKey: "ErrorGeneral",
                alt: "",
                width: 160,
                height: 160
            })
    }));
};
const $e0ce0b995765d610$export$8a4b505874e89d07 = ({ spaceKey: spaceKey, spaceId: spaceId, modalOpenTimestamp: modalOpenTimestamp, onClose: onClose, onSaveSuccess: onSaveSuccess, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)(); // Source identifiers (provider ARIs) the user has narrowed to. Empty means "no filter".
    const [appliedSources, setAppliedSources] = (0, $cozmU.useState)(()=>[]);
    const [filterResetKey, setFilterResetKey] = (0, $cozmU.useState)(0);
    const [isReapplyingFilters, setIsReapplyingFilters] = (0, $cozmU.useState)(false);
    const isFilterApplied = appliedSources.length > 0;
    const handleFilterPopupClose = (0, $cozmU.useCallback)((sources)=>{
        setAppliedSources(sources);
    }, []);
    const clearFilters = (0, $cozmU.useCallback)(()=>{
        setIsReapplyingFilters(true);
        setAppliedSources([]);
        setFilterResetKey((key)=>key + 1);
    }, []);
    const { groups: groups, isLoading: isFetchingSuggestions, isSuppressed: isSuppressed, refetch: refetch } = (0, $b0a504e05d35a946$export$b1532bcf7c9b2548)(spaceKey, (0, $6mKj3.expVal)('confluence_autonomous_space_curation_filtering', 'isEnabled', false) ? appliedSources : undefined);
    const reviewSuggestionsExperience = (0, $b3f0a9dc40fecba0$export$c8d4c1de2c630478)();
    const [suggestionOverrides, setSuggestionOverrides] = (0, $cozmU.useState)(()=>new Map());
    const allSuggestions = (0, $cozmU.useMemo)(()=>groups.flatMap((g)=>g.remoteObjects).map((s)=>{
            const override = suggestionOverrides.get(s.id);
            return override ? {
                ...s,
                ...override
            } : s;
        }), [
        groups,
        suggestionOverrides
    ]);
    const { cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { availableSources: availableSources } = (0, $be72420aa1928141$export$e83bdb5bee7fb6bb)({
        spaceKey: spaceKey,
        cloudId: cloudId,
        skip: !(0, $6mKj3.expVal)('confluence_autonomous_space_curation_filtering', 'isEnabled', false)
    });
    const { thumbnailsByEntityId: loomThumbnails, isLoading: isLoomLoading } = (0, $9e42ae08d7ac1183$export$faa6742940bdf3c4)(allSuggestions, cloudId, activationId);
    const [selectedItems, setSelectedItems] = (0, $cozmU.useState)(()=>new Set());
    const [rejectedItems, setRejectedItems] = (0, $cozmU.useState)(()=>new Set());
    const [_isHoveringGroupList, setIsHoveringGroupList] = (0, $cozmU.useState)(false);
    const [_hoveredParentId, setHoveredParentId] = (0, $cozmU.useState)(null);
    const [hoveredSuggestion, setHoveredSuggestion] = (0, $cozmU.useState)(null);
    const previewConnection = hoveredSuggestion ? (0, $k8jyJ.getConnectionFromContentUrl)(hoveredSuggestion.url) : undefined;
    const [previewParentId, setPreviewParentId] = (0, $cozmU.useState)(groups[0]?.parentId);
    const [isSubmitting, setIsSubmitting] = (0, $cozmU.useState)(false);
    const parentIds = (0, $cozmU.useMemo)(()=>{
        const overriddenIds = [
            ...suggestionOverrides.values()
        ].filter((o)=>o.parentId !== null).map((o)=>String(o.parentId));
        return [
            ...new Set([
                ...groups.filter((g)=>g.parentId !== null).map((g)=>String(g.parentId)),
                ...overriddenIds
            ])
        ];
    }, [
        groups,
        suggestionOverrides
    ]);
    const relatedPageIds = (0, $cozmU.useMemo)(()=>allSuggestions.flatMap((s)=>s.relatedPages ?? []).map((id)=>String(id)).filter(Boolean), [
        allSuggestions
    ]);
    const contentIdsForTitleLookup = (0, $cozmU.useMemo)(()=>[
            ...new Set([
                ...parentIds,
                ...relatedPageIds
            ])
        ], [
        parentIds,
        relatedPageIds
    ]);
    const { titlesByContentId: titlesByContentId, contentMetaById: contentMetaById, isLoading: isLoadingTitles } = (0, $877d8332f9570d6f$export$7610585fadab893e)(contentIdsForTitleLookup);
    const { submitActions: submitActions } = (0, $55e1c5eec5b4b224$export$c9239e53ef385494)({
        spaceKey: spaceKey,
        flags: flags
    });
    const creatorAccountIds = (0, $cozmU.useMemo)(()=>allSuggestions.map((s)=>s.creatorAccountId).filter(Boolean), [
        allSuggestions
    ]);
    const creatorInfoMap = (0, $444ac254b74f8acb$export$949ad1c6f51713db)(creatorAccountIds);
    const hasCompletedInitialLoadRef = (0, $cozmU.useRef)(false);
    if (!isFetchingSuggestions && !isLoadingTitles) hasCompletedInitialLoadRef.current = true;
    const isInitialLoading = !hasCompletedInitialLoadRef.current && (isFetchingSuggestions || isLoadingTitles); // A user-initiated retry from the error state should show the loading view, even though
    // background refetches (post initial load) intentionally do not.
    const [isRetrying, setIsRetrying] = (0, $cozmU.useState)(false);
    const isLoading = isInitialLoading || isSubmitting || isRetrying || isReapplyingFilters;
    const hasFetchedSuggestions = groups.some((group)=>group.remoteObjects.length > 0);
    const wasFetchingSuggestionsRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (isFetchingSuggestions) {
            wasFetchingSuggestionsRef.current = true;
            return;
        }
        if (wasFetchingSuggestionsRef.current || hasFetchedSuggestions) {
            wasFetchingSuggestionsRef.current = false;
            setIsReapplyingFilters(false);
        }
    }, [
        isFetchingSuggestions,
        hasFetchedSuggestions
    ]);
    const isFilteredEmpty = !isLoading && !isSuppressed && !hasFetchedSuggestions && isFilterApplied;
    const showErrorState = !isLoading && (isSuppressed || !hasFetchedSuggestions && !isFilterApplied);
    const handleRetry = (0, $cozmU.useCallback)(async ()=>{
        setIsRetrying(true);
        try {
            await refetch();
        } finally{
            setIsRetrying(false);
        }
    }, [
        refetch
    ]);
    const groupedSuggestionsWithTitles = (0, $cozmU.useMemo)(()=>{
        const originalGroups = new Map();
        const newGroups = new Map();
        const originalParentIds = new Set(groups.map((g)=>g.parentId));
        allSuggestions.forEach((suggestion)=>{
            const pid = suggestion.parentId;
            const isNewGroup = !originalParentIds.has(pid);
            const target = isNewGroup ? newGroups : originalGroups;
            const existing = target.get(pid);
            if (existing) target.set(pid, {
                ...existing,
                suggestions: [
                    ...existing.suggestions,
                    suggestion
                ]
            });
            else target.set(pid, {
                parentTitle: pid !== null ? titlesByContentId.get(String(pid)) ?? '' : '',
                suggestions: [
                    suggestion
                ]
            });
        });
        const nullGroup = originalGroups.get(null);
        if (nullGroup) originalGroups.delete(null);
        const result = new Map([
            ...originalGroups.entries(),
            ...newGroups.entries()
        ]);
        if (nullGroup) result.set(null, nullGroup);
        return result;
    }, [
        allSuggestions,
        titlesByContentId,
        groups
    ]); // The analytics events below log suggestions in the order the user actually sees them, which is
    // the flattened group order (grouped by parent, uncategorized last, moved items relocated) —
    // not the raw fetch order of `allSuggestions`.
    const orderedSuggestions = (0, $cozmU.useMemo)(()=>[
            ...groupedSuggestionsWithTitles.values()
        ].flatMap((group)=>group.suggestions), [
        groupedSuggestionsWithTitles
    ]);
    const { openTimestamp: openTimestamp, fireDismissed: fireDismissed, fireAccepted: fireAccepted, fireSubmitFailed: fireSubmitFailed } = (0, $1bc25cf918df8e30$export$6ec3dc3eba258cc5)({
        spaceId: spaceId,
        spaceKey: spaceKey,
        orderedSuggestions: orderedSuggestions,
        titlesByContentId: titlesByContentId,
        selectedItems: selectedItems,
        rejectedItems: rejectedItems,
        isLoading: isLoading,
        isFetchingSuggestions: isFetchingSuggestions,
        isSuppressed: isSuppressed,
        isFilterApplied: isFilterApplied,
        modalOpenTimestamp: modalOpenTimestamp,
        reviewSuggestionsExperience: reviewSuggestionsExperience,
        filterKey: appliedSources
    });
    const { trackPreviewChange: trackPreviewChange, flushPreviewAnalytics: flushPreviewAnalytics } = (0, $1bc25cf918df8e30$export$92bdbf4fb19eb351)({
        spaceId: spaceId,
        spaceKey: spaceKey
    });
    const { fireSuggestionClicked: fireSuggestionClicked } = (0, $1bc25cf918df8e30$export$39012d7f97d73746)({
        spaceId: spaceId,
        spaceKey: spaceKey
    });
    const handleSuggestionHover = (0, $cozmU.useCallback)((suggestion)=>{
        setHoveredSuggestion(suggestion);
        trackPreviewChange(suggestion);
    }, [
        trackPreviewChange
    ]);
    const handleSuggestionClick = (0, $cozmU.useCallback)((suggestion)=>{
        fireSuggestionClicked(suggestion);
    }, [
        fireSuggestionClicked
    ]);
    const handleClose = async ()=>{
        flushPreviewAnalytics();
        fireDismissed();
        if (rejectedItems.size > 0) {
            const rejectedSuggestions = allSuggestions.filter((s)=>rejectedItems.has(s.id));
            await submitActions(rejectedSuggestions, new Set(), rejectedItems, {
                showFlags: false
            });
            await onClose(true);
        } else await onClose(false);
    };
    const handleAdd = async ()=>{
        setIsSubmitting(true);
        try {
            const ok = await submitActions(allSuggestions, selectedItems, rejectedItems);
            if (ok) {
                fireAccepted();
                const acceptedParentIds = [
                    ...new Set(allSuggestions.filter((s)=>selectedItems.has(s.id)).map((s)=>s.parentId).filter((id)=>id !== null))
                ];
                await onSaveSuccess(acceptedParentIds);
            } else fireSubmitFailed();
        } finally{
            setIsSubmitting(false);
        }
    };
    const handleMoveSuggestion = (0, $cozmU.useCallback)((suggestionId, newParentId)=>{
        setSuggestionOverrides((prev)=>new Map(prev).set(suggestionId, {
                parentId: newParentId
            }));
        setPreviewParentId(newParentId);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (previewParentId === undefined || groups.length === 0) {
            setPreviewParentId(groups[0]?.parentId);
            return;
        }
        if (!groupedSuggestionsWithTitles.has(previewParentId)) setPreviewParentId(groups[0]?.parentId);
    }, [
        groups,
        previewParentId,
        groupedSuggestionsWithTitles
    ]);
    const handleGroupHoverChange = (parentId, isHovering)=>{
        setIsHoveringGroupList(isHovering);
        setHoveredParentId(isHovering ? parentId : null);
        if (isHovering) setPreviewParentId(parentId);
    };
    const toggleSelectItem = (itemId)=>{
        setSelectedItems((prev)=>{
            const next = new Set(prev);
            if (next.has(itemId)) next.delete(itemId);
            else next.add(itemId);
            return next;
        });
    };
    const toggleRejectItem = (itemId)=>{
        setRejectedItems((prev)=>{
            const next = new Set(prev);
            if (next.has(itemId)) next.delete(itemId);
            else {
                // Selecting a reject removes the item from selected
                next.add(itemId);
                setSelectedItems((prevSelected)=>{
                    const nextSelected = new Set(prevSelected);
                    nextSelected.delete(itemId);
                    return nextSelected;
                });
            }
            return next;
        });
    };
    const toggleSelectGroup = (groupSuggestions)=>{
        const allSelected = groupSuggestions.every((s)=>selectedItems.has(s.id));
        setSelectedItems((prev)=>{
            const next = new Set(prev);
            groupSuggestions.forEach((s)=>{
                if (allSelected) next.delete(s.id);
                else next.add(s.id);
            });
            return next;
        });
    };
    let overlayContent = null;
    if (isLoading) overlayContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.loadingOverlay,
        testId: "review-content-suggestions-modal-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "large",
        label: isSubmitting ? formatMessage($e0ce0b995765d610$var$i18n.submitting) : formatMessage($e0ce0b995765d610$var$i18n.loading)
    }));
    else if (showErrorState) overlayContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e0ce0b995765d610$var$ModalErrorState, {
        onClose: handleClose,
        onRetry: handleRetry,
        spaceId: spaceId,
        spaceKey: spaceKey,
        reason: isSuppressed ? 'notProvisioned' : 'empty',
        openTimestamp: openTimestamp
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
        onClose: handleClose,
        width: "auto"
    }, overlayContent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $e0ce0b995765d610$var$styles.layout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.leftPanel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.leftPanelHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "large",
        as: "h1"
    }, formatMessage($e0ce0b995765d610$var$i18n.bringTogetherTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, formatMessage($e0ce0b995765d610$var$i18n.bringTogetherDescription)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.groupListScrollArea
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e0ce0b995765d610$var$ModalLeftPanel, {
        groupedSuggestionsWithTitles: groupedSuggestionsWithTitles,
        contentMetaById: contentMetaById,
        selectedItems: selectedItems,
        rejectedItems: rejectedItems,
        toggleSelectGroup: toggleSelectGroup,
        toggleSelectItem: toggleSelectItem,
        onRejectItem: toggleRejectItem,
        onGroupHoverChange: handleGroupHoverChange,
        onMoveSuggestion: handleMoveSuggestion,
        onSuggestionHover: handleSuggestionHover,
        onSuggestionClick: handleSuggestionClick,
        spaceId: spaceId,
        spaceKey: spaceKey,
        titlesByContentId: titlesByContentId,
        onFilterClose: handleFilterPopupClose,
        filterResetKey: filterResetKey,
        isFilteredEmpty: isFilteredEmpty,
        onClearFilters: clearFilters,
        availableSources: availableSources
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: ()=>void handleAdd(),
        isDisabled: selectedItems.size === 0
    }, selectedItems.size > 0 ? formatMessage($e0ce0b995765d610$var$i18n.addItemsToSpace, {
        count: selectedItems.size
    }) : formatMessage($e0ce0b995765d610$var$i18n.addToThisSpace)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e0ce0b995765d610$var$ModalRightPanel, {
        onClose: handleClose,
        previewImageUrl: hoveredSuggestion ? loomThumbnails.get(hoveredSuggestion.id) ?? hoveredSuggestion.iconUrl : undefined,
        previewImageLoading: isLoomLoading && hoveredSuggestion !== null && hoveredSuggestion.id.includes('::video/') && !loomThumbnails.has(hoveredSuggestion.id),
        previewTitle: hoveredSuggestion?.title,
        previewDescription: hoveredSuggestion?.description,
        previewProductLogoKey: hoveredSuggestion ? (0, $k8jyJ.getSuggestionLogoKeyFromContentUrl)(hoveredSuggestion.url) : undefined,
        previewConnection: previewConnection,
        previewAuthorName: hoveredSuggestion?.creatorAccountId ? creatorInfoMap.get(hoveredSuggestion.creatorAccountId)?.displayName : undefined,
        previewAuthorAvatarUrl: hoveredSuggestion?.creatorAccountId ? creatorInfoMap.get(hoveredSuggestion.creatorAccountId)?.avatarUrl : undefined
    })));
};
const $e0ce0b995765d610$export$c9ce09b966ffa4f7 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e0ce0b995765d610$export$8a4b505874e89d07, {
            ...props,
            flags: flags
        }));



var $eKTWO = parcelRequire("eKTWO");

/* StackedContentIcons.tsx generated by @compiled/babel-plugin v3.0.1 */ 














const $715aa91ca8191370$var$ICON_SIZE = {
    small: 'xxsmall',
    medium: 'xsmall',
    large: 'small'
};
const $715aa91ca8191370$var$i18n = (0, $kSwu1.defineMessages)({
    googleDriveIconAlt: {
        id: "space-curation.space-navigation.google-drive-icon.alt",
        defaultMessage: "Google Drive icon"
    },
    onedriveIconAlt: {
        id: "space-curation.space-navigation.onedrive-icon.alt",
        defaultMessage: "OneDrive icon"
    },
    loomIconAlt: {
        id: "space-curation.space-navigation.loom-icon.alt",
        defaultMessage: "Loom icon"
    }
});
const $715aa91ca8191370$var$styles = {
    wrapper: "_3iDTPbccYA _0hPCNLDIqT _3YEZNOdnbC _2xTnZx2ADO _1RrJLiBwqQ",
    iconSlotFirst: "_0bjKvDKxmn _3YEZNOdnbC _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _0GTcwRdnbC _1mT5xdRAKS _42Yu6BgtVO _1VJPcahzcQ",
    iconSlotSingle: "_0bjKvDKxmn _3YEZNOdnbC _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _0GTcwRdnbC _1mT5xdRAKS",
    iconSlotSecond: "_0bjKvDKxmn _3YEZNOdnbC _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _0GTcwR5UaJ _1mT5xdRAKS _42Yu6B7dHp _1VJPcaiTT8",
    iconSlotThird: "_0bjKvDKxmn _3YEZNOdnbC _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _0GTcwR5UaJ _1mT5xdRAKS _42Yu6BdnbC"
};
const $715aa91ca8191370$var$ICON_ALT_KEY = {
    'google-drive': 'googleDriveIconAlt',
    onedrive: 'onedriveIconAlt',
    loom: 'loomIconAlt'
};
const $715aa91ca8191370$var$SLOT_STYLES = [
    $715aa91ca8191370$var$styles.iconSlotFirst,
    $715aa91ca8191370$var$styles.iconSlotSecond,
    $715aa91ca8191370$var$styles.iconSlotThird
];
const $715aa91ca8191370$export$8f11c373898e3cd4 = ({ variant: variant = 'small', testId: testId = 'stacked-content-icons', singleIcon: singleIcon, singleIconNode: singleIconNode, icons: icons })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const size = $715aa91ca8191370$var$ICON_SIZE[variant];
    if (singleIconNode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $715aa91ca8191370$var$styles.wrapper,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $715aa91ca8191370$var$styles.iconSlotSingle
    }, singleIconNode));
    if (singleIcon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $715aa91ca8191370$var$styles.wrapper,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $715aa91ca8191370$var$styles.iconSlotSingle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fSlSx.ProductLogo), {
        logoKey: singleIcon,
        size: size,
        label: formatMessage($715aa91ca8191370$var$i18n[$715aa91ca8191370$var$ICON_ALT_KEY[singleIcon]])
    })));
    const iconList = icons ?? [
        'google-drive',
        'onedrive'
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $715aa91ca8191370$var$styles.wrapper,
        testId: testId
    }, iconList.map((key, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: key,
            xcss: (0, $w6R6I.cx)($715aa91ca8191370$var$SLOT_STYLES[index])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fSlSx.ProductLogo), {
            logoKey: key,
            size: size,
            label: formatMessage($715aa91ca8191370$var$i18n[$715aa91ca8191370$var$ICON_ALT_KEY[key]])
        }))));
};





/* ThirdPartyAuthentication.tsx generated by @compiled/babel-plugin v3.0.1 */ 















var $7zxJs = parcelRequire("7zxJs");


var $eEPSE = parcelRequire("eEPSE");
































var $6TaGl = parcelRequire("6TaGl");


var $3vgx3 = parcelRequire("3vgx3");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");

const $cb6359e6e5610133$var$i18n = (0, $kSwu1.defineMessages)({
    moreOptions: {
        id: "space-curation.close-menu.more-options",
        defaultMessage: "More options"
    },
    remindTomorrow: {
        id: "space-curation.close-menu.remind-tomorrow",
        defaultMessage: "Remind me tomorrow"
    },
    neverShowAgain: {
        id: "space-curation.close-menu.never-show-again",
        defaultMessage: "Never show again"
    }
});
const $cb6359e6e5610133$export$4805c143e51c45b4 = ({ onDismiss: onDismiss, onNeverShowAgain: onNeverShowAgain })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        isOpen: isOpen,
        onOpenChange: ({ isOpen: nextIsOpen })=>setIsOpen(nextIsOpen),
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...triggerProps,
                ref: triggerRef,
                icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
                        ...iconProps,
                        size: "small"
                    }),
                appearance: "subtle",
                spacing: "compact",
                label: intl.formatMessage($cb6359e6e5610133$var$i18n.moreOptions),
                isTooltipDisabled: false
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        onClick: ()=>{
            setIsOpen(false);
            onDismiss();
        }
    }, intl.formatMessage($cb6359e6e5610133$var$i18n.remindTomorrow)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        onClick: ()=>{
            setIsOpen(false);
            onNeverShowAgain();
        }
    }, intl.formatMessage($cb6359e6e5610133$var$i18n.neverShowAgain))));
};





const $4a7342ec49ac4fa7$export$2c06ec8998ac1741 = ()=>{
    const dismissAction = async ({ neverShowAgain: neverShowAgain = false, remindTomorrow: remindTomorrow = false, undoNeverShowAgain: undoNeverShowAgain = false } = {})=>{
        // Mutually exclusive params, matching backend precedence: undoNeverShowAgain > remindTomorrow > neverShowAgain.
        const params = undoNeverShowAgain ? new URLSearchParams({
            undoNeverShowAgain: 'true'
        }) : remindTomorrow ? new URLSearchParams({
            remindTomorrow: 'true'
        }) : new URLSearchParams({
            neverShowAgain: String(neverShowAgain)
        });
        await (0, $f7B1p.cfetch)(`/wiki/rest/internal/1.0/spaces/remote-objects/suggestions/dismiss?${params.toString()}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });
    };
    return {
        dismissAction: dismissAction
    };
};







const $225bc84a53ca9cda$var$ThirdPartyAuthenticationModal = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "B_q1L",
    name: "ThirdPartyAuthenticationModal",
    loader: async ()=>(await (parcelRequire("lbRgq"))).ThirdPartyAuthenticationModal
});
const $225bc84a53ca9cda$var$styles = {
    container: "_0bjKvDKxmn _4bt5LAnQyn _2WAcuGnQyn _4FKVYE8HPE _0KLXruVva3 _3138422ADO _1mT5xdRAKS",
    topRow: "_3iDTPbQ4SZ _0hPCNLchRC _37wbyuI7V3 _1DCdHi1Y8M",
    mainAction: "_2mHwu81Y8M _4FKVYEPgdg _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _0KLXrujOvk _39xV02N91d _2fwxA57p2s"
};
const $225bc84a53ca9cda$var$i18n = (0, $kSwu1.defineMessages)({
    title: {
        id: "space-curation.space-navigation.third-party-auth.title",
        defaultMessage: "Make the most of docs, sheets, slides, and folders"
    },
    titleGoogleDrive: {
        id: "space-curation.space-navigation.third-party-auth.title-google-drive",
        defaultMessage: "Connect to Google Drive to bring content into your space."
    },
    titleMicrosoft: {
        id: "space-curation.space-navigation.third-party-auth.title-microsoft",
        defaultMessage: "Connect to Microsoft to bring content into your space."
    },
    titleMulti: {
        id: "space-curation.space-navigation.third-party-auth.title-multi",
        defaultMessage: "Connect to apps to bring content into your space."
    },
    beta: {
        id: "space-curation.space-navigation.third-party-auth.beta",
        defaultMessage: "Beta"
    },
    betaUpdated: {
        id: "space-curation.space-navigation.third-party-auth.beta.updated",
        defaultMessage: "Beta"
    },
    connect: {
        id: "space-curation.space-navigation.third-party-auth.connect-apps",
        defaultMessage: "Connect apps"
    },
    connectProvider: {
        id: "space-curation.space-navigation.third-party-auth.connect-provider",
        defaultMessage: "Connect {providerName}"
    },
    successFlagTitle: {
        id: "space-curation.space-navigation.third-party-auth.success-title-v2",
        defaultMessage: "{providerName} connected"
    },
    successFlagDescription: {
        id: "space-curation.space-navigation.third-party-auth.success-description",
        defaultMessage: "We're on it! Rovo is looking for content for this space, check back later."
    },
    cancelledFlagTitle: {
        id: "space-curation.space-navigation.third-party-auth.cancelled-title",
        defaultMessage: "Connection cancelled"
    },
    cancelledFlagDescription: {
        id: "space-curation.space-navigation.third-party-auth.cancelled-description-v2",
        defaultMessage: "Couldn't connect {providerName}. Please try again."
    },
    errorFlagTitle: {
        id: "space-curation.space-navigation.third-party-auth.error-title",
        defaultMessage: "Connection failed"
    },
    errorFlagDescription: {
        id: "space-curation.space-navigation.third-party-auth.error-description-v2",
        defaultMessage: "Something went wrong connecting {providerName}. Please try again."
    },
    remindTomorrowSuccessTitle: {
        id: "space-curation.space-navigation.third-party-auth.remind-tomorrow.success-title",
        defaultMessage: "Got it, we'll check back later"
    },
    remindTomorrowSuccessDescription: {
        id: "space-curation.space-navigation.third-party-auth.remind-tomorrow.success-description",
        defaultMessage: "We'll remind you about these suggestions again in 24 hours."
    },
    neverShowAgainSuccessTitle: {
        id: "space-curation.space-navigation.third-party-auth.never-show-again.success-title",
        defaultMessage: "We won't show this again"
    },
    neverShowAgainSuccessDescription: {
        id: "space-curation.space-navigation.third-party-auth.never-show-again.success-description",
        defaultMessage: "You will no longer see curation suggestions in this space."
    },
    dismissErrorTitle: {
        id: "space-curation.space-navigation.third-party-auth.dismiss.error-title",
        defaultMessage: "Something went wrong"
    },
    dismissErrorDescription: {
        id: "space-curation.space-navigation.third-party-auth.dismiss.error-description",
        defaultMessage: "We couldn't update your preference. Please try again."
    }
});
const $225bc84a53ca9cda$export$55683e4280ace85d = ({ unauthenticatedServices: unauthenticatedServices, onThirdPartyAuthRefetch: onThirdPartyAuthRefetch, onAuthSuccess: onAuthSuccess, spaceId: spaceId, mountTimestamp: mountTimestamp })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [isVisible, setIsVisible] = (0, $cozmU.useState)(true);
    const [isModalOpen, setIsModalOpen] = (0, $cozmU.useState)(false);
    const hasFiredRenderedRef = (0, $cozmU.useRef)(false);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { dismissAction: dismissAction } = (0, $4a7342ec49ac4fa7$export$2c06ec8998ac1741)();
    const eligibleConnectors = (0, $cozmU.useMemo)(()=>(0, $k8jyJ.AUTH_OPTIONS).filter((option)=>unauthenticatedServices[option] && Boolean(unauthenticatedServices[option]?.outboundAuthUrl)), [
        unauthenticatedServices
    ]);
    const isRendered = !(0, $1I9Gw.isPersonalSpace)(spaceKey) && isVisible;
    (0, $cozmU.useEffect)(()=>{
        if (isRendered && spaceId && !hasFiredRenderedRef.current) {
            hasFiredRenderedRef.current = true;
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'rendered',
                    actionSubject: 'curationEntry',
                    source: 'containerNavigation',
                    attributes: {
                        spaceId: spaceId,
                        spaceKey: spaceKey,
                        entryPoint: 'authEntry',
                        suggestionCount: 0,
                        eligibleConnectors: eligibleConnectors,
                        renderLatencyMs: Date.now() - mountTimestamp
                    }
                }
            }).fire();
        }
    }, [
        isRendered,
        spaceId,
        spaceKey,
        eligibleConnectors,
        createAnalyticsEvent,
        mountTimestamp
    ]);
    const handleDismiss = async (flags)=>{
        if (spaceId) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'dismissed',
                actionSubject: 'curationEntry',
                source: 'containerNavigation',
                attributes: {
                    spaceId: spaceId,
                    spaceKey: spaceKey,
                    entryPoint: 'authEntry',
                    dismissMethod: 'close_button'
                }
            }
        }).fire();
        try {
            await dismissAction({
                remindTomorrow: true
            });
            setIsVisible(false);
            flags?.showSuccessFlag({
                id: 'space-curation.space-navigation.third-party-auth.remind-tomorrow.success',
                title: intl.formatMessage($225bc84a53ca9cda$var$i18n.remindTomorrowSuccessTitle),
                description: intl.formatMessage($225bc84a53ca9cda$var$i18n.remindTomorrowSuccessDescription),
                isAutoDismiss: true
            });
        } catch  {
            // If the dismiss POST fails, keep the card visible so the
            // preference is not silently lost.
            flags?.showErrorFlag({
                id: 'space-curation.space-navigation.third-party-auth.remind-tomorrow.error',
                title: intl.formatMessage($225bc84a53ca9cda$var$i18n.dismissErrorTitle),
                description: intl.formatMessage($225bc84a53ca9cda$var$i18n.dismissErrorDescription),
                isAutoDismiss: true
            });
        }
    };
    const handleNeverShowAgain = async (flags)=>{
        if (spaceId) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'dismissed',
                actionSubject: 'curationEntry',
                source: 'containerNavigation',
                attributes: {
                    spaceId: spaceId,
                    spaceKey: spaceKey,
                    entryPoint: 'authEntry',
                    dismissMethod: 'never_show_again'
                }
            }
        }).fire();
        try {
            await dismissAction({
                neverShowAgain: true
            });
            setIsVisible(false);
            flags?.showSuccessFlag({
                id: 'space-curation.space-navigation.third-party-auth.never-show-again.success',
                title: intl.formatMessage($225bc84a53ca9cda$var$i18n.neverShowAgainSuccessTitle),
                description: intl.formatMessage($225bc84a53ca9cda$var$i18n.neverShowAgainSuccessDescription),
                isAutoDismiss: true
            });
        } catch  {
            // If the never-show-again POST fails, keep the card visible so
            // the preference is not silently lost.
            flags?.showErrorFlag({
                id: 'space-curation.space-navigation.third-party-auth.never-show-again.error',
                title: intl.formatMessage($225bc84a53ca9cda$var$i18n.dismissErrorTitle),
                description: intl.formatMessage($225bc84a53ca9cda$var$i18n.dismissErrorDescription),
                isAutoDismiss: true
            });
        }
    };
    if ((0, $1I9Gw.isPersonalSpace)(spaceKey) || !isVisible || eligibleConnectors.length === 0) return null;
    const getProviderName = (option)=>{
        switch(option){
            case (0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).GOOGLE_DRIVE:
                return 'Google Drive';
            case (0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).MICROSOFT:
                return 'Microsoft';
            default:
                return option;
        }
    };
    const handleConnect = async (option, flags)=>{
        const authUrl = unauthenticatedServices[option]?.outboundAuthUrl;
        if (!authUrl) return;
        const providerName = getProviderName(option);
        try {
            await (0, $eEPSE.auth)(authUrl);
            onAuthSuccess?.(option);
            await onThirdPartyAuthRefetch();
            flags?.showSuccessFlag({
                id: 'space-curation.third-party-auth.success',
                title: intl.formatMessage($225bc84a53ca9cda$var$i18n.successFlagTitle, {
                    providerName: providerName
                }),
                description: intl.formatMessage($225bc84a53ca9cda$var$i18n.successFlagDescription),
                isAutoDismiss: true
            });
        } catch (error) {
            if (error instanceof (0, $7zxJs.AuthError) && error.type === 'auth_window_closed') flags?.showWarningFlag({
                id: 'space-curation.third-party-auth.cancelled',
                title: intl.formatMessage($225bc84a53ca9cda$var$i18n.cancelledFlagTitle),
                description: intl.formatMessage($225bc84a53ca9cda$var$i18n.cancelledFlagDescription, {
                    providerName: providerName
                }),
                isAutoDismiss: true
            });
            else flags?.showErrorFlag({
                id: 'space-curation.third-party-auth.error',
                title: intl.formatMessage($225bc84a53ca9cda$var$i18n.errorFlagTitle),
                description: intl.formatMessage($225bc84a53ca9cda$var$i18n.errorFlagDescription, {
                    providerName: providerName
                }),
                isAutoDismiss: true
            });
        }
    };
    const singleConnector = eligibleConnectors.length === 1 ? eligibleConnectors[0] : undefined;
    const CONNECTOR_UI = {
        [(0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).GOOGLE_DRIVE]: {
            singleIcon: 'google-drive',
            titleMessage: intl.formatMessage($225bc84a53ca9cda$var$i18n.titleGoogleDrive)
        },
        [(0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).MICROSOFT]: {
            singleIcon: 'onedrive',
            titleMessage: intl.formatMessage($225bc84a53ca9cda$var$i18n.titleMicrosoft)
        }
    };
    const singleConnectorIcon = singleConnector ? unauthenticatedServices[singleConnector]?.icon : undefined;
    const singleIcon = singleConnector ? CONNECTOR_UI[singleConnector].singleIcon : undefined;
    const titleText = singleConnector ? CONNECTOR_UI[singleConnector].titleMessage : intl.formatMessage($225bc84a53ca9cda$var$i18n.titleMulti);
    const connectText = singleConnector ? intl.formatMessage($225bc84a53ca9cda$var$i18n.connectProvider, {
        providerName: getProviderName(singleConnector)
    }) : intl.formatMessage($225bc84a53ca9cda$var$i18n.connect);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $225bc84a53ca9cda$var$styles.container,
            testId: "space-navigation-third-party-auth"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $225bc84a53ca9cda$var$styles.topRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
            xcss: $225bc84a53ca9cda$var$styles.mainAction,
            onClick: ()=>{
                if (spaceId) createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'curationEntry',
                        source: 'containerNavigation',
                        attributes: {
                            spaceId: spaceId,
                            spaceKey: spaceKey,
                            entryPoint: 'authEntry',
                            eligibleConnectors: eligibleConnectors
                        }
                    }
                }).fire();
                if (singleConnector) handleConnect(singleConnector, flags);
                else setIsModalOpen(true);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $715aa91ca8191370$export$8f11c373898e3cd4), {
            singleIcon: singleIcon,
            singleIconNode: singleConnectorIcon ? singleConnectorIcon({
                size: 'small'
            }) : undefined
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text"
        }, titleText, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: "accent-gray"
        }, intl.formatMessage($225bc84a53ca9cda$var$i18n.betaUpdated)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.link"
        }, connectText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cb6359e6e5610133$export$4805c143e51c45b4), {
            onDismiss: ()=>void handleDismiss(flags),
            onNeverShowAgain: ()=>void handleNeverShowAgain(flags)
        }))), isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($225bc84a53ca9cda$var$ThirdPartyAuthenticationModal, {
            unauthenticatedServices: unauthenticatedServices,
            onClose: ()=>setIsModalOpen(false),
            onConnect: (option)=>void handleConnect(option, flags)
        })));
};











var $7xVCs = parcelRequire("7xVCs");

const $63396382d074ec43$var$PageTreeForceFetchRegistration = ({ pageTreeStateUpdater: pageTreeStateUpdater, onForceFetchPageIdsChange: onForceFetchPageIdsChange })=>{
    const forceFetchPageIds = (0, $cozmU.useCallback)((pageIds)=>{
        const uniquePageIds = new Set();
        pageIds.forEach((pageId)=>{
            const normalizedPageId = String(pageId);
            if (normalizedPageId) uniquePageIds.add(normalizedPageId);
        });
        uniquePageIds.forEach((pageId)=>{
            pageTreeStateUpdater.setForceFetchPageId(pageId);
        });
    }, [
        pageTreeStateUpdater
    ]);
    (0, $cozmU.useEffect)(()=>{
        onForceFetchPageIdsChange(forceFetchPageIds);
        return ()=>onForceFetchPageIdsChange(null);
    }, [
        forceFetchPageIds,
        onForceFetchPageIdsChange
    ]);
    return null;
};
const $63396382d074ec43$export$16d45ab5eeacae08 = ({ onForceFetchPageIdsChange: onForceFetchPageIdsChange })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $7xVCs.PageTreeStateUpdater)
        ]
    }, (pageTreeStateUpdater)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($63396382d074ec43$var$PageTreeForceFetchRegistration, {
            pageTreeStateUpdater: pageTreeStateUpdater,
            onForceFetchPageIdsChange: onForceFetchPageIdsChange
        }));


const $4516149d204af1cd$var$styles = {
    container: "_0bjKvDKxmn _4bt5LAnQyn _2WAcuGnQyn _4FKVYE5zaO _0KLXruVva3 _3138422ADO _1mT5xdRAKS",
    topRow: "_3iDTPbQ4SZ _0hPCNLchRC _37wbyuI7V3 _1DCdHi1Y8M",
    iconsWrapper: "_3iDTPbQ4SZ _0hPCNLDIqT _3YEZNOdnbC",
    mainAction: "_2mHwu81Y8M _4FKVYEPgdg _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _0KLXrujOvk _39xV02N91d _2fwxA57p2s"
};
const $4516149d204af1cd$var$i18n = (0, $kSwu1.defineMessages)({
    addContent: {
        id: "space-curation.space-navigation.related-content.add-content",
        defaultMessage: "Add suggested content from your connected work apps"
    },
    beta: {
        id: "space-curation.space-navigation.related-content.beta",
        defaultMessage: "Beta"
    },
    betaUpdated: {
        id: "space-curation.space-navigation.related-content.beta.updated",
        defaultMessage: "Beta"
    },
    addContentAction: {
        id: "space-curation.space-navigation.related-content.add-content-action",
        defaultMessage: "Review and add"
    },
    remindTomorrowSuccessTitle: {
        id: "space-curation.space-navigation.related-content.remind-tomorrow.success-title",
        defaultMessage: "Got it, we'll check back later"
    },
    remindTomorrowSuccessDescription: {
        id: "space-curation.space-navigation.related-content.remind-tomorrow.success-description",
        defaultMessage: "We'll remind you about these suggestions again in 24 hours."
    },
    neverShowAgainSuccessTitle: {
        id: "space-curation.space-navigation.related-content.never-show-again.success-title",
        defaultMessage: "We won't show this again"
    },
    neverShowAgainSuccessDescription: {
        id: "space-curation.space-navigation.related-content.never-show-again.success-description",
        defaultMessage: "You will no longer see curation suggestions in this space."
    },
    dismissErrorTitle: {
        id: "space-curation.space-navigation.related-content.dismiss.error-title",
        defaultMessage: "Something went wrong"
    },
    dismissErrorDescription: {
        id: "space-curation.space-navigation.related-content.dismiss.error-description",
        defaultMessage: "We couldn't update your preference. Please try again."
    },
    undoAction: {
        id: "space-curation.space-navigation.related-content.never-show-again.undo-action",
        defaultMessage: "Undo"
    }
});
const $4516149d204af1cd$var$SpaceNavigationRelatedContentBody = ({ spaceKey: spaceKey, mountTimestamp: mountTimestamp, suggestionCount: suggestionCount, onDismiss: onDismiss, onNeverShowAgain: onNeverShowAgain, onModalClose: onModalClose, onSaveSuccessRefetch: onSaveSuccessRefetch, spaceId: spaceId })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [modalOpenTimestamp, setModalOpenTimestamp] = (0, $cozmU.useState)(null);
    const isModalOpen = modalOpenTimestamp !== null;
    const forceFetchPageIdsRef = (0, $cozmU.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const mountValuesRef = (0, $cozmU.useRef)({
        spaceId: spaceId,
        spaceKey: spaceKey,
        suggestionCount: suggestionCount,
        mountTimestamp: mountTimestamp,
        createAnalyticsEvent: createAnalyticsEvent
    });
    (0, $cozmU.useEffect)(()=>{
        const { spaceId: si, spaceKey: sk, suggestionCount: sc, mountTimestamp: mt, createAnalyticsEvent: cae } = mountValuesRef.current;
        cae({
            type: 'sendUIEvent',
            data: {
                action: 'rendered',
                actionSubject: 'curationEntry',
                source: 'containerNavigation',
                attributes: {
                    spaceId: si,
                    spaceKey: sk,
                    entryPoint: 'suggestionsEntry',
                    suggestionCount: sc,
                    renderLatencyMs: Date.now() - mt
                }
            }
        }).fire();
    }, []);
    const handleDismiss = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'dismissed',
                actionSubject: 'curationEntry',
                source: 'containerNavigation',
                attributes: {
                    spaceId: spaceId,
                    spaceKey: spaceKey,
                    entryPoint: 'suggestionsEntry',
                    dismissMethod: 'close_button',
                    suggestionCountAtDismiss: suggestionCount
                }
            }
        }).fire();
        onDismiss();
    };
    const handleNeverShowAgain = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'dismissed',
                actionSubject: 'curationEntry',
                source: 'containerNavigation',
                attributes: {
                    spaceId: spaceId,
                    spaceKey: spaceKey,
                    entryPoint: 'suggestionsEntry',
                    dismissMethod: 'never_show_again',
                    suggestionCountAtDismiss: suggestionCount
                }
            }
        }).fire();
        onNeverShowAgain();
    };
    const handleOpenModal = ()=>{
        setModalOpenTimestamp(Date.now());
    };
    const handleForceFetchPageIdsChange = (0, $cozmU.useCallback)((forceFetchPageIds)=>{
        forceFetchPageIdsRef.current = forceFetchPageIds;
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4516149d204af1cd$var$styles.container,
        testId: "space-navigation-related-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4516149d204af1cd$var$styles.topRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4516149d204af1cd$var$styles.iconsWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $715aa91ca8191370$export$8f11c373898e3cd4), {
        variant: "medium",
        icons: [
            'loom',
            'google-drive',
            'onedrive'
        ]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cb6359e6e5610133$export$4805c143e51c45b4), {
        onDismiss: handleDismiss,
        onNeverShowAgain: handleNeverShowAgain
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $4516149d204af1cd$var$styles.mainAction,
        onClick: handleOpenModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, intl.formatMessage($4516149d204af1cd$var$i18n.addContent), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: "accent-gray"
    }, intl.formatMessage($4516149d204af1cd$var$i18n.betaUpdated))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.link",
        weight: "medium"
    }, intl.formatMessage($4516149d204af1cd$var$i18n.addContentAction)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, isModalOpen && modalOpenTimestamp !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e0ce0b995765d610$export$c9ce09b966ffa4f7), {
        spaceKey: spaceKey,
        spaceId: spaceId,
        modalOpenTimestamp: modalOpenTimestamp,
        onClose: async (hadRejections)=>{
            setModalOpenTimestamp(null);
            await onModalClose(hadRejections);
        },
        onSaveSuccess: (acceptedParentIds)=>{
            setModalOpenTimestamp(null);
            onSaveSuccessRefetch();
            forceFetchPageIdsRef.current?.(acceptedParentIds);
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $63396382d074ec43$export$16d45ab5eeacae08), {
        onForceFetchPageIdsChange: handleForceFetchPageIdsChange
    }));
};
const $4516149d204af1cd$export$8372b97ddec977cb = ({ spaceId: spaceId, suggestionCountFragmentRef: suggestionCountFragmentRef })=>suggestionCountFragmentRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4516149d204af1cd$var$SpaceNavigationRelatedContentFromFragment, {
        spaceId: spaceId,
        suggestionCountFragmentRef: suggestionCountFragmentRef
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4516149d204af1cd$var$LegacySpaceNavigationRelatedContent, {
        spaceId: spaceId
    });
const $4516149d204af1cd$var$LegacySpaceNavigationRelatedContent = ({ spaceId: spaceId })=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const suggestionCountResult = (0, $eKTWO.useFetchSuggestionCount)({
        spaceKey: spaceKey,
        cloudId: cloudId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4516149d204af1cd$var$SpaceNavigationRelatedContentInner, {
        spaceId: spaceId,
        spaceKey: spaceKey,
        cloudId: cloudId,
        suggestionCountResult: suggestionCountResult
    });
};
const $4516149d204af1cd$var$SpaceNavigationRelatedContentFromFragment = ({ spaceId: spaceId, suggestionCountFragmentRef: suggestionCountFragmentRef })=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const suggestionCountResult = (0, $eKTWO.useFetchSuggestionCountFromFragment)({
        spaceKey: spaceKey,
        cloudId: cloudId,
        suggestionCountFragmentRef: suggestionCountFragmentRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4516149d204af1cd$var$SpaceNavigationRelatedContentInner, {
        spaceId: spaceId,
        spaceKey: spaceKey,
        cloudId: cloudId,
        suggestionCountResult: suggestionCountResult
    });
};
const $4516149d204af1cd$var$SpaceNavigationRelatedContentInner = ({ spaceId: spaceId, spaceKey: spaceKey, cloudId: cloudId, suggestionCountResult: suggestionCountResult })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [isVisible, setIsVisible] = (0, $cozmU.useState)(true);
    const mountTimestampRef = (0, $cozmU.useRef)(Date.now());
    const { dismissAction: dismissAction } = (0, $4a7342ec49ac4fa7$export$2c06ec8998ac1741)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { count: count, isLoading: isLoadingCount, isSuppressed: isSuppressed, refetch: refetchSuggestionCount } = suggestionCountResult;
    const { unauthenticatedServices: unauthenticatedServices, isLoading: isLoadingThirdPartyAuth, refetch: refetchThirdPartyAuth, markOptimisticallyAuthenticated: markOptimisticallyAuthenticated } = (0, $dddab7bf95955fb3$export$3d6949c2295aff10)({
        products: [
            (0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).GOOGLE_DRIVE,
            (0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).MICROSOFT
        ],
        cloudId: cloudId
    });
    if (!spaceKey || (0, $1I9Gw.isPersonalSpace)(spaceKey) || !isVisible || isLoadingCount || isSuppressed) return null;
    if (!isLoadingCount && !isLoadingThirdPartyAuth && count === 0 && Object.keys(unauthenticatedServices).length != 0) {
        (0, $6mKj3.manuallyLogExpExposure)('confluence_autonomous_space_curation');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $225bc84a53ca9cda$export$55683e4280ace85d), {
            unauthenticatedServices: unauthenticatedServices,
            onThirdPartyAuthRefetch: refetchThirdPartyAuth,
            onAuthSuccess: markOptimisticallyAuthenticated,
            spaceId: spaceId,
            mountTimestamp: mountTimestampRef.current
        });
    }
    if (count > 0) {
        (0, $6mKj3.manuallyLogExpExposure)('confluence_autonomous_space_curation');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: [
                (0, $gqqjz.FlagsStateContainer)
            ]
        }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4516149d204af1cd$var$SpaceNavigationRelatedContentBody, {
                spaceKey: spaceKey,
                mountTimestamp: mountTimestampRef.current,
                suggestionCount: count,
                onDismiss: async ()=>{
                    try {
                        await dismissAction({
                            remindTomorrow: true
                        });
                        setIsVisible(false);
                        flags?.showSuccessFlag({
                            id: 'space-curation.space-navigation.related-content.remind-tomorrow.success',
                            title: intl.formatMessage($4516149d204af1cd$var$i18n.remindTomorrowSuccessTitle),
                            description: intl.formatMessage($4516149d204af1cd$var$i18n.remindTomorrowSuccessDescription),
                            isAutoDismiss: true
                        });
                    } catch  {
                        // If the dismiss POST fails, keep the card visible so the
                        // preference is not silently lost.
                        flags?.showErrorFlag({
                            id: 'space-curation.space-navigation.related-content.remind-tomorrow.error',
                            title: intl.formatMessage($4516149d204af1cd$var$i18n.dismissErrorTitle),
                            description: intl.formatMessage($4516149d204af1cd$var$i18n.dismissErrorDescription),
                            isAutoDismiss: true
                        });
                    }
                },
                onNeverShowAgain: async ()=>{
                    try {
                        await dismissAction({
                            neverShowAgain: true
                        });
                        setIsVisible(false);
                        const neverShowAgainSuccessFlagId = 'space-curation.space-navigation.related-content.never-show-again.success';
                        flags?.showSuccessFlag({
                            id: neverShowAgainSuccessFlagId,
                            title: intl.formatMessage($4516149d204af1cd$var$i18n.neverShowAgainSuccessTitle),
                            description: intl.formatMessage($4516149d204af1cd$var$i18n.neverShowAgainSuccessDescription),
                            actions: [
                                {
                                    content: intl.formatMessage($4516149d204af1cd$var$i18n.undoAction),
                                    onClick: async ()=>{
                                        try {
                                            await dismissAction({
                                                undoNeverShowAgain: true
                                            });
                                            setIsVisible(true);
                                            refetchSuggestionCount();
                                            createAnalyticsEvent({
                                                type: 'sendUIEvent',
                                                data: {
                                                    action: 'undoDismiss',
                                                    actionSubject: 'curationEntry',
                                                    source: 'containerNavigation',
                                                    attributes: {
                                                        spaceId: spaceId,
                                                        spaceKey: spaceKey,
                                                        entryPoint: 'suggestionsEntry',
                                                        dismissMethod: 'never_show_again'
                                                    }
                                                }
                                            }).fire();
                                            flags?.hideFlag(neverShowAgainSuccessFlagId);
                                        } catch  {
                                            flags?.showErrorFlag({
                                                id: 'space-curation.space-navigation.related-content.never-show-again.undo.error',
                                                title: intl.formatMessage($4516149d204af1cd$var$i18n.dismissErrorTitle),
                                                description: intl.formatMessage($4516149d204af1cd$var$i18n.dismissErrorDescription),
                                                isAutoDismiss: true
                                            });
                                        }
                                    }
                                }
                            ],
                            // No auto-dismiss so the Undo link stays actionable.
                            isAutoDismiss: false
                        });
                    } catch  {
                        // If the never-show-again POST fails, keep the card visible so
                        // the preference is not silently lost.
                        flags?.showErrorFlag({
                            id: 'space-curation.space-navigation.related-content.never-show-again.error',
                            title: intl.formatMessage($4516149d204af1cd$var$i18n.dismissErrorTitle),
                            description: intl.formatMessage($4516149d204af1cd$var$i18n.dismissErrorDescription),
                            isAutoDismiss: true
                        });
                    }
                },
                onSaveSuccessRefetch: refetchSuggestionCount,
                onModalClose: (hadRejections)=>{
                    if (hadRejections) refetchSuggestionCount();
                },
                spaceId: spaceId
            }));
    }
};



var $9HB34 = parcelRequire("9HB34");




/**
 * @generated SignedSource<<9300299525f528ef70041e8a4735b6fc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $df9dad97eb1f9f95$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "CommonSpaceNavigationContent_space",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "homepage",
                "plural": false,
                "selections": [
                    v0 /*: any*/ 
                ]
            },
            {
                "concreteType": "OperationCheckResult",
                "kind": "LinkedField",
                "name": "operations",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "operation"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "targetType"
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "SpaceOperationsFragment"
            },
            {
                "kind": "ScalarField",
                "name": "didContainUserContent"
            }
        ],
        "type": "Space"
    };
}();
$df9dad97eb1f9f95$var$node.hash = "df35b90fbfa838a0cb8503ca2715a1c6";
var $df9dad97eb1f9f95$export$2e2bcd8739ae039 = $df9dad97eb1f9f95$var$node;









var $fBqzD = parcelRequire("fBqzD");








var $huaOC = parcelRequire("huaOC");


var $04jMq = parcelRequire("04jMq");

/**
 * @generated SignedSource<<e18d311e5dcb174315def5c0a6f62fe2>>
 * @relayHash e08c660ac5bdc886bb33b567a945aed4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2f68bbc6eea0c63985373f2abbf778bab314f10c540beac0c6a9175be185fbba
const $4d55e7bf74ef8f79$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAdmin"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceViewsControllerQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceViewsControllerQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "e08c660ac5bdc886bb33b567a945aed4",
            "id": "2f68bbc6eea0c63985373f2abbf778bab314f10c540beac0c6a9175be185fbba",
            "metadata": {},
            "name": "SpaceViewsControllerQuery",
            "operationKind": "query",
            "text": "query SpaceViewsControllerQuery($spaceKey:String!){space(key:$spaceKey){id,currentUser{isAdmin}}}"
        }
    };
}();
$4d55e7bf74ef8f79$var$node.hash = "d33ab2e8cd8e66319f41302e5bdaa679";
var $4d55e7bf74ef8f79$export$2e2bcd8739ae039 = $4d55e7bf74ef8f79$var$node;















var $ds2zu = parcelRequire("ds2zu");


var $fg2tf = parcelRequire("fg2tf");


var $d5um7 = parcelRequire("d5um7");

var $jZuGB = parcelRequire("jZuGB");

var $gMhPZ = parcelRequire("gMhPZ");


var $3qtLb = parcelRequire("3qtLb");








var $b3j2Y = parcelRequire("b3j2Y");








var $k5uAm = parcelRequire("k5uAm");


var $lfFzM = parcelRequire("lfFzM");








var $i28ZW = parcelRequire("i28ZW");


var $j3kZx = parcelRequire("j3kZx");


var $gCFsY = parcelRequire("gCFsY");


var $2vuKf = parcelRequire("2vuKf");





var $bOLC6 = parcelRequire("bOLC6");


var $arWla = parcelRequire("arWla");










const $add9014203bde61c$var$stopOrSucceed = (name, attributes, error, experienceTracker)=>{
    if (error) experienceTracker.stopOnError({
        name: name,
        attributes: attributes,
        error: error
    });
    else experienceTracker.succeed({
        name: name,
        attributes: attributes
    });
};
const $add9014203bde61c$export$122d712fe0dbd67 = ({ loading: loading, error: error, persistenceError: persistenceError, persistenceUpdateLoading: persistenceUpdateLoading, persistenceUpdateError: persistenceUpdateError, spaceViewsSort: spaceViewsSort, setSpaceViewsSort: setSpaceViewsSort, isSpaceAdmin: isSpaceAdmin })=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const makeTrackedFetchMore = (0, $cozmU.useCallback)((fetchMore)=>()=>{
            experienceTracker.start({
                name: (0, $irVI7.SPACE_VIEWS_PAGINATE_EXPERIENCE)
            });
            fetchMore();
        }, [
        experienceTracker
    ]);
    const trackedSetSpaceViewsSort = (0, $cozmU.useCallback)((newSort)=>{
        experienceTracker.start({
            name: (0, $irVI7.SPACE_VIEWS_CHANGE_EXPERIENCE),
            attributes: {
                prevSort: spaceViewsSort
            }
        });
        setSpaceViewsSort(newSort);
    }, [
        experienceTracker,
        spaceViewsSort,
        setSpaceViewsSort
    ]);
    (0, $cozmU.useEffect)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.SPACE_VIEWS_INITIAL_EXPERIENCE)
        });
    }, [
        experienceTracker
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!loading && !persistenceUpdateLoading) {
            const attributes = {
                spaceViewsSort: spaceViewsSort
            };
            $add9014203bde61c$var$stopOrSucceed((0, $irVI7.SPACE_VIEWS_INITIAL_EXPERIENCE), {
                spaceViewsSort: spaceViewsSort,
                isSpaceAdmin: isSpaceAdmin
            }, error || persistenceError, experienceTracker);
            $add9014203bde61c$var$stopOrSucceed((0, $irVI7.SPACE_VIEWS_CHANGE_EXPERIENCE), attributes, error || persistenceUpdateError, experienceTracker);
            $add9014203bde61c$var$stopOrSucceed((0, $irVI7.SPACE_VIEWS_PAGINATE_EXPERIENCE), attributes, error, experienceTracker);
        }
    }, [
        experienceTracker,
        loading,
        error,
        persistenceError,
        persistenceUpdateLoading,
        persistenceUpdateError,
        spaceViewsSort,
        isSpaceAdmin
    ]);
    return {
        makeTrackedFetchMore: makeTrackedFetchMore,
        trackedSetSpaceViewsSort: trackedSetSpaceViewsSort
    };
};



const $5a12275e9873d32f$var$SpaceViews = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-2bnv",
    name: "SpaceViews",
    loader: async ()=>(await (parcelRequire("bA71O"))).SpaceViews
});

const $5a12275e9873d32f$var$PagesItemActions = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ctWVd",
    name: "PagesItemActions",
    loader: async ()=>(await (parcelRequire("bBbyC"))).PagesItemActions
});

const $5a12275e9873d32f$var$ContentTreeSearchLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Dl_eE",
    name: "ContentTreeSearchLoader",
    loader: async ()=>(await (parcelRequire("8M9JV"))).ContentTreeSearch
});
const $5a12275e9873d32f$var$i18n = (0, $kSwu1.defineMessages)({
    contentTitle: {
        id: "space-views.collapsible-section.title",
        defaultMessage: "Content"
    },
    multiSelectContentTitle: {
        id: "space-views.collapsible-section.title.multi-select",
        defaultMessage: "Multi-select content"
    }
});
const $5a12275e9873d32f$var$SpaceViewsControllerComponent = ({ spaceViewsRootFragmentRef: spaceViewsRootFragmentRef, initialPersistenceData: initialPersistenceData, pageTreeInitialDataFragmentRef: pageTreeInitialDataFragmentRef, onDragDropSuccess: onDragDropSuccess, isPeekingFromBlogs: isPeekingFromBlogs, spaceHasUserContent: spaceHasUserContent, homepageId: homepageId, onContentTreeLoadComplete: onContentTreeLoadComplete, pageTreeFinishedLoading: pageTreeFinishedLoading })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { isSuperAdmin: isSuperAdmin } = (0, $lfFzM.useIsSuperAdmin)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [pageContextContentType] = (0, $ep3mz.useContentType)();
    const { isLicensed: isLicensed, edition: edition } = (0, $bQm3c.useSessionData)();
    const { spaceViewsSort: spaceViewsSort, setSpaceViewsSort: setSpaceViewsSort, queryLoading: persistenceLoading, queryError: persistenceError, mutationLoading: persistenceUpdateLoading, mutationError: persistenceUpdateError } = (0, $bOLC6.useSpaceViewsOptions)(// @ts-ignore FIXME: `spaceKey` can be `undefined` here, and needs proper handling
    spaceKey, isLicensed, initialPersistenceData);
    const forceExpandBecauseViewingContentTree = pageContextContentType !== 'blogpost';
    const [isPageTreeLoading, setIsPageTreeLoading] = (0, $cozmU.useState)(true);
    const [pageTreeError, setPageTreeError] = (0, $cozmU.useState)();
    const [isSpaceViewsLoading, setIsSpaceViewsLoading] = (0, $cozmU.useState)(true);
    const [contentTreeSize, setContentTreeSize] = (0, $cozmU.useState)(0);
    const [isPageTreeEmpty, setIsPageTreeEmpty] = (0, $cozmU.useState)(false);
    const [spaceViewsError, setSpaceViewsError] = (0, $cozmU.useState)();
    const isPageTree = spaceViewsSort === 'TREE';
    const [isMultiSelectActive] = (0, $2vuKf.useIsMultiSelectActive)();
    // Ref to the space views menu trigger button in the content header
    const spaceViewsMenuTriggerRef = (0, $cozmU.useRef)(null);
    const { data: data, loading: isSpaceAdminQueryLoading, error: isSpaceAdminQueryError } = (0, $jMyy4.useQueryInterop)((0, $4d55e7bf74ef8f79$export$2e2bcd8739ae039), {
        variables: {
            spaceKey: spaceKey ?? ''
        },
        skip: (0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false),
        __callerPackage__: "space-views"
    });
    const { canManageContent: canManageContentOp, loading: operationsLoading } = (0, $i28ZW.useSpaceManagementOperations)({
        spaceKey: spaceKey ?? '',
        skip: !spaceKey || !(0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false)
    });
    const loading = persistenceLoading || (isPageTree ? isPageTreeLoading : isSpaceViewsLoading) || isSpaceAdminQueryLoading && !(0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false) || operationsLoading && (0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false);
    const error = pageTreeError || spaceViewsError || isSpaceAdminQueryError;
    const canManageContent = (0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false) ? Boolean(canManageContentOp) : Boolean(data?.space?.currentUser?.isAdmin);
    const canManageContentOrSuperAdmin = canManageContent || isSuperAdmin;
    const { trackedSetSpaceViewsSort: trackedSetSpaceViewsSort, makeTrackedFetchMore: makeTrackedFetchMore } = (0, $add9014203bde61c$export$122d712fe0dbd67)({
        loading: loading,
        error: error,
        persistenceError: persistenceError,
        persistenceUpdateLoading: persistenceUpdateLoading,
        persistenceUpdateError: persistenceUpdateError,
        spaceViewsSort: spaceViewsSort,
        setSpaceViewsSort: setSpaceViewsSort,
        isSpaceAdmin: canManageContent
    });
    const { onEnterHoverTarget: showHoverPageCardOnEnterHoverTarget, closeAllHoverPageCards: closeAllHoverPageCards, startCloseHoverPageCardTimer: startCloseHoverPageCardTimer, clearHoverPageCardTimers: clearHoverPageCardTimers, showHoverPageCardForItem: showHoverPageCardForItem, isHoverPageCardOptedIn: isHoverPageCardOptedIn, onLeaveHoverTarget: onLeaveHoverTarget, onBlurHoverTarget: onBlurHoverTarget } = (0, $k5uAm.useHoverPageCard)(spaceViewsSort);
    const [shouldRenderAfterIcon, setShouldRenderAfterIcon] = (0, $cozmU.useState)(false);
    const onEnterHoverTarget = (0, $cozmU.useCallback)(({ itemID: itemID, isQuickActionsFocused: isQuickActionsFocused, hoverPageCardTriggerRef: hoverPageCardTriggerRef, isContextualCreateFocused: isContextualCreateFocused })=>{
        showHoverPageCardOnEnterHoverTarget({
            itemID: itemID,
            isQuickActionsFocused: isQuickActionsFocused,
            hoverPageCardTriggerRef: hoverPageCardTriggerRef,
            isContextualCreateFocused: isContextualCreateFocused
        });
        setShouldRenderAfterIcon(true);
    }, [
        showHoverPageCardOnEnterHoverTarget,
        setShouldRenderAfterIcon
    ]);
    const { isExpanded: isExpanded, onExpansionToggle: onExpansionToggle } = (0, $j3kZx.useSpacePersistentExpansion)({
        sectionName: 'contentTree',
        collapsedByDefault: !forceExpandBecauseViewingContentTree,
        forceExpand: forceExpandBecauseViewingContentTree
    });
    const handleSpaceViewCleared = (0, $cozmU.useCallback)(()=>{
        // Focus the space views menu trigger button in the content header using React ref
        if (spaceViewsMenuTriggerRef.current) spaceViewsMenuTriggerRef.current.focus();
    }, [
        spaceViewsMenuTriggerRef
    ]);
    const renderContentTree = (0, $cozmU.useMemo)(()=>{
        if (persistenceLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arWla.FlexCenter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: "medium"
        }));
        const hoverPageCardProps = {
            onEnterHoverTarget: onEnterHoverTarget,
            closeAllHoverPageCards: closeAllHoverPageCards,
            isHoverPageCardOptedIn: isHoverPageCardOptedIn,
            onLeaveHoverTarget: onLeaveHoverTarget,
            onBlurHoverTarget: onBlurHoverTarget
        };
        if (isPageTree) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5a12275e9873d32f$var$ContentTreeSearchLoader, {
            contentTreeSize: contentTreeSize,
            hideSearchRow: isPageTreeEmpty && spaceHasUserContent,
            shouldRenderAfterIcon: shouldRenderAfterIcon,
            selection: spaceViewsSort,
            setSelection: trackedSetSpaceViewsSort,
            isLicensed: isLicensed,
            canManageContentOrSuperAdmin: canManageContentOrSuperAdmin,
            ...hoverPageCardProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3qtLb.PageTree), {
            initialDataFragmentRef: pageTreeInitialDataFragmentRef,
            onDragDropSuccess: onDragDropSuccess,
            isPeekingFromBlogs: isPeekingFromBlogs,
            isSuperAdmin: isSuperAdmin,
            setIsPageTreeLoading: setIsPageTreeLoading,
            setPageTreeError: setPageTreeError,
            shouldRenderAfterIcon: shouldRenderAfterIcon,
            homepageId: homepageId,
            setContentTreeSize: setContentTreeSize,
            setIsPageTreeEmpty: setIsPageTreeEmpty,
            onContentTreeLoadComplete: onContentTreeLoadComplete,
            ...hoverPageCardProps
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5a12275e9873d32f$var$SpaceViews, {
            spaceRootFragmentRef: spaceViewsRootFragmentRef,
            spaceViewsSort: spaceViewsSort,
            setIsSpaceViewsLoading: setIsSpaceViewsLoading,
            setSpaceViewsError: setSpaceViewsError,
            trackedSetSpaceViewsSort: trackedSetSpaceViewsSort,
            makeTrackedFetchMore: makeTrackedFetchMore,
            spaceKey: spaceKey,
            contentId: contentId,
            shouldRenderAfterIcon: shouldRenderAfterIcon,
            contentTreeSize: contentTreeSize,
            onContentTreeLoadComplete: onContentTreeLoadComplete,
            onSpaceViewCleared: handleSpaceViewCleared,
            ...hoverPageCardProps
        });
    }, [
        persistenceLoading,
        spaceViewsRootFragmentRef,
        pageTreeInitialDataFragmentRef,
        onEnterHoverTarget,
        closeAllHoverPageCards,
        isHoverPageCardOptedIn,
        onLeaveHoverTarget,
        onBlurHoverTarget,
        isPageTree,
        spaceViewsSort,
        trackedSetSpaceViewsSort,
        makeTrackedFetchMore,
        spaceKey,
        contentId,
        shouldRenderAfterIcon,
        contentTreeSize,
        isPageTreeEmpty,
        spaceHasUserContent,
        onContentTreeLoadComplete,
        isLicensed,
        onDragDropSuccess,
        isPeekingFromBlogs,
        isSuperAdmin,
        homepageId,
        canManageContentOrSuperAdmin,
        handleSpaceViewCleared
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5um7.ExpandableMenuItem), {
        isExpanded: isExpanded,
        onExpansionToggle: onExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gMhPZ.ExpandableMenuItemTrigger), {
        elemBefore: isMultiSelectActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fg2tf))), {
            label: "",
            color: "currentColor"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ds2zu))), {
            label: "",
            color: "currentColor"
        }),
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5a12275e9873d32f$var$PagesItemActions, {
            isLicensed: isLicensed,
            edition: edition ?? undefined,
            selection: spaceViewsSort,
            setSelection: trackedSetSpaceViewsSort,
            spaceKey: spaceKey || '',
            expandContentSection: ()=>onExpansionToggle(true),
            onItemClick: ()=>onExpansionToggle(true),
            spaceHasUserContent: spaceHasUserContent,
            isPageTreeEmpty: isPageTreeEmpty,
            pageTreeFinishedLoading: pageTreeFinishedLoading,
            canManageContentOrSuperAdmin: canManageContentOrSuperAdmin,
            spaceViewsMenuTriggerRef: spaceViewsMenuTriggerRef
        })
    }, isMultiSelectActive ? formatMessage($5a12275e9873d32f$var$i18n.multiSelectContentTitle) : formatMessage($5a12275e9873d32f$var$i18n.contentTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jZuGB.ExpandableMenuItemContent), null, renderContentTree, isHoverPageCardOptedIn && showHoverPageCardForItem.itemID ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gCFsY.LazySpaceHoverPageCard), {
        showHoverPageCardForItem: showHoverPageCardForItem,
        closeAllHoverPageCards: closeAllHoverPageCards,
        clearHoverPageCardTimers: clearHoverPageCardTimers,
        startCloseHoverPageCardTimer: startCloseHoverPageCardTimer,
        onBlurHoverTarget: onBlurHoverTarget,
        shouldUseAutomationDiscovery: true,
        key: showHoverPageCardForItem.itemID
    }) : null, persistenceError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: persistenceError
    })));
};
const $5a12275e9873d32f$var$SpaceViewsControllerFromFragments = (props)=>{
    const initialPersistenceData = (0, $6SsN4.useFragment)((0, $bOLC6.SpaceViewsOptionsPersistenceFragment), props.spaceViewsPersistenceFragmentRef ?? null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5a12275e9873d32f$var$SpaceViewsControllerComponent, {
        ...props,
        initialPersistenceData: initialPersistenceData ?? undefined
    });
};
const $5a12275e9873d32f$var$SpaceViewsControllerDataSource = (props)=>props.spaceViewsRootFragmentRef || props.spaceViewsPersistenceFragmentRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5a12275e9873d32f$var$SpaceViewsControllerFromFragments, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5a12275e9873d32f$var$SpaceViewsControllerComponent, props);
const $5a12275e9873d32f$export$5bb6552a789f7a6f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).DISCO
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5a12275e9873d32f$var$SpaceViewsControllerDataSource, props));



var $jzS7A = parcelRequire("jzS7A");





var $hSqtY = parcelRequire("hSqtY");








var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");








const $72da3bb5b7695f3e$var$AgentContextItem = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Jxtoc",
    name: "AgentContextItem",
    loader: async ()=>(await (parcelRequire("6jT5w"))).AgentContextItem
});
const $72da3bb5b7695f3e$var$i18n = (0, $kSwu1.defineMessages)({
    suggestionsHeader: {
        id: "side-navigation.space-navigation.suggestions.header",
        defaultMessage: "Suggestions"
    },
    contentIntelligenceHeader: {
        id: "side-navigation.space-navigation.content-intelligence.header",
        defaultMessage: "Content intelligence"
    },
    contentIntelligenceNewLozenge: {
        id: "side-navigation.space-navigation.content-intelligence.new-lozenge",
        defaultMessage: "New"
    },
    contributorsHeader: {
        id: "side-navigation.space-navigation.contributors.header",
        defaultMessage: "Contributors"
    }
});
const $72da3bb5b7695f3e$export$c9895e116f0cb705 = (0, $df9dad97eb1f9f95$export$2e2bcd8739ae039);
const $72da3bb5b7695f3e$export$7716f65eb5d1a3fd = (t0)=>{
    const $ = (0, $bDgLe.c)(49);
    const { showShortcutsSection: showShortcutsSection, space: space, spaceKey: spaceKey, quick: quick, homepageId: homepageId, loading: loading, isSpaceAdmin: isSpaceAdmin, isBlogNavigation: isBlogNavigation, blogsHidden: blogsHidden, pageTreeFinishedLoading: pageTreeFinishedLoading, onDragDropSuccess: onDragDropSuccess, onContentTreeLoadComplete: onContentTreeLoadComplete, shortcutsFragmentRef: shortcutsFragmentRef, spaceViewsRootFragmentRef: spaceViewsRootFragmentRef, spaceViewsPersistenceFragmentRef: spaceViewsPersistenceFragmentRef, treeInitialDataFragmentRef: treeInitialDataFragmentRef } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isAIEarlyAccessEnabled: isAIEarlyAccessEnabled } = (0, $bQm3c.useSessionData)();
    const t1 = space?.operations;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $i28ZW.hasSpaceOperation)(t1, (0, $i28ZW.MANAGE_CONTENT));
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const canManageContent = t2;
    const isContributorsSelected = (0, $dPJCf.useIsOnRoute)((0, $1NBp8.SPACE_CONTRIBUTORS));
    const isSuggestionsSelected = (0, $dPJCf.useIsOnRoute)((0, $1NBp8.SPACE_SUGGESTIONS));
    let t3;
    if ($[2] !== formatMessage || $[3] !== isContributorsSelected || $[4] !== spaceKey) {
        t3 = (0, $6mKj3.expVal)("confluence_space_contributors", "isEnabled", false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
            href: (0, $1NBp8.SPACE_CONTRIBUTORS).toUrl({
                spaceKey: spaceKey
            }),
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fBqzD))), {
                label: "",
                color: "currentColor"
            }),
            "data-testid": "space-contributors-link",
            isSelected: isContributorsSelected
        }, formatMessage($72da3bb5b7695f3e$var$i18n.contributorsHeader));
        $[2] = formatMessage;
        $[3] = isContributorsSelected;
        $[4] = spaceKey;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== canManageContent || $[7] !== formatMessage || $[8] !== isAIEarlyAccessEnabled || $[9] !== isSuggestionsSelected || $[10] !== spaceKey) {
        t4 = canManageContent && isAIEarlyAccessEnabled && (0, $6mKj3.expVal)("confluence_space_organizer", "isEnabled", false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
            href: (0, $1NBp8.SPACE_SUGGESTIONS).toUrl({
                spaceKey: spaceKey
            }),
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4w5V7))), {
                label: "",
                color: "currentColor"
            }),
            elemAfter: (0, $6mKj3.expVal)("confluence_content_intelligence", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
                appearance: "discovery",
                isBold: true,
                testId: "space-content-intelligence-new-lozenge"
            }, formatMessage($72da3bb5b7695f3e$var$i18n.contentIntelligenceNewLozenge)) : undefined,
            "data-testid": "space-suggestions-link",
            isSelected: isSuggestionsSelected
        }, formatMessage((0, $6mKj3.expVal)("confluence_content_intelligence", "isEnabled", false) ? $72da3bb5b7695f3e$var$i18n.contentIntelligenceHeader : $72da3bb5b7695f3e$var$i18n.suggestionsHeader));
        $[6] = canManageContent;
        $[7] = formatMessage;
        $[8] = isAIEarlyAccessEnabled;
        $[9] = isSuggestionsSelected;
        $[10] = spaceKey;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== isSpaceAdmin || $[13] !== quick || $[14] !== shortcutsFragmentRef || $[15] !== showShortcutsSection || $[16] !== space?.id || $[17] !== spaceKey) {
        t5 = showShortcutsSection && (shortcutsFragmentRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $04jMq.ShortcutsSection), {
            isSpaceAdmin: isSpaceAdmin,
            spaceKey: spaceKey,
            spaceSidebarLinksFragmentRef: shortcutsFragmentRef,
            spaceId: space?.id || null
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $04jMq.ShortcutsSection), {
            isSpaceAdmin: isSpaceAdmin,
            spaceKey: spaceKey,
            links: quick,
            spaceId: space?.id || null
        }));
        $[12] = isSpaceAdmin;
        $[13] = quick;
        $[14] = shortcutsFragmentRef;
        $[15] = showShortcutsSection;
        $[16] = space?.id;
        $[17] = spaceKey;
        $[18] = t5;
    } else t5 = $[18];
    let t6;
    if ($[19] !== homepageId || $[20] !== isBlogNavigation || $[21] !== loading || $[22] !== onContentTreeLoadComplete || $[23] !== onDragDropSuccess || $[24] !== pageTreeFinishedLoading || $[25] !== space?.didContainUserContent || $[26] !== spaceKey || $[27] !== spaceViewsPersistenceFragmentRef || $[28] !== spaceViewsRootFragmentRef || $[29] !== treeInitialDataFragmentRef) {
        t6 = !loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-vc": "pageTree",
            "data-testid": "pageTree"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5a12275e9873d32f$export$5bb6552a789f7a6f), {
            spaceViewsRootFragmentRef: spaceViewsRootFragmentRef,
            spaceViewsPersistenceFragmentRef: spaceViewsPersistenceFragmentRef,
            pageTreeInitialDataFragmentRef: treeInitialDataFragmentRef,
            key: spaceKey,
            homepageId: homepageId,
            onDragDropSuccess: onDragDropSuccess,
            isPeekingFromBlogs: isBlogNavigation,
            onContentTreeLoadComplete: onContentTreeLoadComplete,
            spaceHasUserContent: space?.didContainUserContent,
            pageTreeFinishedLoading: pageTreeFinishedLoading
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null);
        $[19] = homepageId;
        $[20] = isBlogNavigation;
        $[21] = loading;
        $[22] = onContentTreeLoadComplete;
        $[23] = onDragDropSuccess;
        $[24] = pageTreeFinishedLoading;
        $[25] = space?.didContainUserContent;
        $[26] = spaceKey;
        $[27] = spaceViewsPersistenceFragmentRef;
        $[28] = spaceViewsRootFragmentRef;
        $[29] = treeInitialDataFragmentRef;
        $[30] = t6;
    } else t6 = $[30];
    let t7;
    if ($[31] !== isAIEarlyAccessEnabled || $[32] !== isAdminHubAIEnabled || $[33] !== spaceKey) {
        t7 = isAdminHubAIEnabled && isAIEarlyAccessEnabled && (0, $6mKj3.expValEquals)("cc_space_agents_md_context", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($72da3bb5b7695f3e$var$AgentContextItem, {
            spaceKey: spaceKey
        })) : null;
        $[31] = isAIEarlyAccessEnabled;
        $[32] = isAdminHubAIEnabled;
        $[33] = spaceKey;
        $[34] = t7;
    } else t7 = $[34];
    let t8;
    if ($[35] !== blogsHidden || $[36] !== loading || $[37] !== pageTreeFinishedLoading || $[38] !== space || $[39] !== spaceKey || $[40] !== treeInitialDataFragmentRef) {
        t8 = !loading && !blogsHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jzS7A.BlogTree), {
            initialDataFragmentRef: treeInitialDataFragmentRef,
            spaceKey: spaceKey,
            pageTreeFinishedLoading: pageTreeFinishedLoading,
            spaceOperationsRef: (0, $6mKj3.expVal)("confluence_contextual_create_relay_space_ops", "isEnabled", false) ? space : undefined
        });
        $[35] = blogsHidden;
        $[36] = loading;
        $[37] = pageTreeFinishedLoading;
        $[38] = space;
        $[39] = spaceKey;
        $[40] = treeInitialDataFragmentRef;
        $[41] = t8;
    } else t8 = $[41];
    let t9;
    if ($[42] !== t3 || $[43] !== t4 || $[44] !== t5 || $[45] !== t6 || $[46] !== t7 || $[47] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t3, t4, t5, t6, t7, t8);
        $[42] = t3;
        $[43] = t4;
        $[44] = t5;
        $[45] = t6;
        $[46] = t7;
        $[47] = t8;
        $[48] = t9;
    } else t9 = $[48];
    return t9;
};





/**
 * @generated SignedSource<<976d5e06a5e1ec0e9d9e5abdb0c16ab9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a5d9c903e21f4503$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isLicensed"
            }
        ],
        "kind": "Fragment",
        "name": "SpaceHeader_space",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "status"
            },
            {
                "concreteType": "Icon",
                "kind": "LinkedField",
                "name": "icon",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "path"
                    }
                ]
            },
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "homepage",
                "plural": false,
                "selections": [
                    v0 /*: any*/ 
                ]
            },
            {
                "condition": "isLicensed",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "SpaceUserMetadata",
                        "kind": "LinkedField",
                        "name": "currentUser",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isAdmin"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "isFavourited"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "isWatched"
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "OperationCheckResult",
                "kind": "LinkedField",
                "name": "operations",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "operation"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "targetType"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "containsExternalCollaborators"
            }
        ],
        "type": "Space"
    };
}();
$a5d9c903e21f4503$var$node.hash = "eedccc77702d6484eacdc7cac611d939";
var $a5d9c903e21f4503$export$2e2bcd8739ae039 = $a5d9c903e21f4503$var$node;















var $gC2EJ = parcelRequire("gC2EJ");


var $3izAL = parcelRequire("3izAL");


var $6Pqow = parcelRequire("6Pqow");


var $buxP3 = parcelRequire("buxP3");




















var $hXDOc = parcelRequire("hXDOc");





var $eWwvy = parcelRequire("eWwvy");




















var $c9Rq0 = parcelRequire("c9Rq0");





var $cJ0FD = parcelRequire("cJ0FD");


var $57p4j = parcelRequire("57p4j");


var $iDrrr = parcelRequire("iDrrr");





var $3SChL = parcelRequire("3SChL");


var $3Awqk = parcelRequire("3Awqk");


var $2AgON = parcelRequire("2AgON");


var $35Nok = parcelRequire("35Nok");

var $73912064fa3e494e$exports = {};
$73912064fa3e494e$exports = new URL("Spaces.5611c4bd.gif", import.meta.url).toString();


var $18964624cf65ea0e$exports = {};
$18964624cf65ea0e$exports = new URL("Spaces-dark.4ceec6cd.gif", import.meta.url).toString();


var $8540facab6b6ae3f$exports = {};
$8540facab6b6ae3f$exports = new URL("Spaces-placeholder.5b3f2999.png", import.meta.url).toString();


var $ef7ad76e18d21f81$exports = {};
$ef7ad76e18d21f81$exports = new URL("Spaces-placeholder-dark.1c1d1b34.png", import.meta.url).toString();



var $aPGTj = parcelRequire("aPGTj");


var $2K2hA = parcelRequire("2K2hA");


var $6OwHS = parcelRequire("6OwHS");


var $4enp7 = parcelRequire("4enp7");


var $6VFk2 = parcelRequire("6VFk2");


var $2Vz7H = parcelRequire("2Vz7H");


var $l3ydK = parcelRequire("l3ydK");


var $4AC39 = parcelRequire("4AC39");


var $gi4qj = parcelRequire("gi4qj");


var $uyMbP = parcelRequire("uyMbP");


var $3eYzF = parcelRequire("3eYzF");


var $8jXZv = parcelRequire("8jXZv");


var $9Zall = parcelRequire("9Zall");

const $f37e6d818dab503c$var$STEP_ID = 'nth-user-orientation-editor-space-spotlight';
const $f37e6d818dab503c$export$febddff29c5b0caa = ({ children: children })=>{
    const { reset: reset, next: next, currentStep: currentStep, progress: progress, hasInteracted: hasInteracted, active: active } = (0, $3SChL.useTour)($f37e6d818dab503c$var$STEP_ID);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isVisible = currentStep === $f37e6d818dab503c$var$STEP_ID;
    const { PopoverContent: PopoverContent } = (0, $lsxnT.useChoreographerAssets)();
    const currentSrc = (0, $35Nok.usePreloadGif)({
        gif: {
            light: (0, (/*@__PURE__*/$parcel$interopDefault($73912064fa3e494e$exports))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($18964624cf65ea0e$exports)))
        },
        placeholder: {
            light: (0, (/*@__PURE__*/$parcel$interopDefault($8540facab6b6ae3f$exports))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($ef7ad76e18d21f81$exports)))
        },
        skip: !active
    });
    const { handleNext: handleNext, handleDismiss: handleDismiss } = (0, $2AgON.useSpotlightAnalytics)({
        spotlightId: $f37e6d818dab503c$var$STEP_ID,
        isVisible: isVisible,
        onNext: next,
        onDismiss: reset
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c9Rq0.Hide), {
        below: "md"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PopoverContent, {
        shouldDismissOnClickOutside: false,
        dismiss: handleDismiss,
        next: handleNext,
        placement: "right-end",
        offset: [
            0,
            24
        ],
        isVisible: isVisible,
        messageId: $f37e6d818dab503c$var$STEP_ID,
        messageType: hasInteracted ? 'transactional' : 'engagement'
    }, (()=>{
        const spotlightCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gi4qj.SpotlightCard), {
            testId: $f37e6d818dab503c$var$STEP_ID
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6VFk2.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4enp7.SpotlightHeadline), null, formatMessage((0, $3Awqk.editorSpaceSpotlight).headline)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AC39.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l3ydK.SpotlightDismissControl), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OwHS.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: currentSrc,
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uyMbP.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $3Awqk.editorSpaceSpotlight).body))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Vz7H.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aPGTj.SpotlightStepCount), null, formatMessage((0, $3Awqk.spotlight).progress, progress)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eYzF.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2K2hA.SpotlightPrimaryAction), null, formatMessage((0, $3Awqk.spotlight).next)))));
        return (0, $iDrrr.fg)('platform-dst-motion-uplift-spotlight') ? spotlightCard : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            entranceDirection: "left"
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", props, spotlightCard));
    })())));
};



var $jlIaF = parcelRequire("jlIaF");











var $f6cdQ = parcelRequire("f6cdQ");











var $kz1Yj = parcelRequire("kz1Yj");








var $eGUIL = parcelRequire("eGUIL");

const $39cc7021b1f9471a$export$c915848be66d4457 = (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { showExCoMessaging: t1 } = t0;
    const showExCoMessaging = t1 === undefined ? false : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { handleScrollToTop: handleScrollToTop } = (0, $eGUIL.useSideNavigation)();
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== handleScrollToTop) {
        t2 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "navigationItem",
                    actionSubjectId: "QuickAccess",
                    source: "spaceNavigation",
                    data: {
                        navigationLayer: "global",
                        navigationContainer: "sidebar",
                        navVersion: "4"
                    }
                }
            }).fire();
            handleScrollToTop();
        };
        $[0] = createAnalyticsEvent;
        $[1] = handleScrollToTop;
        $[2] = t2;
    } else t2 = $[2];
    const onClick = t2;
    const t3 = showExCoMessaging && $39cc7021b1f9471a$var$additionalOffset;
    let t4;
    if ($[3] !== t3) {
        t4 = [
            $39cc7021b1f9471a$var$pressableStyles,
            $39cc7021b1f9471a$var$stickyWrapper,
            t3
        ];
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            borderColor: "transparent"
        };
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f6cdQ))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)",
            size: "small"
        });
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            space: "space.050",
            alignInline: "center",
            alignBlock: "center"
        }, t6, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
            align: "center",
            size: "small",
            color: "color.text.subtle"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $39cc7021b1f9471a$var$i18n.scrollToTopButtonLabel)));
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] !== onClick || $[9] !== t4) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
            xcss: t4,
            id: "scroll-to-top-button",
            onClick: onClick,
            style: t5
        }, t7);
        $[8] = onClick;
        $[9] = t4;
        $[10] = t8;
    } else t8 = $[10];
    let t9;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $39cc7021b1f9471a$var$offsetElement
        });
        $[11] = t9;
    } else t9 = $[11];
    let t10;
    if ($[12] !== t8) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t8, t9);
        $[12] = t8;
        $[13] = t10;
    } else t10 = $[13];
    return t10;
};
const $39cc7021b1f9471a$var$offsetElement = (0, $buxP3.xcss)({
    //this element keeps the spacing from he negative top margin tha hides the button
    height: '17px',
    width: `100%`,
    display: 'flex'
});
const $39cc7021b1f9471a$var$additionalOffset = (0, $buxP3.xcss)({
    top: `76px`
});
const $39cc7021b1f9471a$var$stickyWrapper = (0, $buxP3.xcss)({
    zIndex: 'card',
    // Needs to be at least z-index 2 to appear on top of Content and Shortcuts
    display: 'flex',
    position: 'sticky',
    top: `62px`,
    // @ts-ignore not assignable to type 'MarginSpace | GlobalValue | undefined'
    marginTop: `-50px`,
    //this hides the button underneath the space header until the ser scrolls down
    marginLeft: `auto`,
    marginRight: 'auto'
});
const $39cc7021b1f9471a$var$pressableStyles = (0, $buxP3.xcss)({
    backgroundColor: 'elevation.surface',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderRadius: 'radius.full',
    paddingInline: 'space.100',
    alignItems: 'center',
    justifyContent: 'center',
    width: '125px',
    height: '32px',
    flexShrink: '0',
    boxShadow: 'elevation.shadow.overlay',
    transition: "var(--ds-button-hovered, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))",
    ':hover': {
        backgroundColor: 'elevation.surface.hovered'
    },
    ':active': {
        backgroundColor: 'elevation.surface.pressed',
        transition: "var(--ds-button-pressed, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"
    },
    ':focus': {
        outline: 'color.border.focused'
    }
});
const $39cc7021b1f9471a$var$i18n = (0, $kSwu1.defineMessages)({
    scrollToTopButtonLabel: {
        id: "side-navigation.global.scroll-to-top.button.label",
        defaultMessage: "Back to top"
    }
});















var $gyUf8 = parcelRequire("gyUf8");

















const $476e0e4b3e7f33df$var$LazySpaceMoreActionsMenuContent = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "8HXE5",
    name: "LazySpaceMoreActionsMenuContent",
    loader: async ()=>(await (parcelRequire("ipTw1"))).SpaceMoreActionsMenuContent
});

const $476e0e4b3e7f33df$var$LazyRestrictedSpaceMoreActionsMenuContent = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ZCfkL",
    name: "LazyRestrictedSpaceMoreActionsMenuContent",
    loader: async ()=>(await (parcelRequire("ipTw1"))).RestrictedSpaceMoreActionsMenuContent
});
const $476e0e4b3e7f33df$export$cd488ab2b367186 = (props)=>{
    const $ = (0, $bDgLe.c)(20);
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== props) {
        t0 = ()=>{
            props.setIsOpen(!props.isOpen);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "spaceMoreActionsMenu",
                    source: "spaceNavigation",
                    attributes: {
                        navigationLayer: "container",
                        navigationContainer: "sidebar",
                        navVersion: "4",
                        componentType: "fixedItemButton",
                        itemId: "meatballDropdown",
                        isSpaceAdmin: props.isSpaceAdmin
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    const onClick = t0;
    let t1;
    if ($[3] !== createAnalyticsEvent || $[4] !== props) {
        t1 = (selection)=>(e)=>{
                e.stopPropagation();
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "button",
                        actionSubjectId: "spaceMoreActionsMenuItem",
                        source: "spaceMoreActionsMenu",
                        attributes: {
                            navigationLayer: "container",
                            navigationContainer: "sidebar",
                            navVersion: "4",
                            componentType: "fixedItemAction",
                            itemId: selection,
                            isSpaceAdmin: props.isSpaceAdmin
                        }
                    }
                }).fire();
                props.setIsOpen(false);
            };
        $[3] = createAnalyticsEvent;
        $[4] = props;
        $[5] = t1;
    } else t1 = $[5];
    const onMenuItemClicked = t1;
    let t2;
    if ($[6] !== props) {
        t2 = ()=>props.setIsOpen(false);
        $[6] = props;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== isLoggedIn || $[9] !== onMenuItemClicked || $[10] !== props) {
        t3 = ()=>isLoggedIn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($476e0e4b3e7f33df$var$LazySpaceMoreActionsMenuContent, {
                ...props,
                onMenuItemClicked: onMenuItemClicked
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($476e0e4b3e7f33df$var$LazyRestrictedSpaceMoreActionsMenuContent, {
                ...props,
                onMenuItemClicked: onMenuItemClicked
            });
        $[8] = isLoggedIn;
        $[9] = onMenuItemClicked;
        $[10] = props;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== onClick || $[13] !== props) {
        t4 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...triggerProps,
                icon: $476e0e4b3e7f33df$var$_temp,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $476e0e4b3e7f33df$var$i18n.moreActions),
                onClick: onClick,
                spacing: "compact",
                appearance: "subtle",
                isSelected: props.isOpen
            }), props.isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gyUf8.default), {
                testId: "space-more-actions-menu-blanket",
                isTinted: false,
                shouldAllowClickThrough: !props.isOpen,
                onBlanketClicked: ()=>props.setIsOpen(false)
            }) : null);
        $[12] = onClick;
        $[13] = props;
        $[14] = t4;
    } else t4 = $[14];
    let t5;
    if ($[15] !== props.isOpen || $[16] !== t2 || $[17] !== t3 || $[18] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
            isOpen: props.isOpen,
            onClose: t2,
            content: t3,
            trigger: t4,
            placement: "right-start"
        });
        $[15] = props.isOpen;
        $[16] = t2;
        $[17] = t3;
        $[18] = t4;
        $[19] = t5;
    } else t5 = $[19];
    return t5;
};
const $476e0e4b3e7f33df$var$i18n = (0, $kSwu1.defineMessages)({
    moreActions: {
        id: "side-navigation.space-navigation.more-actions",
        defaultMessage: "More actions"
    }
});
function $476e0e4b3e7f33df$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
        ...iconProps,
        size: "small"
    });
}



const $6f43a2e4204022e9$var$ExternalCollaboratorsSpaceInformationMessageLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "6-_i-",
    loader: async ()=>(await (parcelRequire("inA63"))).ExternalCollaboratorsSpaceInformationMessage,
    name: 'ExternalCollaboratorsSpaceInformationMessage'
});
const $6f43a2e4204022e9$export$d6e867962d0f60bb = (0, $a5d9c903e21f4503$export$2e2bcd8739ae039);
const $6f43a2e4204022e9$var$MANAGE_USERS = 'manage_users';
const $6f43a2e4204022e9$var$MANAGE_NONLICENSED_USERS = 'manage_nonlicensed_users';
const $6f43a2e4204022e9$var$MANAGE_GUEST_USERS = 'manage_guest_users';
const $6f43a2e4204022e9$var$ARCHIVE = 'archive';
const $6f43a2e4204022e9$var$ADMINISTER = 'administer';
const $6f43a2e4204022e9$var$MANAGE_CONTENT = 'manage_content';
const $6f43a2e4204022e9$var$MANAGE_PUBLIC_LINKS = 'manage_public_links';
const $6f43a2e4204022e9$var$VIEW_ANALYTICS = 'view_analytics';
const $6f43a2e4204022e9$var$SpaceHeaderFromFragment = (t0)=>{
    const $ = (0, $bDgLe.c)(36);
    const { spaceFragmentRef: spaceFragmentRef, isExternalCollaborator: isExternalCollaborator, externalCollaboratorsSpaceFragmentRef: externalCollaboratorsSpaceFragmentRef } = t0;
    const space = (0, $6SsN4.useFragment)($6f43a2e4204022e9$export$d6e867962d0f60bb, spaceFragmentRef);
    let t1;
    if ($[0] !== space.operations) {
        t1 = space.operations ?? [];
        $[0] = space.operations;
        $[1] = t1;
    } else t1 = $[1];
    const operations = t1;
    const showExCoMessaging = !isExternalCollaborator && space.containsExternalCollaborators;
    const t2 = space.id ?? "";
    const t3 = space.name ?? "";
    const t4 = space.key ?? "";
    const t5 = space.homepage?.id ?? undefined;
    const t6 = `${(0, $jlIaF.CONTEXT_PATH)}${space.icon?.path}`;
    const t7 = Boolean(space.currentUser?.isFavourited);
    const t8 = Boolean(space.currentUser?.isWatched);
    const t9 = space.currentUser?.isAdmin ?? false;
    let t10;
    if ($[2] !== operations) {
        t10 = operations.some($6f43a2e4204022e9$var$_temp);
        $[2] = operations;
        $[3] = t10;
    } else t10 = $[3];
    let t11;
    if ($[4] !== operations) {
        t11 = operations.some($6f43a2e4204022e9$var$_temp2);
        $[4] = operations;
        $[5] = t11;
    } else t11 = $[5];
    let t12;
    if ($[6] !== operations) {
        t12 = operations.some($6f43a2e4204022e9$var$_temp3);
        $[6] = operations;
        $[7] = t12;
    } else t12 = $[7];
    let t13;
    if ($[8] !== operations) {
        t13 = operations.some($6f43a2e4204022e9$var$_temp4);
        $[8] = operations;
        $[9] = t13;
    } else t13 = $[9];
    let t14;
    if ($[10] !== operations) {
        t14 = operations.some($6f43a2e4204022e9$var$_temp5);
        $[10] = operations;
        $[11] = t14;
    } else t14 = $[11];
    const t15 = space.type === "personal";
    const t16 = space.status === "archived";
    let t17;
    if ($[12] !== operations) {
        t17 = operations.some($6f43a2e4204022e9$var$_temp6);
        $[12] = operations;
        $[13] = t17;
    } else t17 = $[13];
    let t18;
    if ($[14] !== operations) {
        t18 = operations.some($6f43a2e4204022e9$var$_temp7);
        $[14] = operations;
        $[15] = t18;
    } else t18 = $[15];
    let t19;
    if ($[16] !== externalCollaboratorsSpaceFragmentRef || $[17] !== showExCoMessaging || $[18] !== t10 || $[19] !== t11 || $[20] !== t12 || $[21] !== t13 || $[22] !== t14 || $[23] !== t15 || $[24] !== t16 || $[25] !== t17 || $[26] !== t18 || $[27] !== t2 || $[28] !== t3 || $[29] !== t4 || $[30] !== t5 || $[31] !== t6 || $[32] !== t7 || $[33] !== t8 || $[34] !== t9) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f43a2e4204022e9$var$SpaceHeaderInner, {
            spaceId: t2,
            spaceName: t3,
            spaceKey: t4,
            homepageId: t5,
            iconPath: t6,
            isStarred: t7,
            isWatched: t8,
            isSpaceAdmin: t9,
            canManageSomeUsers: t10,
            canAdminister: t11,
            canManageContent: t12,
            canManagePublicLinks: t13,
            canViewAnalytics: t14,
            isPersonalSpace: t15,
            showExCoMessaging: showExCoMessaging,
            externalCollaboratorsSpaceFragmentRef: externalCollaboratorsSpaceFragmentRef,
            isSpaceArchived: t16,
            hasDeleteSpacePermission: t17,
            hasArchiveSpacePermission: t18
        });
        $[16] = externalCollaboratorsSpaceFragmentRef;
        $[17] = showExCoMessaging;
        $[18] = t10;
        $[19] = t11;
        $[20] = t12;
        $[21] = t13;
        $[22] = t14;
        $[23] = t15;
        $[24] = t16;
        $[25] = t17;
        $[26] = t18;
        $[27] = t2;
        $[28] = t3;
        $[29] = t4;
        $[30] = t5;
        $[31] = t6;
        $[32] = t7;
        $[33] = t8;
        $[34] = t9;
        $[35] = t19;
    } else t19 = $[35];
    return t19;
};
const $6f43a2e4204022e9$export$533fb76256978163 = (props)=>{
    const $ = (0, $bDgLe.c)(13);
    if (props.spaceFragmentRef) {
        let t0;
        if ($[0] !== props.externalCollaboratorsSpaceFragmentRef || $[1] !== props.isExternalCollaborator || $[2] !== props.spaceFragmentRef) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f43a2e4204022e9$var$SpaceHeaderFromFragment, {
                spaceFragmentRef: props.spaceFragmentRef,
                isExternalCollaborator: props.isExternalCollaborator,
                externalCollaboratorsSpaceFragmentRef: props.externalCollaboratorsSpaceFragmentRef
            });
            $[0] = props.externalCollaboratorsSpaceFragmentRef;
            $[1] = props.isExternalCollaborator;
            $[2] = props.spaceFragmentRef;
            $[3] = t0;
        } else t0 = $[3];
        return t0;
    }
    let containsExternalCollaborators;
    let externalCollaboratorsSpaceFragmentRef;
    let isExternalCollaborator;
    let spaceHeaderProps;
    if ($[4] !== props) {
        ({ isExternalCollaborator: isExternalCollaborator, containsExternalCollaborators: containsExternalCollaborators, externalCollaboratorsSpaceFragmentRef: externalCollaboratorsSpaceFragmentRef, ...spaceHeaderProps } = props);
        $[4] = props;
        $[5] = containsExternalCollaborators;
        $[6] = externalCollaboratorsSpaceFragmentRef;
        $[7] = isExternalCollaborator;
        $[8] = spaceHeaderProps;
    } else {
        containsExternalCollaborators = $[5];
        externalCollaboratorsSpaceFragmentRef = $[6];
        isExternalCollaborator = $[7];
        spaceHeaderProps = $[8];
    }
    const showExCoMessaging = !isExternalCollaborator && containsExternalCollaborators;
    let t0;
    if ($[9] !== externalCollaboratorsSpaceFragmentRef || $[10] !== showExCoMessaging || $[11] !== spaceHeaderProps) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f43a2e4204022e9$var$SpaceHeaderInner, {
            ...spaceHeaderProps,
            showExCoMessaging: showExCoMessaging,
            externalCollaboratorsSpaceFragmentRef: externalCollaboratorsSpaceFragmentRef
        });
        $[9] = externalCollaboratorsSpaceFragmentRef;
        $[10] = showExCoMessaging;
        $[11] = spaceHeaderProps;
        $[12] = t0;
    } else t0 = $[12];
    return t0;
};
const $6f43a2e4204022e9$var$SpaceHeaderInner = (t0)=>{
    const $ = (0, $bDgLe.c)(46);
    const { spaceId: spaceId, spaceName: spaceName, spaceKey: spaceKey, homepageId: homepageId, iconPath: iconPath, isStarred: isStarred, isWatched: isWatched, isSpaceAdmin: isSpaceAdmin, canManageSomeUsers: canManageSomeUsers, canAdminister: canAdminister, canManageContent: canManageContent, canManagePublicLinks: canManagePublicLinks, canViewAnalytics: canViewAnalytics, isPersonalSpace: isPersonalSpace, showExCoMessaging: showExCoMessaging, isSpaceArchived: isSpaceArchived, hasDeleteSpacePermission: hasDeleteSpacePermission, hasArchiveSpacePermission: hasArchiveSpacePermission, externalCollaboratorsSpaceFragmentRef: externalCollaboratorsSpaceFragmentRef } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isSelected = (0, $dPJCf.useRouteName)($6f43a2e4204022e9$var$isOnSpaceRouteArgs);
    let t1;
    if ($[0] !== homepageId || $[1] !== spaceKey) {
        t1 = (0, $1NBp8.SPACE_OVERVIEW).toUrl({
            spaceKey: spaceKey
        }, homepageId ? {
            query: {
                [(0, $1NBp8.SPACE_OVERVIEW).HOMEPAGE_ID_QUERY_KEY]: homepageId
            }
        } : undefined);
        $[0] = homepageId;
        $[1] = spaceKey;
        $[2] = t1;
    } else t1 = $[2];
    const spaceOverviewHref = t1;
    let t2;
    if ($[3] !== externalCollaboratorsSpaceFragmentRef || $[4] !== showExCoMessaging || $[5] !== spaceKey) {
        t2 = showExCoMessaging ? (0, $6mKj3.expVal)("cc_perms_fix_guests_css_safari", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbgJ9S _1U1ZhbbI28 _4Gn54RiZR3 _39xV02N91d"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f43a2e4204022e9$var$ExternalCollaboratorsSpaceInformationMessageLoader, {
            analyticsSource: "spaceHeader",
            messageType: "IN_SPACE",
            shouldShowMessageIcon: false,
            shouldShowAdditionalMessageContext: false,
            spaceKey: spaceKey,
            spaceFragmentRef: externalCollaboratorsSpaceFragmentRef,
            isSubtle: true
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
            weight: "medium"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f43a2e4204022e9$var$ExternalCollaboratorsSpaceInformationMessageLoader, {
            analyticsSource: "spaceHeader",
            messageType: "IN_SPACE",
            shouldShowMessageIcon: false,
            shouldShowAdditionalMessageContext: false,
            spaceKey: spaceKey,
            spaceFragmentRef: externalCollaboratorsSpaceFragmentRef,
            isSubtle: true
        })) : undefined;
        $[3] = externalCollaboratorsSpaceFragmentRef;
        $[4] = showExCoMessaging;
        $[5] = spaceKey;
        $[6] = t2;
    } else t2 = $[6];
    const description = t2;
    let t3;
    if ($[7] !== createAnalyticsEvent) {
        t3 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "spaceHeader",
                    source: "sideNavigation",
                    attributes: {
                        navVersion: 4
                    }
                }
            }).fire();
        };
        $[7] = createAnalyticsEvent;
        $[8] = t3;
    } else t3 = $[8];
    const onClick = t3;
    const [isMoreActionsOpen, setIsMoreActionsOpen] = (0, $cozmU.useState)(false);
    let t4;
    if ($[9] !== canAdminister || $[10] !== canManageContent || $[11] !== canManagePublicLinks || $[12] !== canManageSomeUsers || $[13] !== canViewAnalytics || $[14] !== hasArchiveSpacePermission || $[15] !== hasDeleteSpacePermission || $[16] !== isMoreActionsOpen || $[17] !== isSpaceAdmin || $[18] !== isSpaceArchived || $[19] !== isStarred || $[20] !== isWatched || $[21] !== spaceId || $[22] !== spaceKey) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $476e0e4b3e7f33df$export$cd488ab2b367186), {
            isOpen: isMoreActionsOpen,
            setIsOpen: setIsMoreActionsOpen,
            spaceId: spaceId,
            spaceKey: spaceKey,
            isStarred: isStarred,
            isWatched: isWatched,
            isSpaceAdmin: isSpaceAdmin,
            canManageSomeUsers: canManageSomeUsers,
            canAdminister: canAdminister,
            canManageContent: canManageContent,
            canManagePublicLinks: canManagePublicLinks,
            canViewAnalytics: canViewAnalytics,
            isSpaceArchived: isSpaceArchived,
            hasDeleteSpacePermission: hasDeleteSpacePermission,
            hasArchiveSpacePermission: hasArchiveSpacePermission
        });
        $[9] = canAdminister;
        $[10] = canManageContent;
        $[11] = canManagePublicLinks;
        $[12] = canManageSomeUsers;
        $[13] = canViewAnalytics;
        $[14] = hasArchiveSpacePermission;
        $[15] = hasDeleteSpacePermission;
        $[16] = isMoreActionsOpen;
        $[17] = isSpaceAdmin;
        $[18] = isSpaceArchived;
        $[19] = isStarred;
        $[20] = isWatched;
        $[21] = spaceId;
        $[22] = spaceKey;
        $[23] = t4;
    } else t4 = $[23];
    const moreActionsMenu = t4;
    let t5;
    if ($[24] !== iconPath || $[25] !== isPersonalSpace || $[26] !== isSpaceAdmin || $[27] !== spaceId || $[28] !== spaceKey) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f43a2e4204022e9$var$EditableSpaceIcon, {
            spaceId: spaceId,
            spaceKey: spaceKey,
            iconPath: iconPath,
            isSpaceAdmin: isSpaceAdmin,
            isPersonalSpace: isPersonalSpace
        });
        $[24] = iconPath;
        $[25] = isPersonalSpace;
        $[26] = isSpaceAdmin;
        $[27] = spaceId;
        $[28] = spaceKey;
        $[29] = t5;
    } else t5 = $[29];
    let t6;
    if ($[30] !== description || $[31] !== isSelected || $[32] !== moreActionsMenu || $[33] !== onClick || $[34] !== spaceName || $[35] !== spaceOverviewHref || $[36] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
            href: spaceOverviewHref,
            isSelected: isSelected,
            onClick: onClick,
            elemBefore: t5,
            actions: moreActionsMenu,
            description: description
        }, spaceName);
        $[30] = description;
        $[31] = isSelected;
        $[32] = moreActionsMenu;
        $[33] = onClick;
        $[34] = spaceName;
        $[35] = spaceOverviewHref;
        $[36] = t5;
        $[37] = t6;
    } else t6 = $[37];
    let t7;
    if ($[38] !== spaceOverviewHref || $[39] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $6f43a2e4204022e9$var$stickyWrapper,
            "data-vc": "Nav4-space-header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f43a2e4204022e9$var$SpaceHeaderContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f37e6d818dab503c$export$febddff29c5b0caa), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hXDOc.HoverPreloader), {
            name: "space-header",
            preloadUrl: spaceOverviewHref,
            preloadOptions: (0, $hXDOc.PreloadingPresets).onlyJSAndCriticalData
        }, t6)))));
        $[38] = spaceOverviewHref;
        $[39] = t6;
        $[40] = t7;
    } else t7 = $[40];
    let t8;
    if ($[41] !== showExCoMessaging) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39cc7021b1f9471a$export$c915848be66d4457), {
            showExCoMessaging: showExCoMessaging
        });
        $[41] = showExCoMessaging;
        $[42] = t8;
    } else t8 = $[42];
    let t9;
    if ($[43] !== t7 || $[44] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t7, t8);
        $[43] = t7;
        $[44] = t8;
        $[45] = t9;
    } else t9 = $[45];
    return t9;
};
const $6f43a2e4204022e9$var$EditableSpaceIcon = (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { spaceId: spaceId, spaceKey: spaceKey, iconPath: iconPath, isSpaceAdmin: isSpaceAdmin, isPersonalSpace: isPersonalSpace } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isDialogOpen, setIsDialogOpen] = (0, $cozmU.useState)(false);
    const [shouldRenderDialog, setShouldRenderDialog] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== iconPath) {
        t1 = iconPath ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
            src: iconPath,
            alt: "",
            "data-testid": "space-icon",
            "data-vc": "space-header-icon-image",
            "data-ssr-placeholder-ignored": true,
            role: "presentation",
            className: (0, $hekY6.default)([
                "_0bjKvDKTcp _39xV02oWWg _0jFU0VoWWg"
            ])
        }) : null;
        $[0] = iconPath;
        $[1] = t1;
    } else t1 = $[1];
    const image = t1;
    const canEdit = isSpaceAdmin && !isPersonalSpace;
    if (!canEdit) return image;
    let t2;
    if ($[2] !== intl) {
        t2 = intl.formatMessage($6f43a2e4204022e9$var$i18n.editSpaceDetails);
        $[2] = intl;
        $[3] = t2;
    } else t2 = $[3];
    const editLabel = t2;
    let t3;
    if ($[4] !== createAnalyticsEvent || $[5] !== experienceTracker || $[6] !== spaceId || $[7] !== spaceKey) {
        t3 = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            experienceTracker.start({
                name: (0, $irVI7.EDIT_SPACE_LOGO_DETAILS_LOAD_EXPERIENCE),
                timeout: 10000
            });
            setShouldRenderDialog(true);
            setIsDialogOpen(true);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "editSpaceDetails",
                    source: "sideNavSpaceHeader",
                    containerType: "space",
                    containerId: spaceId,
                    attributes: {
                        navVersion: 4,
                        entryPoint: "sideNav",
                        spaceKey: spaceKey
                    }
                }
            }).fire();
        };
        $[4] = createAnalyticsEvent;
        $[5] = experienceTracker;
        $[6] = spaceId;
        $[7] = spaceKey;
        $[8] = t3;
    } else t3 = $[8];
    const onClick = t3;
    let t4;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            setShouldRenderDialog(true);
        };
        $[9] = t4;
    } else t4 = $[9];
    const onFocus = t4;
    let t5;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>{
            setShouldRenderDialog(true);
        };
        $[10] = t5;
    } else t5 = $[10];
    const onMouseEnter = t5;
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            setIsDialogOpen(true);
        };
        $[11] = t6;
    } else t6 = $[11];
    const onDialogOpen = t6;
    let t7;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>{
            setIsDialogOpen(false);
        };
        $[12] = t7;
    } else t7 = $[12];
    const onDialogClose = t7;
    let t8;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $6f43a2e4204022e9$var$editIconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
            label: "",
            color: "var(--ds-icon-inverse, #FFFFFF)"
        }));
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] !== editLabel || $[15] !== image || $[16] !== onClick) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
            xcss: (0, $9wGTI.fg)("confluence_frontend_tokenize_border") ? $6f43a2e4204022e9$var$iconButton : $6f43a2e4204022e9$var$iconButtonFallback,
            "aria-label": editLabel,
            onClick: onClick,
            onFocus: onFocus,
            onMouseEnter: onMouseEnter
        }, image, t8);
        $[14] = editLabel;
        $[15] = image;
        $[16] = onClick;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== editLabel || $[19] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: editLabel
        }, t9);
        $[18] = editLabel;
        $[19] = t9;
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== isDialogOpen || $[22] !== shouldRenderDialog || $[23] !== spaceKey) {
        t11 = shouldRenderDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eWwvy.EditSpaceLogo), {
            spaceKey: spaceKey,
            isOpen: isDialogOpen,
            onOpen: onDialogOpen,
            onClose: onDialogClose,
            entryPoint: "sideNav"
        });
        $[21] = isDialogOpen;
        $[22] = shouldRenderDialog;
        $[23] = spaceKey;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== t10 || $[26] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t10, t11);
        $[25] = t10;
        $[26] = t11;
        $[27] = t12;
    } else t12 = $[27];
    return t12;
};
const $6f43a2e4204022e9$var$isOnSpaceRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.SPACE_INDEX).name || routeName === (0, $1NBp8.SPACE_OVERVIEW).name
}; // Safari workaround: the LinkMenuItem `description` slot applies
// `-webkit-line-clamp: 1` which triggers a WebKit bug that clips inline-flex
// children (the "1 guest" button). Nesting our own `-webkit-box` with
// `line-clamp: 2` gives the content enough room that the clamp engine never
// has to truncate, avoiding the bug.
const $6f43a2e4204022e9$var$exCoMessageContainerStyles = null;
const $6f43a2e4204022e9$var$stickyWrapper = (0, $buxP3.xcss)({
    position: 'sticky',
    top: 'space.0',
    zIndex: 'navigation' // Needs to be at least z-index 2 to appear on top of Content and Shortcuts
});
const $6f43a2e4204022e9$var$icon = null;
const $6f43a2e4204022e9$var$iconButton = (0, $buxP3.xcss)({
    border: "var(--ds-space-0, 0px)",
    borderRadius: 'radius.small',
    background: 'none',
    padding: 'space.0',
    position: 'relative',
    width: '24px',
    height: '24px',
    cursor: 'pointer',
    marginTop: 'space.050'
});
const $6f43a2e4204022e9$var$iconButtonFallback = (0, $buxP3.xcss)({
    border: 'none',
    borderRadius: 'radius.small',
    background: 'none',
    padding: 'space.0',
    position: 'relative',
    width: '24px',
    height: '24px',
    cursor: 'pointer',
    marginTop: 'space.050'
});
const $6f43a2e4204022e9$var$editIconWrapper = (0, $buxP3.xcss)({
    position: 'absolute',
    height: '24px',
    width: '24px',
    top: 'space.0',
    left: 'space.0',
    padding: 'space.050',
    opacity: 0,
    transition: 'opacity 0.5s ease',
    ':hover': {
        opacity: 1
    },
    ':focus': {
        opacity: 1
    },
    backgroundColor: 'color.blanket',
    borderRadius: 'radius.medium'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f43a2e4204022e9$var$SpaceHeaderContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0Of8r28HPE _1wydGWdLIE _0KLXrulfZc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $6f43a2e4204022e9$var$i18n = (0, $kSwu1.defineMessages)({
    editSpaceDetails: {
        id: "side-navigation.space-navigation.header.edit-space-details",
        defaultMessage: "Edit space details"
    }
});
function $6f43a2e4204022e9$var$_temp(operation) {
    return operation?.operation === $6f43a2e4204022e9$var$MANAGE_USERS || operation?.operation === $6f43a2e4204022e9$var$MANAGE_NONLICENSED_USERS || operation?.operation === $6f43a2e4204022e9$var$MANAGE_GUEST_USERS;
}
function $6f43a2e4204022e9$var$_temp2(operation_0) {
    return operation_0?.operation === $6f43a2e4204022e9$var$ADMINISTER && operation_0?.targetType === "space";
}
function $6f43a2e4204022e9$var$_temp3(operation_1) {
    return operation_1?.operation === $6f43a2e4204022e9$var$MANAGE_CONTENT && operation_1?.targetType === "space";
}
function $6f43a2e4204022e9$var$_temp4(operation_2) {
    return operation_2?.operation === $6f43a2e4204022e9$var$MANAGE_PUBLIC_LINKS && operation_2?.targetType === "space";
}
function $6f43a2e4204022e9$var$_temp5(operation_3) {
    return operation_3?.operation === $6f43a2e4204022e9$var$VIEW_ANALYTICS && operation_3?.targetType === "space";
}
function $6f43a2e4204022e9$var$_temp6(operation_4) {
    return operation_4?.operation === "delete" && operation_4?.targetType === "space";
}
function $6f43a2e4204022e9$var$_temp7(operation_5) {
    return operation_5?.operation === $6f43a2e4204022e9$var$ARCHIVE && operation_5?.targetType === "space";
}



var $ENihE = parcelRequire("ENihE");




/**
 * @generated SignedSource<<1c6387c3ead8cdcd65a8b84d53f56cdf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e00178ae9521a52a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SpaceLinks_spaceSidebarLinks",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "includeHidden",
                    "value": true
                }
            ],
            "concreteType": "SpaceSidebarLink",
            "kind": "LinkedField",
            "name": "main",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "webItemCompleteKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "position"
                },
                {
                    "kind": "ScalarField",
                    "name": "hidden"
                }
            ],
            "storageKey": "main(includeHidden:true)"
        }
    ],
    "type": "SpaceSidebarLinks"
};
$e00178ae9521a52a$var$node.hash = "26e483dae4ed854796f11e515ee4e767";
var $e00178ae9521a52a$export$2e2bcd8739ae039 = $e00178ae9521a52a$var$node;












var $euL71 = parcelRequire("euL71");











var $28oQf = parcelRequire("28oQf");

const $078c23c8ca6acb4f$export$ec7e3f071e25a7f5 = (0, $e00178ae9521a52a$export$2e2bcd8739ae039);
const $078c23c8ca6acb4f$var$SpaceLinksFromFragment = (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { spaceSidebarLinksFragmentRef: spaceSidebarLinksFragmentRef } = t0;
    const spaceSidebarLinks = (0, $6SsN4.useFragment)($078c23c8ca6acb4f$export$ec7e3f071e25a7f5, spaceSidebarLinksFragmentRef);
    let result;
    if ($[0] !== spaceSidebarLinks.main) {
        result = [];
        for (const link of spaceSidebarLinks.main ?? [])if (link) result.push(link);
        $[0] = spaceSidebarLinks.main;
        $[1] = result;
    } else result = $[1];
    const links = result;
    let t1;
    if ($[2] !== links) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($078c23c8ca6acb4f$var$SpaceLinksInner, {
            links: links
        });
        $[2] = links;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
const $078c23c8ca6acb4f$export$5ff3b51f9b84be4d = (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props.links || $[1] !== props.spaceSidebarLinksFragmentRef) {
        t0 = props.spaceSidebarLinksFragmentRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($078c23c8ca6acb4f$var$SpaceLinksFromFragment, {
            spaceSidebarLinksFragmentRef: props.spaceSidebarLinksFragmentRef
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($078c23c8ca6acb4f$var$SpaceLinksInner, {
            links: props.links
        });
        $[0] = props.links;
        $[1] = props.spaceSidebarLinksFragmentRef;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
const $078c23c8ca6acb4f$var$SpaceLinksInner = /*#__PURE__*/ (0, $cozmU.memo)((t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { links: links } = t0;
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPremiumEdition = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== isPremiumEdition || $[2] !== routeDataRef) {
        t1 = (itemId)=>()=>{
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "navigationItem",
                        actionSubjectId: "spaceNavigationItem",
                        source: "containerNavigation",
                        attributes: {
                            navigationLayer: "container",
                            itemId: itemId,
                            selectedItemPageContext: routeDataRef.current?.routeName,
                            navVersion: "4",
                            isPremiumEdition: isPremiumEdition
                        }
                    }
                }).fire();
            };
        $[0] = createAnalyticsEvent;
        $[1] = isPremiumEdition;
        $[2] = routeDataRef;
        $[3] = t1;
    } else t1 = $[3];
    const sendItemClickedAnalytics = t1;
    let t2;
    if ($[4] !== sendItemClickedAnalytics) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($078c23c8ca6acb4f$var$CalendarsLink, {
            key: "calendars-link",
            onClick: sendItemClickedAnalytics("calendars")
        });
        $[4] = sendItemClickedAnalytics;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== sendItemClickedAnalytics) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($078c23c8ca6acb4f$var$QuestionsLink, {
            key: "questions-native-link",
            onClick: sendItemClickedAnalytics("questions")
        });
        $[6] = sendItemClickedAnalytics;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== links || $[9] !== t2 || $[10] !== t3) {
        const builtInitemsMapping = {
            [(0, $28oQf.CALENDARS_KEY)]: t2,
            [(0, $28oQf.QUESTIONS_NATIVE_KEY)]: t3
        };
        t4 = links.filter($078c23c8ca6acb4f$var$_temp).slice().sort($078c23c8ca6acb4f$var$_temp2).map((t5)=>{
            const { webItemCompleteKey: webItemCompleteKey } = t5;
            return webItemCompleteKey && builtInitemsMapping[webItemCompleteKey] || null;
        });
        $[8] = links;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    const renderedLinks = t4;
    let t5;
    if ($[12] !== renderedLinks) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderedLinks);
        $[12] = renderedLinks;
        $[13] = t5;
    } else t5 = $[13];
    return t5;
});

const $078c23c8ca6acb4f$var$CalendarsLink = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HaydR",
    name: "CalendarsLink",
    loader: async ()=>(await (parcelRequire("29Vr1"))).CalendarsLink
});

const $078c23c8ca6acb4f$var$QuestionsLink = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "8uaMN",
    name: "QuestionsLink",
    loader: async ()=>(await (parcelRequire("3vaGk"))).QuestionsLink
});
function $078c23c8ca6acb4f$var$_temp(link) {
    return !link.hidden;
}
function $078c23c8ca6acb4f$var$_temp2(a, b) {
    return Number(a.position) - Number(b.position);
}



var $aWrnw = parcelRequire("aWrnw");


var $dJFqB = parcelRequire("dJFqB");


var $dGmBZ = parcelRequire("dGmBZ");


const $c83507daffd5a949$var$ErrorView = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "NxOnG",
    name: "ErrorView",
    loader: async ()=>(await (parcelRequire("3gezS"))).ErrorView
});

const $c83507daffd5a949$var$SpaceApps = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MuuSQ",
    name: "SpaceApps",
    loader: async ()=>(await (parcelRequire("kofcT"))).SpaceApps
});
const $c83507daffd5a949$var$spaceLinksStyles = null;
const $c83507daffd5a949$var$SidebarContent = /*#__PURE__*/ (0, $cozmU.memo)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1wydGWPgdg _1mT5xdRAKS _313842IZbP",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}));
const $c83507daffd5a949$var$relatedContentStyles = {
    container: "_1mT5xdHE3j _0Bm75GdnbC _0KLXrulfZc _1wydGW8HPE _42Yu6B7dHp"
};
const $c83507daffd5a949$var$separatorStyles = null;
const $c83507daffd5a949$var$separatorStylesFallback = null;
const $c83507daffd5a949$export$ec7f7d400376dc53 = (props)=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] !== props) {
        t0 = (!(0, $1xpoY.default).isKillSwitchOn("confluence_space_nav_core_frag_reader") || !(0, $1xpoY.default).isKillSwitchOn("confluence_space_nav_space_views_frag_reader") || !(0, $1xpoY.default).isKillSwitchOn("confluence_space_nav_trees_frag_reader")) && (0, $6mKj3.expVal)("confluence_exp_space_nav_contract", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c83507daffd5a949$var$RouteBackedSpaceNavigationContent, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c83507daffd5a949$var$LegacySpaceNavigationContent, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    const content = t0;
    let t1;
    if ($[2] !== content || $[3] !== props.navigationProps) {
        t1 = !(0, $1xpoY.default).isKillSwitchOn("confluence_space_nav_affordances_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_space_nav_contract", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dJFqB.SpaceNavigationAffordanceDataProvider), {
            spaceKey: props.navigationProps.spaceKey,
            variables: props.navigationProps.routeReaderVariables
        }, content) : content;
        $[2] = content;
        $[3] = props.navigationProps;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
};
const $c83507daffd5a949$var$RouteBackedSpaceNavigationContent = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    let props;
    if ($[0] !== t0) {
        ({ ...props } = t0);
        $[0] = t0;
        $[1] = props;
    } else props = $[1];
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $9HB34.getRelayEnvironment)();
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6SsN4.RelayEnvironmentProvider), {
            environment: t1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c83507daffd5a949$var$RouteBackedSpaceNavigationContentInner, props));
        $[3] = props;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
const $c83507daffd5a949$var$RouteBackedSpaceNavigationContentInner = (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    let navigationProps;
    let props;
    if ($[0] !== t0) {
        ({ navigationProps: navigationProps, ...props } = t0);
        $[0] = t0;
        $[1] = navigationProps;
        $[2] = props;
    } else {
        navigationProps = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            fetchPolicy: "store-only"
        };
        $[3] = t1;
    } else t1 = $[3];
    const routeData = (0, $6SsN4.useLazyLoadQuery)((0, $dGmBZ.default), navigationProps.routeReaderVariables, t1);
    if (!routeData.space || !routeData.spaceSidebarLinks && !(0, $1xpoY.default).isKillSwitchOn("confluence_space_nav_core_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_space_nav_contract", "isEnabled", false)) {
        let t2;
        if ($[4] !== navigationProps || $[5] !== props) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c83507daffd5a949$var$LegacySpaceNavigationContent, {
                navigationProps: navigationProps,
                ...props
            });
            $[4] = navigationProps;
            $[5] = props;
            $[6] = t2;
        } else t2 = $[6];
        return t2;
    }
    const t2 = routeData.spaceSidebarLinks ?? undefined;
    const t3 = routeData.userPreferences ?? undefined;
    let t4;
    if ($[7] !== routeData || $[8] !== t2 || $[9] !== t3) {
        t4 = {
            query: routeData,
            space: routeData.space,
            spaceSidebarLinks: t2,
            userPreferences: t3
        };
        $[7] = routeData;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== navigationProps || $[12] !== props || $[13] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c83507daffd5a949$var$SpaceNavigationContentLayout, {
            navigationProps: navigationProps,
            routeFragmentRefs: t4,
            ...props
        });
        $[11] = navigationProps;
        $[12] = props;
        $[13] = t4;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
};
const $c83507daffd5a949$var$LegacySpaceNavigationContent = (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c83507daffd5a949$var$SpaceNavigationContentLayout, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
const $c83507daffd5a949$var$SpaceNavigationContentLayout = (t0)=>{
    const $ = (0, $bDgLe.c)(63);
    const { navigationProps: navigationProps, errorProps: errorProps, spaceDetails: spaceDetails, routeFragmentRefs: routeFragmentRefs } = t0;
    const affordanceData = (0, $dJFqB.useSpaceNavigationAffordanceData)();
    const { loading: loading, hasSpace: hasSpace, space: space, spaceKey: spaceKey, homepageId: homepageId, main: main, quick: quick, isSpaceAdmin: isSpaceAdmin, isBlogNavigation: isBlogNavigation, blogsHidden: blogsHidden, pageTreeFinishedLoading: pageTreeFinishedLoading, onDragDropSuccess: onDragDropSuccess, showShortcutsSection: showShortcutsSection, shouldRenderSpaceApps: shouldRenderSpaceApps, allAppLinks: allAppLinks, allVisibleAppLinks: allVisibleAppLinks, loadingForgeApps: loadingForgeApps, onContentTreeLoadComplete: onContentTreeLoadComplete } = navigationProps;
    const { canAdminister: canAdminister } = spaceDetails;
    const t1 = spaceKey || "";
    let t2;
    if ($[0] !== t1) {
        t2 = {
            spaceKey: t1,
            operation: (0, $lfBMY.OperationTypes).CREATE,
            contentType: "page"
        };
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const [canCreateContent] = (0, $2wo33.useCanPerformSpaceOperation)(t2);
    const { unhandledError: unhandledError, hasRestrictedError: hasRestrictedError, hasNotFoundError: hasNotFoundError, anonymousAccessQueryError: anonymousAccessQueryError } = errorProps;
    if (unhandledError || hasRestrictedError || hasNotFoundError || anonymousAccessQueryError || !loading && !hasSpace) {
        const t3 = unhandledError || anonymousAccessQueryError;
        let t4;
        if ($[2] !== hasNotFoundError || $[3] !== hasRestrictedError || $[4] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c83507daffd5a949$var$ErrorView, {
                unhandledError: t3,
                hasRestrictedError: hasRestrictedError,
                hasNotFoundError: hasNotFoundError
            });
            $[2] = hasNotFoundError;
            $[3] = hasRestrictedError;
            $[4] = t3;
            $[5] = t4;
        } else t4 = $[5];
        return t4;
    }
    let t3;
    if ($[6] !== affordanceData?.isUserExternalCollaborator || $[7] !== affordanceData?.spaceFragmentRef || $[8] !== routeFragmentRefs || $[9] !== spaceDetails) {
        t3 = routeFragmentRefs && !(0, $1xpoY.default).isKillSwitchOn("confluence_space_nav_core_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_space_nav_contract", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6f43a2e4204022e9$export$533fb76256978163), {
            spaceFragmentRef: routeFragmentRefs.space,
            isExternalCollaborator: affordanceData?.isUserExternalCollaborator ?? Boolean(spaceDetails.isExternalCollaborator),
            externalCollaboratorsSpaceFragmentRef: affordanceData?.spaceFragmentRef
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6f43a2e4204022e9$export$533fb76256978163), {
            ...spaceDetails,
            externalCollaboratorsSpaceFragmentRef: affordanceData?.spaceFragmentRef
        });
        $[6] = affordanceData?.isUserExternalCollaborator;
        $[7] = affordanceData?.spaceFragmentRef;
        $[8] = routeFragmentRefs;
        $[9] = spaceDetails;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== loading) {
        t4 = !loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.APP_NAV_CONTAINER_EXPERIENCE)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null);
        $[11] = loading;
        $[12] = t4;
    } else t4 = $[12];
    const t5 = routeFragmentRefs?.spaceSidebarLinks && !(0, $1xpoY.default).isKillSwitchOn("confluence_space_nav_core_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_space_nav_contract", "isEnabled", false) ? routeFragmentRefs.spaceSidebarLinks : undefined;
    const t6 = routeFragmentRefs && !(0, $1xpoY.default).isKillSwitchOn("confluence_space_nav_trees_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_space_nav_contract", "isEnabled", false) ? routeFragmentRefs.query : undefined;
    const t7 = routeFragmentRefs && !(0, $1xpoY.default).isKillSwitchOn("confluence_space_nav_space_views_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_space_nav_contract", "isEnabled", false) ? routeFragmentRefs.space : undefined;
    const t8 = routeFragmentRefs && !(0, $1xpoY.default).isKillSwitchOn("confluence_space_nav_space_views_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_space_nav_contract", "isEnabled", false) ? routeFragmentRefs.userPreferences : undefined;
    let t9;
    if ($[13] !== blogsHidden || $[14] !== homepageId || $[15] !== isBlogNavigation || $[16] !== isSpaceAdmin || $[17] !== loading || $[18] !== onContentTreeLoadComplete || $[19] !== onDragDropSuccess || $[20] !== pageTreeFinishedLoading || $[21] !== quick || $[22] !== showShortcutsSection || $[23] !== space || $[24] !== spaceKey || $[25] !== t5 || $[26] !== t6 || $[27] !== t7 || $[28] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $72da3bb5b7695f3e$export$7716f65eb5d1a3fd), {
            showShortcutsSection: showShortcutsSection,
            space: space,
            spaceKey: spaceKey,
            quick: quick,
            homepageId: homepageId,
            loading: loading,
            isSpaceAdmin: isSpaceAdmin,
            isBlogNavigation: isBlogNavigation,
            blogsHidden: blogsHidden,
            pageTreeFinishedLoading: pageTreeFinishedLoading,
            onDragDropSuccess: onDragDropSuccess,
            onContentTreeLoadComplete: onContentTreeLoadComplete,
            shortcutsFragmentRef: t5,
            treeInitialDataFragmentRef: t6,
            spaceViewsRootFragmentRef: t7,
            spaceViewsPersistenceFragmentRef: t8
        });
        $[13] = blogsHidden;
        $[14] = homepageId;
        $[15] = isBlogNavigation;
        $[16] = isSpaceAdmin;
        $[17] = loading;
        $[18] = onContentTreeLoadComplete;
        $[19] = onDragDropSuccess;
        $[20] = pageTreeFinishedLoading;
        $[21] = quick;
        $[22] = showShortcutsSection;
        $[23] = space;
        $[24] = spaceKey;
        $[25] = t5;
        $[26] = t6;
        $[27] = t7;
        $[28] = t8;
        $[29] = t9;
    } else t9 = $[29];
    let t10;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = (0, $hekY6.default)([
            "_2XghbEPgdg _4FKVYEPgdg _1LMyvKYbGa _254aKfPgdg"
        ]);
        $[30] = t10;
    } else t10 = $[30];
    let t11;
    if ($[31] !== loading || $[32] !== main || $[33] !== routeFragmentRefs) {
        t11 = loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ENihE.ContainerSkeleton), {
            header: false
        }) : routeFragmentRefs?.spaceSidebarLinks && !(0, $1xpoY.default).isKillSwitchOn("confluence_space_nav_core_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_space_nav_contract", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $078c23c8ca6acb4f$export$5ff3b51f9b84be4d), {
            spaceSidebarLinksFragmentRef: routeFragmentRefs.spaceSidebarLinks
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $078c23c8ca6acb4f$export$5ff3b51f9b84be4d), {
            links: main
        });
        $[31] = loading;
        $[32] = main;
        $[33] = routeFragmentRefs;
        $[34] = t11;
    } else t11 = $[34];
    let t12;
    if ($[35] !== t10 || $[36] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", {
            "data-testid": "space-links",
            className: t10
        }, t11);
        $[35] = t10;
        $[36] = t11;
        $[37] = t12;
    } else t12 = $[37];
    let t13;
    if ($[38] !== allAppLinks || $[39] !== allVisibleAppLinks || $[40] !== canAdminister || $[41] !== loading || $[42] !== loadingForgeApps || $[43] !== shouldRenderSpaceApps || $[44] !== spaceKey) {
        t13 = !loading && !loadingForgeApps && shouldRenderSpaceApps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
            metric: (0, $aWrnw.SPACE_APPS_METRIC)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c83507daffd5a949$var$SpaceApps, {
            spaceKey: spaceKey,
            canAdminister: canAdminister,
            allAppLinks: allAppLinks,
            allVisibleAppLinks: allVisibleAppLinks
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null);
        $[38] = allAppLinks;
        $[39] = allVisibleAppLinks;
        $[40] = canAdminister;
        $[41] = loading;
        $[42] = loadingForgeApps;
        $[43] = shouldRenderSpaceApps;
        $[44] = spaceKey;
        $[45] = t13;
    } else t13 = $[45];
    let t14;
    if ($[46] !== affordanceData?.suggestionCountFragmentRef || $[47] !== canCreateContent || $[48] !== loading || $[49] !== space?.id) {
        t14 = !loading && canCreateContent && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)("confluence_autonomous_space_curation", "isEnabled", true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $c83507daffd5a949$var$relatedContentStyles.container
            ])
        }, (0, $6mKj3.expValEquals)("confluence_autonomous_space_curation_ssr_streaming", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
            dataFetcherName: "space-curation",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4516149d204af1cd$export$8372b97ddec977cb), {
            spaceId: space?.id,
            suggestionCountFragmentRef: affordanceData?.suggestionCountFragmentRef
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4516149d204af1cd$export$8372b97ddec977cb), {
            spaceId: space?.id,
            suggestionCountFragmentRef: affordanceData?.suggestionCountFragmentRef
        }));
        $[46] = affordanceData?.suggestionCountFragmentRef;
        $[47] = canCreateContent;
        $[48] = loading;
        $[49] = space?.id;
        $[50] = t14;
    } else t14 = $[50];
    let t15;
    if ($[51] !== t12 || $[52] !== t13 || $[53] !== t14 || $[54] !== t4 || $[55] !== t9) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c83507daffd5a949$var$SidebarContent, {
            "data-vc": "space-navigation-sidebar-content"
        }, t4, t9, t12, t13, t14);
        $[51] = t12;
        $[52] = t13;
        $[53] = t14;
        $[54] = t4;
        $[55] = t9;
        $[56] = t15;
    } else t15 = $[56];
    let t16;
    if ($[57] !== loading) {
        t16 = !loading && ((0, $9wGTI.fg)("confluence_frontend_tokenize_border") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("hr", {
            role: "presentation",
            id: "space-header-top-divider",
            className: (0, $hekY6.default)([
                "_30huDKPgdg _2YLqiKB0rP _1x1D3gOeNX _3138428HPE"
            ])
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("hr", {
            role: "presentation",
            id: "space-header-top-divider",
            className: (0, $hekY6.default)([
                "_30huDKdnbC _2YLqiKB0rP _1x1D3gOeNX _3138428HPE"
            ])
        }));
        $[57] = loading;
        $[58] = t16;
    } else t16 = $[58];
    let t17;
    if ($[59] !== t15 || $[60] !== t16 || $[61] !== t3) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t3, t15, t16);
        $[59] = t15;
        $[60] = t16;
        $[61] = t3;
        $[62] = t17;
    } else t17 = $[62];
    return t17;
};
module.exports["SpaceNavigationContent"] = $c83507daffd5a949$export$ec7f7d400376dc53;

});

parcelRegister("8zMP3", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $a1L5E = parcelRequire("a1L5E");


var $hZpML = parcelRequire("hZpML");


var $cemw8 = parcelRequire("cemw8");


var $8zKDl = parcelRequire("8zKDl");


var $dAPGk = parcelRequire("dAPGk");

const $5cfe2edd168ef31e$export$b17d024ed060ce0b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $dAPGk.useSuspenseBoundaryName)();
} : ()=>(0, $dAPGk.useSuspenseBoundaryName)();
const $5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader = (0, $3u0dr.isReactCompilerActiveV2)() ? function SuspenseWithDataFetcherReader(t0) {
    const $ = (0, $bDgLe.c)(2);
    const { dataFetcher: dataFetcher, children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : function SuspenseWithDataFetcherReader({ dataFetcher: dataFetcher, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
function $5cfe2edd168ef31e$export$553ede96e278ba94({ dataFetcherName: dataFetcherName, fallback: fallback = null, children: children }) {
    // Capture the SSR streaming value on initial render using useRef
    // This ensures the component tree doesn't change when the global variable
    // is deleted during route navigation
    const isSSRStreaming = (0, $cozmU.useRef)(window.__SSR_REACT_STREAMING__);
    // Get the current boundary chain from parent context
    const parentBoundaryChain = (0, $cozmU.useContext)((0, $dAPGk.SuspenseBoundaryNameContext));
    // Create new chain by appending current boundary to parent chain
    const currentBoundaryChain = (0, $cozmU.useMemo)(()=>[
            ...parentBoundaryChain,
            dataFetcherName
        ], [
        parentBoundaryChain,
        dataFetcherName
    ]);
    if (isSSRStreaming.current) {
        const dataFetcher = (0, $8zKDl.getDataFetcherForSuspense)(dataFetcherName, isSSRStreaming.current);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dAPGk.SuspenseBoundaryNameContext).Provider, {
            value: currentBoundaryChain
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cemw8.HydrationSafeSuspense), {
            fallback: fallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader, {
            dataFetcher: dataFetcher
        }, (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SUSPENSE}/${dataFetcherName}.start`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: `stream-suspense-${dataFetcherName}`
        }, children), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SUSPENSE}/${dataFetcherName}.end`))));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
}
module.exports["SuspenseWithDataFetcher"] = $5cfe2edd168ef31e$export$553ede96e278ba94;

});

parcelRegister("cemw8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $e4o8D = parcelRequire("e4o8D");

const $28f120e398482486$var$HydrationSafeSuspenseContent = /*#__PURE__*/ (0, $cozmU.memo)(function HydrationSafeSuspenseContent({ children: children, fallback: fallback }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: fallback
    }, children);
}, (_prevProps, nextProps)=>{
    // Block updates while locked (during hydration)
    return nextProps.isLocked;
});
function $28f120e398482486$export$a0bfcafd6d556141({ fallback: fallback = null, children: children }) {
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28f120e398482486$var$HydrationSafeSuspenseContent, {
        isLocked: renderServerPlaceholder,
        fallback: fallback
    }, children);
}
module.exports["HydrationSafeSuspense"] = $28f120e398482486$export$a0bfcafd6d556141;

});

parcelRegister("8zKDl", function(module, exports) {
function $2b2227915da27313$export$63116239d47be9ca(dataFetcherName, isSSRStreaming = true) {
    if (!isSSRStreaming || !dataFetcherName) return null;
    return window.__dataFetcherForSuspense__?.[dataFetcherName] ?? null;
}
module.exports["getDataFetcherForSuspense"] = $2b2227915da27313$export$63116239d47be9ca;

});

parcelRegister("2wo33", function(module, exports) {

var $cFXjQ = parcelRequire("cFXjQ");


var $9Z22p = parcelRequire("9Z22p");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $c0rhi = parcelRequire("c0rhi");




var $63cta = parcelRequire("63cta");


var $5rZJf = parcelRequire("5rZJf");

const $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    const permittedOperations = operationCheckResult?.content?.nodes?.[0]?.operations ?? [];
    const targetContentType = !!contentType ? contentType : operationCheckResult?.content?.nodes?.[0]?.type;
    if (!targetContentType) return false;
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === targetContentType);
};
const $fec7e6ab8c349d98$export$9df6fd1dd45ee771 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    // prettier-ignore
    const permittedOperations = operationCheckResult?.space?.operations ?? [];
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === contentType);
};
const $fec7e6ab8c349d98$export$e1260b60fe3f2784 = async ({ contentId: contentId, operation: operation, contentType: contentType })=>{
    const contentOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            query: (0, $63cta.ContentOperationsQuery),
            variables: {
                contentId: contentId,
                status: [
                    'current',
                    'archived',
                    'draft'
                ]
            },
            fetchPolicy: 'cache-first'
        } : {
            query: (0, $63cta.ContentOperationsQuery),
            variables: {
                contentId: contentId
            }
        },
        __callerPackage__: "entity-operations"
    });
    return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: contentOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$bcbdef0ac5f1ac47 = async ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const spaceOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $5rZJf.SpaceOperationsQuery),
        variables: {
            spaceKey: spaceKey
        },
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            fetchPolicy: 'cache-first'
        } : {},
        __callerPackage__: "entity-operations"
    });
    return $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: spaceOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$301dbe403ac05dd5 = ({ contentId: contentId, operation: operation, contentType: contentType, status: status })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $9Z22p.default), {
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            variables: {
                contentId: contentId,
                status: status ?? [
                    'current',
                    'archived',
                    'draft'
                ]
            },
            skip: !contentId,
            fetchPolicy: 'cache-first'
        } : {
            variables: {
                contentId: contentId,
                status: status
            },
            skip: !contentId
        },
        __callerPackage__: "entity-operations"
    });
    if (!contentId) return false;
    if (graphQLResult?.data) return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return undefined;
};
const $fec7e6ab8c349d98$export$1fefcc1c89f32022 = ({ spaceKey: spaceKey, operation: operation, contentType: contentType, skip: skip })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $cFXjQ.default), {
        variables: {
            spaceKey: spaceKey
        },
        skip: skip,
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            fetchPolicy: 'cache-first'
        } : {},
        __callerPackage__: "entity-operations"
    });
    // Only show the publish button if the user has permission to update (edit) this content.
    let canPerformOperation = undefined;
    if (graphQLResult?.data) canPerformOperation = $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return [
        canPerformOperation,
        graphQLResult
    ];
};
module.exports["canPerformSpaceOperation"] = $fec7e6ab8c349d98$export$9df6fd1dd45ee771;
module.exports["useCanPerformContentOperation"] = $fec7e6ab8c349d98$export$301dbe403ac05dd5;
module.exports["useCanPerformSpaceOperation"] = $fec7e6ab8c349d98$export$1fefcc1c89f32022;

});

parcelRegister("cFXjQ", function(module, exports) {
/**
 * @generated SignedSource<<1341e8100a34db255d375a90f5c4a762>>
 * @relayHash 66373ccec9c74286b704fa866e6f85ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b
const $718578d961a6d231$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "66373ccec9c74286b704fa866e6f85ed",
            "id": "1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b",
            "metadata": {},
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersSpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$718578d961a6d231$var$node.hash = "e5daa0845f1390f74a58e4fd57f9defb";
var $718578d961a6d231$export$2e2bcd8739ae039 = $718578d961a6d231$var$node;
module.exports["default"] = $718578d961a6d231$export$2e2bcd8739ae039;

});

parcelRegister("9Z22p", function(module, exports) {
/**
 * @generated SignedSource<<48d9ee7fb5d606ab817066b5f7172f92>>
 * @relayHash 74ad4c4ef681c6629c8477bfc21dc6ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58
const $16467728a654d6f6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "74ad4c4ef681c6629c8477bfc21dc6ca",
            "id": "e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58",
            "metadata": {},
            "name": "entityOperationsHelpersContentOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$16467728a654d6f6$var$node.hash = "0a581f032f7c1b6232f4634d5c3d1376";
var $16467728a654d6f6$export$2e2bcd8739ae039 = $16467728a654d6f6$var$node;
module.exports["default"] = $16467728a654d6f6$export$2e2bcd8739ae039;

});

parcelRegister("63cta", function(module, exports) {

var $8r0lJ = parcelRequire("8r0lJ");

const $bc89d0f4a052c761$export$a42cd9ccc4f06e9e = (0, $8r0lJ.default);
module.exports["ContentOperationsQuery"] = $bc89d0f4a052c761$export$a42cd9ccc4f06e9e;

});

parcelRegister("8r0lJ", function(module, exports) {
/**
 * @generated SignedSource<<d4c33eb851813f5d8bdf7b8ddf9d7fb7>>
 * @relayHash afd2c148a694798349dbf7c95e9faf5e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a
const $9494deed8cae7257$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "afd2c148a694798349dbf7c95e9faf5e",
            "id": "e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a",
            "metadata": {},
            "name": "ContentOperationsQuery",
            "operationKind": "query",
            "text": "query ContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$9494deed8cae7257$var$node.hash = "4ac4e53f1dd0ba665b3f48217ce7b74b";
var $9494deed8cae7257$export$2e2bcd8739ae039 = $9494deed8cae7257$var$node;
module.exports["default"] = $9494deed8cae7257$export$2e2bcd8739ae039;

});

parcelRegister("5rZJf", function(module, exports) {

var $3QLqz = parcelRequire("3QLqz");

const $8e7057c5d2ae7999$export$636a01496687d185 = (0, $3QLqz.default);
module.exports["SpaceOperationsQuery"] = $8e7057c5d2ae7999$export$636a01496687d185;

});

parcelRegister("3QLqz", function(module, exports) {
/**
 * @generated SignedSource<<eaa114c9e42c98e4d30da80006b4df1f>>
 * @relayHash 5ff0445d5306228126745d8454e82696
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6
const $5b7055a8a77b29df$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5ff0445d5306228126745d8454e82696",
            "id": "b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6",
            "metadata": {},
            "name": "SpaceOperationsQuery",
            "operationKind": "query",
            "text": "query SpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$5b7055a8a77b29df$var$node.hash = "5796c3a83a0773d6d932bd63d2fbf511";
var $5b7055a8a77b29df$export$2e2bcd8739ae039 = $5b7055a8a77b29df$var$node;
module.exports["default"] = $5b7055a8a77b29df$export$2e2bcd8739ae039;

});

parcelRegister("lfBMY", function(module, exports) {
var $93e6e1e47a4562a8$export$64e79c67b77e1326 = /*#__PURE__*/ function(OperationTypes) {
    OperationTypes["USE"] = "use";
    OperationTypes["LIMITED_USE"] = "limited_use";
    OperationTypes["EXTERNAL_COLLABORATOR_USE"] = "external_collaborator_use";
    OperationTypes["CREATE"] = "create";
    OperationTypes["READ"] = "read";
    OperationTypes["UPDATE"] = "update";
    OperationTypes["DELETE"] = "delete";
    OperationTypes["COPY"] = "copy";
    OperationTypes["MOVE"] = "move";
    OperationTypes["EXPORT"] = "export";
    OperationTypes["ARCHIVE"] = "archive";
    OperationTypes["PURGE"] = "purge";
    OperationTypes["PURGE_VERSION"] = "purge_version";
    OperationTypes["ADMINISTER"] = "administer";
    OperationTypes["RESTORE"] = "restore";
    OperationTypes["CREATE_SPACE"] = "create_space";
    OperationTypes["RESTRICT_CONTENT"] = "restrict_content";
    OperationTypes["CLEAR_PERMISSIONS"] = "clear_permissions";
    return OperationTypes;
}({});
module.exports["OperationTypes"] = $93e6e1e47a4562a8$export$64e79c67b77e1326;

});

parcelRegister("1I9Gw", function(module, exports) {
const $f0a04d35c062874d$export$1598149f6f3f7d46 = (spaceKey)=>{
    return spaceKey?.[0] === '~';
};
module.exports["isPersonalSpace"] = $f0a04d35c062874d$export$1598149f6f3f7d46;

});

parcelRegister("k8jyJ", function(module, exports) {
var $9d3782c3b842cfbc$export$e19cd5f9376f8cee = /*#__PURE__*/ function(Action) {
    Action["SUGGEST"] = "SUGGEST";
    Action["ACCEPT"] = "ACCEPT";
    Action["REJECT"] = "REJECT";
    Action["IGNORE"] = "IGNORE";
    return Action;
}({});
const $9d3782c3b842cfbc$export$f0c7a43b2eefe22f = {
    LOOM: 'loom',
    GOOGLE_DRIVE: 'drive',
    MICROSOFT: 'microsoft'
};
const $9d3782c3b842cfbc$export$fcdafa222e2a08e2 = Object.values($9d3782c3b842cfbc$export$f0c7a43b2eefe22f);
const $9d3782c3b842cfbc$var$PROVIDER_INTEGRATION_TO_CONNECTION = {
    google: $9d3782c3b842cfbc$export$f0c7a43b2eefe22f.GOOGLE_DRIVE,
    'google-drive': $9d3782c3b842cfbc$export$f0c7a43b2eefe22f.GOOGLE_DRIVE,
    loom: $9d3782c3b842cfbc$export$f0c7a43b2eefe22f.LOOM,
    microsoft: $9d3782c3b842cfbc$export$f0c7a43b2eefe22f.MICROSOFT,
    'microsoft-teams': $9d3782c3b842cfbc$export$f0c7a43b2eefe22f.MICROSOFT
};
const $9d3782c3b842cfbc$export$d499d92aec747a1e = (providerId)=>{
    const integration = providerId.split('integration/')[1]?.split('/')[0];
    return integration ? $9d3782c3b842cfbc$var$PROVIDER_INTEGRATION_TO_CONNECTION[integration] : undefined;
};
const $9d3782c3b842cfbc$export$f092255c909e2b34 = [
    $9d3782c3b842cfbc$export$f0c7a43b2eefe22f.GOOGLE_DRIVE,
    $9d3782c3b842cfbc$export$f0c7a43b2eefe22f.MICROSOFT
];
const $9d3782c3b842cfbc$var$PRODUCT_ICON_MAP = [
    {
        pattern: 'docs.google.com/document',
        product: 'Google Docs',
        productKey: 'googleDocs',
        logoKey: 'google-docs',
        connection: $9d3782c3b842cfbc$export$f0c7a43b2eefe22f.GOOGLE_DRIVE
    },
    {
        pattern: 'docs.google.com/spreadsheets',
        product: 'Google Sheets',
        productKey: 'googleSheets',
        logoKey: 'google-sheets',
        connection: $9d3782c3b842cfbc$export$f0c7a43b2eefe22f.GOOGLE_DRIVE
    },
    {
        pattern: 'docs.google.com/presentation',
        product: 'Google Slides',
        productKey: 'googleSlides',
        logoKey: 'google-slides',
        connection: $9d3782c3b842cfbc$export$f0c7a43b2eefe22f.GOOGLE_DRIVE
    },
    {
        pattern: 'drive.google.com',
        product: 'Google Drive',
        productKey: 'googleDrive',
        logoKey: 'google-drive',
        connection: $9d3782c3b842cfbc$export$f0c7a43b2eefe22f.GOOGLE_DRIVE
    },
    {
        pattern: 'loom.com',
        product: 'Loom',
        productKey: 'loom',
        logoKey: 'loom',
        connection: $9d3782c3b842cfbc$export$f0c7a43b2eefe22f.LOOM
    },
    {
        pattern: 'teams.microsoft.com',
        product: 'Microsoft Teams',
        productKey: 'microsoftTeams',
        logoKey: 'microsoft-teams',
        connection: $9d3782c3b842cfbc$export$f0c7a43b2eefe22f.MICROSOFT
    },
    {
        pattern: 'sharepoint.com',
        product: 'Microsoft SharePoint',
        productKey: 'microsoftTeams',
        logoKey: 'microsoft-sharepoint',
        connection: $9d3782c3b842cfbc$export$f0c7a43b2eefe22f.MICROSOFT
    }
];
function $9d3782c3b842cfbc$var$getProductIconMapEntryForContentUrl(url) {
    return $9d3782c3b842cfbc$var$PRODUCT_ICON_MAP.find((entry)=>url.includes(entry.pattern));
}
function $9d3782c3b842cfbc$export$39b141cbf41f04f3(url) {
    return $9d3782c3b842cfbc$var$getProductIconMapEntryForContentUrl(url)?.productKey ?? 'link';
}
function $9d3782c3b842cfbc$export$e71ceae9ed8d683e(url) {
    return $9d3782c3b842cfbc$var$getProductIconMapEntryForContentUrl(url)?.logoKey;
}
function $9d3782c3b842cfbc$export$bb60325743692ab0(url) {
    return $9d3782c3b842cfbc$var$getProductIconMapEntryForContentUrl(url)?.connection;
}
module.exports["Action"] = $9d3782c3b842cfbc$export$e19cd5f9376f8cee;
module.exports["EXTERNAL_PRODUCT_CONNECTION"] = $9d3782c3b842cfbc$export$f0c7a43b2eefe22f;
module.exports["getConnectionForProviderId"] = $9d3782c3b842cfbc$export$d499d92aec747a1e;
module.exports["AUTH_OPTIONS"] = $9d3782c3b842cfbc$export$f092255c909e2b34;
module.exports["getSuggestionProductKeyFromContentUrl"] = $9d3782c3b842cfbc$export$39b141cbf41f04f3;
module.exports["getSuggestionLogoKeyFromContentUrl"] = $9d3782c3b842cfbc$export$e71ceae9ed8d683e;
module.exports["getConnectionFromContentUrl"] = $9d3782c3b842cfbc$export$bb60325743692ab0;

});

parcelRegister("431p7", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $cJ0FD = parcelRequire("cJ0FD");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");


var $7xXfm = parcelRequire("7xXfm");

const $672c665181f62065$var$rootStyles = (0, $buxP3.xcss)({
    display: 'block',
    maxWidth: '100%',
    height: 'auto',
    objectFit: 'contain',
    objectPosition: 'center'
});
const $672c665181f62065$var$fillStyles = (0, $buxP3.xcss)({
    position: 'absolute',
    inset: 'space.0',
    width: '100%',
    height: '100%'
});
const $672c665181f62065$var$autoDarkStyles = (0, $buxP3.xcss)({
    filter: 'invert(1) hue-rotate(180deg)'
});
const $672c665181f62065$export$75e378065cb7d6c0 = ({ srcLight: srcLight, srcDark: srcDark = srcLight, autoDark: autoDark = true, alt: alt, fill: fill = false, testId: testId, ...imgProps })=>{
    const isDarkMode = document.documentElement.getAttribute('data-theme') === 'dark';
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3izAL.Box), {
        xcss: [
            $672c665181f62065$var$rootStyles,
            ...fill ? [
                $672c665181f62065$var$fillStyles
            ] : [],
            ...isDarkMode && srcDark === srcLight && autoDark ? [
                $672c665181f62065$var$autoDarkStyles
            ] : []
        ],
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cJ0FD.default), {
            src: isDarkMode && srcDark ? srcDark : srcLight,
            srcDark: srcDark,
            alt: alt,
            testId: testId,
            ...imgProps
        })
    });
};
function $672c665181f62065$export$d43c2e2ca9b2c105({ ...props }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)($672c665181f62065$export$75e378065cb7d6c0, {
        ...props
    });
}
const $672c665181f62065$export$785d3703e302bc58 = ({ illustrationKey: illustrationKey, ...props })=>{
    const illustration = (0, $7xXfm.getIllustration)(illustrationKey);
    return /*#__PURE__*/ (0, $8aG6j.jsx)($672c665181f62065$export$d43c2e2ca9b2c105, {
        illustrationKey: illustrationKey,
        srcLight: illustration.light,
        srcDark: illustration.dark,
        ...props
    });
};
const $672c665181f62065$export$60247ecb8593cd70 = Object.keys((0, $7xXfm.illustrationMap));
module.exports["IllustrationComponent"] = $672c665181f62065$export$785d3703e302bc58;

});

parcelRegister("7xXfm", function(module, exports) {
const $c34e8ca54dbc708b$export$3baf7546f5f75a65 = {
    Roadmap: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7jw212gilh0pq8s0hyul84fdi678bf3k.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0j3wjupcj175311cn17hjvu3505dfeui.svg'
    },
    LetterOpen: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0rq27e55o54h8b5712rj4y7w6pyw77k4.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3d1701i21867ve0bh5o0mbsj03713erf.svg'
    },
    ErrorStateSearchNoResults: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/j6orj168ea4wt8pf7gmy3f34fvhe5dhf.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/duh2c4s6cuwgu70xrp0phjc8q6mb214q.svg'
    },
    AddUser: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/320g85q2c1i2bb3r68d03w53mfbgf80a.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/b70i6y7u7xe1xl0tb6imq53e8jq76iul.svg'
    },
    AddTeam: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/25k7w5wf47sb030idd3p8473kw6jx812.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/443ly120bio7a4626h3vu431o8af6v65.svg'
    },
    BasicsUserManagement: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/x30s04076y6v8m351n3f1s8vtbb1fr28.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/fy16p5y4vm63ojm2f244m21pb66l64wq.svg'
    },
    RefreshUpdate: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/v2c0s81enc43u8c8yp1425nju6lm4hja.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/o3nxb5ua68n5h1s67d6x0750a07y55co.svg'
    },
    EmptyStateDone: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8xyyd278180s44355m6ai1u0q36aedgu.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/77c3l22p8jr18230f77r34ud130xua44.svg'
    },
    ErrorStateSearch: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/h5b4hajdmg7555sxeguvler50nh26m2b.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/k611370iv6do1622kj2wyto863oe82w8.svg'
    },
    DevOps: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/p5xhuk78014yagtkpu4r6f0x1n5105dt.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/x32yp5sb5q5340t3j57r24bv54vsfxdy.svg'
    },
    BasicsDone: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4fx5w8c7ygm211h3hk56gd063r12iuxx.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1p180c132m3w8pn6lwd050i5131qg7u5.svg'
    },
    BasicsMap: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/k501d3mq2mr856ifm73xw0f54ld05hi5.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/80487c5lci30v652q126ob2v7lg5hxqm.svg'
    },
    BasicsCloud: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/k87t038hjt8ug7b4e74hcxfjj725yh0a.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/mt0g72401sly7i6817l0pmy50g7ux1gs.svg'
    },
    BasicsToolbox: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7bl2xobvtdl5l087p3ekiif3245mh5bq.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7b3hyne70j556m3386dq524lm8604054.svg'
    },
    BasicsIntegration: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/i6h32pl6kgxhw4rnvv6032y2m2g12k58.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4vx3hb148215x8k2nmoo6c6i1d24ctm6.svg'
    },
    BasicsNetwork: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/hkom1wq6850fkil8l387x661p5i618v6.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2718224l1o08ub15ckk8y40gkv4a0htm.svg'
    },
    BasicsTelescope: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7j80s288m4qhgsetie6sve68n2ej1405.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/mfdrhx07ec534x8u6883a1g8304a5wkf.svg'
    },
    BasicsMigrations: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/02h181332ob0bb0h8y01dn463ac85650.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/e41m7730o4jx767sr3q0wqxy40q478d0.svg'
    },
    EmptyStateAddCard: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/qxxv401l02xqijm865431t77jlj56o42.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/cs314684x4sdec707ruwgkw7s4l2j238.svg'
    },
    PurchaseSolutions: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1m6mj7is0crda1j8k4001pf33f5ayg3v.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4836vvm76sj7b5bk4nlnrlf2w7156ahp.svg'
    },
    BasicsToggle: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/q5jk78i1638850vvywhnq3a88fkulcgg.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1ugf4n1b1obwy3x50o3cy7b1cb2ogvlt.svg'
    },
    Gear: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2054s3i80cnl0rj21onct4wni4503y2f.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/pe4r106m14js5axb1104afiy6u86q1q7.svg'
    },
    Clipboard: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/x261nhq5uvo03ck303l448ok54we4s40.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/v6k72hphq6iy40h02b06x4tjn0pp1xg2.svg'
    },
    BasicsPadlockKey: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8mdy4ly4472iy7oe1so16p7n8tg0tq4j.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/m780xv54x0c80rl10fj7st2827143du8.svg'
    },
    BasicsSafe: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/61515r0ky6w25rgox71ikg8xr8ews7c2.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/84gvg2c6ne2404470v8nhm20t50o141n.svg'
    },
    BasicsCompliance: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/v02gk84pk8m4615us43275j34152ao8e.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/64px0476b1560y7213q21d838a5h536w.svg'
    },
    BasicsTracking: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/jw6pndhya20421lupo7fa1lrq838jjt6.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/720328508vo54hxd37g211kgq785r20l.svg'
    },
    BasicsGear: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/b5fd2x7vyous80066drr052o0fv54jq7.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/42fqbi1p3krj77y4x35027s6bhykshj6.svg'
    },
    BasicsSearchDocuments: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/481u3aim7rr8i4ody7g8x73851400u66.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/86a33isl2idxkh3l7p0h577h02f66lq7.svg'
    },
    IdBadge: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/583882gc55qf4rc6r65e42x73o6y8050.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0kqc63x6c2g52f53c42543m284q2r01b.svg'
    },
    DataPrivacy: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/203264h64h0jjak63j4844s47b2d0hi4.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/l33xi5x21ktjj23c6403663u6oy1g0bu.svg'
    },
    Firewall: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/88100e300go74n6bpg2xl2o2y42s85jh.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/54v6f06r1lefsgmppt70v086q5cy00ca.svg'
    },
    BasicsCalendar: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/kaw757yfmx4x318281etb8x1x73tdnr1.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/xuah062301y0cf7hg8f17tp7s6d1l17p.svg'
    },
    BasicsCaptureUsers: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/wh17145204218s6k8ob72577fk02733b.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/y5e147js1ix8263j84t6hd20m475lqs4.svg'
    },
    EmptyStateAddItem: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/457n14i63u567yex70d3f7whn3muk424.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4kc212md11dd2sf8p3br83cltr1l5pfl.svg'
    },
    BasicsPlatform: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/214yy1pd03tl403v5a2b52540y8001y1.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ngr7gg603m7xa7p387t5lp4346ocmn28.svg'
    },
    Coins: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/06fh24615yc78k4m6f425t5ubds7u2od.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/vhu2f73mpr4umr41oku53wac1ymjjl7o.svg'
    },
    ErrorColor: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2e655j87263160n28qbq8w21442ap32e.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/027e8530v08n5no10q4531pn3bj2xff2.svg'
    },
    EmptyStateLinkProduct: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/vw8wnk2l1ir45e3paqo112k1o7pe7651.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8o713f7rqa14ybt1h2p607p8q7trs07i.svg'
    },
    EmptyStateAddDomain: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/5w8wk47o7bk5tnc0kaobgli411ewr670.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/24fyu3u2u7w1te42ey0kbp0vkw7my7o3.svg'
    },
    Target: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/td5b33i7s8eo54p44y0g8sc514qh3yt5.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/eey6g3u233r4ed2od7vxfj5k8jpe00y6.svg'
    },
    Keys: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/78p40jv6as05i5igau72l3g786t60v6d.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/l6s154tgi0x86c5d8fmbe8w25tappa8y.svg'
    },
    LegalSignature: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/r1kv0fypxbw3b87dw51b1s87g3sbye7j.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4tvrp0lg435g3ul8qtf1k0mul2202ld2.svg'
    },
    Certificate: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/olc6ly6444j28201xvy1l47u875c7ni5.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/45mu552reqn43g0ll8247215v73357l2.svg'
    },
    Book: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/rgls54sa2ht127b36w6gtrn007hq540r.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ta66oqj1j4p06b78dj0lgsrnsrn7v8g0.svg'
    },
    Scalability: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/e43505bjv28k04y3p1op386fl3bbv635.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/p51k45qsv122cmfk7l346kghiduaoai1.svg'
    },
    Launch: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/mo4ruaiviisypd0843v5122af3058412.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ghd3w62kfhyuut0712ft7aml7r31rhea.svg'
    },
    Safe: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3tgmc31cmtkh1f15850ljn63ij8c780q.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/083e51o6yx24qd652c4516osh7l7m3xp.svg'
    },
    FileCabinet: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3s5fh384d6711v6v8nh25i62p87s3234.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0h181827yev84ha3143f8gwdv2211l4j.svg'
    },
    BasicsSearchFiles: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/m06sfph6ghm12alyp2qbjduo138s717k.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/14ck50342nk275nrd1kb61i274071537.svg'
    },
    BasicsEncryption: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/34806iiapwi25t3e6prty1362w8q1q30.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/14ra46smb04xi65x078mu23je85p8gv7.svg'
    },
    BasicsUpload: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/fgry4p8x7a41p0rgy602e2ihd8m3t1f2.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/nvr5bibqhna6f8s62txcp74uy0l1a817.svg'
    },
    BasicsIntergrations: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3ej70r224drtwu8rp5rme5r8jca4b3t7.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/g06n8681o6xlgg2m85166viix55trhvx.svg'
    },
    BasicsPadlock: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/xm6yhtu41o0a72s0120656i5635i0psh.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3tk03r230nw0qj42m10hu78bb8g8v686.svg'
    },
    ErrorGeneral: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/y57gh135brj0y5636ry8373s216388ll.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ma5w4y4y8fpe380ty61yb76737387358.svg'
    },
    GeneralSpeed: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/s4whr5562p47uxh3e53w28c873hc02eg.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/f5k75b0e166640ia64560hf14644107x.svg'
    },
    GeneralFolder: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/uuxyrbe462u44513566nt718214bf703.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/745g31l520pn56wy4qge851et537of67.svg'
    },
    EmptyStateAddPage: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2mp148gy6fg4b7dhyw31cjj3261oej2v.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3h018oh050r4v4058l7544f5xxk4s6h5.svg'
    },
    CreditCard: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/nh0bbp8rjwq8mk2r1w342ke3j24uoi02.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/r1rn72wjhah5mfg5muyk81mactw8m5f6.svg'
    },
    PowerfulFeature: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2o22x8xvx8g8264iug346lp75n281520.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/67my2r0s61mbw76b5oxcyfs5s88k72q3.svg'
    },
    HourGlass: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/y3mm3ad1u5kpvr68j3jb0e8e7d00o5r0.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/456r68qp3q717ln3q431n5gw0871gc27.svg'
    },
    ValueDiamond: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/55y50mimx1v7p7713d4k71v26o15u0ru.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ihgmiq546710w63n2u3yl453t36127sk.svg'
    },
    TeamValues: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/d3rf5ch87s3xw25n8uw0jm3844171n0h.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/888g5f0t3480wi2soeu231gl2tu40uyh.svg'
    },
    RainIncident: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/icukl8b50y8ob6353w2o542843177n01.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/q046fj32r665n7677ggmt554kpm27ven.svg'
    },
    PageBarChart: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/5h2511y7u13g4pkjb0r5gbqdajts3a7p.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/575j1hj7237ocbtqr7c800ice3d50523.svg'
    },
    GlobalNetwork: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/y0uarnxka84le10408im250c41v1xl7r.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/op3g5cwa212b37uechd58dmqysc2504v.svg'
    },
    Users: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/v60acd80fl8007s5g101hh76yfb7ne7v.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4nqf045g7731f2lk1p78ktc8eq3j4qqr.svg'
    },
    FlagLogo: {
        light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12PK9.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT15WPF.svg'
    }
};
const $c34e8ca54dbc708b$export$60247ecb8593cd70 = Object.keys($c34e8ca54dbc708b$export$3baf7546f5f75a65);
const $c34e8ca54dbc708b$export$6754ebb763d0f990 = (key)=>{
    const illustration = $c34e8ca54dbc708b$export$3baf7546f5f75a65[key];
    if (typeof illustration === 'string') return {
        light: illustration,
        dark: illustration
    };
    return illustration;
};
module.exports["illustrationMap"] = $c34e8ca54dbc708b$export$3baf7546f5f75a65;
module.exports["getIllustration"] = $c34e8ca54dbc708b$export$6754ebb763d0f990;

});

parcelRegister("lsxnT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $i3jcY = parcelRequire("i3jcY");


var $cryCi = parcelRequire("cryCi");


var $3KdFR = parcelRequire("3KdFR");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $cozmU.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    const plugin = ctx?.plugin;
    const isDisplayed = Boolean(plugin?.state?.isDisplayingMessage);
    (0, $cozmU.useEffect)(()=>{
        window.__PO_ASSET_DISPLAYED__ = window.__PO_ASSET_DISPLAYED__ || isDisplayed;
    }, [
        isDisplayed
    ]);
    // Stubbed context monkey-patches the original context to prevent Choreographer components
    // from being rendered, to avoid random impact on performance and UI stability tests.
    // This is ONLY intended to use with E2E/playwright/Criterion tests loading Confluence
    // with `?stableUI=1` URL parameter.
    const stubbedContext = (0, $cozmU.useMemo)(()=>({
            ...ctx,
            ...(0, $3KdFR.choreographerContextStub)
        }), [
        ctx
    ]);
    return (0, $i3jcY.isStableUIEnabledForTests)() ? stubbedContext : ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("i3jcY", function(module, exports) {

const $47902e6ccb9229f6$var$STABLE_UI_PARAM = 'stableUI=1';
const $47902e6ccb9229f6$export$c0b9078f666b1acf = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return (window.location.search ?? '').includes($47902e6ccb9229f6$var$STABLE_UI_PARAM);
};
module.exports["isStableUIEnabledForTests"] = $47902e6ccb9229f6$export$c0b9078f666b1acf;

});

parcelRegister("3KdFR", function(module, exports) {
const $d24b02c281555a47$var$ChoreographerComponentStub = ()=>{
    return null;
};
const $d24b02c281555a47$var$withChoreographerStub = ()=>{
    return ()=>null;
};
const $d24b02c281555a47$export$62522e606ba73c28 = {
    AutoDismissFlag: $d24b02c281555a47$var$ChoreographerComponentStub,
    Banner: $d24b02c281555a47$var$ChoreographerComponentStub,
    ChoreographedComponent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Flag: $d24b02c281555a47$var$ChoreographerComponentStub,
    InlineDialog: $d24b02c281555a47$var$ChoreographerComponentStub,
    Modal: $d24b02c281555a47$var$ChoreographerComponentStub,
    PopoverContent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popper: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popup: $d24b02c281555a47$var$ChoreographerComponentStub,
    Spotlight: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightCard: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightTarget: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedRender: $d24b02c281555a47$var$withChoreographerStub,
    withChoreographedToggle: $d24b02c281555a47$var$withChoreographerStub
};
module.exports["choreographerContextStub"] = $d24b02c281555a47$export$62522e606ba73c28;

});

parcelRegister("fSlSx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6Ec6w = parcelRequire("6Ec6w");


var $lb2PL = parcelRequire("lb2PL");


var $jx3SX = parcelRequire("jx3SX");


var $4zc1o = parcelRequire("4zc1o");


var $1448l = parcelRequire("1448l");


var $2XmSX = parcelRequire("2XmSX");


var $5TdBT = parcelRequire("5TdBT");


var $8RTwe = parcelRequire("8RTwe");


var $aKu7b = parcelRequire("aKu7b");


var $k8jyJ = parcelRequire("k8jyJ");

const $6cfcd88ce0ff451c$var$CONNECTION_LOGO_KEY = {
    [(0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).GOOGLE_DRIVE]: 'google-drive',
    [(0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).MICROSOFT]: 'onedrive',
    [(0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).LOOM]: 'loom'
};
const $6cfcd88ce0ff451c$export$62989d7cb9b14377 = ({ logoKey: logoKey, size: size = 'xsmall', label: label = '', testId: testId })=>{
    switch(logoKey){
        case 'google-drive':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4zc1o.GoogleDriveIcon), {
                label: label,
                size: size,
                testId: testId
            });
        case 'google-docs':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jx3SX.GoogleDocsIcon), {
                label: label,
                size: size,
                testId: testId
            });
        case 'google-sheets':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1448l.GoogleSheetsIcon), {
                label: label,
                size: size,
                testId: testId
            });
        case 'google-slides':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2XmSX.GoogleSlidesIcon), {
                label: label,
                size: size,
                testId: testId
            });
        case 'onedrive':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5TdBT.MicrosoftOneDriveIcon), {
                label: label,
                size: size,
                testId: testId
            });
        case 'microsoft-teams':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aKu7b.MicrosoftTeamsIcon), {
                label: label,
                size: size,
                testId: testId
            });
        case 'microsoft-sharepoint':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8RTwe.MicrosoftSharePointIcon), {
                label: label,
                size: size,
                testId: testId
            });
        case 'loom':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lb2PL.LoomIcon), {
                label: label,
                size: size,
                testId: testId
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Ec6w))), {
                label: label,
                color: "var(--ds-icon-subtle, #505258)",
                testId: testId
            });
    }
};
const $6cfcd88ce0ff451c$export$465a3683f8bbe7a6 = ({ connection: connection, size: size, label: label, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6cfcd88ce0ff451c$export$62989d7cb9b14377, {
        logoKey: $6cfcd88ce0ff451c$var$CONNECTION_LOGO_KEY[connection],
        size: size,
        label: label,
        testId: testId
    });
module.exports["ProductLogo"] = $6cfcd88ce0ff451c$export$62989d7cb9b14377;
module.exports["ConnectionLogo"] = $6cfcd88ce0ff451c$export$465a3683f8bbe7a6;

});

parcelRegister("lb2PL", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $c420f5a156d6b7cf$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302"/>
</svg>
`;
const $c420f5a156d6b7cf$export$8d789f76fde3e05 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LoomIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Loom" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $c420f5a156d6b7cf$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function LoomIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Loom', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $c420f5a156d6b7cf$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["LoomIcon"] = $c420f5a156d6b7cf$export$8d789f76fde3e05;

});

parcelRegister("jx3SX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a60c27a2e8da95b9ed40b1ec66afff05>>
 * @codegenCommand yarn workspace @atlassian/logo-third-party generate:components
 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $bD1F5 = parcelRequire("bD1F5");

const $4d235de2f28ed7f0$var$markup = '<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><mask id="mask0_118280_5584" width="22" height="30" x="13" y="9" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#3186ff" d="M29.76 39H18.046c-1.523 0-2.287 0-2.89-.239a3.4 3.4 0 0 1-1.916-1.916C13 36.24 13 35.479 13 33.956v-19.91c0-1.523 0-2.287.239-2.89a3.4 3.4 0 0 1 1.915-1.916C15.759 9 16.523 9 18.047 9h6.545l9.34 9.34c.282.282.424.424.533.584.157.231.266.492.318.767.035.19.035.392.035.798-.006 8.338-.009 8.42-.009 13.46 0 1.528 0 2.293-.239 2.898a3.4 3.4 0 0 1-1.916 1.914c-.605.239-1.367.239-2.892.239"/></mask><g mask="url(#mask0_118280_5584)"><path fill="#3186ff" d="M34.808 39H13V9h11.59l10.228 10.227z"/><g filter="url(#filter0_f_118280_5584)"><path fill="url(#paint0_linear_118280_5584)" d="M14.875 40.365h18.068V11.047H14.875z"/></g></g><path fill="#76bbff" d="M33.966 18.375a2.54 2.54 0 0 0-1.534-.511h-5.66a2.18 2.18 0 0 1-2.18-2.182V9z"/><path fill="#fff" d="M28.34 27.07h-8.86a1.02 1.02 0 0 0 0 2.05h8.86a1.02 1.02 0 0 0 0-2.05m-2.73 4.94h-6.14a1.02 1.02 0 0 0 0 2.05h6.14a1.02 1.02 0 0 0 0-2.04"/><defs><linearGradient id="paint0_linear_118280_5584" x1="23.909" x2="16.854" y1="17.742" y2="36.843" gradientUnits="userSpaceOnUse"><stop offset=".33" stop-color="#3186ff"/><stop offset="1" stop-color="#a9a8ff"/></linearGradient><filter id="filter0_f_118280_5584" width="22.159" height="33.407" x="12.829" y="9.001" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape"/><feGaussianBlur result="effect1_foregroundBlur_118280_5584" stdDeviation="1.023"/></filter></defs></svg>';
function $4d235de2f28ed7f0$export$3b2f6ea0ca384894({ size: size, label: label = 'Google Docs', testId: testId, type: type }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bD1F5.ThirdPartyLogoWrapper), {
        markup: $4d235de2f28ed7f0$var$markup,
        label: label,
        size: size,
        testId: testId,
        type: type
    });
}
module.exports["GoogleDocsIcon"] = $4d235de2f28ed7f0$export$3b2f6ea0ca384894;

});

parcelRegister("bD1F5", function(module, exports) {
/* wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $8aG6j = parcelRequire("8aG6j");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $9NPFC = parcelRequire("9NPFC");

const $4c67a4021f7bef2b$var$glyphStyles = null;
const $4c67a4021f7bef2b$var$hexagonSizeStyles = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F",
    xsmall: "_39xV02SPN1 _0jFU0VSPN1",
    small: "_39xV02oWWg _0jFU0VoWWg",
    medium: "_39xV02Uofl _0jFU0VUofl",
    large: "_39xV02UF4f _0jFU0VUF4f",
    xlarge: "_39xV02pJKa _0jFU0VpJKa"
};
const $4c67a4021f7bef2b$var$hexagonRootStyles = null;
const $4c67a4021f7bef2b$var$hexagonStyles = null;
const $4c67a4021f7bef2b$var$hexagonBorderStyles = null;
const $4c67a4021f7bef2b$var$hexagonContentStyles = null;
const $4c67a4021f7bef2b$var$svgIdAttributePattern = /\sid=(["'])([^"']+)\1/g;
const $4c67a4021f7bef2b$var$getSvgIdNamespace = (instanceId)=>`third-party-logo-${instanceId.replace(/[^a-zA-Z0-9_-]/g, '-')}`; /**
                                                                                                                             * Third-party SVGs can contain gradients, masks, and clipPaths with document-wide IDs.
                                                                                                                             * Namespacing each render keeps repeated logos from resolving `url(#id)` references to the
                                                                                                                             * first matching SVG definition elsewhere on the page.
                                                                                                                             */ 
const $4c67a4021f7bef2b$var$namespaceSvgIds = (markup, namespace)=>{
    const ids = Array.from(markup.matchAll($4c67a4021f7bef2b$var$svgIdAttributePattern), ([, , id])=>id);
    const uniqueIds = Array.from(new Set(ids));
    return uniqueIds.reduce((updatedMarkup, id)=>{
        const namespacedId = `${namespace}-${id}`;
        const escapedId = $4c67a4021f7bef2b$var$escapeRegExp(id);
        return updatedMarkup.replace(new RegExp(`\\sid=(["'])${escapedId}\\1`, 'g'), ` id=$1${namespacedId}$1`).replace(new RegExp(`url\\(#${escapedId}\\)`, 'g'), `url(#${namespacedId})`).replace(new RegExp(`(\\s(?:href|xlink:href)=["'])#${escapedId}(["'])`, 'g'), `$1#${namespacedId}$2`);
    }, markup);
};
const $4c67a4021f7bef2b$var$escapeRegExp = (value)=>value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
function $4c67a4021f7bef2b$export$96b07167eb29fb14({ markup: markup, size: size = 'medium', label: label = '', testId: testId, type: type = 'app' }) {
    const instanceId = (0, $cozmU.useId)();
    const namespacedMarkup = (0, $cozmU.useMemo)(()=>$4c67a4021f7bef2b$var$namespaceSvgIds(markup, $4c67a4021f7bef2b$var$getSvgIdNamespace(instanceId)), [
        markup,
        instanceId
    ]);
    const glyph = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "aria-hidden": "true",
        dangerouslySetInnerHTML: {
            __html: namespacedMarkup
        },
        className: (0, $hekY6.default)([
            "_3iDTPbvLZJ _39xV02N91d _0jFU0VN91d"
        ])
    });
    if (type === 'agent') return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $hekY6.default)([
            "_3iDTPbccYA _3YEZNOdnbC _1RrJLit2nV",
            $4c67a4021f7bef2b$var$hexagonSizeStyles[size]
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: (0, $hekY6.default)([
                "_3iDTPbccYA _24h04i2Njc _39xV02N91d _0jFU0VN91d _1uo2ZfTcEg",
                "_4c065UNvrM _2Y7lL4NvrM _0KLXruIDZ8"
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                className: (0, $hekY6.default)([
                    "_3iDTPbvLZJ _39xV02N91d _0jFU0VN91d _0KLXrut28M _1uo2ZfOLYo"
                ]),
                children: glyph
            })
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9NPFC.default // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Tile's backgroundColor API accepts the semantic `white` value.
    ), {
        backgroundColor: "white",
        label: label,
        size: size,
        testId: testId,
        hasBorder: true,
        isInset: false,
        children: glyph
    });
}
module.exports["ThirdPartyLogoWrapper"] = $4c67a4021f7bef2b$export$96b07167eb29fb14;

});

parcelRegister("9NPFC", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


const $60cc37ad75899268$var$tileSizePx = {
    xxsmall: 16,
    xsmall: 20,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 48
};
const $60cc37ad75899268$var$styles = {
    root: "_0bjKvD0O7w _4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS _3iDTPbccYA _24h04i2Njc _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _2O5VijdnbC _4ouGXIdnbC _4kiQYAdnbC _1RrJLit2nV",
    border: "_2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67",
    inset: "_3B3jB1IZbP _0LETLXIZbP _4ACwSfIZbP _2Qxi4nIZbP",
    nonInset: "_49oNbqN91d _1tJeXfN91d _0VARMJN91d _27VeLCN91d _3B3jB1N91d _0LETLXN91d _4ACwSfN91d _2Qxi4nN91d _3G0Ib8iObl"
};
const $60cc37ad75899268$var$sizeMap = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F _4ya3eEuFDC",
    xsmall: "_39xV02SPN1 _0jFU0VSPN1 _4ya3eExpxF",
    small: "_39xV02oWWg _0jFU0VoWWg _4ya3eEEbN9",
    medium: "_39xV02Uofl _0jFU0VUofl _4ya3eEey7F",
    large: "_39xV02UF4f _0jFU0VUF4f _4ya3eESPN1",
    xlarge: "_39xV02pJKa _0jFU0VpJKa _4ya3eEoWWg"
};
const $60cc37ad75899268$var$insetSizeMap = {
    xxsmall: "_49oNbquFDC _1tJeXfuFDC _0VARMJuFDC _27VeLCuFDC _0mzAWiNKBH _3woHNtNKBH _430i96NKBH _1GBPVvNKBH",
    xsmall: "_49oNbqxpxF _1tJeXfxpxF _0VARMJxpxF _27VeLCxpxF _0mzAWiqBG1 _3woHNtqBG1 _430i96qBG1 _1GBPVvqBG1",
    small: "_49oNbqEbN9 _1tJeXfEbN9 _0VARMJEbN9 _27VeLCEbN9 _0mzAWif9wp _3woHNtf9wp _430i96f9wp _1GBPVvf9wp",
    medium: "_49oNbqey7F _1tJeXfey7F _0VARMJey7F _27VeLCey7F _0mzAWiIRC9 _3woHNtIRC9 _430i96IRC9 _1GBPVvIRC9",
    large: "_49oNbqSPN1 _1tJeXfSPN1 _0VARMJSPN1 _27VeLCSPN1 _0mzAWiPcut _3woHNtPcut _430i96Pcut _1GBPVvPcut",
    xlarge: "_49oNbqoWWg _1tJeXfoWWg _0VARMJoWWg _27VeLCoWWg _0mzAWiY6u9 _3woHNtY6u9 _430i96Y6u9 _1GBPVvY6u9"
};
const $60cc37ad75899268$var$backgroundColorMap = {
    white: "_0KLXrut28M",
    black: "_0KLXru52mJ",
    transparent: "_0KLXrujOvk",
    'color.background.accent.lime.subtlest': "_0KLXruXL80",
    'color.background.accent.lime.subtler': "_0KLXruuKDS",
    'color.background.accent.lime.subtle': "_0KLXruZcd0",
    'color.background.accent.lime.bolder': "_0KLXrubYhN",
    'color.background.accent.red.subtlest': "_0KLXrusDFP",
    'color.background.accent.red.subtler': "_0KLXrubV9i",
    'color.background.accent.red.subtle': "_0KLXru0cUQ",
    'color.background.accent.red.bolder': "_0KLXruQrW1",
    'color.background.accent.orange.subtlest': "_0KLXru2QQR",
    'color.background.accent.orange.subtler': "_0KLXruwJ86",
    'color.background.accent.orange.subtle': "_0KLXruuwVU",
    'color.background.accent.orange.bolder': "_0KLXrux4f7",
    'color.background.accent.yellow.subtlest': "_0KLXru56u3",
    'color.background.accent.yellow.subtler': "_0KLXruLv9B",
    'color.background.accent.yellow.subtle': "_0KLXruC29w",
    'color.background.accent.yellow.bolder': "_0KLXruYB6L",
    'color.background.accent.green.subtlest': "_0KLXruV6wL",
    'color.background.accent.green.subtler': "_0KLXruNUep",
    'color.background.accent.green.subtle': "_0KLXru50ZN",
    'color.background.accent.green.bolder': "_0KLXrude1t",
    'color.background.accent.teal.subtlest': "_0KLXruuBpz",
    'color.background.accent.teal.subtler': "_0KLXrunfgW",
    'color.background.accent.teal.subtle': "_0KLXrufjGw",
    'color.background.accent.teal.bolder': "_0KLXruzHaB",
    'color.background.accent.blue.subtlest': "_0KLXruVva3",
    'color.background.accent.blue.subtler': "_0KLXrup9dS",
    'color.background.accent.blue.subtle': "_0KLXru28sy",
    'color.background.accent.blue.bolder': "_0KLXrutfbE",
    'color.background.accent.purple.subtlest': "_0KLXruB8KG",
    'color.background.accent.purple.subtler': "_0KLXruWOdT",
    'color.background.accent.purple.subtle': "_0KLXruf89Q",
    'color.background.accent.purple.bolder': "_0KLXruhdss",
    'color.background.accent.magenta.subtlest': "_0KLXru8frT",
    'color.background.accent.magenta.subtler': "_0KLXruXM4x",
    'color.background.accent.magenta.subtle': "_0KLXrupmfs",
    'color.background.accent.magenta.bolder': "_0KLXruxE6Y",
    'color.background.accent.gray.subtlest': "_0KLXrumhAQ",
    'color.background.accent.gray.subtler': "_0KLXruG6qS",
    'color.background.accent.gray.subtle': "_0KLXrueZ10",
    'color.background.accent.gray.bolder': "_0KLXrurxgm",
    'color.background.inverse.subtle': "_0KLXruB4sa",
    'color.background.neutral': "_0KLXruDMqu",
    'color.background.neutral.bold': "_0KLXrugozt",
    'color.background.brand.subtlest': "_0KLXrunl7T",
    'color.background.brand.bold': "_0KLXruDM2k",
    'color.background.brand.boldest': "_0KLXru2o0p",
    'color.background.danger': "_0KLXruhH7k",
    'color.background.danger.bold': "_0KLXruqsXs",
    'color.background.warning': "_0KLXruhxIM",
    'color.background.warning.bold': "_0KLXruKLKE",
    'color.background.success': "_0KLXruzaZe",
    'color.background.success.bold': "_0KLXruhbjP",
    'color.background.discovery': "_0KLXru94rk",
    'color.background.discovery.bold': "_0KLXruqjHC",
    'color.background.information': "_0KLXrugNg3",
    'color.background.information.bold': "_0KLXruASYT"
}; /**
    * __Tile__
    *
    * A tile is a rounded square that takes an asset and represents a noun.
    *
    */ 
const $60cc37ad75899268$var$Tile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Tile(props) {
    const $ = (0, $bDgLe.c)(17);
    const { children: children, label: label, size: t0, backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: t1, testId: testId } = props;
    const size = t0 === undefined ? "medium" : t0;
    const isInset = t1 === undefined ? true : t1;
    const containerRef = (0, $cozmU.useRef)(null);
    let t2;
    if ($[0] !== size) {
        t2 = ()=>{
            return;
        };
        $[0] = size;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children || $[3] !== size) {
        t3 = [
            children,
            size
        ];
        $[2] = children;
        $[3] = size;
        $[4] = t3;
    } else t3 = $[4];
    (0, $cozmU.useEffect)(t2, t3);
    const t4 = label !== "" ? label : undefined;
    const t5 = label !== "" ? "img" : undefined;
    const t6 = $60cc37ad75899268$var$sizeMap[size];
    const t7 = isInset ? $60cc37ad75899268$var$styles.inset : $60cc37ad75899268$var$styles.nonInset;
    const t8 = isInset && $60cc37ad75899268$var$insetSizeMap[size];
    const t9 = $60cc37ad75899268$var$backgroundColorMap[backgroundColor || "color.background.neutral"];
    const t10 = hasBorder && $60cc37ad75899268$var$styles.border;
    let t11;
    if ($[5] !== t10 || $[6] !== t6 || $[7] !== t7 || $[8] !== t8 || $[9] !== t9) {
        t11 = (0, $hekY6.default)([
            $60cc37ad75899268$var$styles.root,
            t6,
            t7,
            t8,
            t9,
            t10
        ]);
        $[5] = t10;
        $[6] = t6;
        $[7] = t7;
        $[8] = t8;
        $[9] = t9;
        $[10] = t11;
    } else t11 = $[10];
    let t12;
    if ($[11] !== children || $[12] !== t11 || $[13] !== t4 || $[14] !== t5 || $[15] !== testId) {
        t12 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            ref: containerRef,
            "data-testid": testId,
            "aria-label": t4,
            role: t5,
            className: t11,
            children: children
        });
        $[11] = children;
        $[12] = t11;
        $[13] = t4;
        $[14] = t5;
        $[15] = testId;
        $[16] = t12;
    } else t12 = $[16];
    return t12;
} : function Tile(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    const containerRef = (0, $cozmU.useRef)(null); // Dev-mode only: validate that raster images passed into the tile
    // are square and retina-compatible (at least 2x the rendered tile size).
    (0, $cozmU.useEffect)(()=>{
        return;
    }, [
        children,
        size
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        ref: containerRef,
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $hekY6.default)([
            $60cc37ad75899268$var$styles.root,
            $60cc37ad75899268$var$sizeMap[size],
            isInset ? $60cc37ad75899268$var$styles.inset : $60cc37ad75899268$var$styles.nonInset,
            isInset && $60cc37ad75899268$var$insetSizeMap[size],
            $60cc37ad75899268$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $60cc37ad75899268$var$styles.border
        ]),
        children: children
    });
};
var $60cc37ad75899268$export$2e2bcd8739ae039 = $60cc37ad75899268$var$Tile;
function $60cc37ad75899268$var$_temp(fn) {
    return fn();
}
module.exports["default"] = $60cc37ad75899268$export$2e2bcd8739ae039;

});

parcelRegister("4zc1o", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bf4bc7217f58b5ef916be3252e86e461>>
 * @codegenCommand yarn workspace @atlassian/logo-third-party generate:components
 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $bD1F5 = parcelRequire("bD1F5");

const $0245abe18739bd2c$var$markup = '<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><mask id="mask0_118280_5589" width="32" height="28" x="8" y="9" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#b43333" d="M18.03 12.455c2.659-4.606 9.307-4.607 11.967 0l8.187 14.181C40.844 31.242 37.52 37 32.201 37H15.825c-5.318 0-8.642-5.758-5.983-10.364z"/></mask><g mask="url(#mask0_118280_5589)"><path fill="url(#paint0_linear_118280_5589)" d="M44.178 37.004H27.47l-3.457-5.988 8.353-14.47z"/><path fill="url(#paint1_linear_118280_5589)" d="m3.846 37.004 11.811-20.457-3.456 5.987h6.913l8.354 14.47z"/><path fill="url(#paint2_linear_118280_5589)" d="m24.015 2.074 8.354 14.47-3.457 5.987H12.204z"/></g><defs><linearGradient id="paint0_linear_118280_5589" x1="41.759" x2="25.302" y1="35.836" y2="25.947" gradientUnits="userSpaceOnUse"><stop offset=".09" stop-color="#ffe921"/><stop offset="1" stop-color="#fec700"/></linearGradient><linearGradient id="paint1_linear_118280_5589" x1="27.359" x2="9.383" y1="38.75" y2="27.875" gradientUnits="userSpaceOnUse"><stop offset=".15" stop-color="#a9a8ff"/><stop offset=".33" stop-color="#6d97ff"/><stop offset=".48" stop-color="#3186ff"/></linearGradient><linearGradient id="paint2_linear_118280_5589" x1="29.992" x2="11.777" y1="12.613" y2="21.115" gradientUnits="userSpaceOnUse"><stop offset=".55" stop-color="#0ebc5f"/><stop offset=".85" stop-color="#78c9ff"/></linearGradient></defs></svg>';
function $0245abe18739bd2c$export$e16bd899bb4eebf9({ size: size, label: label = 'Google Drive', testId: testId, type: type }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bD1F5.ThirdPartyLogoWrapper), {
        markup: $0245abe18739bd2c$var$markup,
        label: label,
        size: size,
        testId: testId,
        type: type
    });
}
module.exports["GoogleDriveIcon"] = $0245abe18739bd2c$export$e16bd899bb4eebf9;

});

parcelRegister("1448l", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b1f5ffa69b5c0e453beda5633352f13d>>
 * @codegenCommand yarn workspace @atlassian/logo-third-party generate:components
 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $bD1F5 = parcelRequire("bD1F5");

const $d7fa96db4fb26034$var$markup = '<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><path fill="#009954" d="M9 20.26c0-1.524 0-2.286.24-2.891a3.4 3.4 0 0 1 1.914-1.915c.605-.24 1.367-.24 2.892-.24h10.363c1.524 0 2.287 0 2.891.24a3.4 3.4 0 0 1 1.915 1.915c.24.605.24 1.367.24 2.891v7.296c0 1.524 0 2.286-.24 2.891a3.4 3.4 0 0 1-1.915 1.915c-.604.24-1.367.24-2.89.24H14.045c-1.525 0-2.287 0-2.892-.24a3.4 3.4 0 0 1-1.915-1.915C9 29.842 9 29.08 9 27.556z"/><mask id="mask0_118280_5597" width="28" height="22" x="11" y="13" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#0ebc5f" d="M35.59 13H15.137a3.41 3.41 0 0 0-3.409 3.41v15a3.41 3.41 0 0 0 3.41 3.408H35.59A3.41 3.41 0 0 0 39 31.41v-15A3.41 3.41 0 0 0 35.59 13"/></mask><g mask="url(#mask0_118280_5597)"><path fill="#0ebc5f" d="M11.727 13H39v21.818H11.727z"/><g filter="url(#filter0_f_118280_5597)"><path fill="url(#paint0_linear_118280_5597)" d="M29.182 32.602H13.364A4.364 4.364 0 0 1 9 28.238v-8.66a4.364 4.364 0 0 1 4.364-4.363h15.818a4.364 4.364 0 0 1 4.363 4.364v8.659a4.364 4.364 0 0 1-4.363 4.364"/></g></g><path stroke="#fff" stroke-linecap="round" stroke-width="2.045" d="M21.273 28.17H35.59m-3.41 3.24V20.5"/><defs><linearGradient id="paint0_linear_118280_5597" x1="29.836" x2="12.539" y1="25.219" y2="25.219" gradientUnits="userSpaceOnUse"><stop stop-color="#0ebc5f"/><stop offset=".95" stop-color="#78c9ff"/></linearGradient><filter id="filter0_f_118280_5597" width="28.636" height="21.478" x="6.955" y="13.169" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape"/><feGaussianBlur result="effect1_foregroundBlur_118280_5597" stdDeviation="1.023"/></filter></defs></svg>';
function $d7fa96db4fb26034$export$8f2f3b35698eb007({ size: size, label: label = 'Google Sheets', testId: testId, type: type }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bD1F5.ThirdPartyLogoWrapper), {
        markup: $d7fa96db4fb26034$var$markup,
        label: label,
        size: size,
        testId: testId,
        type: type
    });
}
module.exports["GoogleSheetsIcon"] = $d7fa96db4fb26034$export$8f2f3b35698eb007;

});

parcelRegister("2XmSX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::967d6746ac12ab9f19a2546e408780e0>>
 * @codegenCommand yarn workspace @atlassian/logo-third-party generate:components
 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $bD1F5 = parcelRequire("bD1F5");

const $18a69ac08dbf147a$var$markup = '<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><path fill="url(#paint0_linear_118280_5603)" d="M9.124 18.167a5 5 0 0 1 4.128-5.74l17.273-2.822a5 5 0 0 1 5.74 4.129l2.63 16.105a5 5 0 0 1-4.128 5.74l-17.272 2.822a5 5 0 0 1-5.74-4.129z"/><path fill="url(#paint1_linear_118280_5603)" d="M9.018 17.86c0-1.597 0-2.396.251-3.029a3.57 3.57 0 0 1 2.006-2.006c.633-.25 1.432-.25 3.029-.25h19.428c1.597 0 2.396 0 3.03.25a3.57 3.57 0 0 1 2.005 2.006c.251.633.251 1.432.251 3.029v12.286c0 1.597 0 2.395-.25 3.029a3.57 3.57 0 0 1-2.007 2.006c-.633.25-1.432.25-3.029.25H14.304c-1.597 0-2.396 0-3.03-.25a3.57 3.57 0 0 1-2.005-2.006c-.25-.634-.25-1.432-.25-3.03z"/><mask id="mask0_118280_5603" width="31" height="24" x="9" y="12" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#fec700" d="M9.018 17.86c0-1.597 0-2.396.251-3.029a3.57 3.57 0 0 1 2.006-2.006c.633-.25 1.432-.25 3.029-.25h19.428c1.597 0 2.396 0 3.03.25a3.57 3.57 0 0 1 2.005 2.006c.251.633.251 1.432.251 3.029v12.286c0 1.597 0 2.395-.25 3.029a3.57 3.57 0 0 1-2.007 2.006c-.633.25-1.432.25-3.029.25H14.304c-1.597 0-2.396 0-3.03-.25a3.57 3.57 0 0 1-2.005-2.006c-.25-.634-.25-1.432-.25-3.03z"/></mask><g filter="url(#filter0_f_118280_5603)" mask="url(#mask0_118280_5603)"><path fill="#ffbe00" d="m12.9 41.06 25.785-3.854-4.434-29.67-25.785 3.853z"/><path fill="url(#paint2_linear_118280_5603)" d="m12.9 41.06 25.785-3.854-4.434-29.67-25.785 3.853z"/></g><path fill="#fff" fill-rule="evenodd" d="M33.304 17.219a1.07 1.07 0 0 1 1.071 1.071v11.43a1.07 1.07 0 0 1-1.071 1.071H14.732l-.055-.001a1.07 1.07 0 0 1-1.016-1.07V18.29a1.07 1.07 0 0 1 1.016-1.07l.055-.001zm-17.5 11.428h16.428v-9.285H15.804z" clip-rule="evenodd"/><defs><linearGradient id="paint0_linear_118280_5603" x1="21.888" x2="34.947" y1="11.016" y2="35.578" gradientUnits="userSpaceOnUse"><stop offset=".2" stop-color="#ffdb0f"/><stop offset=".67" stop-color="#ffbe00"/><stop offset=".91" stop-color="#ffa8e3"/></linearGradient><linearGradient id="paint1_linear_118280_5603" x1="24.018" x2="24.018" y1="12.574" y2="35.431" gradientUnits="userSpaceOnUse"><stop stop-color="#ffbe00"/><stop offset="1" stop-color="#fec700"/></linearGradient><linearGradient id="paint2_linear_118280_5603" x1="26.254" x2="21.868" y1="36.889" y2="11.373" gradientUnits="userSpaceOnUse"><stop offset=".07" stop-color="#fff549"/><stop offset=".78" stop-color="#ffbe00" stop-opacity="0"/></linearGradient><filter id="filter0_f_118280_5603" width="34.505" height="37.809" x="6.323" y="5.392" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape"/><feGaussianBlur result="effect1_foregroundBlur_118280_5603" stdDeviation="1.071"/></filter></defs></svg>';
function $18a69ac08dbf147a$export$76eb192103c43b3f({ size: size, label: label = 'Google Slides', testId: testId, type: type }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bD1F5.ThirdPartyLogoWrapper), {
        markup: $18a69ac08dbf147a$var$markup,
        label: label,
        size: size,
        testId: testId,
        type: type
    });
}
module.exports["GoogleSlidesIcon"] = $18a69ac08dbf147a$export$76eb192103c43b3f;

});

parcelRegister("5TdBT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d2dbb3e83d74c73f9a7ff48dd32e63e6>>
 * @codegenCommand yarn workspace @atlassian/logo-third-party generate:components
 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $bD1F5 = parcelRequire("bD1F5");

const $f87149460128dc3a$var$markup = '<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><path fill="url(#paint0_radial_118280_5819)" d="M16.396 15.797c-5.198 0-9.083 4.255-9.376 8.995.181 1.021.776 3.038 1.708 2.935 1.165-.13 4.1 0 6.602-4.531 1.828-3.31 5.589-7.4 1.066-7.4"/><path fill="url(#paint1_radial_118280_5819)" d="M15.194 17.566c-1.747 2.767-4.1 6.73-4.893 7.978-.944 1.483-3.442.853-3.235-1.273q-.03.26-.047.522a9.517 9.517 0 0 0 9.497 10.121c6.013 0 20.353-7.491 18.902-14.997-1.53-4.412-5.83-7.577-10.701-7.577s-7.995 2.807-9.523 5.226"/><path fill="url(#paint2_radial_118280_5819)" fill-opacity=".4" d="M15.194 17.566c-1.747 2.767-4.1 6.73-4.893 7.978-.944 1.483-3.442.853-3.235-1.273q-.03.26-.047.522a9.517 9.517 0 0 0 9.497 10.121c6.013 0 20.353-7.491 18.902-14.997-1.53-4.412-5.83-7.577-10.701-7.577s-7.995 2.807-9.523 5.226"/><path fill="url(#paint3_radial_118280_5819)" d="M15.194 17.566c-1.747 2.767-4.1 6.73-4.893 7.978-.944 1.483-3.442.853-3.235-1.273q-.03.26-.047.522a9.517 9.517 0 0 0 9.497 10.121c6.013 0 20.353-7.491 18.902-14.997-1.53-4.412-5.83-7.577-10.701-7.577s-7.995 2.807-9.523 5.226"/><path fill="url(#paint4_radial_118280_5819)" fill-opacity=".6" d="M15.194 17.566c-1.747 2.767-4.1 6.73-4.893 7.978-.944 1.483-3.442.853-3.235-1.273q-.03.26-.047.522a9.517 9.517 0 0 0 9.497 10.121c6.013 0 20.353-7.491 18.902-14.997-1.53-4.412-5.83-7.577-10.701-7.577s-7.995 2.807-9.523 5.226"/><path fill="url(#paint5_radial_118280_5819)" fill-opacity=".9" d="M15.194 17.566c-1.747 2.767-4.1 6.73-4.893 7.978-.944 1.483-3.442.853-3.235-1.273q-.03.26-.047.522a9.517 9.517 0 0 0 9.497 10.121c6.013 0 20.353-7.491 18.902-14.997-1.53-4.412-5.83-7.577-10.701-7.577s-7.995 2.807-9.523 5.226"/><path fill="url(#paint6_linear_118280_5819)" d="M16.429 34.918s14.357.028 16.792.028c4.419 0 7.779-3.608 7.779-7.818s-3.428-7.796-7.78-7.796c-4.351 0-6.857 3.256-8.74 6.81-2.205 4.164-5.019 8.726-8.051 8.776"/><path fill="url(#paint7_radial_118280_5819)" fill-opacity=".4" d="M16.429 34.918s14.357.028 16.792.028c4.419 0 7.779-3.608 7.779-7.818s-3.428-7.796-7.78-7.796c-4.351 0-6.857 3.256-8.74 6.81-2.205 4.164-5.019 8.726-8.051 8.776"/><path fill="url(#paint8_radial_118280_5819)" fill-opacity=".9" d="M16.429 34.918s14.357.028 16.792.028c4.419 0 7.779-3.608 7.779-7.818s-3.428-7.796-7.78-7.796c-4.351 0-6.857 3.256-8.74 6.81-2.205 4.164-5.019 8.726-8.051 8.776"/><defs><radialGradient id="paint0_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(50.153 -14.375 16.71)scale(10.7161 17.7747)" gradientUnits="userSpaceOnUse"><stop stop-color="#4894fe"/><stop offset=".695" stop-color="#0934b3"/></radialGradient><radialGradient id="paint1_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(130.923 17.143 10.667)scale(46.0803 34.1459)" gradientUnits="userSpaceOnUse"><stop offset=".165" stop-color="#23c0fe"/><stop offset=".534" stop-color="#1c91ff"/></radialGradient><radialGradient id="paint2_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(220.014 10.522 6.163)scale(9.36856 21.4466)" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset=".661" stop-color="#adc0ff" stop-opacity="0"/></radialGradient><radialGradient id="paint3_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(220.236 17.663 9.818)scale(10.5597 16.0372)" gradientUnits="userSpaceOnUse"><stop stop-color="#033acc"/><stop offset="1" stop-color="#368eff" stop-opacity="0"/></radialGradient><radialGradient id="paint4_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(66.571 -1.855 16.474)scale(23.1705 25.0138)" gradientUnits="userSpaceOnUse"><stop offset=".593" stop-color="#3464e3" stop-opacity="0"/><stop offset="1" stop-color="#033acc"/></radialGradient><radialGradient id="paint5_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(135 16.558 11.022)scale(34.0831 53.3967)" gradientUnits="userSpaceOnUse"><stop stop-color="#4bfde8"/><stop offset=".544" stop-color="#4bfde8" stop-opacity="0"/></radialGradient><radialGradient id="paint7_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(21.632 -45.065 64.673)scale(15.4444 29.2464)" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset=".785" stop-color="#fff" stop-opacity="0"/></radialGradient><radialGradient id="paint8_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(139.243 16.894 16.587)scale(21.1738 21.2455)" gradientUnits="userSpaceOnUse"><stop stop-color="#4bfde8"/><stop offset=".585" stop-color="#4bfde8" stop-opacity="0"/></radialGradient><linearGradient id="paint6_linear_118280_5819" x1="28.722" x2="28.722" y1="34.931" y2="19.517" gradientUnits="userSpaceOnUse"><stop stop-color="#0086ff"/><stop offset=".49" stop-color="#0bf"/></linearGradient></defs></svg>';
function $f87149460128dc3a$export$adf3a43722623322({ size: size, label: label = 'Microsoft OneDrive', testId: testId, type: type }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bD1F5.ThirdPartyLogoWrapper), {
        markup: $f87149460128dc3a$var$markup,
        label: label,
        size: size,
        testId: testId,
        type: type
    });
}
module.exports["MicrosoftOneDriveIcon"] = $f87149460128dc3a$export$adf3a43722623322;

});

parcelRegister("8RTwe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1069d04804a2ae0ab9d0c6315e1cb5f4>>
 * @codegenCommand yarn workspace @atlassian/logo-third-party generate:components
 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $bD1F5 = parcelRequire("bD1F5");

const $9a3d60b77ddc3f21$var$markup = '<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><path fill="url(#paint0_linear_118280_5862)" d="M22.58 27.1c5.006 0 9.064-4.052 9.064-9.05S27.585 9 22.58 9s-9.064 4.052-9.064 9.05 4.058 9.05 9.064 9.05"/><path fill="url(#paint1_radial_118280_5862)" d="M22.58 27.1c5.006 0 9.064-4.052 9.064-9.05S27.585 9 22.58 9s-9.064 4.052-9.064 9.05 4.058 9.05 9.064 9.05"/><path fill="url(#paint2_radial_118280_5862)" d="M22.58 27.1c5.006 0 9.064-4.052 9.064-9.05S27.585 9 22.58 9s-9.064 4.052-9.064 9.05 4.058 9.05 9.064 9.05"/><path fill="url(#paint3_radial_118280_5862)" d="M22.58 27.1c5.006 0 9.064-4.052 9.064-9.05S27.585 9 22.58 9s-9.064 4.052-9.064 9.05 4.058 9.05 9.064 9.05"/><path fill="url(#paint4_linear_118280_5862)" d="M30.847 33.13c4.172 0 7.553-3.376 7.553-7.541s-3.381-7.542-7.553-7.542c-4.171 0-7.553 3.376-7.553 7.542 0 4.165 3.382 7.541 7.553 7.541"/><path fill="url(#paint5_radial_118280_5862)" d="M30.847 33.13c4.172 0 7.553-3.376 7.553-7.541s-3.381-7.542-7.553-7.542c-4.171 0-7.553 3.376-7.553 7.542 0 4.165 3.382 7.541 7.553 7.541"/><path fill="url(#paint6_radial_118280_5862)" d="M30.847 33.13c4.172 0 7.553-3.376 7.553-7.541s-3.381-7.542-7.553-7.542c-4.171 0-7.553 3.376-7.553 7.542 0 4.165 3.382 7.541 7.553 7.541"/><path fill="url(#paint7_linear_118280_5862)" d="M23.712 39.169c3.546 0 6.42-2.87 6.42-6.41s-2.874-6.411-6.42-6.411a6.415 6.415 0 0 0-6.42 6.41c0 3.54 2.875 6.41 6.42 6.41"/><path fill="url(#paint8_linear_118280_5862)" d="M23.712 39.169c3.546 0 6.42-2.87 6.42-6.41s-2.874-6.411-6.42-6.411a6.415 6.415 0 0 0-6.42 6.41c0 3.54 2.875 6.41 6.42 6.41"/><path fill="url(#paint9_radial_118280_5862)" d="M13.703 23.324h7.179a2.453 2.453 0 0 1 2.453 2.453v7.16a2.453 2.453 0 0 1-2.453 2.454h-7.179a2.453 2.453 0 0 1-2.453-2.453v-7.16a2.453 2.453 0 0 1 2.453-2.454"/><path fill="url(#paint10_radial_118280_5862)" d="M13.703 23.324h7.179a2.453 2.453 0 0 1 2.453 2.453v7.16a2.453 2.453 0 0 1-2.453 2.454h-7.179a2.453 2.453 0 0 1-2.453-2.453v-7.16a2.453 2.453 0 0 1 2.453-2.454"/><path fill="#fff" d="m14.689 31.445 1.31-.683q.221.447.579.659.36.211.79.212.476 0 .726-.193.25-.198.25-.591a.67.67 0 0 0-.24-.52q-.24-.216-.853-.327-1.166-.212-1.695-.74-.525-.53-.525-1.318 0-.981.694-1.569.694-.585 1.83-.586.765 0 1.349.313.583.312.925.894l-1.281.66a1.4 1.4 0 0 0-.457-.472q-.247-.15-.617-.15-.443 0-.675.193a.63.63 0 0 0-.226.5q0 .265.217.467.222.197.886.322 1.117.212 1.666.77.555.553.554 1.4 0 1.03-.66 1.63t-1.883.6q-.886 0-1.599-.384a2.54 2.54 0 0 1-1.064-1.087z"/><defs><radialGradient id="paint1_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(-5.32263 -12.8627 -23.1621 9.55567 25.665 29.882)" gradientUnits="userSpaceOnUse"><stop offset=".29" stop-color="#003b5d" stop-opacity=".2"/><stop offset=".61" stop-color="#004a6c" stop-opacity=".138"/><stop offset=".97" stop-color="#006f94" stop-opacity="0"/></radialGradient><radialGradient id="paint2_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(-4.41835 -10.8865 -19.5798 7.9222 24.391 24.611)" gradientUnits="userSpaceOnUse"><stop offset=".26" stop-color="#002a42" stop-opacity=".31"/><stop offset=".61" stop-color="#004261" stop-opacity=".214"/><stop offset=".97" stop-color="#006f94" stop-opacity="0"/></radialGradient><radialGradient id="paint3_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(-5.56759 8.10392 8.11617 5.55934 27.893 10.686)" gradientUnits="userSpaceOnUse"><stop stop-color="#78edff" stop-opacity=".698"/><stop offset="1" stop-color="#2ccfca" stop-opacity="0"/></radialGradient><radialGradient id="paint5_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(3.0738 -8.81188 -15.9013 -5.52951 26.098 31.084)" gradientUnits="userSpaceOnUse"><stop stop-color="#003b5d" stop-opacity=".502"/><stop offset=".49" stop-color="#004c6c" stop-opacity=".362"/><stop offset=".97" stop-color="#007a86" stop-opacity="0"/></radialGradient><radialGradient id="paint6_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(-4.6396 6.75319 6.76325 4.63263 34.97 19.304)" gradientUnits="userSpaceOnUse"><stop stop-color="#78edff" stop-opacity=".698"/><stop offset="1" stop-color="#2ccfca" stop-opacity="0"/></radialGradient><radialGradient id="paint9_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(12.1028 12.086 12.105 -12.0839 13.08 23.761)" gradientUnits="userSpaceOnUse"><stop offset=".06" stop-color="#00b6bd"/><stop offset=".89" stop-color="#00495c"/></radialGradient><radialGradient id="paint10_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(0 8.45945 -9.64483 0 17.124 30.643)" gradientUnits="userSpaceOnUse"><stop offset=".57" stop-color="#1e8581" stop-opacity="0"/><stop offset=".97" stop-color="#1ecbe6" stop-opacity=".6"/></radialGradient><linearGradient id="paint0_linear_118280_5862" x1="16.812" x2="28.885" y1="10.479" y2="26.325" gradientUnits="userSpaceOnUse"><stop stop-color="#00e3df"/><stop offset=".41" stop-color="#0097a8"/><stop offset="1" stop-color="#007791"/></linearGradient><linearGradient id="paint4_linear_118280_5862" x1="26.04" x2="36.102" y1="19.279" y2="32.485" gradientUnits="userSpaceOnUse"><stop stop-color="#00e3df"/><stop offset=".48" stop-color="#00a2b8"/><stop offset=".95" stop-color="#00637c"/></linearGradient><linearGradient id="paint7_linear_118280_5862" x1="20.506" x2="26.919" y1="26.346" y2="39.17" gradientUnits="userSpaceOnUse"><stop offset=".05" stop-color="#75fff6"/><stop offset=".51" stop-color="#00c7d1"/><stop offset=".96" stop-color="#0096ad"/></linearGradient><linearGradient id="paint8_linear_118280_5862" x1="28.894" x2="25.466" y1="40.029" y2="35.22" gradientUnits="userSpaceOnUse"><stop offset=".26" stop-color="#0e5a5d" stop-opacity=".322"/><stop offset=".54" stop-color="#126c6b" stop-opacity=".222"/><stop offset=".97" stop-color="#1c948a" stop-opacity="0"/></linearGradient></defs></svg>';
function $9a3d60b77ddc3f21$export$18737550276ca4ad({ size: size, label: label = 'Microsoft SharePoint', testId: testId, type: type }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bD1F5.ThirdPartyLogoWrapper), {
        markup: $9a3d60b77ddc3f21$var$markup,
        label: label,
        size: size,
        testId: testId,
        type: type
    });
}
module.exports["MicrosoftSharePointIcon"] = $9a3d60b77ddc3f21$export$18737550276ca4ad;

});

parcelRegister("aKu7b", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::da47da1b5e64654108e26910fa19a540>>
 * @codegenCommand yarn workspace @atlassian/logo-third-party generate:components
 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $bD1F5 = parcelRequire("bD1F5");

const $8e1b7c443fefb49f$var$markup = '<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><g clip-path="url(#clip0_118280_5876)"><path fill="url(#paint0_radial_118280_5876)" d="M23.33 20.398h8.552a4.276 4.276 0 0 1 4.276 4.277v7.127a4.276 4.276 0 1 1-8.552 0v-7.127a4.276 4.276 0 0 0-4.277-4.277"/><path fill="url(#paint1_radial_118280_5876)" d="M13.351 23.253a4.276 4.276 0 0 1 4.277-4.276h5.701a4.276 4.276 0 0 1 4.277 4.276v8.552a4.276 4.276 0 0 0 4.276 4.277H20.478a7.127 7.127 0 0 1-7.127-7.127z"/><path fill="url(#paint2_linear_118280_5876)" fill-opacity=".7" d="M13.351 23.253a4.276 4.276 0 0 1 4.277-4.276h5.701a4.276 4.276 0 0 1 4.277 4.276v8.552a4.276 4.276 0 0 0 4.276 4.277H20.478a7.127 7.127 0 0 1-7.127-7.127z"/><path fill="url(#paint3_radial_118280_5876)" fill-opacity=".7" d="M13.351 23.253a4.276 4.276 0 0 1 4.277-4.276h5.701a4.276 4.276 0 0 1 4.277 4.276v8.552a4.276 4.276 0 0 0 4.276 4.277H20.478a7.127 7.127 0 0 1-7.127-7.127z"/><path fill="url(#paint4_radial_118280_5876)" d="M31.17 18.979a3.564 3.564 0 1 0 0-7.127 3.564 3.564 0 0 0 0 7.127"/><path fill="url(#paint5_radial_118280_5876)" fill-opacity=".46" d="M31.17 18.979a3.564 3.564 0 1 0 0-7.127 3.564 3.564 0 0 0 0 7.127"/><path fill="url(#paint6_radial_118280_5876)" fill-opacity=".4" d="M31.17 18.979a3.564 3.564 0 1 0 0-7.127 3.564 3.564 0 0 0 0 7.127"/><path fill="url(#paint7_radial_118280_5876)" d="M20.479 17.553a4.276 4.276 0 1 0 0-8.553 4.276 4.276 0 0 0 0 8.553"/><path fill="url(#paint8_radial_118280_5876)" fill-opacity=".6" d="M20.479 17.553a4.276 4.276 0 1 0 0-8.553 4.276 4.276 0 0 0 0 8.553"/><path fill="url(#paint9_radial_118280_5876)" fill-opacity=".5" d="M20.479 17.553a4.276 4.276 0 1 0 0-8.553 4.276 4.276 0 0 0 0 8.553"/><path fill="url(#paint10_radial_118280_5876)" d="M19.587 22.543h-6.77a2.316 2.316 0 0 0-2.317 2.316v6.771a2.316 2.316 0 0 0 2.317 2.317h6.77a2.316 2.316 0 0 0 2.317-2.317v-6.77a2.316 2.316 0 0 0-2.317-2.317"/><path fill="url(#paint11_radial_118280_5876)" fill-opacity=".7" d="M19.587 22.543h-6.77a2.316 2.316 0 0 0-2.317 2.316v6.771a2.316 2.316 0 0 0 2.317 2.317h6.77a2.316 2.316 0 0 0 2.317-2.317v-6.77a2.316 2.316 0 0 0-2.317-2.317"/><path fill="#fff" d="M18.681 26.18h-1.744v5.32h-1.471v-5.32H13.72v-1.196h4.96z"/></g><defs><radialGradient id="paint0_radial_118280_5876" cx="0" cy="0" r="1" gradientTransform="matrix(9.60632 0 0 23.7117 36.014 21.948)" gradientUnits="userSpaceOnUse"><stop stop-color="#a98aff"/><stop offset=".14" stop-color="#8c75ff"/><stop offset=".565" stop-color="#5f50e2"/><stop offset=".9" stop-color="#3c2cb8"/></radialGradient><radialGradient id="paint1_radial_118280_5876" cx="0" cy="0" r="1" gradientTransform="rotate(68.154 -6.218 19.215)scale(23.343 23.6075)" gradientUnits="userSpaceOnUse"><stop stop-color="#85c2ff"/><stop offset=".69" stop-color="#7588ff"/><stop offset="1" stop-color="#6459fe"/></radialGradient><radialGradient id="paint3_radial_118280_5876" cx="0" cy="0" r="1" gradientTransform="rotate(113.326 7.57 18.166)scale(13.6975 10.9953)" gradientUnits="userSpaceOnUse"><stop stop-color="#bd96ff"/><stop offset=".687" stop-color="#bd96ff" stop-opacity="0"/></radialGradient><radialGradient id="paint4_radial_118280_5876" cx="0" cy="0" r="1" gradientTransform="matrix(0 -7.12719 8.99566 0 31.17 14.397)" gradientUnits="userSpaceOnUse"><stop offset=".268" stop-color="#6868f7"/><stop offset="1" stop-color="#3923b1"/></radialGradient><radialGradient id="paint5_radial_118280_5876" cx="0" cy="0" r="1" gradientTransform="rotate(40.052 -4.633 45.55)scale(5.0933 7.36688)" gradientUnits="userSpaceOnUse"><stop offset=".271" stop-color="#a1d3ff"/><stop offset=".813" stop-color="#a1d3ff" stop-opacity="0"/></radialGradient><radialGradient id="paint6_radial_118280_5876" cx="0" cy="0" r="1" gradientTransform="rotate(-41.658 34.798 -37.925)scale(6.0672 14.8833)" gradientUnits="userSpaceOnUse"><stop stop-color="#e3acfd"/><stop offset=".816" stop-color="#9fa2ff" stop-opacity="0"/></radialGradient><radialGradient id="paint7_radial_118280_5876" cx="0" cy="0" r="1" gradientTransform="matrix(0 -8.55263 10.7948 0 20.479 12.055)" gradientUnits="userSpaceOnUse"><stop offset=".268" stop-color="#8282ff"/><stop offset="1" stop-color="#3923b1"/></radialGradient><radialGradient id="paint8_radial_118280_5876" cx="0" cy="0" r="1" gradientTransform="rotate(40.052 -6.859 28.832)scale(6.11195 8.84021)" gradientUnits="userSpaceOnUse"><stop offset=".271" stop-color="#a1d3ff"/><stop offset=".813" stop-color="#a1d3ff" stop-opacity="0"/></radialGradient><radialGradient id="paint9_radial_118280_5876" cx="0" cy="0" r="1" gradientTransform="rotate(-41.658 26.433 -25.877)scale(7.28064 17.86)" gradientUnits="userSpaceOnUse"><stop stop-color="#e3acfd"/><stop offset=".816" stop-color="#9fa2ff" stop-opacity="0"/></radialGradient><radialGradient id="paint10_radial_118280_5876" cx="0" cy="0" r="1" gradientTransform="rotate(45 -21.962 23.946)scale(16.127)" gradientUnits="userSpaceOnUse"><stop offset=".047" stop-color="#688eff"/><stop offset=".947" stop-color="#230f94"/></radialGradient><radialGradient id="paint11_radial_118280_5876" cx="0" cy="0" r="1" gradientTransform="matrix(0 7.98246 -9.31538 0 16.202 29.385)" gradientUnits="userSpaceOnUse"><stop offset=".571" stop-color="#6965f6" stop-opacity="0"/><stop offset="1" stop-color="#8f8fff"/></radialGradient><linearGradient id="paint2_linear_118280_5876" x1="22.327" x2="22.327" y1="18.977" y2="36.082" gradientUnits="userSpaceOnUse"><stop offset=".801" stop-color="#6864f6" stop-opacity="0"/><stop offset="1" stop-color="#5149de"/></linearGradient><clipPath id="clip0_118280_5876"><path fill="#fff" d="M10.5 9h25.658v27.083H10.5z"/></clipPath></defs></svg>';
function $8e1b7c443fefb49f$export$cce9aa98f30fc4ea({ size: size, label: label = 'Microsoft Teams', testId: testId, type: type }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bD1F5.ThirdPartyLogoWrapper), {
        markup: $8e1b7c443fefb49f$var$markup,
        label: label,
        size: size,
        testId: testId,
        type: type
    });
}
module.exports["MicrosoftTeamsIcon"] = $8e1b7c443fefb49f$export$cce9aa98f30fc4ea;

});

parcelRegister("e0Gob", function(module, exports) {
/* ContentPreviewPlaceholder.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $dinVW = parcelRequire("dinVW");

var $320cc310d84c5b29$exports = {};
$320cc310d84c5b29$exports = new URL("preview-no-selection.14e43eee.svg", import.meta.url).toString();


var $39054e692c50a9dd$exports = {};
$39054e692c50a9dd$exports = new URL("content-preview-squiggle.027b5d84.svg", import.meta.url).toString();


const $32647b41ad829cc7$var$styles = {
    container: "_1mT5xdRAKS _0jFU0VN91d",
    squiggleWrapper: "_43nrzTkG2W _0rIjykNHnM",
    skeletonBarFull: "_39xV02Qjzx _0jFU0VJg58 _0KLXrumhAQ",
    skeletonBarShortWrapper: "_43nrzT8HPE",
    skeletonBarShort: "_39xV023CA1 _0jFU0VJg58 _0KLXrumhAQ",
    skeletonBarBottom: "_39xV02zfVU _0jFU0VZimw _0KLXrumhAQ _1mT5xdWVPG _0Bm75GPgdg _3OE6xYPgdg"
};
const $32647b41ad829cc7$export$5589fb4f49509a9b = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $32647b41ad829cc7$var$styles.container,
        testId: "content-preview-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($320cc310d84c5b29$exports))),
        alt: "",
        "aria-hidden": "true",
        width: "100%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $32647b41ad829cc7$var$styles.squiggleWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($39054e692c50a9dd$exports))),
        alt: "",
        "aria-hidden": "true",
        width: "84",
        height: "15"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $32647b41ad829cc7$var$styles.skeletonBarFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $32647b41ad829cc7$var$styles.skeletonBarFull
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $32647b41ad829cc7$var$styles.skeletonBarShortWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $32647b41ad829cc7$var$styles.skeletonBarShort
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $32647b41ad829cc7$var$styles.skeletonBarBottom
    }));
};
module.exports["ContentPreviewPlaceholder"] = $32647b41ad829cc7$export$5589fb4f49509a9b;

});

parcelRegister("e3Wrf", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $cozmU = parcelRequire("cozmU");


var $7r5Hr = parcelRequire("7r5Hr");


var $iDrrr = parcelRequire("iDrrr");

const $f7ddda300dd34381$var$packageName = "platform-pkg";
const $f7ddda300dd34381$var$packageVersion = "0.0.0-use.local";
const $f7ddda300dd34381$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $f7ddda300dd34381$var$packageName,
    packageVersion: $f7ddda300dd34381$var$packageVersion
};
const $f7ddda300dd34381$var$lineHeightBase = 20;
const $f7ddda300dd34381$var$lineHeightCompact = 16;
const $f7ddda300dd34381$var$compactVerticalPadding = 2;
const $f7ddda300dd34381$var$verticalPadding = 6;
const $f7ddda300dd34381$var$transitionDuration = '0.2s';
const $f7ddda300dd34381$var$borderWidth = 2;
const $f7ddda300dd34381$var$baseStyles = null;
const $f7ddda300dd34381$var$finessePlaceholderStyles = null;
const $f7ddda300dd34381$var$appearanceStyles = {
    standard: "_3hxITi6wH8 _1mHXSFHKt7 _3OEoix7Cj1 _39nh0ghQC5 _2jpXBkVrZW _31SgFAHKt7 _2zr3nGqWX3 _3LfWyLFQfX _2vsVfZFQfX _2DQpWtXJux _0SosFGXJux _1CDq3qgVvo _2FTXAcgVvo _0tVs2sXJux _3JVwBfXJux _0xkEdpnXvL _1iy5hxutHW _0ui43CPhRM _2UNgvCnXvL _1LO7QkVrZW",
    subtle: "_3hxITi6wH8 _1mHXSFjOvk _3OEoixjOvk _31SgFAHKt7 _2zr3nGqWX3 _3LfWyLFQfX _2vsVfZFQfX _2DQpWtXJux _0SosFGXJux _1CDq3qgVvo _2FTXAcgVvo _3JVwBfXJux _0tVs2sXJux _0xkEdpnXvL _1iy5hxutHW _0ui43CPhRM",
    none: "_3hxITiYbGa _1mHXSFjOvk _3OEoixjOvk _31SgFAjOvk _2zr3nGjOvk _3LfWyLFQfX _0SosFGgVvo _2vsVfZFQfX _2DQpWtgVvo _1CDq3qgVvo _3JVwBfgVvo _2FTXAcgVvo _0tVs2sgVvo _0xkEdpjOvk _1iy5hxjOvk _0ui43Cw5zn"
}; // iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on mobile devices, the textarea uses font.body.large (16px) by default,
// then switches to the smaller font.body on screens wider than 30rem (desktop).
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $f7ddda300dd34381$var$fontStyles = {
    default: "_2sNsIg20Hp _4kBIzkmnOE",
    monospace: "_2sNsIg20Hp _0WKd3Gfx9v _4kBIzkmnOE _2GdZyqdh5F"
};
const $f7ddda300dd34381$var$resizeStyles = {
    horizontal: "_2HIj7GD4qA",
    vertical: "_2HIj7GbI28",
    auto: "_2HIj7GZSoF",
    smart: "_2HIj7GYbGa",
    none: "_2HIj7GYbGa"
};
const $f7ddda300dd34381$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $f7ddda300dd34381$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $f7ddda300dd34381$var$InnerTextArea = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(63);
    const ourRef = (0, $cozmU.useRef)(null);
    let onBlur;
    let onChange;
    let onFocus;
    let rest;
    let style;
    let t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    let testId;
    let value;
    if ($[0] !== props) {
        ({ resize: t0, appearance: t1, isCompact: t2, isRequired: t3, isReadOnly: t4, isDisabled: t5, isInvalid: t6, isMonospaced: t7, minimumRows: t8, testId: testId, maxHeight: t9, onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props);
        $[0] = props;
        $[1] = onBlur;
        $[2] = onChange;
        $[3] = onFocus;
        $[4] = rest;
        $[5] = style;
        $[6] = t0;
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
        $[13] = t7;
        $[14] = t8;
        $[15] = t9;
        $[16] = testId;
        $[17] = value;
    } else {
        onBlur = $[1];
        onChange = $[2];
        onFocus = $[3];
        rest = $[4];
        style = $[5];
        t0 = $[6];
        t1 = $[7];
        t2 = $[8];
        t3 = $[9];
        t4 = $[10];
        t5 = $[11];
        t6 = $[12];
        t7 = $[13];
        t8 = $[14];
        t9 = $[15];
        testId = $[16];
        value = $[17];
    }
    const resize = t0 === undefined ? "smart" : t0;
    const appearance = t1 === undefined ? "standard" : t1;
    const isCompact = t2 === undefined ? false : t2;
    const isRequired = t3 === undefined ? false : t3;
    const isReadOnly = t4 === undefined ? false : t4;
    const isDisabled = t5 === undefined ? false : t5;
    const isInvalid = t6 === undefined ? false : t6;
    const isMonospaced = t7 === undefined ? false : t7;
    const minimumRows = t8 === undefined ? 2 : t8;
    const maxHeight = t9 === undefined ? "50vh" : t9;
    const borderHeight = appearance === "none" ? 2 : 1;
    let t10;
    if ($[18] !== resize) {
        t10 = ()=>{
            const el = ourRef.current;
            if (resize === "smart" && el) $f7ddda300dd34381$var$setSmartHeight(el);
        };
        $[18] = resize;
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] !== resize || $[21] !== value) {
        t11 = [
            resize,
            value
        ];
        $[20] = resize;
        $[21] = value;
        $[22] = t11;
    } else t11 = $[22];
    (0, $cozmU.useEffect)(t10, t11);
    let t12;
    if ($[23] !== onBlur) {
        t12 = {
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: "blurred",
            ...$f7ddda300dd34381$var$analyticsParams
        };
        $[23] = onBlur;
        $[24] = t12;
    } else t12 = $[24];
    const onBlurWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t12);
    let t13;
    if ($[25] !== onFocus) {
        t13 = {
            fn: (event_0)=>{
                onFocus && onFocus(event_0);
            },
            action: "focused",
            ...$f7ddda300dd34381$var$analyticsParams
        };
        $[25] = onFocus;
        $[26] = t13;
    } else t13 = $[26];
    const onFocusWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t13);
    let t14;
    if ($[27] !== ref) {
        t14 = (elementRef)=>{
            ourRef.current = elementRef;
            if (ref && typeof ref === "object") ref.current = elementRef;
            if (ref && typeof ref === "function") ref(elementRef);
        };
        $[27] = ref;
        $[28] = t14;
    } else t14 = $[28];
    const getTextAreaRef = t14;
    let t15;
    if ($[29] !== onChange || $[30] !== resize) {
        t15 = (e)=>{
            const el_0 = ourRef.current;
            if (resize === "smart" && el_0) $f7ddda300dd34381$var$setSmartHeight(el_0);
            onChange && onChange(e);
        };
        $[29] = onChange;
        $[30] = resize;
        $[31] = t15;
    } else t15 = $[31];
    const handleOnChange = t15;
    const t16 = isInvalid ? isInvalid : undefined;
    const t17 = isCompact ? isCompact : undefined;
    const t18 = testId ? testId : undefined;
    let t19;
    if ($[32] !== t16 || $[33] !== t17 || $[34] !== t18) {
        t19 = {
            "data-invalid": t16,
            "data-compact": t17,
            "data-testid": t18
        };
        $[32] = t16;
        $[33] = t17;
        $[34] = t18;
        $[35] = t19;
    } else t19 = $[35];
    const controlProps = t19;
    let t20;
    if ($[36] !== appearance || $[37] !== isMonospaced || $[38] !== resize) {
        t20 = (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2O5Vij7dHp _3YEZNO7dHp _1bHrqEN91d _0bjKvDKTcp _2sNsIgmnOE _2xIroY98eZ _497WNwYbGa _2zndICT6kp _4bt5LAIZbP _2WAcuGIZbP _23rrnH5Vpu _2V7sgONvrM _3iDTPbvLZJ _24h04i2Njc _39xV02N91d _4ouGXIdnbC _1EqgXlN91d _1mT5xdRAKS _1UtDYzy7kJ _1T2N03wPeg _2IasYonod9 _03v5H87Cj1 _32yk65FKgL _24bGaTot27 _02aXbKsyl5 _0OS5PY7dHp _1kg4OzZqHV _3tCyJvYbGa _2DoaPjYbGa _3pNDujnod9 _1cY5OfqWX3 _0sBZ7MFKgL _30pU6CVrZW _3AxjleKGUX _3MV4MUot27 _1yFQeXQWvZ _3TNCtG1AUN _3OInhJnXvL _1xHRfPutHW _4skx3vPhRM",
            (0, $iDrrr.fg)("platform-dst-tokens-finesse") && "_3AxjleZpcK",
            $f7ddda300dd34381$var$appearanceStyles[appearance],
            $f7ddda300dd34381$var$fontStyles[isMonospaced ? "monospace" : "default"],
            $f7ddda300dd34381$var$resizeStyles[resize],
            "_22P5CgPgdP _2Ombu6q5bj"
        ]);
        $[36] = appearance;
        $[37] = isMonospaced;
        $[38] = resize;
        $[39] = t20;
    } else t20 = $[39];
    const t21 = $f7ddda300dd34381$var$lineHeightCompact * minimumRows + $f7ddda300dd34381$var$compactVerticalPadding * 2 + borderHeight * 2;
    let t22;
    if ($[40] !== t21) {
        t22 = (0, $9aYkv.default)(t21, "px");
        $[40] = t21;
        $[41] = t22;
    } else t22 = $[41];
    const t23 = $f7ddda300dd34381$var$lineHeightBase * minimumRows + $f7ddda300dd34381$var$verticalPadding * 2 + borderHeight * 2;
    let t24;
    if ($[42] !== t23) {
        t24 = (0, $9aYkv.default)(t23, "px");
        $[42] = t23;
        $[43] = t24;
    } else t24 = $[43];
    let t25;
    if ($[44] !== maxHeight || $[45] !== style || $[46] !== t22 || $[47] !== t24) {
        t25 = {
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": t22,
            "--_eorxnz": t24
        };
        $[44] = maxHeight;
        $[45] = style;
        $[46] = t22;
        $[47] = t24;
        $[48] = t25;
    } else t25 = $[48];
    let t26;
    if ($[49] !== controlProps || $[50] !== getTextAreaRef || $[51] !== handleOnChange || $[52] !== isDisabled || $[53] !== isReadOnly || $[54] !== isRequired || $[55] !== minimumRows || $[56] !== onBlurWithAnalytics || $[57] !== onFocusWithAnalytics || $[58] !== rest || $[59] !== t20 || $[60] !== t25 || $[61] !== value) {
        t26 = /*#__PURE__*/ (0, $8aG6j.jsx)("textarea", {
            ...controlProps,
            value: value,
            disabled: isDisabled,
            readOnly: isReadOnly,
            required: isRequired,
            ref: getTextAreaRef,
            onChange: handleOnChange,
            onBlur: onBlurWithAnalytics,
            onFocus: onFocusWithAnalytics,
            rows: minimumRows,
            ...rest,
            className: t20,
            style: t25
        });
        $[49] = controlProps;
        $[50] = getTextAreaRef;
        $[51] = handleOnChange;
        $[52] = isDisabled;
        $[53] = isReadOnly;
        $[54] = isRequired;
        $[55] = minimumRows;
        $[56] = onBlurWithAnalytics;
        $[57] = onFocusWithAnalytics;
        $[58] = rest;
        $[59] = t20;
        $[60] = t25;
        $[61] = value;
        $[62] = t26;
    } else t26 = $[62];
    return t26;
} : (props, ref)=>{
    const ourRef = (0, $cozmU.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $cozmU.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $cozmU.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $f7ddda300dd34381$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$f7ddda300dd34381$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: (event_0)=>{
            onFocus && onFocus(event_0);
        },
        action: 'focused',
        ...$f7ddda300dd34381$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $cozmU.useCallback)((e)=>{
        const el_0 = ourRef.current;
        if (resize === 'smart' && el_0) $f7ddda300dd34381$var$setSmartHeight(el_0);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2O5Vij7dHp _3YEZNO7dHp _1bHrqEN91d _0bjKvDKTcp _2sNsIgmnOE _2xIroY98eZ _497WNwYbGa _2zndICT6kp _4bt5LAIZbP _2WAcuGIZbP _23rrnH5Vpu _2V7sgONvrM _3iDTPbvLZJ _24h04i2Njc _39xV02N91d _4ouGXIdnbC _1EqgXlN91d _1mT5xdRAKS _1UtDYzy7kJ _1T2N03wPeg _2IasYonod9 _03v5H87Cj1 _32yk65FKgL _24bGaTot27 _02aXbKsyl5 _0OS5PY7dHp _1kg4OzZqHV _3tCyJvYbGa _2DoaPjYbGa _3pNDujnod9 _1cY5OfqWX3 _0sBZ7MFKgL _30pU6CVrZW _3AxjleKGUX _3MV4MUot27 _1yFQeXQWvZ _3TNCtG1AUN _3OInhJnXvL _1xHRfPutHW _4skx3vPhRM",
            (0, $iDrrr.fg)('platform-dst-tokens-finesse') && "_3AxjleZpcK",
            $f7ddda300dd34381$var$appearanceStyles[appearance],
            $f7ddda300dd34381$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $f7ddda300dd34381$var$resizeStyles[resize],
            "_22P5CgPgdP _2Ombu6q5bj"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $9aYkv.default)($f7ddda300dd34381$var$lineHeightCompact * minimumRows + $f7ddda300dd34381$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $9aYkv.default)($f7ddda300dd34381$var$lineHeightBase * minimumRows + $f7ddda300dd34381$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $f7ddda300dd34381$var$TextArea = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)($f7ddda300dd34381$var$InnerTextArea, {
            ref: ref,
            ...props
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>/*#__PURE__*/ (0, $8aG6j.jsx)($f7ddda300dd34381$var$InnerTextArea, {
        ref: ref,
        ...props
    })));
$f7ddda300dd34381$var$TextArea.displayName = 'TextArea';
var $f7ddda300dd34381$export$2e2bcd8739ae039 = $f7ddda300dd34381$var$TextArea;
module.exports["default"] = $f7ddda300dd34381$export$2e2bcd8739ae039;

});

parcelRegister("dJySn", function(module, exports) {
module.exports = new URL("preview-background.054f72c1.svg", import.meta.url).toString();

});

parcelRegister("3WMx1", function(module, exports) {
module.exports = new URL("content-preview-sparkle.2c80a83f.svg", import.meta.url).toString();

});

parcelRegister("eKTWO", function(module, exports) {

var $hU1C8 = parcelRequire("hU1C8");


var $jwbRi = parcelRequire("jwbRi");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $6mKj3 = parcelRequire("6mKj3");


var $hBkCm = parcelRequire("hBkCm");

var $f7B1p = parcelRequire("f7B1p");


var $jMyy4 = parcelRequire("jMyy4");

const $862814430f69e6aa$export$47d4842719bdb071 = (0, $jwbRi.default);
const $862814430f69e6aa$export$aad7e27ed56b51fc = (0, $hU1C8.default);
const $862814430f69e6aa$export$ba9e49b520a30a69 = ({ spaceKey: spaceKey, cloudId: cloudId })=>$862814430f69e6aa$var$useFetchSuggestionCountInternal({
        spaceKey: spaceKey,
        cloudId: cloudId
    }, (0, $6mKj3.expVal)('confluence_autonomous_space_curation_ssr_streaming', 'isEnabled', false));
const $862814430f69e6aa$export$d39f13847aa08df3 = ({ spaceKey: spaceKey, cloudId: cloudId, suggestionCountFragmentRef: suggestionCountFragmentRef })=>{
    const fragmentData = (0, $6SsN4.useFragment)($862814430f69e6aa$export$47d4842719bdb071, suggestionCountFragmentRef);
    return $862814430f69e6aa$var$useFetchSuggestionCountInternal({
        spaceKey: spaceKey,
        cloudId: cloudId
    }, (0, $6mKj3.expVal)('confluence_autonomous_space_curation_ssr_streaming', 'isEnabled', false), fragmentData);
};
const $862814430f69e6aa$var$useFetchSuggestionCountInternal = ({ spaceKey: spaceKey, cloudId: cloudId }, isStreamingEnabled, fragmentData)=>{
    const usesRouteData = fragmentData !== undefined;
    // Apollo path — runs when experiment is on. useQueryInterop must be called
    // unconditionally; the skip option prevents network activity when unused.
    const { data: apolloData, loading: apolloLoading, refetch: apolloRefetch } = (0, $jMyy4.useQueryInterop)($862814430f69e6aa$export$aad7e27ed56b51fc, {
        variables: {
            cloudId: cloudId,
            spaceKey: spaceKey ?? ''
        },
        skip: !isStreamingEnabled || !spaceKey || usesRouteData,
        interopApolloAggClient: true,
        __callerPackage__: "space-curation"
    });
    const apolloResult = (0, $cozmU.useMemo)(()=>{
        if (!isStreamingEnabled) return null;
        const hasChildQueryData = apolloData != null;
        const raw = hasChildQueryData ? apolloData.confluence_remoteObjectSuggestionCount : fragmentData?.confluence_remoteObjectSuggestionCount;
        const isLoading = usesRouteData && !hasChildQueryData ? false : apolloLoading;
        // null data is the suppression signal — this includes the case where the
        // backend returns errors alongside null data (e.g. NotFoundException when
        // the user has been permanently suppressed). Do not gate on apolloError.
        const apolloIsSuppressed = !isLoading && raw == null;
        return {
            count: raw ?? 0,
            isLoading: isLoading,
            isSuppressed: apolloIsSuppressed,
            refetch: ()=>{
                apolloRefetch();
            }
        };
    }, [
        apolloData,
        apolloLoading,
        apolloRefetch,
        fragmentData,
        isStreamingEnabled,
        usesRouteData
    ]);
    // cfetch path — used when experiment is off
    const [count, setCount] = (0, $cozmU.useState)(0);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const [isSuppressed, setIsSuppressed] = (0, $cozmU.useState)(false);
    const fetchCount = (0, $cozmU.useCallback)(async ()=>{
        if (isStreamingEnabled) return;
        if (!spaceKey) {
            setCount(0);
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        try {
            const response = await (0, $f7B1p.cfetch)(`/wiki/rest/internal/1.0/spaces/${spaceKey}/remote-objects/suggestions/count`, {
                method: 'GET'
            });
            const text = await response.text();
            const parsed = parseInt(text, 10);
            if (isNaN(parsed)) setIsSuppressed(true);
            else {
                setCount(parsed);
                setIsSuppressed(false);
            }
        } catch (error) {
            if ((0, $hBkCm.BadStatusError).isBadStatusError(error) && error.response.status === 404) setIsSuppressed(true);
        // silently fail on other errors
        } finally{
            setIsLoading(false);
        }
    }, [
        isStreamingEnabled,
        spaceKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
        fetchCount();
    }, [
        fetchCount
    ]);
    if (isStreamingEnabled) return apolloResult ?? {
        count: count,
        isLoading: isLoading,
        isSuppressed: isSuppressed,
        refetch: fetchCount
    };
    return {
        count: count,
        isLoading: isLoading,
        isSuppressed: isSuppressed,
        refetch: fetchCount
    };
};
module.exports["RemoteObjectSuggestionCountQuery"] = $862814430f69e6aa$export$aad7e27ed56b51fc;
module.exports["useFetchSuggestionCount"] = $862814430f69e6aa$export$ba9e49b520a30a69;
module.exports["useFetchSuggestionCountFromFragment"] = $862814430f69e6aa$export$d39f13847aa08df3;

});

parcelRegister("hU1C8", function(module, exports) {
/**
 * @generated SignedSource<<7ed3a2785ef14914cca4babcea9ce45a>>
 * @relayHash 2928057d03b4f5d5a1a268a9759b926b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e2a667fff01500eb3e9307529089fae38f8ffbfdb7afefb552f82585ed918492
const $41493c5c0e5e4e0b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_remoteObjectSuggestionCount"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFetchSuggestionCountQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFetchSuggestionCountQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "2928057d03b4f5d5a1a268a9759b926b",
            "id": "e2a667fff01500eb3e9307529089fae38f8ffbfdb7afefb552f82585ed918492",
            "metadata": {},
            "name": "useFetchSuggestionCountQuery",
            "operationKind": "query",
            "text": "query useFetchSuggestionCountQuery($cloudId:ID!,$spaceKey:String!){confluence_remoteObjectSuggestionCount(cloudId:$cloudId,spaceKey:$spaceKey)}"
        }
    };
}();
$41493c5c0e5e4e0b$var$node.hash = "050919681608acb31690dce800b52bae";
var $41493c5c0e5e4e0b$export$2e2bcd8739ae039 = $41493c5c0e5e4e0b$var$node;
module.exports["default"] = $41493c5c0e5e4e0b$export$2e2bcd8739ae039;

});

parcelRegister("jwbRi", function(module, exports) {
/**
 * @generated SignedSource<<38626ff8705a6c0de9b2d1e6d56973af>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b18ce3bc11082c03$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "spaceKey"
        }
    ],
    "kind": "Fragment",
    "name": "useFetchSuggestionCount_query",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_remoteObjectSuggestionCount"
        }
    ],
    "type": "Query"
};
$b18ce3bc11082c03$var$node.hash = "b4d0196e6c2004ac771cb71891cd74af";
var $b18ce3bc11082c03$export$2e2bcd8739ae039 = $b18ce3bc11082c03$var$node;
module.exports["default"] = $b18ce3bc11082c03$export$2e2bcd8739ae039;

});

parcelRegister("lbRgq", function(module, exports) {

let $f6d3f1286a8027b3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f6d3f1286a8027b3$var$load("536mm").then(()=>parcelRequire('l3QM4'));

});

parcelRegister("7xVCs", function(module, exports) {

var $3u5lg = parcelRequire("3u5lg");


var $kNIYN = parcelRequire("kNIYN");

class $3c23582ca65aa05a$export$90a06df90d015db9 extends (0, $kNIYN.Container) {
    scrollToCurrentPage() {
        this.setState({
            scrollToCurrent: true
        });
    }
    clearScrollTo() {
        this.setState({
            scrollToCurrent: false
        });
    }
    setHighlightPagesIds(pageIds) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(this.state.highlightPagesIds, pageIds)) this.setState({
            highlightPagesIds: pageIds
        });
    }
    clearHighlightedPages() {
        this.setHighlightPagesIds([]);
    }
    setForceFetchPageId(pageId) {
        this.setState({
            forceFetchPageId: pageId
        });
    }
    clearForceFetch() {
        this.setForceFetchPageId(null);
    }
    setOptimisticDeleteId(pageId) {
        this.setState({
            optimisticDeletePageId: pageId
        });
    }
    clearOptimisticDeleteId() {
        this.setOptimisticDeleteId(null);
    }
    setIsEditingTitleId(contentId) {
        return this.setState({
            editingTitle: {
                contentId: contentId
            }
        });
    }
    // This is for content types such as folders that do not have a create content url
    // Instead, we allow naming the content inside the page tree immediately after creation
    forceFetchWithInlineRename(forceFetchId, contentId) {
        this.setState({
            forceFetchPageId: forceFetchId,
            editingTitle: {
                contentId: contentId,
                isNewContent: true
            },
            scrollToPageId: contentId
        });
    }
    clearScrollToPageId() {
        this.setState({
            scrollToPageId: null
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            highlightPagesIds: [],
            forceFetchPageId: null,
            optimisticDeletePageId: null,
            scrollToCurrent: false,
            scrollToPageId: null,
            editingTitle: {
                contentId: null
            }
        };
    }
}
module.exports["PageTreeStateUpdater"] = $3c23582ca65aa05a$export$90a06df90d015db9;

});

parcelRegister("huaOC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4Qc44 = parcelRequire("4Qc44");


var $lmzCg = parcelRequire("lmzCg");


var $hLtfj = parcelRequire("hLtfj");


var $KuePV = parcelRequire("KuePV");


var $4o9cR = parcelRequire("4o9cR");

const $e30c6d4ea2de4ef1$var$listItemStyles = {
    root: "_2pQraJ0Qmj"
};
const $e30c6d4ea2de4ef1$var$LinkMenuItemNoRef = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, forwardedRef)=>{
    const $ = (0, $bDgLe.c)(26);
    const { testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator } = t0;
    const itemRef = (0, $cozmU.useRef)(null);
    const t1 = isSelected ?? false;
    let t2;
    if ($[0] !== t1) {
        t2 = {
            elementRef: itemRef,
            isSelected: t1
        };
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    (0, $4o9cR.useScrollMenuItemIntoView)(t2);
    const t3 = listItemRef ?? null;
    let t4;
    if ($[2] !== t3) {
        t4 = (0, $lmzCg.default)([
            itemRef,
            t3
        ]);
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    const ref = t4;
    let t5;
    if ($[4] !== actions || $[5] !== actionsOnHover || $[6] !== children || $[7] !== description || $[8] !== dropIndicator || $[9] !== elemAfter || $[10] !== elemBefore || $[11] !== forwardedRef || $[12] !== hasDragIndicator || $[13] !== href || $[14] !== interactionName || $[15] !== isContentTooltipDisabled || $[16] !== isDragging || $[17] !== isSelected || $[18] !== onClick || $[19] !== target || $[20] !== testId || $[21] !== visualContentRef) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $KuePV.MenuItemBase), {
            testId: testId,
            description: description,
            actions: actions,
            elemAfter: elemAfter,
            elemBefore: elemBefore,
            href: href,
            target: target,
            actionsOnHover: actionsOnHover,
            isSelected: isSelected,
            onClick: onClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator
        }, children);
        $[4] = actions;
        $[5] = actionsOnHover;
        $[6] = children;
        $[7] = description;
        $[8] = dropIndicator;
        $[9] = elemAfter;
        $[10] = elemBefore;
        $[11] = forwardedRef;
        $[12] = hasDragIndicator;
        $[13] = href;
        $[14] = interactionName;
        $[15] = isContentTooltipDisabled;
        $[16] = isDragging;
        $[17] = isSelected;
        $[18] = onClick;
        $[19] = target;
        $[20] = testId;
        $[21] = visualContentRef;
        $[22] = t5;
    } else t5 = $[22];
    let t6;
    if ($[23] !== ref || $[24] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $hLtfj.ListItem), {
            ref: ref,
            xcss: $e30c6d4ea2de4ef1$var$listItemStyles.root
        }, t5);
        $[23] = ref;
        $[24] = t5;
        $[25] = t6;
    } else t6 = $[25];
    return t6;
} : ({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const itemRef = (0, $cozmU.useRef)(null);
    (0, $4o9cR.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: isSelected ?? false
    });
    const ref = (0, $cozmU.useMemo)(()=>{
        return (0, $lmzCg.default)([
            itemRef,
            listItemRef ?? null
        ]);
    }, [
        itemRef,
        listItemRef
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $hLtfj.ListItem), {
        ref: ref,
        xcss: $e30c6d4ea2de4ef1$var$listItemStyles.root
    }, /*#__PURE__*/ $cozmU.createElement((0, $KuePV.MenuItemBase), {
        testId: testId,
        description: description,
        actions: actions,
        elemAfter: elemAfter,
        elemBefore: elemBefore,
        href: href,
        target: target,
        actionsOnHover: actionsOnHover,
        isSelected: isSelected,
        onClick: onClick,
        ref: forwardedRef,
        visualContentRef: visualContentRef,
        interactionName: interactionName,
        isContentTooltipDisabled: isContentTooltipDisabled,
        isDragging: isDragging,
        hasDragIndicator: hasDragIndicator,
        dropIndicator: dropIndicator
    }, children));
};
const $e30c6d4ea2de4ef1$export$d2cad7a1cce7b35f = (0, $4Qc44.default)($e30c6d4ea2de4ef1$var$LinkMenuItemNoRef);
module.exports["LinkMenuItem"] = $e30c6d4ea2de4ef1$export$d2cad7a1cce7b35f;

});

parcelRegister("4Qc44", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5936b606760a760$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $e5936b606760a760$export$2e2bcd8739ae039 = (0, $cozmU.forwardRef);

});

parcelRegister("4o9cR", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bB0i2 = parcelRequire("bB0i2");


var $8AWCX = parcelRequire("8AWCX");

function $9fe3f1218f1710c7$var$scrollMenuItemIntoView(element) {
    /**
   * If [scrollIntoViewIfNeeded](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoViewIfNeeded) is available,
   * we are using it to scroll the element into view _in the center_ of the scroll container. Because it is a non-standard method
   * and not available on all browsers (currently not supported in Firefox), we are using it for progressive enhancement.
   *
   * Otherwise, we are falling back to [scrollIntoView](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView).
   */ const elementWithScrollMethod = element;
    if (typeof elementWithScrollMethod.scrollIntoViewIfNeeded === 'function') {
        elementWithScrollMethod.scrollIntoViewIfNeeded(true);
        return;
    }
    // JSDOM does not support scrollIntoView, so defensively using it (see https://github.com/jsdom/jsdom/issues/1695)
    element.scrollIntoView?.({
        // We are using `nearest` to prevent scrolling on user interaction when the menu item is already in view.
        block: 'nearest'
    });
}
const $9fe3f1218f1710c7$export$2c52ec851fcc6058 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useScrollMenuItemIntoView(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { elementRef: elementRef, isSelected: isSelected } = t0;
    const areAllAncestorsExpanded = (0, $8AWCX.useAreAllAncestorsExpanded)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            type: "waiting-to-be-selected-and-all-ancestors-expanded"
        };
        $[0] = t1;
    } else t1 = $[0];
    const waitingStateRef = (0, $cozmU.useRef)(t1);
    let t2;
    let t3;
    if ($[1] !== areAllAncestorsExpanded || $[2] !== elementRef || $[3] !== isSelected) {
        t2 = ()=>{
            if (waitingStateRef.current.type === "waiting-to-be-selected-and-all-ancestors-expanded") {
                const shouldScroll = areAllAncestorsExpanded && isSelected;
                if (!shouldScroll) return;
                const element = elementRef.current;
                (0, $bB0i2.default)(element, "Element ref must be set");
                $9fe3f1218f1710c7$var$scrollMenuItemIntoView(element);
                waitingStateRef.current.type = "waiting-to-be-unselected";
                return;
            }
            if (waitingStateRef.current.type === "waiting-to-be-unselected") {
                if (!isSelected) waitingStateRef.current.type = "waiting-to-be-selected-and-all-ancestors-expanded";
                return;
            }
        };
        t3 = [
            areAllAncestorsExpanded,
            elementRef,
            isSelected
        ];
        $[1] = areAllAncestorsExpanded;
        $[2] = elementRef;
        $[3] = isSelected;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $cozmU.useEffect)(t2, t3);
} : function useScrollMenuItemIntoView({ elementRef: elementRef, isSelected: isSelected }) {
    const areAllAncestorsExpanded = (0, $8AWCX.useAreAllAncestorsExpanded)();
    const waitingStateRef = (0, $cozmU.useRef)({
        type: 'waiting-to-be-selected-and-all-ancestors-expanded'
    });
    (0, $cozmU.useEffect)(()=>{
        if (waitingStateRef.current.type === 'waiting-to-be-selected-and-all-ancestors-expanded') {
            const shouldScroll = areAllAncestorsExpanded && isSelected;
            if (!shouldScroll) return;
            const element = elementRef.current;
            (0, $bB0i2.default)(element, 'Element ref must be set');
            $9fe3f1218f1710c7$var$scrollMenuItemIntoView(element);
            // Now that we are scrolled the menu item into view, we need to wait for the menu item to
            // be unselected before checking again.
            waitingStateRef.current.type = 'waiting-to-be-unselected';
            return;
        }
        if (waitingStateRef.current.type === 'waiting-to-be-unselected') {
            if (!isSelected) waitingStateRef.current.type = 'waiting-to-be-selected-and-all-ancestors-expanded';
            return;
        }
    }, [
        areAllAncestorsExpanded,
        elementRef,
        isSelected
    ]);
};
module.exports["useScrollMenuItemIntoView"] = $9fe3f1218f1710c7$export$2c52ec851fcc6058;

});

parcelRegister("04jMq", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $16e27872478384c0$export$7f1bcb54a9a4d80e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "kWSCB",
    name: "ShortcutsSection",
    loader: async ()=>(await (parcelRequire("3CPtZ"))).ShortcutsSection
});
module.exports["ShortcutsSection"] = $16e27872478384c0$export$7f1bcb54a9a4d80e;

});

parcelRegister("3CPtZ", function(module, exports) {

let $2a3cdb1fe9f6cff8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2a3cdb1fe9f6cff8$var$load("9VG8E"),
    $2a3cdb1fe9f6cff8$var$load("ea3NB"),
    $2a3cdb1fe9f6cff8$var$load("aC3bY"),
    $2a3cdb1fe9f6cff8$var$load("Lm7SH"),
    $2a3cdb1fe9f6cff8$var$load("6wr18"),
    $2a3cdb1fe9f6cff8$var$load("fLZBc"),
    $2a3cdb1fe9f6cff8$var$load("hgxd4"),
    $2a3cdb1fe9f6cff8$var$load("llcQo"),
    $2a3cdb1fe9f6cff8$var$load("bLZ3r"),
    $2a3cdb1fe9f6cff8$var$load("h6m7t"),
    $2a3cdb1fe9f6cff8$var$load("Tjs4D"),
    $2a3cdb1fe9f6cff8$var$load("Wowvf"),
    $2a3cdb1fe9f6cff8$var$load("aLwQm"),
    $2a3cdb1fe9f6cff8$var$load("excC5"),
    $2a3cdb1fe9f6cff8$var$load("ffEVr"),
    $2a3cdb1fe9f6cff8$var$load("6zCMk"),
    $2a3cdb1fe9f6cff8$var$load("8hP2l"),
    $2a3cdb1fe9f6cff8$var$load("1XtfK"),
    $2a3cdb1fe9f6cff8$var$load("80Yra"),
    $2a3cdb1fe9f6cff8$var$load("d1n8n"),
    $2a3cdb1fe9f6cff8$var$load("7EorR"),
    $2a3cdb1fe9f6cff8$var$load("953Uz"),
    $2a3cdb1fe9f6cff8$var$load("hhss7"),
    $2a3cdb1fe9f6cff8$var$load("1NnjK")
]).then(()=>parcelRequire('eTFt9'));

});

parcelRegister("d5um7", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $5Dlqn = parcelRequire("5Dlqn");


var $h11I1 = parcelRequire("h11I1");


var $8AWCX = parcelRequire("8AWCX");

const $6b9c8550570135b2$var$relativeStyles = {
    root: "_1mT5xdRAKS"
}; /**
    * __ExpandableMenuItem__
    *
    * A composable component for nested menu items that can be revealed and hidden by interacting witih the parent menu item.
    *
    * Follows the [disclosure pattern](https://www.w3.org/WAI/ARIA/apg/patterns/disclosure/).
    *
    * Should be used with `ExpandableMenuItemTrigger` as the parent menu item, and children menu items should be wrapped in a `ExpandableMenuItemContent`.
    *
    * Usage example:
    * ```jsx
    * <ExpandableMenuItem>
    *   <ExpandableMenuItemTrigger>Parent menu item</ExpandableMenuItemTrigger>
    *   <ExpandableMenuItemContent>
    *     <ButtonMenuItem>Item 1</ButtonMenuItem>
    *     <ButtonMenuItem>Item 2</ButtonMenuItem>
    *   </ExpandableMenuItemContent>
    * </ExpandableMenuItem>
    * ```
    */ 
const $6b9c8550570135b2$export$341dea48c30b36ff = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, forwardedRef)=>{
    const $ = (0, $bDgLe.c)(21);
    const { isExpanded: isExpandedControlled, isDefaultExpanded: t1, onExpansionToggle: onExpansionToggle, children: children, dropIndicator: dropIndicator, testId: testId } = t0;
    const isDefaultExpanded = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== isDefaultExpanded) {
        t2 = ()=>isDefaultExpanded;
        $[0] = isDefaultExpanded;
        $[1] = t2;
    } else t2 = $[1];
    const [isExpanded, setIsExpanded] = (0, $5Dlqn.default)(isExpandedControlled, t2);
    const t3 = onExpansionToggle ?? null;
    const t4 = dropIndicator && $6b9c8550570135b2$var$relativeStyles.root;
    let t5;
    if ($[2] !== t4) {
        t5 = (0, $hekY6.default)([
            t4
        ]);
        $[2] = t4;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== children || $[5] !== dropIndicator || $[6] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t5
        }, children, dropIndicator);
        $[4] = children;
        $[5] = dropIndicator;
        $[6] = t5;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== forwardedRef || $[9] !== t6 || $[10] !== testId) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $h11I1.MenuListItem), {
            ref: forwardedRef,
            testId: testId
        }, t6);
        $[8] = forwardedRef;
        $[9] = t6;
        $[10] = testId;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== t3 || $[13] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $8AWCX.OnExpansionToggleContext).Provider, {
            value: t3
        }, t7);
        $[12] = t3;
        $[13] = t7;
        $[14] = t8;
    } else t8 = $[14];
    let t9;
    if ($[15] !== setIsExpanded || $[16] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $8AWCX.SetIsExpandedContext).Provider, {
            value: setIsExpanded
        }, t8);
        $[15] = setIsExpanded;
        $[16] = t8;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== isExpanded || $[19] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $8AWCX.IsExpandedContext).Provider, {
            value: isExpanded
        }, t9);
        $[18] = isExpanded;
        $[19] = t9;
        $[20] = t10;
    } else t10 = $[20];
    return t10;
} : ({ isExpanded: isExpandedControlled, isDefaultExpanded: isDefaultExpanded = false, onExpansionToggle: onExpansionToggle, children: children, dropIndicator: dropIndicator, testId: testId }, forwardedRef)=>{
    const [isExpanded, setIsExpanded] = (0, $5Dlqn.default)(isExpandedControlled, ()=>isDefaultExpanded);
    return /*#__PURE__*/ $cozmU.createElement((0, $8AWCX.IsExpandedContext).Provider, {
        value: isExpanded
    }, /*#__PURE__*/ $cozmU.createElement((0, $8AWCX.SetIsExpandedContext).Provider, {
        value: setIsExpanded
    }, /*#__PURE__*/ $cozmU.createElement((0, $8AWCX.OnExpansionToggleContext).Provider, {
        value: onExpansionToggle ?? null
    }, /*#__PURE__*/ $cozmU.createElement((0, $h11I1.MenuListItem), {
        ref: forwardedRef,
        testId: testId
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            dropIndicator && $6b9c8550570135b2$var$relativeStyles.root
        ])
    }, children, dropIndicator)))));
});
module.exports["ExpandableMenuItem"] = $6b9c8550570135b2$export$341dea48c30b36ff;

});

parcelRegister("jZuGB", function(module, exports) {
/* expandable-menu-item-content.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $k27u5 = parcelRequire("k27u5");


var $8AWCX = parcelRequire("8AWCX");

const $9c28a97efb757560$var$styles = {
    content: "_0LQT5ExpxF",
    collapsedContent: "_3iDTPbYbGa"
};
const $9c28a97efb757560$export$bd680a81504a92e9 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children }, forwardedRef)=>{
    const isExpanded = (0, $8AWCX.useIsExpanded)();
    const level = (0, $8AWCX.useLevel)();
    const hasExpanded = (0, $cozmU.useRef)(false);
    const areAllAncestorsExpanded = (0, $8AWCX.useAreAllAncestorsExpanded)();
    if (!isExpanded && !hasExpanded.current) return null;
    hasExpanded.current = true;
    return /*#__PURE__*/ $cozmU.createElement((0, $8AWCX.LevelContext).Provider, {
        value: level + 1
    }, /*#__PURE__*/ $cozmU.createElement((0, $8AWCX.AreAllAncestorsExpandedContext).Provider, {
        value: /**
     * By combining the current ancestor and with the current menu item's state, all nested menu items will know if their
     * ancestor menu items are all expanded.
     */ areAllAncestorsExpanded && isExpanded
    }, /*#__PURE__*/ $cozmU.createElement((0, $k27u5.List), {
        ref: forwardedRef,
        xcss: (0, $k12R1.cx)($9c28a97efb757560$var$styles.content, !isExpanded && $9c28a97efb757560$var$styles.collapsedContent)
    }, children)));
});
module.exports["ExpandableMenuItemContent"] = $9c28a97efb757560$export$bd680a81504a92e9;

});

parcelRegister("k27u5", function(module, exports) {
/* list.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");

function $3028fcb6dba16eaa$var$_List({ children: children, testId: testId, xcss: xcss }, forwardedRef) {
    return(/**
     * We are using `role="list"` instead of a `ul` element to enable more flexible
     * composition. By using ARIA roles we can validly have elements between a list
     * and list items, as long as those in-between elements have no semantics.
     */ /*#__PURE__*/ $cozmU.createElement("div", {
        role: "list",
        ref: forwardedRef,
        className: xcss,
        "data-testid": testId
    }, children));
}
const $3028fcb6dba16eaa$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $cozmU.forwardRef)($3028fcb6dba16eaa$var$_List);
module.exports["List"] = $3028fcb6dba16eaa$export$54c2e3dc7acea9f5;

});

parcelRegister("gMhPZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $1sCHt = parcelRequire("1sCHt");


var $4Qc44 = parcelRequire("4Qc44");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $KuePV = parcelRequire("KuePV");


var $4o9cR = parcelRequire("4o9cR");


var $8AWCX = parcelRequire("8AWCX");

const $17b37eab23d553a8$var$chevronDisplayCssVar = '--expandable-chevron-display';
const $17b37eab23d553a8$var$providedElemBeforeDisplayCssVar = '--expandable-provided-elembefore-display';
const $17b37eab23d553a8$var$wrapperStyles = {
    root: "_3RTSTAQ4SZ _2MvGBxYbGa",
    showProvidedElemBefore: "_3RTSTAYbGa _2MvGBxcK7c _3g4o8sQ4SZ _1H0K9XYbGa _0Jml7pQ4SZ _4sQNN8Q4SZ _2zl65PYbGa _1FfrqxYbGa"
}; // Merge back into the `wrapperStyles` after cleanup
const $17b37eab23d553a8$var$nestedOpenPopupStyles = {
    showProvidedElemBefore: "_3g4o8sQ4SZ _1H0K9XYbGa"
};
const $17b37eab23d553a8$var$iconStyles = {
    chevron: "_3iDTPbismd _4lYzgRyz1h",
    providedElemBefore: "_3iDTPbC5M9",
    providedElemBeforeSelected: "_1UtDYzrFwf"
};
const $17b37eab23d553a8$var$ExpandableMenuItemIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { iconProps: iconProps, isExpanded: isExpanded, isSelected: isSelected, providedElemBefore: providedElemBefore } = t0;
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    const t1 = isSelected ? "var(--ds-icon-selected, #1868DB)" : undefined;
    let t2;
    if ($[0] !== ChevronIcon || $[1] !== iconProps || $[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ChevronIcon, {
            ...iconProps,
            label: "",
            color: t1,
            size: "small"
        });
        $[0] = ChevronIcon;
        $[1] = iconProps;
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    const chevronElem = t2;
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            $17b37eab23d553a8$var$iconStyles.chevron
        ]);
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== chevronElem) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t3
        }, chevronElem);
        $[5] = chevronElem;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isSelected || $[8] !== providedElemBefore) {
        t5 = providedElemBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $17b37eab23d553a8$var$iconStyles.providedElemBefore,
                isSelected && $17b37eab23d553a8$var$iconStyles.providedElemBeforeSelected
            ])
        }, providedElemBefore);
        $[7] = isSelected;
        $[8] = providedElemBefore;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== t4 || $[11] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t4, t5);
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ iconProps: iconProps, isExpanded: isExpanded, isSelected: isSelected, providedElemBefore: providedElemBefore })=>{
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    const chevronElem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ChevronIcon, {
        ...iconProps,
        label: "",
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : undefined,
        size: "small"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $17b37eab23d553a8$var$iconStyles.chevron
        ])
    }, chevronElem), providedElemBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $17b37eab23d553a8$var$iconStyles.providedElemBefore,
            isSelected && $17b37eab23d553a8$var$iconStyles.providedElemBeforeSelected
        ])
    }, providedElemBefore));
};
const $17b37eab23d553a8$export$fe6fe51056867f4d = (0, $4Qc44.default)(({ actions: actions, isSelected: isSelected, href: href, elemBefore: providedElemBefore, elemAfter: elemAfter, actionsOnHover: actionsOnHover, onClick: onClick, children: children, testId: testId, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const id = (0, $cozmU.useId)();
    const onExpansionToggle = (0, $8AWCX.useOnExpansionToggle)();
    const isExpanded = (0, $8AWCX.useIsExpanded)();
    const setIsExpanded = (0, $8AWCX.useSetIsExpanded)();
    const itemRef = (0, $cozmU.useRef)(null);
    const handleIconClick = (0, $cozmU.useCallback)(()=>{
        onExpansionToggle?.(!isExpanded);
        setIsExpanded(!isExpanded);
    }, [
        isExpanded,
        onExpansionToggle,
        setIsExpanded
    ]);
    const handleMenuContentClick = (0, $cozmU.useCallback)((event, analyticsEvent)=>{
        const newValue = !isExpanded;
        onClick?.(event, analyticsEvent, {
            isExpanded: newValue
        });
        onExpansionToggle?.(newValue);
        setIsExpanded(newValue);
    }, [
        onClick,
        onExpansionToggle,
        isExpanded,
        setIsExpanded
    ]);
    const isSelectable = typeof href !== 'undefined';
    (0, $4o9cR.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: Boolean(isSelectable && isSelected)
    }); // Wrapped in an IconButton if the expandable menu item trigger is selectable
    const elemBefore = isSelectable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($17b37eab23d553a8$var$ExpandableMenuItemIcon, {
                iconProps: iconProps,
                isExpanded: isExpanded,
                isSelected: isSelected,
                providedElemBefore: providedElemBefore
            }),
        "aria-expanded": isExpanded,
        // screen readers on what will actually be expanded or collapsed. Screen readers will also use the
        // `aria-expanded` attribute to indicate the expanded state of the menu item.
        // We are not using the `aria-label` attribute here as it is not supported by the `IconButton` component.
        "aria-labelledby": id,
        // `aria-labelledby`, which will be used instead.
        label: "",
        appearance: "subtle",
        spacing: "compact",
        onClick: handleIconClick,
        interactionName: interactionName,
        testId: testId ? `${testId}--elem-before-button` : undefined
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($17b37eab23d553a8$var$ExpandableMenuItemIcon, {
        isExpanded: isExpanded,
        isSelected: isSelected,
        providedElemBefore: providedElemBefore
    }); // For expandable menu items, we shouldn't wrap in a `li` here. The `li` is instead at a higher level (`ExpandableMenuItem`), grouping the expandable menu item trigger and its content
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: itemRef,
        className: (0, $hekY6.default)([
            $17b37eab23d553a8$var$wrapperStyles.root,
            providedElemBefore && $17b37eab23d553a8$var$wrapperStyles.showProvidedElemBefore,
            $17b37eab23d553a8$var$nestedOpenPopupStyles.showProvidedElemBefore
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $KuePV.MenuItemBase), {
        id: id,
        actions: actions,
        actionsOnHover: actionsOnHover,
        elemBefore: elemBefore,
        ariaExpanded: isExpanded,
        elemAfter: elemAfter,
        href: href,
        isSelected: isSelected,
        onClick: handleMenuContentClick,
        ref: forwardedRef,
        visualContentRef: visualContentRef,
        testId: testId,
        interactionName: interactionName,
        isContentTooltipDisabled: isContentTooltipDisabled,
        isDragging: isDragging,
        hasDragIndicator: hasDragIndicator,
        dropIndicator: dropIndicator
    }, children));
});
module.exports["ExpandableMenuItemTrigger"] = $17b37eab23d553a8$export$fe6fe51056867f4d;

});

parcelRegister("3qtLb", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");

const $674e09754a51af28$export$19ffb24f8071504 = 2;

const $674e09754a51af28$export$10d5dbd9dd81149f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-KKls",
    name: "PageTreeLoader",
    loader: async ()=>(await (parcelRequire("b1gBU"))).PageTree
});
const $674e09754a51af28$export$73500bf5f2e2b0c4 = (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($674e09754a51af28$export$10d5dbd9dd81149f, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
module.exports["ANIMATE_TIME_SEC"] = $674e09754a51af28$export$19ffb24f8071504;
module.exports["PageTreeLoader"] = $674e09754a51af28$export$10d5dbd9dd81149f;
module.exports["PageTree"] = $674e09754a51af28$export$73500bf5f2e2b0c4;

});

parcelRegister("b1gBU", function(module, exports) {

let $805cac31f2666d81$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $805cac31f2666d81$var$load("ezYRV"),
    $805cac31f2666d81$var$load("kPyOr"),
    $805cac31f2666d81$var$load("gjIbu"),
    $805cac31f2666d81$var$load("aLbuU"),
    $805cac31f2666d81$var$load("i7f39"),
    $805cac31f2666d81$var$load("hwJJ4"),
    $805cac31f2666d81$var$load("8hP2l"),
    $805cac31f2666d81$var$load("1XtfK"),
    $805cac31f2666d81$var$load("Lm7SH"),
    $805cac31f2666d81$var$load("6wr18"),
    $805cac31f2666d81$var$load("e4XZ1"),
    $805cac31f2666d81$var$load("cvw7S"),
    $805cac31f2666d81$var$load("gbDLp"),
    $805cac31f2666d81$var$load("4Pu1k"),
    $805cac31f2666d81$var$load("4fYzp"),
    $805cac31f2666d81$var$load("jzPyj"),
    $805cac31f2666d81$var$load("f7R6d"),
    $805cac31f2666d81$var$load("bxj2D"),
    $805cac31f2666d81$var$load("Tjs4D"),
    $805cac31f2666d81$var$load("kHXvF"),
    $805cac31f2666d81$var$load("ffEVr"),
    $805cac31f2666d81$var$load("4izLy"),
    $805cac31f2666d81$var$load("hhss7"),
    $805cac31f2666d81$var$load("Wowvf"),
    $805cac31f2666d81$var$load("953Uz"),
    $805cac31f2666d81$var$load("7EorR"),
    $805cac31f2666d81$var$load("ltXeo")
]).then(()=>parcelRequire('bbZCI'));

});

parcelRegister("k5uAm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $9eE57 = parcelRequire("9eE57");


var $jsQN1 = parcelRequire("jsQN1");

const $f35e894e447c6262$export$2de55e286c149cfa = 300;
const $f35e894e447c6262$export$1bbe776c3ae63e35 = 400;
const $f35e894e447c6262$export$3bba19b3f6dc31cd = (source)=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isHoverPageCardOptedIn: isHoverPageCardOptedIn } = (0, $jsQN1.useHoverPageCardsOptStatus)();
    // the tree item id and the trigger should be grouped into one state as the trigger always corresponds with the itemID
    // this prevents unnecessary rerenders of the hover page card
    const [showHoverPageCardForItem, setShowHoverPageCardForItem] = (0, $cozmU.useState)({
        itemID: null,
        trigger: null
    });
    const openSidebarPopupTimerRef = (0, $cozmU.useRef)(null);
    const closeSidebarPopupTimerRef = (0, $cozmU.useRef)(null);
    /**
   * Cancel the open sidebar popup cards timer
   */ const clearOpenSidebarPopupTimer = (0, $cozmU.useCallback)(()=>{
        if (openSidebarPopupTimerRef?.current) {
            clearTimeout(openSidebarPopupTimerRef.current);
            openSidebarPopupTimerRef.current = null;
        }
    }, [
        openSidebarPopupTimerRef
    ]);
    /**
   * Cancel the close sidebar popup cards timer
   */ const clearCloseSidebarPopupTimer = (0, $cozmU.useCallback)(()=>{
        if (closeSidebarPopupTimerRef.current) {
            clearTimeout(closeSidebarPopupTimerRef?.current);
            closeSidebarPopupTimerRef.current = null;
        }
    }, [
        closeSidebarPopupTimerRef
    ]);
    /**
   * On mouse enter/focus of the hover target, create a hover card for that itemId
   * Start the timer which will open the popup if the user hovers on the tree item for HOVER_DELAY_TIME.
   * Clears any closePageCard timers since we don't need to close the popup, we can just replace the showHoverPageCardForItem.
   * This is called onMouseOver of page tree items.
   */ const onEnterHoverTarget = (0, $cozmU.useCallback)(({ itemID: itemID, isQuickActionsFocused: isQuickActionsFocused, hoverPageCardTriggerRef: hoverPageCardTriggerRef, isContextualCreateFocused: isContextualCreateFocused })=>{
        clearCloseSidebarPopupTimer();
        // only show a hover card if it matches to conditions to show it and it isn't already showing a card for the same itemID
        if (isHoverPageCardOptedIn && !isQuickActionsFocused && !isContextualCreateFocused && showHoverPageCardForItem.itemID !== itemID) {
            if (openSidebarPopupTimerRef.current === null) openSidebarPopupTimerRef.current = setTimeout(()=>{
                // this setstate is the one and only line that causes SpaceHoverPageCard to rerender
                setShowHoverPageCardForItem({
                    itemID: itemID,
                    trigger: hoverPageCardTriggerRef
                });
                experienceTracker.start({
                    name: (0, $irVI7.SPACE_VIEWS_HOVER_PAGE_CARD_EXPERIENCE),
                    timeout: (0, $aJPUt.ExperienceTimeout).SPACE_VIEWS,
                    attributes: {
                        source: source
                    }
                });
                (0, $9eE57.perfMarkStart)({
                    subject: 'HoverPageCard',
                    subjectId: 'rendered'
                });
                openSidebarPopupTimerRef.current = null;
            }, $f35e894e447c6262$export$2de55e286c149cfa);
        }
    }, // adding showHoverPageCardForItem into the dependency array causes the entire page tree to rerender on any item hover.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        clearCloseSidebarPopupTimer,
        experienceTracker,
        isHoverPageCardOptedIn,
        source
    ]);
    /**
   * Closes all popups after CLOSE_DELAY_TIME if the closeSidebarPopupTimerRef timer has not been cleared before then
   * Called on mouse leave of a page tree item
   */ const startCloseHoverPageCardTimer = (0, $cozmU.useCallback)(()=>{
        experienceTracker.abort({
            name: (0, $irVI7.SPACE_VIEWS_HOVER_PAGE_CARD_EXPERIENCE),
            reason: 'Popup closed'
        });
        clearOpenSidebarPopupTimer();
        if (closeSidebarPopupTimerRef.current === null) closeSidebarPopupTimerRef.current = setTimeout(()=>{
            setShowHoverPageCardForItem({
                itemID: null,
                trigger: null
            });
            closeSidebarPopupTimerRef.current = null;
        }, $f35e894e447c6262$export$1bbe776c3ae63e35);
    }, [
        experienceTracker,
        clearOpenSidebarPopupTimer
    ]);
    /**
   * Clear all the timers, called when the mouse reenters
   */ const clearHoverPageCardTimers = (0, $cozmU.useCallback)(()=>{
        clearOpenSidebarPopupTimer();
        clearCloseSidebarPopupTimer();
    }, [
        clearOpenSidebarPopupTimer,
        clearCloseSidebarPopupTimer
    ]);
    /**
   * Immediately force close all popups when this is called.
   * Called when the popup is clicked on or when the page is redirected
   */ const closeAllHoverPageCards = (0, $cozmU.useCallback)(()=>{
        clearHoverPageCardTimers();
        setShowHoverPageCardForItem({
            itemID: null,
            trigger: null
        });
        experienceTracker.abort({
            name: (0, $irVI7.SPACE_VIEWS_HOVER_PAGE_CARD_EXPERIENCE),
            reason: 'Popup closed'
        });
    }, [
        experienceTracker,
        clearHoverPageCardTimers
    ]);
    /**
   * On mouseleave of the hover target, start close timer for that item's hover card
   */ const onLeaveHoverTarget = (0, $cozmU.useCallback)(()=>{
        startCloseHoverPageCardTimer();
    }, [
        startCloseHoverPageCardTimer
    ]);
    /**
   * On blur of the hover target, start close timer for that item's hover card
   */ const onBlurHoverTarget = (0, $cozmU.useCallback)((e)=>{
        if (!e.currentTarget.contains(e.relatedTarget)) startCloseHoverPageCardTimer();
    }, [
        startCloseHoverPageCardTimer
    ]);
    return {
        closeAllHoverPageCards: closeAllHoverPageCards,
        startCloseHoverPageCardTimer: startCloseHoverPageCardTimer,
        clearHoverPageCardTimers: clearHoverPageCardTimers,
        showHoverPageCardForItem: showHoverPageCardForItem,
        isHoverPageCardOptedIn: isHoverPageCardOptedIn,
        onEnterHoverTarget: onEnterHoverTarget,
        onLeaveHoverTarget: onLeaveHoverTarget,
        onBlurHoverTarget: onBlurHoverTarget
    };
};
module.exports["useHoverPageCard"] = $f35e894e447c6262$export$3bba19b3f6dc31cd;

});

parcelRegister("aJPUt", function(module, exports) {
var $bcb0fe1d423eb4f4$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 45000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_PAGE_COMMENT"] = 30000] = "VIEW_PAGE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});
module.exports["ExperienceTimeout"] = $bcb0fe1d423eb4f4$export$5e180a90f8d3e374;

});

parcelRegister("9eE57", function(module, exports) {

var $ge2sX = parcelRequire("ge2sX");


var $04e9M = parcelRequire("04e9M");


var $5ZqQS = parcelRequire("5ZqQS");

const $e8c3b9e45ae9a31e$export$1a717feb4df1a945 = (names)=>{
    if (window.performance?.clearMarks) names.forEach((name)=>window.performance.clearMarks(name));
};
const $e8c3b9e45ae9a31e$export$1c64491a086778ac = (name)=>{
    if (window.performance?.getEntriesByType) {
        const entries = window.performance.getEntriesByType(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce = (name)=>{
    if (window.performance?.getEntriesByName) {
        const entries = window.performance.getEntriesByName(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d = (a, b)=>{
    const entryA = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(a);
    const entryB = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(b);
    if (entryA && entryB) return Math.abs(entryA.startTime - entryB.startTime);
    return undefined;
};
const $e8c3b9e45ae9a31e$export$f45af69d005a6ed = (name)=>{
    const mark = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(name);
    if (mark) return mark.startTime;
    return undefined;
};
const $e8c3b9e45ae9a31e$export$91b34dd9e71ad666 = ({ subject: subject, subjectId: subjectId = '' })=>{
    const startMark = `${subject}.${subjectId}.start`;
    const endMark = `${subject}.${subjectId}.end`;
    $e8c3b9e45ae9a31e$export$1a717feb4df1a945([
        startMark,
        endMark
    ]);
    window.performance?.mark?.(startMark);
};
// Filter out feature flags with falsy values to save user bandwidth
const $e8c3b9e45ae9a31e$var$filterFeatureFlags = (flags = {})=>Object.keys(flags).filter((key)=>flags[key]).reduce((acc, key)=>{
        acc[key] = flags[key];
        return acc;
    }, {});
const $e8c3b9e45ae9a31e$var$performanceEnd = async ({ details: details, subject: subject, subjectId: subjectId, includeFeatureFlags: includeFeatureFlags })=>{
    const endMark = `${subject}.${subjectId}.end`;
    window.performance?.mark?.(endMark);
    const duration = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d(`${subject}.${subjectId}.start`, endMark);
    if (duration === undefined) return;
    try {
        const analyticsClientPromise = (0, $04e9M.getAnalyticsWebClient)();
        const sessionDataPromise = includeFeatureFlags ? (0, $ge2sX.getSessionData)() : Promise.resolve({
            featureFlags: {}
        });
        const [client, { featureFlags: featureFlags }] = await Promise.all([
            analyticsClientPromise,
            sessionDataPromise
        ]);
        const filteredFeatureFlags = $e8c3b9e45ae9a31e$var$filterFeatureFlags(featureFlags);
        client.sendOperationalEvent({
            tags: [
                'performance'
            ],
            source: 'confluence-frontend',
            action: 'done',
            actionSubject: subject,
            actionSubjectId: subjectId,
            attributes: {
                featureFlags: filteredFeatureFlags,
                duration: duration,
                ...details
            }
        });
    } catch (ex) {
        // This is a catch-all no-op, to prevent analytics component from screwing
        // up the user experience in case of any unexpected errors.
        (0, $5ZqQS.getMonitoringClient)().submitError(ex, {
            attribution: 'unknown'
        });
    }
};
const $e8c3b9e45ae9a31e$export$9cbdebb35a11386 = ({ subject: subject, subjectId: subjectId = '', details: details = {}, includeFeatureFlags: includeFeatureFlags = false })=>{
    const endMarkExists = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(`${subject}.${subjectId}.end`);
    if (!endMarkExists) $e8c3b9e45ae9a31e$var$performanceEnd({
        details: details,
        includeFeatureFlags: includeFeatureFlags,
        subject: subject,
        subjectId: subjectId
    });
};
module.exports["clearMarks"] = $e8c3b9e45ae9a31e$export$1a717feb4df1a945;
module.exports["getEntryByName"] = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce;
module.exports["measureMarks"] = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d;
module.exports["getMark"] = $e8c3b9e45ae9a31e$export$f45af69d005a6ed;
module.exports["perfMarkStart"] = $e8c3b9e45ae9a31e$export$91b34dd9e71ad666;
module.exports["perfMarkEnd"] = $e8c3b9e45ae9a31e$export$9cbdebb35a11386;

});

parcelRegister("jsQN1", function(module, exports) {

var $4Tg4P = parcelRequire("4Tg4P");


var $bQm3c = parcelRequire("bQm3c");


var $5xaHK = parcelRequire("5xaHK");


var $jMyy4 = parcelRequire("jMyy4");

const $2d41bbac85093ab1$var$useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery = (0, $4Tg4P.default);
const $2d41bbac85093ab1$export$f824d805fc04fcb2 = ()=>{
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { data: data } = (0, $jMyy4.useQueryInterop)($2d41bbac85093ab1$var$useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery, {
        skip: !isLicensed,
        __callerPackage__: "page-card"
    });
    // don't render popups for anon users.
    // This is after the useQuery because conditionally running hooks isn't allowed.
    if (!isLicensed) return {
        isHoverPageCardOptedIn: false
    };
    const userPreference = data?.userPreferences?.shouldShowCardOnPageTreeHover;
    return {
        isHoverPageCardOptedIn: userPreference !== (0, $5xaHK.PageCardInPageTreeHoverPreference).NO_SHOW_PAGECARD
    };
};
module.exports["useHoverPageCardsOptStatus"] = $2d41bbac85093ab1$export$f824d805fc04fcb2;

});

parcelRegister("4Tg4P", function(module, exports) {
/**
 * @generated SignedSource<<a665c5157f59b317979b9478df22a2c3>>
 * @relayHash d1f433c5859a639556bc75700750a999
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 120a251ef0e72af4b4ef1b63e426a00a7b1a22b16ee4caccb4dd87acdfa9d006
const $48c38c534b125c22$var$node = function() {
    var v0 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "shouldShowCardOnPageTreeHover"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "d1f433c5859a639556bc75700750a999",
            "id": "120a251ef0e72af4b4ef1b63e426a00a7b1a22b16ee4caccb4dd87acdfa9d006",
            "metadata": {},
            "name": "useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery",
            "operationKind": "query",
            "text": "query useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery{userPreferences{shouldShowCardOnPageTreeHover}}"
        }
    };
}();
$48c38c534b125c22$var$node.hash = "1e92ca51a019c1c7e4b73556b6c593ea";
var $48c38c534b125c22$export$2e2bcd8739ae039 = $48c38c534b125c22$var$node;
module.exports["default"] = $48c38c534b125c22$export$2e2bcd8739ae039;

});

parcelRegister("5xaHK", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 *
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $f8a43fdc91a5738e$export$8d4d3d8b2da7ecab = /*#__PURE__*/ function(PageCardInPageTreeHoverPreference) {
    PageCardInPageTreeHoverPreference["NO_OPTION_SELECTED"] = "NO_OPTION_SELECTED";
    PageCardInPageTreeHoverPreference["NO_SHOW_PAGECARD"] = "NO_SHOW_PAGECARD";
    PageCardInPageTreeHoverPreference["SHOW_PAGECARD"] = "SHOW_PAGECARD";
    return PageCardInPageTreeHoverPreference;
}({});
module.exports["PageCardInPageTreeHoverPreference"] = $f8a43fdc91a5738e$export$8d4d3d8b2da7ecab;

});

parcelRegister("lfFzM", function(module, exports) {

var $6b4nE = parcelRequire("6b4nE");


var $jMyy4 = parcelRequire("jMyy4");


var $6jrkJ = parcelRequire("6jrkJ");


var $hiC7Y = parcelRequire("hiC7Y");

const $f78b3fd6fbd1f922$export$dd53ec461ae8f03e = ()=>{
    // if the claim does not exist, we'll skip doing the actual query
    const hasSuperAdminClaim = (0, $6jrkJ.getSuperAdminClaim)();
    const { loading: loading, error: error, data: data } = (0, $jMyy4.useQueryInterop)((0, $hiC7Y.default), {
        skip: !hasSuperAdminClaim,
        __callerPackage__: "super-admin"
    });
    return hasSuperAdminClaim ? {
        loading: loading,
        error: error,
        isSuperAdmin: Boolean(data?.user?.confluence?.roles?.isSuperAdmin)
    } : {
        loading: false,
        isSuperAdmin: false
    };
};
const $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a = ({ children: children })=>{
    const { isSuperAdmin: isSuperAdmin, loading: loading, error: error } = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e();
    return children({
        loading: loading,
        error: error,
        isSuperAdmin: isSuperAdmin
    });
};
$f78b3fd6fbd1f922$export$a7f16c8c21f70b7a.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func.isRequired
};
module.exports["useIsSuperAdmin"] = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e;
module.exports["AdminKeyQuery"] = $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a;

});

parcelRegister("6jrkJ", function(module, exports) {

var $68uaC = parcelRequire("68uaC");


var $9wGTI = parcelRequire("9wGTI");

const $00ee7f2affe27fcd$var$SUPER_ADMIN_COOKIE = 'confluence.asSuperAdmin';
function $00ee7f2affe27fcd$export$2fc1623749affa1a() {
    return Boolean((0, $68uaC.Cookies).get($00ee7f2affe27fcd$var$SUPER_ADMIN_COOKIE));
}
function $00ee7f2affe27fcd$export$b097cdee5288154b() {
    if ((0, $9wGTI.fg)('remove_admin_cookie_on_banner_dismiss')) (0, $68uaC.Cookies).removeStrictlyNecessary($00ee7f2affe27fcd$var$SUPER_ADMIN_COOKIE);
    else (0, $68uaC.Cookies).remove($00ee7f2affe27fcd$var$SUPER_ADMIN_COOKIE);
}
async function $00ee7f2affe27fcd$export$f5d5d0f409509831() {
    await (0, $68uaC.Cookies).set($00ee7f2affe27fcd$var$SUPER_ADMIN_COOKIE, 'true', undefined, (0, $68uaC.CookieLevel).NECESSARY);
}
module.exports["getSuperAdminClaim"] = $00ee7f2affe27fcd$export$2fc1623749affa1a;
module.exports["removeSuperAdminClaim"] = $00ee7f2affe27fcd$export$b097cdee5288154b;
module.exports["setSuperAdminClaim"] = $00ee7f2affe27fcd$export$f5d5d0f409509831;

});

parcelRegister("hiC7Y", function(module, exports) {
/**
 * @generated SignedSource<<994231445f227a67e1aaccbbe4790b5b>>
 * @relayHash 0f84e07ae7daaa03ff834c7e22000d77
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 54df31e8c4d8a985ea8cf57de4e9987537d70dbc168cfc0cfa0a076f20f53d78
const $55ca182de67fa1f0$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphQLConfluenceUserRoles",
                            "kind": "LinkedField",
                            "name": "roles",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isSuperAdmin"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "IsSuperAdminQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "IsSuperAdminQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "0f84e07ae7daaa03ff834c7e22000d77",
            "id": "54df31e8c4d8a985ea8cf57de4e9987537d70dbc168cfc0cfa0a076f20f53d78",
            "metadata": {},
            "name": "IsSuperAdminQuery",
            "operationKind": "query",
            "text": "query IsSuperAdminQuery{user:confluence_atlassianUser(current:true){id,confluence{roles{isSuperAdmin}}}}"
        }
    };
}();
$55ca182de67fa1f0$var$node.hash = "9aa53dcf116596c8f8285a3aa93878ce";
var $55ca182de67fa1f0$export$2e2bcd8739ae039 = $55ca182de67fa1f0$var$node;
module.exports["default"] = $55ca182de67fa1f0$export$2e2bcd8739ae039;

});

parcelRegister("i28ZW", function(module, exports) {

var $i0mmi = parcelRequire("i0mmi");


var $6mKj3 = parcelRequire("6mKj3");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $iquRY = parcelRequire("iquRY");


var $jMyy4 = parcelRequire("jMyy4");

const $981a614bc39b93a3$var$useSpaceManagementOperationsSpacePropertiesQuery = (0, $i0mmi.default);
const $981a614bc39b93a3$export$42add616309f8ea4 = 'manage_users';
const $981a614bc39b93a3$export$ceb95831d69da149 = 'manage_nonlicensed_users';
const $981a614bc39b93a3$export$3eb61eb33a05d6fe = 'manage_guest_users';
const $981a614bc39b93a3$export$fae9e1a00840692e = 'manage_public_links';
const $981a614bc39b93a3$export$d9a801072630763d = 'manage_templates';
const $981a614bc39b93a3$export$80ed1bd55ccf4772 = 'administer';
const $981a614bc39b93a3$export$a89133b28496ff30 = 'manage_look_and_feel';
const $981a614bc39b93a3$export$50faaafd42078ad9 = 'manage_content';
const $981a614bc39b93a3$export$a7c1ec142e70d69d = 'archive';
const $981a614bc39b93a3$export$92f9e1ed9114d3a6 = 'copy';
const $981a614bc39b93a3$export$3ea24d3a964169d2 = 'view_analytics';
const $981a614bc39b93a3$export$df267ad9042b4cda = 'export';
const $981a614bc39b93a3$export$4111393d4921f4a7 = 'create';
const $981a614bc39b93a3$export$5c2e91d1aa10ff80 = 'attachment';
const $981a614bc39b93a3$export$b838cef2a8827875 = (operations, spaceOperation)=>{
    return operations?.some((operation)=>operation?.operation === spaceOperation && operation?.targetType === 'space') ?? false;
};
const $981a614bc39b93a3$export$f8731d5631669ee8 = ({ spaceKey: spaceKey, skip: skip })=>{
    const { isRbacEnabled: isRbacEnabled, loading: isLoadingSpaceRoleMode } = (0, $iquRY.useSpaceRoleMode)();
    const defaultSkip = !spaceKey || !isRbacEnabled && !(0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false);
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($981a614bc39b93a3$var$useSpaceManagementOperationsSpacePropertiesQuery, {
        variables: {
            spaceKey: spaceKey
        },
        skip: skip !== undefined ? skip : defaultSkip,
        onError: (error)=>{
            if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
            else (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
            });
        },
        __callerPackage__: "space-utils"
    });
    const operations = data?.space?.operations;
    return {
        canManageSomeUsers: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$42add616309f8ea4) || $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$ceb95831d69da149) || $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$3eb61eb33a05d6fe),
        canManageUsers: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$42add616309f8ea4),
        canManageNonlicensedUsers: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$ceb95831d69da149),
        canManageGuestUsers: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$3eb61eb33a05d6fe),
        canManagePublicLinks: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$fae9e1a00840692e),
        canManageTemplates: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$d9a801072630763d),
        canManageLookAndFeel: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$a89133b28496ff30),
        canAdminister: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$80ed1bd55ccf4772),
        canManageContent: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$50faaafd42078ad9),
        canArchive: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$a7c1ec142e70d69d),
        canCopy: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$92f9e1ed9114d3a6),
        canViewAnalytics: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$3ea24d3a964169d2),
        canExportSpace: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$df267ad9042b4cda),
        canAddAttachment: operations?.some((operation)=>operation?.operation === $981a614bc39b93a3$export$4111393d4921f4a7 && operation?.targetType === $981a614bc39b93a3$export$5c2e91d1aa10ff80) ?? false,
        loading: loading || isLoadingSpaceRoleMode
    };
};
module.exports["MANAGE_PUBLIC_LINKS"] = $981a614bc39b93a3$export$fae9e1a00840692e;
module.exports["ADMINISTER"] = $981a614bc39b93a3$export$80ed1bd55ccf4772;
module.exports["MANAGE_CONTENT"] = $981a614bc39b93a3$export$50faaafd42078ad9;
module.exports["hasSpaceOperation"] = $981a614bc39b93a3$export$b838cef2a8827875;
module.exports["useSpaceManagementOperations"] = $981a614bc39b93a3$export$f8731d5631669ee8;

});

parcelRegister("i0mmi", function(module, exports) {
/**
 * @generated SignedSource<<10e9286ab7437b1579bfb197b3cdf663>>
 * @relayHash 0a3dc9cecca8233daf01e0443fdaa5e6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1509aa25f2392b1667fcb4313ac8da10a214bb194abea1065d129f0c6ea9e471
const $7dc84e66153faa36$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAdmin"
                        }
                    ]
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceManagementOperationsSpacePropertiesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceManagementOperationsSpacePropertiesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "0a3dc9cecca8233daf01e0443fdaa5e6",
            "id": "1509aa25f2392b1667fcb4313ac8da10a214bb194abea1065d129f0c6ea9e471",
            "metadata": {},
            "name": "useSpaceManagementOperationsSpacePropertiesQuery",
            "operationKind": "query",
            "text": "query useSpaceManagementOperationsSpacePropertiesQuery($spaceKey:String!){space(key:$spaceKey){id,currentUser{isAdmin},operations{operation,targetType}}}"
        }
    };
}();
$7dc84e66153faa36$var$node.hash = "4d967e32f567d3367490b1d8fb6f1ecf";
var $7dc84e66153faa36$export$2e2bcd8739ae039 = $7dc84e66153faa36$var$node;
module.exports["default"] = $7dc84e66153faa36$export$2e2bcd8739ae039;

});

parcelRegister("iquRY", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $24WXz = parcelRequire("24WXz");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $cccaa992351fdb79$export$dcac763621aee435 = ()=>{
    const $ = (0, $bDgLe.c)(9);
    const { cloudId: cloudId, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== cloudId) {
        t0 = {
            cloudId: cloudId
        };
        $[0] = cloudId;
        $[1] = t0;
    } else t0 = $[1];
    const t1 = !isLoggedIn;
    let t2;
    if ($[2] !== t0 || $[3] !== t1) {
        t2 = {
            variables: t0,
            skip: t1,
            onError: $cccaa992351fdb79$var$_temp
        };
        $[2] = t0;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $24WXz.default), {
        ...t2,
        __callerPackage__: "space-utils"
    });
    const isNotPreRoles = data?.confluence_spaceRoleMode ? data.confluence_spaceRoleMode !== "PRE_ROLES" : false;
    const t3 = data?.confluence_spaceRoleMode;
    let t4;
    if ($[5] !== isNotPreRoles || $[6] !== loading || $[7] !== t3) {
        t4 = {
            spaceRoleMode: t3,
            isRbacEnabled: isNotPreRoles,
            loading: loading
        };
        $[5] = isNotPreRoles;
        $[6] = loading;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
};
function $cccaa992351fdb79$var$_temp(error) {
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
    });
    (0, $7Sm4c.markErrorAsHandled)(error);
}
module.exports["useSpaceRoleMode"] = $cccaa992351fdb79$export$dcac763621aee435;

});

parcelRegister("24WXz", function(module, exports) {
/**
 * @generated SignedSource<<2ff02ee1cce578f61d9a435abf2def2c>>
 * @relayHash 60ed41889a4cd98154a0419dcf1f59f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82
const $016cc5cc0310f39a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_spaceRoleMode"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "60ed41889a4cd98154a0419dcf1f59f5",
            "id": "568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82",
            "metadata": {},
            "name": "useSpaceRoleModeQuery",
            "operationKind": "query",
            "text": "query useSpaceRoleModeQuery($cloudId:ID!){confluence_spaceRoleMode(cloudId:$cloudId)}"
        }
    };
}();
$016cc5cc0310f39a$var$node.hash = "88c4ae8983cc6692099b2b1e1d7a4379";
var $016cc5cc0310f39a$export$2e2bcd8739ae039 = $016cc5cc0310f39a$var$node;
module.exports["default"] = $016cc5cc0310f39a$export$2e2bcd8739ae039;

});

parcelRegister("j3kZx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $748c02fb00e52ac9$export$a0aa95d2fbef03e8 = ({ sectionName: sectionName, collapsedByDefault: collapsedByDefault = false, forceExpand: forceExpand = false })=>{
    const [isExpandedManually, setIsExpandedManually] = (0, $cozmU.useState)();
    const isDefaultExpanded = (0, $cozmU.useMemo)(()=>$748c02fb00e52ac9$var$getExpandedStateBySpace(sectionName, collapsedByDefault), [
        sectionName,
        collapsedByDefault
    ]);
    const hasManualExpansion = isExpandedManually !== undefined;
    const isExpanded = hasManualExpansion ? isExpandedManually : forceExpand || isDefaultExpanded;
    const onExpansionToggle = (0, $cozmU.useCallback)((newIsExpanded)=>{
        setIsExpandedManually(newIsExpanded);
        $748c02fb00e52ac9$var$updateExpandedStateBySpace(sectionName, newIsExpanded);
    }, [
        sectionName
    ]);
    return {
        isExpanded: isExpanded,
        onExpansionToggle: onExpansionToggle
    };
};
const $748c02fb00e52ac9$var$getExpandedStateBySpace = (sectionName, collapsedByDefault)=>{
    if ((0, $17wUi.confluenceLocalStorageInstance) && (0, $17wUi.confluenceLocalStorageInstance).doesContain((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES)) {
        const sideNavExpansionStates = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES);
        if (typeof sideNavExpansionStates[sectionName] === 'boolean') return sideNavExpansionStates[sectionName];
    }
    return !collapsedByDefault;
};
const $748c02fb00e52ac9$var$updateExpandedStateBySpace = (sectionName, isExpanded)=>{
    if (!(0, $17wUi.confluenceLocalStorageInstance)) return;
    const sideNavExpansionStates = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES) || {};
    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES, {
        ...sideNavExpansionStates,
        [sectionName]: isExpanded
    });
};
module.exports["useSpacePersistentExpansion"] = $748c02fb00e52ac9$export$a0aa95d2fbef03e8;

});

parcelRegister("gCFsY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d9810ba2fa073e42$export$d09f0ee316c3b5c1 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "06Lgw",
    name: "LazySpaceHoverPageCard",
    loader: async ()=>(await (parcelRequire("gBgmJ"))).SpaceHoverPageCard
});
module.exports["LazySpaceHoverPageCard"] = $d9810ba2fa073e42$export$d09f0ee316c3b5c1;

});

parcelRegister("gBgmJ", function(module, exports) {

let $c15ccbe62ea70d61$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c15ccbe62ea70d61$var$load("gjIbu"),
    $c15ccbe62ea70d61$var$load("fEMSy"),
    $c15ccbe62ea70d61$var$load("1lDWJ"),
    $c15ccbe62ea70d61$var$load("6zCMk"),
    $c15ccbe62ea70d61$var$load("bb3WM"),
    $c15ccbe62ea70d61$var$load("hEj0j"),
    $c15ccbe62ea70d61$var$load("i35vr"),
    $c15ccbe62ea70d61$var$load("1GCFv"),
    $c15ccbe62ea70d61$var$load("dZsGY"),
    $c15ccbe62ea70d61$var$load("52ZTT"),
    $c15ccbe62ea70d61$var$load("32NHR"),
    $c15ccbe62ea70d61$var$load("glmO2"),
    $c15ccbe62ea70d61$var$load("1cQg7"),
    $c15ccbe62ea70d61$var$load("kkkxt"),
    $c15ccbe62ea70d61$var$load("1FRba"),
    $c15ccbe62ea70d61$var$load("4x9Jx"),
    $c15ccbe62ea70d61$var$load("kHXvF"),
    $c15ccbe62ea70d61$var$load("7gL7H"),
    $c15ccbe62ea70d61$var$load("ea3NB"),
    $c15ccbe62ea70d61$var$load("6wr18"),
    $c15ccbe62ea70d61$var$load("59hV4"),
    $c15ccbe62ea70d61$var$load("fuOfV"),
    $c15ccbe62ea70d61$var$load("jL1Ke"),
    $c15ccbe62ea70d61$var$load("5MQ0D"),
    $c15ccbe62ea70d61$var$load("ffEVr"),
    $c15ccbe62ea70d61$var$load("8hP2l"),
    $c15ccbe62ea70d61$var$load("1XtfK"),
    $c15ccbe62ea70d61$var$load("4izLy"),
    $c15ccbe62ea70d61$var$load("h4Nf7"),
    $c15ccbe62ea70d61$var$load("Wowvf"),
    $c15ccbe62ea70d61$var$load("lkxmG"),
    $c15ccbe62ea70d61$var$load("7EorR"),
    $c15ccbe62ea70d61$var$load("953Uz"),
    $c15ccbe62ea70d61$var$load("hhss7"),
    $c15ccbe62ea70d61$var$load("cQVtz")
]).then(()=>parcelRequire('k8aVt'));

});

parcelRegister("2vuKf", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $bwL2u = parcelRequire("bwL2u");

const $d03c194add2856c2$export$214964e539560671 = (0, $kBr4q.createHook)((0, $bwL2u.Store), {
    selector: (state)=>state.multiSelectMode === (0, $bwL2u.MultiSelectMode).ACTIVE
});
module.exports["useIsMultiSelectActive"] = $d03c194add2856c2$export$214964e539560671;

});

parcelRegister("bwL2u", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

var $647b75406606f8a7$export$630aa3bad9698e43 = /*#__PURE__*/ function(MultiSelectMode) {
    MultiSelectMode["ACTIVE"] = "active";
    MultiSelectMode["INACTIVE"] = "inactive";
    MultiSelectMode["DISABLED"] = "disabled";
    return MultiSelectMode;
}({});
const $647b75406606f8a7$var$initialState = {
    multiSelectMode: "inactive",
    selectedContent: {},
    count: 0,
    loadingDescendantIds: new Set()
};
const $647b75406606f8a7$var$actions = {
    getState: ()=>({ getState: getState })=>{
            return getState();
        },
    enterMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "active",
                selectedContent: {},
                count: 0
            });
        },
    exitMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "inactive",
                selectedContent: {},
                count: 0,
                loadingDescendantIds: new Set()
            });
        },
    disableMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "disabled"
            });
        },
    getSelectedDescendantCount: (contentId)=>({ getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            return selectedContent[contentId].selectedDescendantCount;
        },
    updateTotalCount: (delta)=>({ getState: getState, setState: setState })=>{
            const { count: prevCount } = getState();
            setState({
                count: prevCount + delta
            });
        },
    // Update the selected descendant count.
    updateSelectedDescendantsCount: (contentId, descendantCount)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = {
                ...selectedContent,
                [contentId]: {
                    selectedDescendantCount: descendantCount,
                    deselectedChildren: selectedContent[contentId]?.deselectedChildren ?? new Set()
                }
            };
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Update the parent content's deselected children array.
    updateParent: (contentId, parentId)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = {
                ...selectedContent,
                [parentId]: {
                    selectedDescendantCount: selectedContent[parentId].selectedDescendantCount,
                    deselectedChildren: new Set([
                        ...selectedContent[parentId].deselectedChildren
                    ].filter((x)=>x !== contentId)) ?? new Set()
                }
            };
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Selects the content and its descendants, updating the selectedContent state.
    selectNestedContent: (items)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            // First element in items is the current item being selected.
            const currentItemId = items[0].id;
            const newSelectedContent = {
                ...selectedContent
            };
            for (const item of items){
                if (currentItemId === item.id && item.parentId && item.parentId in newSelectedContent) newSelectedContent[item.parentId].deselectedChildren.delete(item.id);
                newSelectedContent[item.id] = {
                    selectedDescendantCount: 0,
                    deselectedChildren: selectedContent[item.id]?.deselectedChildren ?? new Set()
                };
            }
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Selects the content and its descendants, updating the selectedContent state.
    incrementAncestors: (ancestorIds, currentContentSelectionCount, countToRemove)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = ancestorIds.reduce((acc, parentId)=>{
                if (parentId in acc) acc[parentId] = {
                    ...acc[parentId],
                    selectedDescendantCount: acc[parentId].selectedDescendantCount + currentContentSelectionCount - countToRemove + 1
                };
                return acc;
            }, {
                ...selectedContent
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Decrement the selected descendant count of ancestors when a content is deselected.
    decrementAncestors: (ancestorIds, currentContentId)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const selectItemCount = selectedContent[currentContentId].selectedDescendantCount;
            const newSelectedContent = ancestorIds.reduce((acc, parentId)=>{
                if (parentId in acc) acc[parentId] = {
                    ...acc[parentId],
                    selectedDescendantCount: acc[parentId].selectedDescendantCount - selectItemCount - 1
                };
                return acc;
            }, {
                ...selectedContent
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Deselects the content and its descendants, updating the selectedContent state.
    deselectNestedContent: (contentIds, parentIds)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            let newSelectedContent = {
                ...selectedContent
            };
            contentIds.forEach((contentId)=>{
                // Remove the contentId from selectedContent
                const { [contentId]: removed, ...rest } = newSelectedContent;
                newSelectedContent = rest;
                // For each parentId, update its deselectedChildren set
                parentIds.forEach((parentId)=>{
                    if (parentId in newSelectedContent) {
                        const parentContent = {
                            ...newSelectedContent[parentId]
                        };
                        if (!parentContent.deselectedChildren) parentContent.deselectedChildren = new Set();
                        parentContent.deselectedChildren.add(contentId);
                        newSelectedContent[parentId] = parentContent;
                    }
                });
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    clearSelection: ()=>({ setState: setState })=>{
            setState({
                selectedContent: {},
                count: 0,
                loadingDescendantIds: new Set()
            });
        },
    addLoadingDescendant: (contentId)=>({ setState: setState, getState: getState })=>{
            const next = new Set(getState().loadingDescendantIds);
            next.add(contentId);
            setState({
                loadingDescendantIds: next
            });
        },
    removeLoadingDescendant: (contentId)=>({ setState: setState, getState: getState })=>{
            const next = new Set(getState().loadingDescendantIds);
            next.delete(contentId);
            setState({
                loadingDescendantIds: next
            });
        }
};
const $647b75406606f8a7$export$390f32400eaf98c9 = (0, $8s9DV.createStore)({
    initialState: $647b75406606f8a7$var$initialState,
    actions: $647b75406606f8a7$var$actions,
    name: 'contentTreeSelection'
});
const $647b75406606f8a7$export$cbc26e3dcdb786e6 = (0, $kBr4q.createHook)($647b75406606f8a7$export$390f32400eaf98c9);
const $647b75406606f8a7$export$ce1c0cba22262219 = (0, $kBr4q.createActionsHook)($647b75406606f8a7$export$390f32400eaf98c9);
module.exports["MultiSelectMode"] = $647b75406606f8a7$export$630aa3bad9698e43;
module.exports["Store"] = $647b75406606f8a7$export$390f32400eaf98c9;
module.exports["useContentTreeSelection"] = $647b75406606f8a7$export$cbc26e3dcdb786e6;
module.exports["useContentTreeSelectionActions"] = $647b75406606f8a7$export$ce1c0cba22262219;

});

parcelRegister("bOLC6", function(module, exports) {
/**
 * @generated SignedSource<<894f0475d89546b8f8ba914dd859e916>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a3f5a4229d0143cd$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "spaceKey"
        }
    ],
    "kind": "Fragment",
    "name": "useSpaceViewsOptionsSpaceViewsPersistenceWriteFragment",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "kind": "ScalarField",
            "name": "spaceViewsPersistence"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "UserPreferences"
};
$a3f5a4229d0143cd$var$node.hash = "9ec903133829a75826057a66a4a62727";
var $a3f5a4229d0143cd$export$2e2bcd8739ae039 = $a3f5a4229d0143cd$var$node;



var $3AeIf = parcelRequire("3AeIf");

/**
 * @generated SignedSource<<baa83179ea6ec445b8b4849c98f06252>>
 * @relayHash 197595cb76d03c058f5fbb845dc266a1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 89a76fcc88ae0753908f2aaff4b8debcf7a025d460506fe67d47266e32c2ec9b
const $2bef0e4e0b22cfa3$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "persistenceOption"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
    }, v3 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "fields": [
                                {
                                    "kind": "Variable",
                                    "name": "persistenceOption",
                                    "variableName": "persistenceOption"
                                },
                                v2 /*: any*/ 
                            ],
                            "kind": "ObjectValue",
                            "name": "spaceViewsPersistence"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "userPreferences"
                }
            ],
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "updateUserPreferences",
            "plural": false,
            "selections": [
                {
                    "args": [
                        v2 /*: any*/ 
                    ],
                    "kind": "ScalarField",
                    "name": "spaceViewsPersistence"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useSpaceViewsOptionsSpaceViewsPersistenceMutation",
            "selections": v3 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useSpaceViewsOptionsSpaceViewsPersistenceMutation",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "197595cb76d03c058f5fbb845dc266a1",
            "id": "89a76fcc88ae0753908f2aaff4b8debcf7a025d460506fe67d47266e32c2ec9b",
            "metadata": {},
            "name": "useSpaceViewsOptionsSpaceViewsPersistenceMutation",
            "operationKind": "mutation",
            "text": "mutation useSpaceViewsOptionsSpaceViewsPersistenceMutation($spaceKey:String!,$persistenceOption:SpaceViewsPersistenceOption!){updateUserPreferences(userPreferences:{spaceViewsPersistence:{spaceKey:$spaceKey,persistenceOption:$persistenceOption}}){spaceViewsPersistence(spaceKey:$spaceKey)}}"
        }
    };
}();
$2bef0e4e0b22cfa3$var$node.hash = "c904b4b947ce0e659a2538aaffec18be";
var $2bef0e4e0b22cfa3$export$2e2bcd8739ae039 = $2bef0e4e0b22cfa3$var$node;


/**
 * @generated SignedSource<<d93db42c439d7cbbb31ca1a955877b2a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a3e602a39b045224$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "spaceKey"
        }
    ],
    "kind": "Fragment",
    "name": "useSpaceViewsOptionsPersistence_userPreferences",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "kind": "ScalarField",
            "name": "spaceViewsPersistence"
        }
    ],
    "type": "UserPreferences"
};
$a3e602a39b045224$var$node.hash = "6e14a936c397037e855ea8ebac2ce34c";
var $a3e602a39b045224$export$2e2bcd8739ae039 = $a3e602a39b045224$var$node;



var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $ij4CE = parcelRequire("ij4CE");


const $c39f0c35d43dec0d$export$48adb441ab08928c = (0, $a3e602a39b045224$export$2e2bcd8739ae039);
const $c39f0c35d43dec0d$var$useSpaceViewsOptionsSpaceViewsPersistenceMutation = (0, $2bef0e4e0b22cfa3$export$2e2bcd8739ae039);
const $c39f0c35d43dec0d$var$useSpaceViewsOptionsPersistenceQuery = (0, $3AeIf.default);
const $c39f0c35d43dec0d$export$1723fb5a667b3274 = (0, $kSwu1.defineMessages)({
    TREE: {
        id: "space-views.tree",
        defaultMessage: "Tree"
    },
    RECENTLY_VIEWED: {
        id: "space-views.recently.viewed",
        defaultMessage: "My visits"
    },
    RECENTLY_MODIFIED: {
        id: "space-views.recently.modified",
        defaultMessage: "Last updated"
    },
    TITLE_AZ: {
        id: "space-views.a-z.desc",
        defaultMessage: "Title - A to Z"
    }
});
const $c39f0c35d43dec0d$export$d285edfa1d91469 = (spaceKey, isLicensed = false, initialPersistenceData)=>{
    const { data: data, loading: queryLoading, error: queryError } = (0, $jMyy4.useQueryInterop)($c39f0c35d43dec0d$var$useSpaceViewsOptionsPersistenceQuery, {
        variables: {
            spaceKey: spaceKey
        },
        skip: !isLicensed,
        __callerPackage__: "space-views"
    });
    const [updatePersistence, { loading: mutationLoading, error: mutationError }] = (0, $308Wd.useMutationInterop)($c39f0c35d43dec0d$var$useSpaceViewsOptionsSpaceViewsPersistenceMutation, {
        __callerPackage__: "space-views"
    });
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $a3f5a4229d0143cd$export$2e2bcd8739ae039),
        fragmentSpec: (0, $a3f5a4229d0143cd$export$2e2bcd8739ae039),
        __callerPackage__: "space-views"
    });
    const setSpaceViewsSort = (0, $cozmU.useCallback)((newSort)=>{
        updatePersistence({
            variables: {
                spaceKey: spaceKey,
                persistenceOption: newSort
            }
        }).catch(()=>{}); // ignoring errors here because we are consuming error from useMutation
        // Update the cache to keep UI updated regardless of whether the mutation succeeds
        writeFragmentInterop({
            fragmentId: `$ROOT_QUERY.userPreferences`,
            data: {
                spaceViewsPersistence: newSort,
                __typename: 'UserPreferences'
            },
            variables: {
                spaceKey: spaceKey
            }
        });
    }, [
        spaceKey,
        updatePersistence,
        writeFragmentInterop
    ]);
    const spaceViewsSort = initialPersistenceData?.spaceViewsPersistence || data?.userPreferences?.spaceViewsPersistence || 'TREE'; //tree is default
    return {
        spaceViewsSort: spaceViewsSort,
        setSpaceViewsSort: setSpaceViewsSort,
        queryLoading: initialPersistenceData ? false : queryLoading,
        queryError: initialPersistenceData ? undefined : queryError,
        mutationLoading: mutationLoading,
        mutationError: mutationError
    };
};
module.exports["SpaceViewsOptionsPersistenceFragment"] = $c39f0c35d43dec0d$export$48adb441ab08928c;
module.exports["sortI18n"] = $c39f0c35d43dec0d$export$1723fb5a667b3274;
module.exports["useSpaceViewsOptions"] = $c39f0c35d43dec0d$export$d285edfa1d91469;

});

parcelRegister("3AeIf", function(module, exports) {
/**
 * @generated SignedSource<<30433c300b34114d28e5a73869e7e5f1>>
 * @relayHash f18661cc7a1d2d55f19018b453d74e49
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5b9f82627568e61d5a48e4bdd045a30d7fc6ac7b992beec39feead5b18838e62
const $ca580f7b974eac2e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "spaceViewsPersistence"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f18661cc7a1d2d55f19018b453d74e49",
            "id": "5b9f82627568e61d5a48e4bdd045a30d7fc6ac7b992beec39feead5b18838e62",
            "metadata": {},
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "operationKind": "query",
            "text": "query useSpaceViewsOptionsPersistenceQuery($spaceKey:String!){userPreferences{spaceViewsPersistence(spaceKey:$spaceKey)}}"
        }
    };
}();
$ca580f7b974eac2e$var$node.hash = "ed56952e91ea2d83611b306fd16f1677";
var $ca580f7b974eac2e$export$2e2bcd8739ae039 = $ca580f7b974eac2e$var$node;
module.exports["default"] = $ca580f7b974eac2e$export$2e2bcd8739ae039;

});

parcelRegister("arWla", function(module, exports) {
/* PresentationalComponents.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $7ZB0A = parcelRequire("7ZB0A");

const $c4de3c3a60bbeec4$var$buttonStyle = null;
const $c4de3c3a60bbeec4$var$menuButtonIconColor = (isWhiteboardBetaEnabled)=>{
    return isWhiteboardBetaEnabled ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)";
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @compiled/no-exported-css -- Ignored via go/DSP-18766
const $c4de3c3a60bbeec4$export$266a769812832828 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = (0, $7ZB0A.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_s1xtjf": (0, $9aYkv.default)($c4de3c3a60bbeec4$var$menuButtonIconColor(__cmplp.isWhiteboardBetaEnabled))
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_30huDKYbGa _0bjKvDzXzM _0KLXrujOvk _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0VUofl _39xV02Uofl _0wOv4Q7zJH _1bZTgd8ujp _30zrXRKcZT",
            __cmplp.isOpen ? "_3koOgUZkES" : "_3koOgU4YkS",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c4de3c3a60bbeec4$export$7d1bd82e49cf3a3b = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDzXzM _2sNsIg7NXe _0Of8r2HZdu _1Znuxb4Y4b _1wydGWHZdu _2Zuz6Q4Y4b _0KLXruDMqu _1UtDYzy7kJ _1kk5Tkmb2E",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c4de3c3a60bbeec4$export$74be2ccc72ce5bce = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0jFU0VoWWg _39xV02oWWg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c4de3c3a60bbeec4$export$11b902a59791d036 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_39xV02N91d _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _2O5Vij7dHp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c4de3c3a60bbeec4$export$bbba74ab4c493bc2 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2XghbEGDOm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c4de3c3a60bbeec4$export$851411cf794a4cc4 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_313842UNDJ _0adFHsUNDJ _1DCdHiUNDJ _2XsHFMJg58 _0bjKvDS5Zs _4FKVYE3NPf _30huDKYbGa _2sNsIgmnOE _2xIroY98eZ _497WNwYbGa _2zndICT6kp _0KLXruVva3 _1UtDYzGaer _3iDTPbQ4SZ _0hPCNLDIqT _0wOv4Q7zJH",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c4de3c3a60bbeec4$export$97bdf39f6b82bb0 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4FKVYE8HPE _2XghbErjwI _2sNsIgmnOE _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _37wbyuDIqT _2fwxA5DIqT _0jFU0VWD6W _1UtDYzy7kJ",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c4de3c3a60bbeec4$export$b2471e0920d79944 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1DCdHi2ADO",
            __cmplp.className
        ])
    });
});
module.exports["DefaultLabel"] = $c4de3c3a60bbeec4$export$7d1bd82e49cf3a3b;
module.exports["NoIcon"] = $c4de3c3a60bbeec4$export$74be2ccc72ce5bce;
module.exports["FlexCenter"] = $c4de3c3a60bbeec4$export$11b902a59791d036;
module.exports["MoreButtonContainer"] = $c4de3c3a60bbeec4$export$bbba74ab4c493bc2;
module.exports["ErrorContainer"] = $c4de3c3a60bbeec4$export$97bdf39f6b82bb0;
module.exports["ErrorIconWrapper"] = $c4de3c3a60bbeec4$export$b2471e0920d79944;

});

parcelRegister("bA71O", function(module, exports) {

let $86e88223e9086b3c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $86e88223e9086b3c$var$load("iWnyc"),
    $86e88223e9086b3c$var$load("8hP2l"),
    $86e88223e9086b3c$var$load("1XtfK"),
    $86e88223e9086b3c$var$load("4izLy"),
    $86e88223e9086b3c$var$load("953Uz"),
    $86e88223e9086b3c$var$load("5TCys")
]).then(()=>parcelRequire('1wIcl'));

});

parcelRegister("bBbyC", function(module, exports) {

let $871c1d78dffdd057$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $871c1d78dffdd057$var$load("eW2qV"),
    $871c1d78dffdd057$var$load("jrVkD"),
    $871c1d78dffdd057$var$load("8Y23K"),
    $871c1d78dffdd057$var$load("6gmSt")
]).then(()=>parcelRequire('5SYww'));

});

parcelRegister("8M9JV", function(module, exports) {

let $663a5c840d2e4048$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $663a5c840d2e4048$var$load("kJLy8"),
    $663a5c840d2e4048$var$load("jzPyj"),
    $663a5c840d2e4048$var$load("hhss7"),
    $663a5c840d2e4048$var$load("eQlG4")
]).then(()=>parcelRequire('32xcy'));

});

parcelRegister("jzS7A", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2956b96ada85ef60$export$a2e535ad780a85fe = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9L4J0",
    name: "BlogTree",
    loader: async ()=>(await (parcelRequire("hN8Yp"))).BlogTree
});
module.exports["BlogTree"] = $2956b96ada85ef60$export$a2e535ad780a85fe;

});

parcelRegister("hN8Yp", function(module, exports) {

let $cf3df92ed0e39d52$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $cf3df92ed0e39d52$var$load("6damH"),
    $cf3df92ed0e39d52$var$load("ea3NB"),
    $cf3df92ed0e39d52$var$load("8hP2l"),
    $cf3df92ed0e39d52$var$load("1XtfK"),
    $cf3df92ed0e39d52$var$load("Lm7SH"),
    $cf3df92ed0e39d52$var$load("6wr18"),
    $cf3df92ed0e39d52$var$load("e4XZ1"),
    $cf3df92ed0e39d52$var$load("cvw7S"),
    $cf3df92ed0e39d52$var$load("llcQo"),
    $cf3df92ed0e39d52$var$load("bxj2D"),
    $cf3df92ed0e39d52$var$load("Tjs4D"),
    $cf3df92ed0e39d52$var$load("7EorR"),
    $cf3df92ed0e39d52$var$load("ffEVr"),
    $cf3df92ed0e39d52$var$load("aLbuU"),
    $cf3df92ed0e39d52$var$load("4izLy"),
    $cf3df92ed0e39d52$var$load("Wowvf"),
    $cf3df92ed0e39d52$var$load("953Uz"),
    $cf3df92ed0e39d52$var$load("hhss7"),
    $cf3df92ed0e39d52$var$load("hDNUK")
]).then(()=>parcelRequire('esUj7'));

});

parcelRegister("6jT5w", function(module, exports) {

let $499f3fc3dd87b5d3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $499f3fc3dd87b5d3$var$load("jzPyj"),
    $499f3fc3dd87b5d3$var$load("bdsZU")
]).then(()=>parcelRequire('aiYSz'));

});

parcelRegister("hXDOc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $9wGTI = parcelRequire("9wGTI");

var $b22e252a6b9677fd$export$3c7387d0e5ed624d = /*#__PURE__*/ function(PreloadingMode) {
    PreloadingMode["onlyJS"] = "onlyJS";
    PreloadingMode["onlyJSAndCriticalData"] = "onlyJSAndCriticalData";
    PreloadingMode["everything"] = "everything";
    return PreloadingMode;
}({});
const $b22e252a6b9677fd$var$PRELOAD_TIMER = 100;
const $b22e252a6b9677fd$var$sendAnalyticsEvent = (createAnalyticsEvent, action, name, attributes)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'hoverPreloader',
            actionSubjectId: name ?? 'n/a',
            source: 'hoverPreloader',
            attributes: attributes
        }
    }).fire();
};
const $b22e252a6b9677fd$var$preload = (preloadUrl, options = {})=>{
    window.dispatchEvent(new CustomEvent('preloadOnHover', {
        bubbles: true,
        detail: {
            preloadUrl: preloadUrl,
            ...options
        }
    }));
};
const $b22e252a6b9677fd$var$TransitionPreloaderImpl = ({ name: name, children: children, preloadUrl: preloadUrl, preloadOptions: preloadOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const hoverTimeoutRef = (0, $cozmU.useRef)(null);
    const preloadRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            preloadRef.current = false;
            if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        };
    }, []);
    // Here we implement multi-stage preloading. JS can be preloaded immediately and unconditionally.
    // For the rest of the preload options / experiments require at least a timeout, but other cases
    // may require more sophisticated logic to decide when or whether to preload.
    const onMouseEnter = (0, $cozmU.useCallback)(()=>{
        preloadRef.current = false;
        $b22e252a6b9677fd$var$preload(preloadUrl, {
            preloadingMode: "onlyJS"
        });
        // Do not proceed to the next stage if only JS preloading is enabled
        if (preloadOptions?.preloadingMode === "onlyJS") return;
        // Trigger next preloading stage either if everything is enabled or if critical data preloading
        // is enabled and the corresponding feature flag is enabled.
        const shouldPreload = preloadOptions?.preloadingMode === "everything" ? true : preloadOptions?.preloadingMode === "onlyJSAndCriticalData" && (0, $9wGTI.fg)('confluence_preload_critical_data');
        if (!shouldPreload) return;
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = window.setTimeout(()=>{
            $b22e252a6b9677fd$var$preload(preloadUrl, preloadOptions);
            preloadRef.current = true;
        }, $b22e252a6b9677fd$var$PRELOAD_TIMER);
    }, [
        preloadUrl,
        preloadOptions
    ]);
    const onMouseLeave = (0, $cozmU.useCallback)(()=>{
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        if (preloadRef.current) $b22e252a6b9677fd$var$sendAnalyticsEvent(createAnalyticsEvent, 'preloadAndLeave', name, {
            preloadingMode: preloadOptions?.preloadingMode
        });
    }, [
        createAnalyticsEvent,
        name,
        preloadOptions?.preloadingMode
    ]);
    const onMouseDown = (0, $cozmU.useCallback)(()=>{
        preloadRef.current = false;
    }, []);
    // Helper to chain child handlers with hover-preloader handlers
    const chain = (...fns)=>(...args)=>{
            fns.forEach((fn)=>{
                if (fn) fn(...args);
            });
        };
    const wrappedChild = /*#__PURE__*/ (0, $cozmU.isValidElement)(children) ? /*#__PURE__*/ (0, $cozmU.cloneElement)(children, {
        onMouseEnter: chain(children.props.onMouseEnter, onMouseEnter),
        onFocus: chain(children.props.onFocus, onMouseEnter),
        onMouseLeave: chain(children.props.onMouseLeave, onMouseLeave),
        onBlur: chain(children.props.onBlur, onMouseLeave),
        onMouseDown: chain(children.props.onMouseDown, onMouseDown)
    }) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-vc": `hover-preloader-${name}`,
        "data-testid": "hover-preloader"
    }, wrappedChild);
};
const $b22e252a6b9677fd$export$16d0fec7f7c7ddfa = (props)=>{
    if (!props.preloadUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b22e252a6b9677fd$var$TransitionPreloaderImpl, props);
};
const $b22e252a6b9677fd$export$f5ad7b1003f136b2 = {
    onlyJS: {
        preloadingMode: "onlyJS"
    },
    onlyJSAndCriticalData: {
        preloadingMode: "onlyJSAndCriticalData"
    },
    everything: {
        preloadingMode: "everything"
    }
};
module.exports["PreloadingMode"] = $b22e252a6b9677fd$export$3c7387d0e5ed624d;
module.exports["HoverPreloader"] = $b22e252a6b9677fd$export$16d0fec7f7c7ddfa;
module.exports["PreloadingPresets"] = $b22e252a6b9677fd$export$f5ad7b1003f136b2;

});

parcelRegister("eWwvy", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $49b80c0b2fd2c306$export$9c32b7bc3af8de64 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "5liJC",
    name: "EditSpaceLogo",
    loader: async ()=>(await (parcelRequire("lXV4d"))).EditSpaceLogo
});
module.exports["EditSpaceLogo"] = $49b80c0b2fd2c306$export$9c32b7bc3af8de64;

});

parcelRegister("lXV4d", function(module, exports) {

let $ffdb5ffe164d52e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ffdb5ffe164d52e8$var$load("hhss7"),
    $ffdb5ffe164d52e8$var$load("kyxdN")
]).then(()=>parcelRequire('asonV'));

});

parcelRegister("c9Rq0", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $c3b64ab3db691a18$var$styles = {
    'above.xs': "_2rTNeWYbGa",
    'above.sm': "_2UeR8bYbGa",
    'above.md': "_0THHewYbGa",
    'above.lg': "_1hlSbsYbGa",
    'above.xl': "_4pVFIkYbGa",
    'below.xs': "_3PnjIVYbGa",
    'below.sm': "_1U2uuEYbGa",
    'below.md': "_3RxhahYbGa",
    'below.lg': "_1q55U0YbGa",
    'below.xl': "_2HqVMBYbGa"
};
const $c3b64ab3db691a18$export$bed28288a051538 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { above: above, below: below, children: children, as: t1, xcss: xcss } = t0;
    const AsElement = t1 === undefined ? "div" : t1;
    const t2 = above && $c3b64ab3db691a18$var$styles[`above.${above}`];
    const t3 = below && $c3b64ab3db691a18$var$styles[`below.${below}`];
    let t4;
    if ($[0] !== t2 || $[1] !== t3 || $[2] !== xcss) {
        t4 = (0, $hekY6.default)([
            t2,
            t3,
            xcss
        ]);
        $[0] = t2;
        $[1] = t3;
        $[2] = xcss;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== AsElement || $[5] !== children || $[6] !== t4) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)(AsElement, {
            className: t4,
            children: children
        });
        $[4] = AsElement;
        $[5] = children;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
} : ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)(AsElement, {
        className: (0, $hekY6.default)([
            above && $c3b64ab3db691a18$var$styles[`above.${above}`],
            below && $c3b64ab3db691a18$var$styles[`below.${below}`],
            xcss
        ]),
        children: children
    });
};
module.exports["Hide"] = $c3b64ab3db691a18$export$bed28288a051538;

});

parcelRegister("3SChL", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $751fcd22fac4dec6$export$7a357837346c6789 = {
    editor: [
        'nth-user-orientation-editor-space-spotlight',
        'nth-user-orientation-editor-for-you-spotlight',
        'nth-user-orientation-editor-bpqa-spotlight'
    ]
};
const $751fcd22fac4dec6$var$detectTour = (renderedSpotlights)=>{
    // Find the first tour where all required spotlights are registered
    for (const [tour, spotlights] of Object.entries($751fcd22fac4dec6$export$7a357837346c6789)){
        if (spotlights.every((spotlight)=>renderedSpotlights.has(spotlight))) return tour;
    }
    return null;
};
const $751fcd22fac4dec6$var$Store = (0, $8s9DV.createStore)({
    initialState: {
        active: false,
        step: 0,
        renderedSpotlights: new Set(),
        hasInteracted: false
    },
    actions: {
        activate: ()=>({ setState: setState })=>{
                setState({
                    active: true,
                    step: 0
                });
            },
        reset: ()=>({ setState: setState })=>{
                setState({
                    active: false,
                    step: 0,
                    hasInteracted: false
                });
            },
        next: ()=>({ setState: setState, getState: getState })=>{
                const nextStep = Math.min(getState().step + 1, 2);
                setState({
                    step: nextStep,
                    hasInteracted: true
                });
            },
        back: ()=>({ setState: setState, getState: getState })=>{
                const prevStep = Math.max(getState().step - 1, 0);
                setState({
                    step: prevStep,
                    hasInteracted: true
                });
            },
        registerSpotlight: ({ spotlightId: spotlightId })=>({ setState: setState, getState: getState })=>{
                const newRegistered = new Set(getState().renderedSpotlights);
                newRegistered.add(spotlightId);
                setState({
                    renderedSpotlights: newRegistered
                });
            },
        deregisterSpotlight: ({ spotlightId: spotlightId })=>({ setState: setState, getState: getState })=>{
                const newRegistered = new Set(getState().renderedSpotlights);
                newRegistered.delete(spotlightId);
                setState({
                    renderedSpotlights: newRegistered
                });
            }
    },
    name: 'experiment-nth-user-orientation-store'
});
const $751fcd22fac4dec6$export$6d3060c9729a9bf7 = (0, $kBr4q.createStateHook)($751fcd22fac4dec6$var$Store);
const $751fcd22fac4dec6$export$31ec7099503725e8 = (0, $kBr4q.createActionsHook)($751fcd22fac4dec6$var$Store);
const $751fcd22fac4dec6$export$e9b94d8bc34db24 = (spotlightId)=>{
    const { next: next, back: back, reset: reset, registerSpotlight: registerSpotlight, deregisterSpotlight: deregisterSpotlight } = $751fcd22fac4dec6$export$31ec7099503725e8();
    const { step: step, active: active, renderedSpotlights: renderedSpotlights, hasInteracted: hasInteracted } = $751fcd22fac4dec6$export$6d3060c9729a9bf7();
    // Auto-register/deregister the spotlight when spotlights use this hook. This way
    // we can keep track of which spotlights are currently rendered, and use that list
    // to figure out if the user is eligible for a tour.
    (0, $cozmU.useEffect)(()=>{
        registerSpotlight({
            spotlightId: spotlightId
        });
        return ()=>{
            deregisterSpotlight({
                spotlightId: spotlightId
            });
        };
    }, [
        spotlightId,
        registerSpotlight,
        deregisterSpotlight
    ]);
    const detectedTour = (0, $cozmU.useMemo)(()=>$751fcd22fac4dec6$var$detectTour(renderedSpotlights), [
        renderedSpotlights
    ]);
    if (!active || !detectedTour) return {
        reset: reset,
        back: back,
        next: next,
        currentStep: null,
        progress: {
            step: 0,
            steps: 0
        },
        hasInteracted: hasInteracted,
        active: active
    };
    return {
        reset: reset,
        back: back,
        next: next,
        currentStep: $751fcd22fac4dec6$export$7a357837346c6789[detectedTour][step],
        progress: {
            step: step + 1,
            steps: detectedTour ? $751fcd22fac4dec6$export$7a357837346c6789[detectedTour].length : 0
        },
        hasInteracted: hasInteracted,
        active: active
    };
};
module.exports["useNthUserOrientationState"] = $751fcd22fac4dec6$export$6d3060c9729a9bf7;
module.exports["useNthUserOrientationActions"] = $751fcd22fac4dec6$export$31ec7099503725e8;
module.exports["useTour"] = $751fcd22fac4dec6$export$e9b94d8bc34db24;

});

parcelRegister("3Awqk", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $90247d71b6534bef$export$ce22f6f6b0034afd = (0, $kSwu1.defineMessages)({
    next: {
        id: "experiment-nth-user-orientation.spotlight.next",
        defaultMessage: "Next"
    },
    back: {
        id: "experiment-nth-user-orientation.spotlight.back",
        defaultMessage: "Back"
    },
    done: {
        id: "experiment-nth-user-orientation.spotlight.done",
        defaultMessage: "Done"
    },
    dismiss: {
        id: "experiment-nth-user-orientation.spotlight.dismiss",
        defaultMessage: "Dismiss Tour"
    },
    progress: {
        id: "experiment-nth-user-orientation.spotlight.progress",
        defaultMessage: "{step} of {steps}"
    }
});
const $90247d71b6534bef$export$9a4454cd199ce080 = (0, $kSwu1.defineMessages)({
    headline: {
        id: "experiment-nth-user-orientation.editorSpaceSpotlight.headline",
        defaultMessage: "Your space, your start"
    },
    body: {
        id: "experiment-nth-user-orientation.editorSpaceSpotlight.body",
        defaultMessage: "This is your personal space. Create more to organize your team\u2019s work."
    }
});
const $90247d71b6534bef$export$252e22890fb2efa6 = (0, $kSwu1.defineMessages)({
    headline: {
        id: "experiment-nth-user-orientation.editorForYouSpotlight.headline",
        defaultMessage: "Catch up on team activity here"
    },
    body: {
        id: "experiment-nth-user-orientation.editorForYouSpotlight.body",
        defaultMessage: "See recent pages, team updates, and quick links tailored for you."
    }
});
const $90247d71b6534bef$export$6794fada8079fe55 = (0, $kSwu1.defineMessages)({
    headline: {
        id: "experiment-nth-user-orientation.editorBpqaSpotlight.headline",
        defaultMessage: "Now let\u2019s create your first page!"
    },
    body: {
        id: "experiment-nth-user-orientation.editorBpqaSpotlight.body",
        defaultMessage: "With a template, a page is a click away. Hover on one for a preview."
    }
});
module.exports["spotlight"] = $90247d71b6534bef$export$ce22f6f6b0034afd;
module.exports["editorSpaceSpotlight"] = $90247d71b6534bef$export$9a4454cd199ce080;
module.exports["editorForYouSpotlight"] = $90247d71b6534bef$export$252e22890fb2efa6;
module.exports["editorBpqaSpotlight"] = $90247d71b6534bef$export$6794fada8079fe55;

});

parcelRegister("2AgON", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");

const $3c36b21fe0d55bcd$var$SPOTLIGHT_ACTION_SUBJECT_IDS = {
    'nth-user-orientation-editor-space-spotlight': 'nthUserOrientationEditorSpaceSpotlight',
    'nth-user-orientation-editor-for-you-spotlight': 'nthUserOrientationEditorForYouSpotlight',
    'nth-user-orientation-editor-bpqa-spotlight': 'nthUserOrientationEditorBpqaSpotlight'
};
function $3c36b21fe0d55bcd$export$b54fada573f13a91({ spotlightId: spotlightId, isVisible: isVisible, onNext: onNext, onBack: onBack, onDismiss: onDismiss }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    // Fire render event when spotlight becomes visible
    (0, $cozmU.useEffect)(()=>{
        if (isVisible) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'rendered',
                actionSubject: 'spotlight',
                actionSubjectId: $3c36b21fe0d55bcd$var$SPOTLIGHT_ACTION_SUBJECT_IDS[spotlightId],
                source: 'nth-user-orientation'
            }
        }).fire();
    }, [
        isVisible,
        createAnalyticsEvent,
        spotlightId
    ]);
    const handleNext = (0, $cozmU.useCallback)(()=>{
        if (onNext) {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'next',
                    source: spotlightId
                }
            }).fire();
            onNext();
        }
    }, [
        onNext,
        createAnalyticsEvent,
        spotlightId
    ]);
    const handleBack = (0, $cozmU.useCallback)(()=>{
        if (onBack) {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'back',
                    source: spotlightId
                }
            }).fire();
            onBack();
        }
    }, [
        onBack,
        createAnalyticsEvent,
        spotlightId
    ]);
    const handleDismiss = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismissTour',
                source: spotlightId
            }
        }).fire();
        onDismiss();
    }, [
        onDismiss,
        createAnalyticsEvent,
        spotlightId
    ]);
    return {
        handleNext: onNext ? handleNext : undefined,
        handleBack: onBack ? handleBack : undefined,
        handleDismiss: handleDismiss
    };
}
module.exports["useSpotlightAnalytics"] = $3c36b21fe0d55bcd$export$b54fada573f13a91;

});

parcelRegister("35Nok", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $IQ4Dz = parcelRequire("IQ4Dz");

const $cd2e96a49affba4b$export$4b64aca38e15f2eb = ({ gif: gif, placeholder: placeholder, skip: skip = false })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const gifSrc = gif[colorMode ?? 'light'];
    const placeholderSrc = placeholder[colorMode ?? 'light'];
    const [isReady, setIsReady] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (skip) return;
        setIsReady(false);
        const image = new Image();
        image.onload = ()=>{
            setIsReady(true);
        };
        image.onerror = ()=>{
            setIsReady(false);
        };
        image.src = gifSrc;
        // If the image has already loaded (cached), handle it immediately
        if (image.complete) setIsReady(true);
    }, [
        gifSrc,
        skip
    ]);
    return isReady ? gifSrc : placeholderSrc;
};
module.exports["usePreloadGif"] = $cd2e96a49affba4b$export$4b64aca38e15f2eb;

});

parcelRegister("eGUIL", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6ab3d9f83e467c30$export$8ff51aff18368071 = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $6ab3d9f83e467c30$export$18d9743f01f9c283 = ()=>{
    const context = (0, $cozmU.useContext)($6ab3d9f83e467c30$export$8ff51aff18368071);
    if (!context) throw new Error("useSideNavigation must be used within a SideNavigationContext.Provider");
    return context;
};
module.exports["SideNavigationContext"] = $6ab3d9f83e467c30$export$8ff51aff18368071;
module.exports["useSideNavigation"] = $6ab3d9f83e467c30$export$18d9743f01f9c283;

});

parcelRegister("ipTw1", function(module, exports) {

let $d685a0021926a079$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d685a0021926a079$var$load("kPyOr"),
    $d685a0021926a079$var$load("6wr18"),
    $d685a0021926a079$var$load("diMTQ"),
    $d685a0021926a079$var$load("ffEVr"),
    $d685a0021926a079$var$load("aLbuU"),
    $d685a0021926a079$var$load("PkFdp")
]).then(()=>parcelRequire('hSgLQ'));

});

parcelRegister("inA63", function(module, exports) {

let $d6166006e155d91d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d6166006e155d91d$var$load("4tFwP"),
    $d6166006e155d91d$var$load("6oFhK")
]).then(()=>parcelRequire('iwt54'));

});

parcelRegister("28oQf", function(module, exports) {
const $a5e3205ff2d8ec91$export$38788381122702f5 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-addonengine-analytics-space-analytics';
const $a5e3205ff2d8ec91$export$6c3d789a4f56bea2 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-addonengine-analytics-moderate-space-analytics';
const $a5e3205ff2d8ec91$export$ee99bc1ad01a63ae = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-automation';
const $a5e3205ff2d8ec91$export$dad26f289a3f773e = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-blogs';
const $a5e3205ff2d8ec91$export$27d01545acc1e1ca = 'com.atlassian.confluence.extra.team-calendars:space-calendar-sidebar-link';
const $a5e3205ff2d8ec91$export$a1081c7e806b45a0 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-k15t-orderly-databases-database';
const $a5e3205ff2d8ec91$export$de45ec31104af09 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-atlassian-confluence-plugins-confluence-questions-question';
const $a5e3205ff2d8ec91$export$1b86edccef2dd51 = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-questions';
const $a5e3205ff2d8ec91$export$f618e448a4ddfafa = 'com.atlassian.confluence.plugins.confluence-frontend-support:space-tools-link';
const $a5e3205ff2d8ec91$export$9727611105a72ba4 = 'com.atlassian.plugins.atlassian-connect-plugin';
const $a5e3205ff2d8ec91$export$35d69df876e79a8b = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-shortcuts';
const $a5e3205ff2d8ec91$export$28596511f20e98f2 = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-apps';
const $a5e3205ff2d8ec91$export$1c0f21b83a6a96d6 = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-content-manager';
module.exports["ANALYTICS_KEY"] = $a5e3205ff2d8ec91$export$38788381122702f5;
module.exports["ANALYTICS_KEY_MODERATE"] = $a5e3205ff2d8ec91$export$6c3d789a4f56bea2;
module.exports["BLOG_KEY"] = $a5e3205ff2d8ec91$export$dad26f289a3f773e;
module.exports["CALENDARS_KEY"] = $a5e3205ff2d8ec91$export$27d01545acc1e1ca;
module.exports["DATABASES_KEY"] = $a5e3205ff2d8ec91$export$a1081c7e806b45a0;
module.exports["QUESTIONS_KEY"] = $a5e3205ff2d8ec91$export$de45ec31104af09;
module.exports["QUESTIONS_NATIVE_KEY"] = $a5e3205ff2d8ec91$export$1b86edccef2dd51;
module.exports["CONNECT_ADDON_KEY"] = $a5e3205ff2d8ec91$export$9727611105a72ba4;
module.exports["SHORTCUTS_KEY"] = $a5e3205ff2d8ec91$export$35d69df876e79a8b;
module.exports["APPS_KEY"] = $a5e3205ff2d8ec91$export$28596511f20e98f2;

});

parcelRegister("29Vr1", function(module, exports) {

let $1928f96b85f18df7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1928f96b85f18df7$var$load("6wr18"),
    $1928f96b85f18df7$var$load("ffEVr"),
    $1928f96b85f18df7$var$load("c08ou")
]).then(()=>parcelRequire('99rcJ'));

});

parcelRegister("3vaGk", function(module, exports) {

let $28cc8d87dd6f2ca6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $28cc8d87dd6f2ca6$var$load("6wr18"),
    $28cc8d87dd6f2ca6$var$load("ffEVr"),
    $28cc8d87dd6f2ca6$var$load("8uhuz")
]).then(()=>parcelRequire('ar6Ga'));

});

parcelRegister("dJFqB", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $euL71 = parcelRequire("euL71");


var $9HB34 = parcelRequire("9HB34");


var $bQm3c = parcelRequire("bQm3c");


var $dGmBZ = parcelRequire("dGmBZ");

const $ec7296adc394eb50$var$SpaceNavigationAffordanceDataContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $ec7296adc394eb50$export$8290219e59a270d8 = ()=>{
    return (0, $cozmU.useContext)($ec7296adc394eb50$var$SpaceNavigationAffordanceDataContext);
};
const $ec7296adc394eb50$var$SpaceNavigationAffordanceDataProviderInner = (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { children: children, spaceKey: spaceKey, variables: variables } = t0;
    const { cloudId: cloudId, edition: edition, isLicensed: isLicensed, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const includePersistentInviteLicense = edition !== (0, $euL71.ConfluenceEdition).FREE && isLoggedIn && isLicensed;
    let t1;
    if ($[0] !== cloudId || $[1] !== includePersistentInviteLicense || $[2] !== isLicensed || $[3] !== spaceKey || $[4] !== variables) {
        t1 = variables ?? {
            cloudId: cloudId,
            spaceKey: spaceKey,
            isLicensed: isLicensed,
            includePersistentInviteLicense: includePersistentInviteLicense,
            includeSpaceCurationCount: false,
            includeSpaceViewsPersistence: false
        };
        $[0] = cloudId;
        $[1] = includePersistentInviteLicense;
        $[2] = isLicensed;
        $[3] = spaceKey;
        $[4] = variables;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            fetchPolicy: "store-only"
        };
        $[6] = t2;
    } else t2 = $[6];
    const routeData = (0, $6SsN4.useLazyLoadQuery)((0, $dGmBZ.default), t1, t2);
    routeData.user?.confluence?.permissionType;
    let t3;
    bb0: {
        if (!routeData.space) {
            t3 = undefined;
            break bb0;
        }
        const t4 = routeData.user?.confluence?.permissionType === "EXTERNAL";
        let t5;
        if ($[7] !== routeData.license || $[8] !== routeData.space || $[9] !== routeData.spaceCurationSuggestionCount || $[10] !== t4) {
            t5 = {
                spaceFragmentRef: routeData.space,
                licenseFragmentRef: routeData.license,
                suggestionCountFragmentRef: routeData.spaceCurationSuggestionCount,
                isUserExternalCollaborator: t4
            };
            $[7] = routeData.license;
            $[8] = routeData.space;
            $[9] = routeData.spaceCurationSuggestionCount;
            $[10] = t4;
            $[11] = t5;
        } else t5 = $[11];
        t3 = t5;
    }
    const affordanceData = t3;
    if (!affordanceData) {
        let t4;
        if ($[12] !== children) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[12] = children;
            $[13] = t4;
        } else t4 = $[13];
        return t4;
    }
    let t4;
    if ($[14] !== affordanceData || $[15] !== children) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ec7296adc394eb50$var$SpaceNavigationAffordanceDataContext.Provider, {
            value: affordanceData
        }, children);
        $[14] = affordanceData;
        $[15] = children;
        $[16] = t4;
    } else t4 = $[16];
    return t4;
};
const $ec7296adc394eb50$export$653a8018007c119 = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, spaceKey: spaceKey, variables: variables } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $9HB34.getRelayEnvironment)();
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== spaceKey || $[3] !== variables) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6SsN4.RelayEnvironmentProvider), {
            environment: t1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ec7296adc394eb50$var$SpaceNavigationAffordanceDataProviderInner, {
            spaceKey: spaceKey,
            variables: variables
        }, children));
        $[1] = children;
        $[2] = spaceKey;
        $[3] = variables;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
module.exports["useSpaceNavigationAffordanceData"] = $ec7296adc394eb50$export$8290219e59a270d8;
module.exports["SpaceNavigationAffordanceDataProvider"] = $ec7296adc394eb50$export$653a8018007c119;

});

parcelRegister("3gezS", function(module, exports) {

let $25fe2c8b764ddc96$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $25fe2c8b764ddc96$var$load("6wr18"),
    $25fe2c8b764ddc96$var$load("ffEVr"),
    $25fe2c8b764ddc96$var$load("klGUa")
]).then(()=>parcelRequire('8o2bj'));

});

parcelRegister("kofcT", function(module, exports) {

let $03d4acc7979517d6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $03d4acc7979517d6$var$load("6wr18"),
    $03d4acc7979517d6$var$load("ffEVr"),
    $03d4acc7979517d6$var$load("aLbuU"),
    $03d4acc7979517d6$var$load("kZjBp")
]).then(()=>parcelRequire('1xLOH'));

});

parcelRegister("ir4h8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $ac2J9 = parcelRequire("ac2J9");

const $abc73c6f5c74c436$export$6d558eab13290f59 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
} : ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
module.exports["useRouterLink"] = $abc73c6f5c74c436$export$6d558eab13290f59;

});

parcelRegister("ac2J9", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b797161b98bd0492$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $cozmU.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $b797161b98bd0492$var$RouterLinkProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { routerLinkComponent: routerLinkComponent, children: children } = t0;
    let t1;
    if ($[0] !== routerLinkComponent) {
        t1 = {
            routerLinkComponent: routerLinkComponent
        };
        $[0] = routerLinkComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
            value: t1,
            children: children
        });
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b797161b98bd0492$export$2e2bcd8739ae039 = $b797161b98bd0492$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $b797161b98bd0492$export$2931e0ee690eee88;

});

parcelRegister("4Uejl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jlWUB = parcelRequire("jlWUB");


var $lrDw7 = parcelRequire("lrDw7");


var $7BVQi = parcelRequire("7BVQi");


var $g3XYx = parcelRequire("g3XYx");


var $1U6E9 = parcelRequire("1U6E9");


var $jhrdR = parcelRequire("jhrdR");

/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $8b8583a0a90649e3$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $8b8583a0a90649e3$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $8b8583a0a90649e3$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
const $8b8583a0a90649e3$export$a300664a1a230956 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion } = t0;
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            cleanup: "next-effect"
        };
        $[0] = t1;
    } else t1 = $[0];
    const setTimeout = (0, $1U6E9.useSetTimeout)(t1);
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    let t2;
    if ($[1] !== element) {
        t2 = ()=>{
            if ((0, $jlWUB.isReducedMotion)() || !element) return;
            const rect = element.getBoundingClientRect();
            prevDimensions.current = {
                width: rect.width,
                height: rect.height
            };
        };
        $[1] = element;
        $[2] = t2;
    } else t2 = $[2];
    (0, $jhrdR.useSnapshotBeforeUpdate)(t2);
    let t3;
    if ($[3] !== dimension || $[4] !== duration || $[5] !== easing || $[6] !== element || $[7] !== onFinishMotion || $[8] !== requestAnimationFrame || $[9] !== setTimeout) {
        t3 = ()=>{
            if ((0, $jlWUB.isReducedMotion)() || !element || !prevDimensions.current) return;
            element.setAttribute("style", "");
            const rect_0 = element.getBoundingClientRect();
            const nextDimensions = {
                width: rect_0.width,
                height: rect_0.height
            };
            if (!$8b8583a0a90649e3$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
                onFinishMotion?.();
                return;
            }
            const propertyList = $8b8583a0a90649e3$var$getDimensionPropertyList(dimension);
            const newStyles = {
                willChange: propertyList,
                transitionProperty: propertyList,
                transitionDuration: duration,
                boxSizing: "border-box",
                transitionTimingFunction: easing
            };
            if (dimension === "width" || dimension === "both") newStyles.width = `${prevDimensions.current.width}px`;
            if (dimension === "height" || dimension === "both") newStyles.height = `${prevDimensions.current.height}px`;
            Object.assign(element.style, newStyles);
            const resolvedDuration = $8b8583a0a90649e3$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    if (!element) return;
                    if (dimension === "width" || dimension === "both") element.style.width = `${nextDimensions.width}px`;
                    if (dimension === "height" || dimension === "both") element.style.height = `${nextDimensions.height}px`;
                    setTimeout(()=>{
                        if (!element) return;
                        element.setAttribute("style", "");
                        onFinishMotion?.();
                    }, resolvedDuration);
                });
            });
        };
        $[3] = dimension;
        $[4] = duration;
        $[5] = easing;
        $[6] = element;
        $[7] = onFinishMotion;
        $[8] = requestAnimationFrame;
        $[9] = setTimeout;
        $[10] = t3;
    } else t3 = $[10];
    (0, $7BVQi.useLayoutEffect)(t3);
    let t4;
    if ($[11] !== setElementRef) {
        t4 = {
            ref: setElementRef
        };
        $[11] = setElementRef;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : ({ dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion })=>{
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    const setTimeout = (0, $1U6E9.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    (0, $jhrdR.useSnapshotBeforeUpdate)(()=>{
        if ((0, $jlWUB.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $7BVQi.useLayoutEffect)(()=>{
        if ((0, $jlWUB.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect_0 = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect_0.width,
            height: rect_0.height
        };
        if (!$8b8583a0a90649e3$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion?.();
            return;
        }
        const propertyList = $8b8583a0a90649e3$var$getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = $8b8583a0a90649e3$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion?.();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
module.exports["useResizing"] = $8b8583a0a90649e3$export$a300664a1a230956;

});

parcelRegister("lrDw7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6a66563ef19581ba$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $cozmU.useRef)(null);
    const setRef = (0, $cozmU.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $6a66563ef19581ba$export$ff879f35a69d56b7;

});

parcelRegister("g3XYx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $f8fe10123ae9dc81$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $f8fe10123ae9dc81$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $cozmU.useRef)([]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $f8fe10123ae9dc81$var$getHookDeps(opts));
    return (0, $cozmU.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
module.exports["useRequestAnimationFrame"] = $f8fe10123ae9dc81$export$1775f27e7c8051ca;

});

parcelRegister("jhrdR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7BVQi = parcelRequire("7BVQi");

const $8584e1bffd64d1d0$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $cozmU.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $7BVQi.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};
module.exports["useSnapshotBeforeUpdate"] = $8584e1bffd64d1d0$export$9e95200239cd148b;

});

parcelRegister("kdKo9", function(module, exports) {
/**
 * @generated SignedSource<<f026ee318392a45fe95d1de0923dc1ed>>
 * @relayHash 8899b56f857af5bbb6a7740a976421fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ccc3fed4f1272376987ab0969757e99e08b473a8f3181629a4d10c47646cafb7
const $04119cd59f78d958$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceSettings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "routeOverrideEnabled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceRestrictionCheckQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceRestrictionCheckQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8899b56f857af5bbb6a7740a976421fb",
            "id": "ccc3fed4f1272376987ab0969757e99e08b473a8f3181629a4d10c47646cafb7",
            "metadata": {},
            "name": "SpaceRestrictionCheckQuery",
            "operationKind": "query",
            "text": "query SpaceRestrictionCheckQuery($spaceKey:String!){space(key:$spaceKey){id,settings{routeOverrideEnabled}}}"
        }
    };
}();
$04119cd59f78d958$var$node.hash = "57291753cf0096ea57a2f2351520a494";
var $04119cd59f78d958$export$2e2bcd8739ae039 = $04119cd59f78d958$var$node;
module.exports["default"] = $04119cd59f78d958$export$2e2bcd8739ae039;

});

parcelRegister("fG32j", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $kdKo9 = parcelRequire("kdKo9");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");



var $jMyy4 = parcelRequire("jMyy4");

const $06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery = (0, $kdKo9.default);
const $06e8bea7aad8a7b8$export$f1b4255eb8ae314e = (0, $3u0dr.isReactCompilerActiveV2)() ? function SpaceRestrictionCheck(t0) {
    const $ = (0, $bDgLe.c)(14);
    const { asSuperAdmin: asSuperAdmin, children: children, spaceKey: spaceKey, contentId: contentId } = t0;
    const [stateSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    let t1;
    if ($[0] !== asSuperAdmin) {
        t1 = asSuperAdmin == undefined ? undefined : {
            asSuperAdmin: asSuperAdmin
        };
        $[0] = asSuperAdmin;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = spaceKey || stateSpaceKey;
    let t3;
    if ($[2] !== t2) {
        t3 = {
            spaceKey: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t1 || $[5] !== t3) {
        t4 = {
            context: t1,
            errorPolicy: "all",
            variables: t3
        };
        $[4] = t1;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery, {
        ...t4,
        __callerPackage__: "restrictions"
    });
    let t5;
    let t6;
    if ($[7] !== children || $[8] !== contentId || $[9] !== data || $[10] !== error || $[11] !== loading) {
        t6 = Symbol.for("react.early_return_sentinel");
        bb0: {
            let isSpaceNotFound;
            let isSpaceRestricted;
            if (error) {
                isSpaceNotFound = $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error);
                isSpaceRestricted = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error);
                if (isSpaceNotFound || isSpaceRestricted) (0, $7Sm4c.markErrorAsHandled)(error);
            } else if (data) {
                const errorSwallowed = data.space === null;
                isSpaceNotFound = errorSwallowed && window.__SPACE_NOTFOUND_CHECK_ERROR__;
                isSpaceRestricted = errorSwallowed && window.__SPACE_RESTRICTED_CHECK_ERROR__;
            }
            if (loading) {
                t6 = null;
                break bb0;
            }
            const contentIsNotViewableBecauseOfSpaceRestrictions = Boolean(contentId) && window?.__SPACE_RESTRICTED_ERROR__ === contentId;
            t5 = children({
                error: error,
                isSpaceNotFound: isSpaceNotFound,
                isSpaceRestricted: isSpaceRestricted || contentIsNotViewableBecauseOfSpaceRestrictions
            });
        }
        $[7] = children;
        $[8] = contentId;
        $[9] = data;
        $[10] = error;
        $[11] = loading;
        $[12] = t5;
        $[13] = t6;
    } else {
        t5 = $[12];
        t6 = $[13];
    }
    if (t6 !== Symbol.for("react.early_return_sentinel")) return t6;
    return t5;
} : function SpaceRestrictionCheck({ asSuperAdmin: asSuperAdmin, children: children, spaceKey: spaceKey, contentId: contentId }) {
    const [stateSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery, {
        context: asSuperAdmin == undefined ? undefined : {
            asSuperAdmin: asSuperAdmin
        },
        errorPolicy: 'all',
        variables: {
            // XXX Though SpaceRestrictionCheckProps defines spaceKey as required,
            // SpaceBaseComponent is not written in TypeScript and it may provide
            // undefined as it is reading spaceKey from redux. While it would result
            // in a better separation of concerns to have a fix in SpaceBaseComponent,
            // such a fix would be riskier.
            spaceKey: spaceKey || stateSpaceKey
        },
        __callerPackage__: "restrictions"
    });
    let isSpaceNotFound;
    let isSpaceRestricted;
    if (error) {
        isSpaceNotFound = $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error);
        isSpaceRestricted = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error);
        if (isSpaceNotFound || isSpaceRestricted) (0, $7Sm4c.markErrorAsHandled)(error);
    } else if (data) {
        const errorSwallowed = data.space === null;
        isSpaceNotFound = errorSwallowed && window['__SPACE_NOTFOUND_CHECK_ERROR__'];
        isSpaceRestricted = errorSwallowed && window['__SPACE_RESTRICTED_CHECK_ERROR__'];
    }
    if (loading) return null;
    const contentIsNotViewableBecauseOfSpaceRestrictions = Boolean(contentId) && window?.['__SPACE_RESTRICTED_ERROR__'] === contentId;
    return children({
        error: error,
        isSpaceNotFound: isSpaceNotFound,
        isSpaceRestricted: isSpaceRestricted || contentIsNotViewableBecauseOfSpaceRestrictions
    });
};
function $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error) {
    return $06e8bea7aad8a7b8$var$isSpaceError(error, ({ statusCode: statusCode })=>statusCode === 404 || statusCode === 400);
}
function $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error) {
    return $06e8bea7aad8a7b8$var$isSpaceError(error, ()=>(0, $1uFM6.isUnauthorizedError)(error));
}
function $06e8bea7aad8a7b8$var$isSpaceError({ graphQLErrors: graphQLErrors }, extensionsPredicate) {
    if (graphQLErrors && graphQLErrors.length > 0) for (const { extensions: extensions, path: path } of graphQLErrors){
        if (Array.isArray(path) && path.indexOf('space') !== -1 && extensions && extensionsPredicate(extensions)) return true;
    }
    return false;
}
module.exports["SpaceRestrictionCheck"] = $06e8bea7aad8a7b8$export$f1b4255eb8ae314e;
module.exports["isSpaceNotFoundError"] = $06e8bea7aad8a7b8$export$498e7daa29ea2c61;
module.exports["isSpaceRestrictedError"] = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef;

});

parcelRegister("iDdJP", function(module, exports) {

var $k27u5 = parcelRequire("k27u5");

const $c514d668c0af497d$export$d4c4e98c5044dc8 = (0, $k27u5.List);
module.exports["MenuList"] = $c514d668c0af497d$export$d4c4e98c5044dc8;

});

parcelRegister("4K4h4", function(module, exports) {
$parcel$export(module.exports, "ContentTreeIcon", () => (parcelRequire("iU0gR")).ContentTreeIcon);

var $jmjWc = parcelRequire("jmjWc");


var $iU0gR = parcelRequire("iU0gR");


const $61f85e63c6992485$export$e511f243d20dd25e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "g-l5_",
    name: "ContentTreeIconLoader",
    loader: async ()=>(await Promise.resolve((parcelRequire("iU0gR")))).ContentTreeIcon
});
module.exports["ContentTreeIconLoader"] = $61f85e63c6992485$export$e511f243d20dd25e;

});

parcelRegister("iU0gR", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hMaHH = parcelRequire("hMaHH");


var $bDjVc = parcelRequire("bDjVc");


var $lBKFk = parcelRequire("lBKFk");


var $7A1BE = parcelRequire("7A1BE");


var $2hJf7 = parcelRequire("2hJf7");


var $kWSTb = parcelRequire("kWSTb");


var $kLlYX = parcelRequire("kLlYX");


var $cow67 = parcelRequire("cow67");


var $5tsXU = parcelRequire("5tsXU");


var $a6VRS = parcelRequire("a6VRS");


var $hT3jf = parcelRequire("hT3jf");

const $3b6036244b1fd25e$export$160f5c89496b5ea9 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { label: label, color: color, spacing: spacing, type: type, subType: subType, isExpanded: t1, isMarkdownMode: t2 } = t0;
    const isExpanded = t1 === undefined ? false : t1;
    const isMarkdownMode = t2 === undefined ? false : t2;
    const t3 = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7A1BE))) : (0, (/*@__PURE__*/$parcel$interopDefault($2hJf7)));
    const t4 = isMarkdownMode ? (0, (/*@__PURE__*/$parcel$interopDefault($cow67))) : (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX)));
    let t5;
    if ($[0] !== t3 || $[1] !== t4) {
        t5 = {
            page: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
            whiteboard: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
            slide: (0, (/*@__PURE__*/$parcel$interopDefault($kWSTb))),
            database: (0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))),
            folder: t3,
            liveDoc: t4
        };
        $[0] = t3;
        $[1] = t4;
        $[2] = t5;
    } else t5 = $[2];
    const contentTreeIconTypes = t5;
    const icon = contentTreeIconTypes[type];
    const isManagedFolder = (0, $hT3jf.isSmartFolder)({
        type: type,
        subType: subType
    });
    const testIdType = isManagedFolder ? "managed-folder" : type === "liveDoc" && isMarkdownMode ? "markdown" : type;
    const testId = `content-tree-icon${spacing !== "none" ? `-${spacing}` : ""}-${testIdType}${type === "folder" && isExpanded ? "-open" : ""}`;
    if (isManagedFolder) {
        const ManagedFolderIcon = isExpanded ? (0, $a6VRS.ManagedFolderOpenIcon) : (0, $5tsXU.ManagedFolderClosedIcon);
        let t6;
        if ($[3] !== ManagedFolderIcon || $[4] !== color || $[5] !== label || $[6] !== testId) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ManagedFolderIcon, {
                label: label,
                color: color,
                size: "small",
                testId: testId
            });
            $[3] = ManagedFolderIcon;
            $[4] = color;
            $[5] = label;
            $[6] = testId;
            $[7] = t6;
        } else t6 = $[7];
        return t6;
    }
    let t6;
    if ($[8] !== color || $[9] !== icon || $[10] !== label || $[11] !== spacing || $[12] !== testId) {
        let t7;
        if ($[14] !== color || $[15] !== label || $[16] !== spacing || $[17] !== testId) {
            t7 = {
                spacing: spacing,
                label: label,
                color: color,
                testId: testId
            };
            $[14] = color;
            $[15] = label;
            $[16] = spacing;
            $[17] = testId;
            $[18] = t7;
        } else t7 = $[18];
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(icon, t7);
        $[8] = color;
        $[9] = icon;
        $[10] = label;
        $[11] = spacing;
        $[12] = testId;
        $[13] = t6;
    } else t6 = $[13];
    return t6;
} : ({ label: label, color: color, spacing: // can override default icon color
spacing, type: type, subType: subType, isExpanded: isExpanded = false, isMarkdownMode: isMarkdownMode = false })=>{
    const contentTreeIconTypes = {
        page: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
        whiteboard: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
        slide: (0, (/*@__PURE__*/$parcel$interopDefault($kWSTb))),
        database: (0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))),
        folder: isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7A1BE))) : (0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))),
        liveDoc: isMarkdownMode ? (0, (/*@__PURE__*/$parcel$interopDefault($cow67))) : (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX)))
    };
    const icon = contentTreeIconTypes[type];
    const isManagedFolder = (0, $hT3jf.isSmartFolder)({
        type: type,
        subType: subType
    });
    const testIdType = isManagedFolder ? 'managed-folder' : type === 'liveDoc' && isMarkdownMode ? 'markdown' : type;
    const testId = `content-tree-icon${spacing !== 'none' ? `-${spacing}` : ''}-${testIdType}${type === 'folder' && isExpanded ? '-open' : ''}`;
    if (isManagedFolder) {
        const ManagedFolderIcon = isExpanded ? (0, $a6VRS.ManagedFolderOpenIcon) : (0, $5tsXU.ManagedFolderClosedIcon);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ManagedFolderIcon, {
            label: label,
            color: color,
            size: "small",
            testId: testId
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(icon, {
        spacing: spacing,
        label: label,
        color: color,
        testId: testId
    });
};
module.exports["ContentTreeIcon"] = $3b6036244b1fd25e$export$160f5c89496b5ea9;

});

parcelRegister("a6VRS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

/**
 * Custom icon for a managed (synced) open folder.
 * Renders an open folder with a circle badge in the bottom-right corner.
 * Uses currentColor so the icon responds to theming and dark mode.
 */ const $6b5b62a1c1d5201a$export$d5c72b0cf938803f = ({ label: label, size: size = 'medium', color: color, testId: testId })=>{
    const dimensions = size === 'small' ? 16 : 24;
    const fillColor = color || 'currentColor';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        "data-testid": testId,
        width: dimensions,
        height: dimensions,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: label ? 'img' : 'presentation',
        "aria-label": label || undefined,
        "aria-hidden": !label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.31055 2.75H12C13.1046 2.75 14 3.64543 14 4.75V6H14.6599C15.5809 6 16.2416 6.88783 15.9771 7.77002L15.3081 10H13.7419L14.4919 7.5H4.55811L2.75806 13.5H10V15H1.75C0.783502 15 0 14.2165 0 13.25V3C0 1.89543 0.895431 1 2 1H5.56055L7.31055 2.75ZM2 2.5C1.72386 2.5 1.5 2.72386 1.5 3V12.4731L3.14795 6.97998C3.32243 6.39838 3.85788 6 4.46509 6H12.5V4.75C12.5 4.47386 12.2761 4.25 12 4.25H6.68945L4.93945 2.5H2Z",
        fill: fillColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M15.75 13.75C15.75 14.8546 14.8546 15.75 13.75 15.75C12.6454 15.75 11.75 14.8546 11.75 13.75C11.75 12.6454 12.6454 11.75 13.75 11.75C14.8546 11.75 15.75 12.6454 15.75 13.75Z",
        fill: fillColor
    }));
};
module.exports["ManagedFolderOpenIcon"] = $6b5b62a1c1d5201a$export$d5c72b0cf938803f;

});

parcelRegister("6bZDi", function(module, exports) {
const $a8768b1a0c8c67c8$export$ee7a362b3ed8b036 = [
    'page',
    'whiteboard',
    'database',
    'slide',
    'folder',
    'liveDoc'
];
const $a8768b1a0c8c67c8$export$a73714094b2817b7 = (obj)=>typeof obj === 'string' && $a8768b1a0c8c67c8$export$ee7a362b3ed8b036.includes(obj);
const $a8768b1a0c8c67c8$export$204659eac14d740b = (obj)=>$a8768b1a0c8c67c8$export$a73714094b2817b7(obj) ? obj : undefined;
const $a8768b1a0c8c67c8$export$c7c48cc42c0546b7 = (contentType)=>{
    const contentTreeType = $a8768b1a0c8c67c8$export$204659eac14d740b(contentType);
    return !!contentTreeType && $a8768b1a0c8c67c8$export$ee7a362b3ed8b036.includes(contentTreeType);
};
module.exports["isContentTreeType"] = $a8768b1a0c8c67c8$export$a73714094b2817b7;
module.exports["toContentTreeType"] = $a8768b1a0c8c67c8$export$204659eac14d740b;
module.exports["includesValidContentTreeType"] = $a8768b1a0c8c67c8$export$c7c48cc42c0546b7;

});


//# sourceMappingURL=SpaceNavigationContent.cbb32094.js.map
